(function (_, kotlin_kotlin, kotlin_com_glovoapp_analytics_common) {
  'use strict';
  //region block: imports
  var THROW_IAE = kotlin_kotlin.$_$.u1;
  var Unit_instance = kotlin_kotlin.$_$.f;
  var Enum = kotlin_kotlin.$_$.r1;
  var protoOf = kotlin_kotlin.$_$.j1;
  var defineProp = kotlin_kotlin.$_$.t;
  var initMetadataForClass = kotlin_kotlin.$_$.y;
  var VOID = kotlin_kotlin.$_$.b;
  var initMetadataForObject = kotlin_kotlin.$_$.b1;
  var Event = kotlin_com_glovoapp_analytics_common.$_$.b;
  var get_value = kotlin_com_glovoapp_analytics_common.$_$.e;
  var to = kotlin_kotlin.$_$.w1;
  var mapOf = kotlin_kotlin.$_$.o;
  var get_value_0 = kotlin_com_glovoapp_analytics_common.$_$.g;
  var get_value_1 = kotlin_com_glovoapp_analytics_common.$_$.h;
  var Screen = kotlin_com_glovoapp_analytics_common.$_$.c;
  var mapOf_0 = kotlin_kotlin.$_$.n;
  var get_value_2 = kotlin_com_glovoapp_analytics_common.$_$.f;
  var toString = kotlin_kotlin.$_$.l1;
  var emptyMap = kotlin_kotlin.$_$.k;
  var getStringHashCode = kotlin_kotlin.$_$.x;
  var equals = kotlin_kotlin.$_$.u;
  var get_data = kotlin_com_glovoapp_analytics_common.$_$.d;
  var plus = kotlin_kotlin.$_$.p;
  var EventType_Search_getInstance = kotlin_com_glovoapp_analytics_common.$_$.k;
  var Event_0 = kotlin_com_glovoapp_analytics_common.$_$.a;
  var listOf = kotlin_kotlin.$_$.l;
  var Action_AddToCart_getInstance = kotlin_com_glovoapp_analytics_common.$_$.i;
  var Action_RemoveFromCart_getInstance = kotlin_com_glovoapp_analytics_common.$_$.j;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ActiveFeatures, 'ActiveFeatures', VOID, Enum);
  initMetadataForObject(Metadata, 'Metadata');
  initMetadataForClass(AddTokenizedAPMStatus, 'AddTokenizedAPMStatus', VOID, Event);
  initMetadataForObject(Metadata_0, 'Metadata');
  initMetadataForClass(AddressBottomSheet, 'AddressBottomSheet', AddressBottomSheet, Event);
  initMetadataForObject(Metadata_1, 'Metadata');
  initMetadataForClass(AddressBottomSheetAction, 'AddressBottomSheetAction', VOID, Event);
  initMetadataForClass(AddressBottomSheetActionType, 'AddressBottomSheetActionType', VOID, Enum);
  initMetadataForObject(Metadata_2, 'Metadata');
  initMetadataForClass(AddressCheck, 'AddressCheck', VOID, Event);
  initMetadataForClass(AddressCheckType, 'AddressCheckType', VOID, Enum);
  initMetadataForObject(Metadata_3, 'Metadata');
  initMetadataForClass(AddressCreationSucceeded, 'AddressCreationSucceeded', AddressCreationSucceeded, Event);
  initMetadataForObject(Metadata_4, 'Metadata');
  initMetadataForClass(AddressDetails, 'AddressDetails', VOID, Screen);
  initMetadataForClass(AddressDetailsSource, 'AddressDetailsSource', VOID, Enum);
  initMetadataForObject(Metadata_5, 'Metadata');
  initMetadataForClass(AddressFlowLandingScreen, 'AddressFlowLandingScreen', VOID, Screen);
  initMetadataForClass(AddressLandingOption, 'AddressLandingOption', VOID, Enum);
  initMetadataForObject(Metadata_6, 'Metadata');
  initMetadataForClass(AddressLandingOptionClicked, 'AddressLandingOptionClicked', VOID, Event);
  initMetadataForObject(Metadata_7, 'Metadata');
  initMetadataForClass(AddressMapSearchFailed, 'AddressMapSearchFailed', VOID, Event);
  initMetadataForObject(Metadata_8, 'Metadata');
  initMetadataForClass(AddressSearchFailed, 'AddressSearchFailed', VOID, Event);
  initMetadataForClass(AddressSearchSource, 'AddressSearchSource', VOID, Enum);
  initMetadataForClass(AddressSource, 'AddressSource', VOID, Enum);
  initMetadataForObject(Metadata_9, 'Metadata');
  initMetadataForClass(AddressTooFarErrorFired, 'AddressTooFarErrorFired', VOID, Event);
  initMetadataForClass(AddressType, 'AddressType', VOID, Enum);
  initMetadataForClass(AllFiltersCleared, 'AllFiltersCleared', AllFiltersCleared, Event);
  initMetadataForClass(AlternativePlatformNameType, 'AlternativePlatformNameType');
  initMetadataForObject(ApplePay, 'ApplePay', VOID, AlternativePlatformNameType);
  initMetadataForObject(GooglePay, 'GooglePay', VOID, AlternativePlatformNameType);
  initMetadataForObject(DotPay, 'DotPay', VOID, AlternativePlatformNameType);
  initMetadataForObject(PayPal, 'PayPal', VOID, AlternativePlatformNameType);
  initMetadataForObject(Edenred, 'Edenred', VOID, AlternativePlatformNameType);
  initMetadataForObject(BalanceCredit, 'BalanceCredit', VOID, AlternativePlatformNameType);
  initMetadataForClass(WebPayment, 'WebPayment', VOID, AlternativePlatformNameType);
  initMetadataForClass(NativePayment, 'NativePayment', VOID, AlternativePlatformNameType);
  initMetadataForObject(Unknown, 'Unknown', VOID, AlternativePlatformNameType);
  initMetadataForClass(AppliedFilterOrigin, 'AppliedFilterOrigin', VOID, Enum);
  initMetadataForObject(Metadata_10, 'Metadata');
  initMetadataForClass(ApplyConsent, 'ApplyConsent', VOID, Event);
  initMetadataForClass(AuthenticationOption, 'AuthenticationOption', VOID, Enum);
  initMetadataForClass(AuthenticationOptionSelected, 'AuthenticationOptionSelected', VOID, Event);
  initMetadataForClass(AuthenticationOptionsScreen, 'AuthenticationOptionsScreen', VOID, Screen);
  initMetadataForClass(AvailabilityStatus, 'AvailabilityStatus');
  initMetadataForClass(Closed, 'Closed', VOID, AvailabilityStatus);
  initMetadataForClass(Unavailable, 'Unavailable', VOID, AvailabilityStatus);
  initMetadataForClass(Schedulable, 'Schedulable', VOID, AvailabilityStatus);
  initMetadataForObject(Asap, 'Asap', VOID, AvailabilityStatus);
  initMetadataForObject(OutOfDeliveryZone, 'OutOfDeliveryZone', VOID, AvailabilityStatus);
  initMetadataForObject(Metadata_11, 'Metadata');
  initMetadataForClass(BackToBasketScreenFromCheckout, 'BackToBasketScreenFromCheckout', VOID, Event);
  initMetadataForClass(BadgeType, 'BadgeType', VOID, Enum);
  initMetadataForObject(Metadata_12, 'Metadata');
  initMetadataForClass(BasketCreated, 'BasketCreated', VOID, Event);
  initMetadataForClass(BasketCreationOrigin, 'BasketCreationOrigin', VOID, Enum);
  initMetadataForObject(Metadata_13, 'Metadata');
  initMetadataForClass(BasketDeleted, 'BasketDeleted', VOID, Event);
  initMetadataForObject(Metadata_14, 'Metadata');
  initMetadataForClass(BasketError, 'BasketError', VOID, Event);
  initMetadataForClass(BasketOrigin, 'BasketOrigin', VOID, Enum);
  initMetadataForObject(Metadata_15, 'Metadata');
  initMetadataForClass(BasketRecovered, 'BasketRecovered', VOID, Event);
  initMetadataForObject(Metadata_16, 'Metadata');
  initMetadataForClass(BasketScreen, 'BasketScreen', VOID, Screen);
  initMetadataForClass(BottomSheetScreen, 'BottomSheetScreen', VOID, Enum);
  initMetadataForClass(BottomSheetShown, 'BottomSheetShown', VOID, Event);
  initMetadataForClass(BottomSheetSource, 'BottomSheetSource', VOID, Enum);
  initMetadataForClass(BottomSheetType, 'BottomSheetType');
  initMetadataForClass(CheckoutErrorHandling, 'CheckoutErrorHandling', VOID, BottomSheetType);
  initMetadataForClass(CCChatProvider, 'CCChatProvider', VOID, Enum);
  initMetadataForClass(CTA, 'CTA', VOID, Enum);
  initMetadataForClass(CarouselScrollDirection, 'CarouselScrollDirection', VOID, Enum);
  initMetadataForClass(CarouselScrolled, 'CarouselScrolled', VOID, Event);
  initMetadataForObject(Metadata_17, 'Metadata');
  initMetadataForClass(CartEntryPointImpression, 'CartEntryPointImpression', VOID, Event);
  initMetadataForObject(Metadata_18, 'Metadata');
  initMetadataForClass(CartEntryPointNavigationClick, 'CartEntryPointNavigationClick', VOID, Event);
  initMetadataForObject(Metadata_19, 'Metadata');
  initMetadataForClass(CartExpired, 'CartExpired', VOID, Event);
  initMetadataForObject(Metadata_20, 'Metadata');
  initMetadataForClass(CartInteracted, 'CartInteracted', VOID, Event);
  initMetadataForClass(CartInteractionType, 'CartInteractionType');
  initMetadataForObject(HelpClicked, 'HelpClicked', VOID, CartInteractionType);
  initMetadataForObject(GoBack, 'GoBack', VOID, CartInteractionType);
  initMetadataForClass(AddRemoveQuantityClicked, 'AddRemoveQuantityClicked', VOID, CartInteractionType);
  initMetadataForClass(RemoveProductClicked, 'RemoveProductClicked', VOID, CartInteractionType);
  initMetadataForObject(GoCheckout, 'GoCheckout', VOID, CartInteractionType);
  initMetadataForObject(GoPNAInstructions, 'GoPNAInstructions', VOID, CartInteractionType);
  initMetadataForObject(GoGiftingOptions, 'GoGiftingOptions', VOID, CartInteractionType);
  initMetadataForObject(Metadata_21, 'Metadata');
  initMetadataForClass(CartLoaded, 'CartLoaded', VOID, Event);
  initMetadataForObject(Metadata_22, 'Metadata');
  initMetadataForClass(CartProductImpression, 'CartProductImpression', VOID, Event);
  initMetadataForObject(Metadata_23, 'Metadata');
  initMetadataForClass(CartRecoveryStarted, 'CartRecoveryStarted', VOID, Event);
  initMetadataForObject(Metadata_24, 'Metadata');
  initMetadataForClass(CartRemovalButtonClicked, 'CartRemovalButtonClicked', VOID, Event);
  initMetadataForObject(Metadata_25, 'Metadata');
  initMetadataForClass(CartRemovalModalConfirmed, 'CartRemovalModalConfirmed', VOID, Event);
  initMetadataForObject(Metadata_26, 'Metadata');
  initMetadataForClass(CartRemovalModalDenied, 'CartRemovalModalDenied', VOID, Event);
  initMetadataForClass(CartType, 'CartType');
  initMetadataForClass(ProductNotAvailable, 'ProductNotAvailable', ProductNotAvailable, CartType);
  initMetadataForClass(ProductList, 'ProductList', ProductList, CartType);
  initMetadataForObject(EmptyCart, 'EmptyCart', VOID, CartType);
  initMetadataForObject(Metadata_27, 'Metadata');
  initMetadataForClass(CashAmountConfirmed, 'CashAmountConfirmed', VOID, Event);
  initMetadataForObject(Metadata_28, 'Metadata');
  initMetadataForClass(CashAmountScreen, 'CashAmountScreen', VOID, Screen);
  initMetadataForClass(CategoryGroup, 'CategoryGroup', VOID, Screen);
  initMetadataForClass(CategoryGroupContentShown, 'CategoryGroupContentShown', VOID, Event);
  initMetadataForClass(CategoryGroupOpened, 'CategoryGroupOpened', VOID, Event);
  initMetadataForClass(CategoryOpened, 'CategoryOpened', VOID, Event);
  initMetadataForClass(ChatNotificationType, 'ChatNotificationType', VOID, Enum);
  initMetadataForClass(ChatProvider, 'ChatProvider', VOID, Enum);
  initMetadataForClass(ChatType, 'ChatType', VOID, Enum);
  initMetadataForObject(Metadata_29, 'Metadata');
  initMetadataForClass(Checkout, 'Checkout', VOID, Screen);
  initMetadataForObject(Metadata_30, 'Metadata');
  initMetadataForClass(CheckoutComponentShown, 'CheckoutComponentShown', VOID, Event);
  initMetadataForObject(Metadata_31, 'Metadata');
  initMetadataForClass(CheckoutConfirmationButtonPressed, 'CheckoutConfirmationButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_32, 'Metadata');
  initMetadataForClass(CheckoutContentShown, 'CheckoutContentShown', VOID, Event);
  initMetadataForObject(Metadata_33, 'Metadata');
  initMetadataForClass(CheckoutCountdownContinueButtonPressed, 'CheckoutCountdownContinueButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_34, 'Metadata');
  initMetadataForClass(CheckoutCountdownFinished, 'CheckoutCountdownFinished', VOID, Event);
  initMetadataForObject(Metadata_35, 'Metadata');
  initMetadataForClass(CheckoutCountdownModifyButtonPressed, 'CheckoutCountdownModifyButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_36, 'Metadata');
  initMetadataForClass(CheckoutCountdownScreenShown, 'CheckoutCountdownScreenShown', VOID, Screen);
  initMetadataForObject(Metadata_37, 'Metadata');
  initMetadataForClass(CheckoutMapHyperlinkClicked, 'CheckoutMapHyperlinkClicked', CheckoutMapHyperlinkClicked, Event);
  initMetadataForObject(Metadata_38, 'Metadata');
  initMetadataForClass(CheckoutOrderButtonPressed, 'CheckoutOrderButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_39, 'Metadata');
  initMetadataForClass(CheckoutOrderConfirmation, 'CheckoutOrderConfirmation', VOID, Screen);
  initMetadataForObject(Metadata_40, 'Metadata');
  initMetadataForClass(CheckoutPrimeBannerShown, 'CheckoutPrimeBannerShown', VOID, Event);
  initMetadataForObject(Metadata_41, 'Metadata');
  initMetadataForClass(CheckoutTemplateReceived, 'CheckoutTemplateReceived', VOID, Screen);
  initMetadataForClass(CollectionGroupImpression, 'CollectionGroupImpression', VOID, Event);
  initMetadataForClass(CollectionGroupOpened, 'CollectionGroupOpened', VOID, Event);
  initMetadataForClass(CollectionImpression, 'CollectionImpression', VOID, Event);
  initMetadataForClass(CollectionOpened, 'CollectionOpened', CollectionOpened, Event);
  initMetadataForClass(CollectionOrigin, 'CollectionOrigin');
  initMetadataForObject(CollectionGroup, 'CollectionGroup', VOID, CollectionOrigin);
  initMetadataForObject(NestedCollectionGroup, 'NestedCollectionGroup', VOID, CollectionOrigin);
  initMetadataForObject(NavigationMenu, 'NavigationMenu', VOID, CollectionOrigin);
  initMetadataForObject(ContentExpansionButton, 'ContentExpansionButton', VOID, CollectionOrigin);
  initMetadataForObject(StoreHomeMosaic, 'StoreHomeMosaic', VOID, CollectionOrigin);
  initMetadataForObject(SearchArrow, 'SearchArrow', VOID, CollectionOrigin);
  initMetadataForObject(Deeplink, 'Deeplink', VOID, CollectionOrigin);
  initMetadataForClass(Widget, 'Widget', VOID, CollectionOrigin);
  initMetadataForClass(CollectionType, 'CollectionType');
  initMetadataForClass(Catalogue, 'Catalogue', VOID, CollectionType);
  initMetadataForObject(EasyReorder, 'EasyReorder', VOID, CollectionType);
  initMetadataForObject(TopSellers, 'TopSellers', VOID, CollectionType);
  initMetadataForObject(Promotions, 'Promotions', VOID, CollectionType);
  initMetadataForObject(MealsUnderX, 'MealsUnderX', VOID, CollectionType);
  initMetadataForClass(ConnectionSource, 'ConnectionSource', VOID, Enum);
  initMetadataForObject(Metadata_42, 'Metadata');
  initMetadataForClass(ConsentFirstLayerApplied, 'ConsentFirstLayerApplied', VOID, Event);
  initMetadataForObject(Metadata_43, 'Metadata');
  initMetadataForClass(ConsentFirstLayerNotNeeded, 'ConsentFirstLayerNotNeeded', VOID, Event);
  initMetadataForObject(Metadata_44, 'Metadata');
  initMetadataForClass(ConsentFirstLayerShown, 'ConsentFirstLayerShown', ConsentFirstLayerShown, Event);
  initMetadataForObject(Metadata_45, 'Metadata');
  initMetadataForClass(ConsentSecondLayerApplied, 'ConsentSecondLayerApplied', VOID, Event);
  initMetadataForObject(Metadata_46, 'Metadata');
  initMetadataForClass(ConsentSecondLayerShown, 'ConsentSecondLayerShown', ConsentSecondLayerShown, Event);
  initMetadataForClass(ContactCourier, 'ContactCourier', ContactCourier, Screen);
  initMetadataForClass(ContactReason, 'ContactReason', VOID, Enum);
  initMetadataForObject(Metadata_47, 'Metadata');
  initMetadataForClass(ContactSupportPressed, 'ContactSupportPressed', VOID, Event);
  initMetadataForObject(Metadata_48, 'Metadata');
  initMetadataForClass(ContactTreeNodePopup, 'ContactTreeNodePopup', VOID, Screen);
  initMetadataForObject(Metadata_49, 'Metadata');
  initMetadataForClass(ContactTreeNodeSelected, 'ContactTreeNodeSelected', VOID, Event);
  initMetadataForClass(ContactTreeOpened, 'ContactTreeOpened', VOID, Event);
  initMetadataForClass(ContactTreeSelectedNode, 'ContactTreeSelectedNode', VOID, Event);
  initMetadataForClass(ContactUsOrigin, 'ContactUsOrigin', VOID, Enum);
  initMetadataForObject(Metadata_50, 'Metadata');
  initMetadataForClass(ContactUsUsed, 'ContactUsUsed', VOID, Event);
  initMetadataForClass(ContentTranslatedAction, 'ContentTranslatedAction', VOID, Enum);
  initMetadataForClass(CreatePassword, 'CreatePassword', CreatePassword, Screen);
  initMetadataForClass(CsatReason, 'CsatReason', VOID, Enum);
  initMetadataForClass(CsatSide, 'CsatSide', VOID, Enum);
  initMetadataForObject(Metadata_51, 'Metadata');
  initMetadataForClass(DeliveryOptionSelected, 'DeliveryOptionSelected', VOID, Event);
  initMetadataForObject(Metadata_52, 'Metadata');
  initMetadataForClass(DeliveryOptionsAvailable, 'DeliveryOptionsAvailable', VOID, Event);
  initMetadataForObject(Metadata_53, 'Metadata');
  initMetadataForClass(DeliveryOptionsDescriptionViewed, 'DeliveryOptionsDescriptionViewed', DeliveryOptionsDescriptionViewed, Event);
  initMetadataForObject(Metadata_54, 'Metadata');
  initMetadataForClass(DeliveryOptionsExpandableListChanged, 'DeliveryOptionsExpandableListChanged', VOID, Event);
  initMetadataForClass(DynamicSessionStarted, 'DynamicSessionStarted', VOID, Event);
  initMetadataForClass(EasyReorderScreenType, 'EasyReorderScreenType', VOID, Enum);
  initMetadataForObject(Metadata_55, 'Metadata');
  initMetadataForClass(EditAddressButtonPressed, 'EditAddressButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_56, 'Metadata');
  initMetadataForClass(EditAddressClicked, 'EditAddressClicked', VOID, Event);
  initMetadataForClass(EditAddressOrigins, 'EditAddressOrigins', VOID, Enum);
  initMetadataForClass(ElementAction, 'ElementAction', VOID, Enum);
  initMetadataForClass(ElementScreen, 'ElementScreen', VOID, Enum);
  initMetadataForClass(ElementSource, 'ElementSource', VOID, Enum);
  initMetadataForClass(ElementTapped, 'ElementTapped', VOID, Event);
  initMetadataForClass(ElementType, 'ElementType', VOID, Enum);
  initMetadataForClass(EnterEmailOrigin, 'EnterEmailOrigin', VOID, Enum);
  initMetadataForClass(EnterEmailScreen, 'EnterEmailScreen', VOID, Screen);
  initMetadataForClass(EnterPassword, 'EnterPassword', EnterPassword, Screen);
  initMetadataForObject(Metadata_57, 'Metadata');
  initMetadataForClass(ExploreStoresButtonClicked, 'ExploreStoresButtonClicked', VOID, Event);
  initMetadataForObject(Metadata_58, 'Metadata');
  initMetadataForClass(FAQ, 'FAQ', FAQ, Screen);
  initMetadataForClass(FeedGroupImpression, 'FeedGroupImpression', VOID, Event);
  initMetadataForClass(FeedGroupInteracted, 'FeedGroupInteracted', VOID, Event);
  initMetadataForClass(FeedGroupInteractionType, 'FeedGroupInteractionType');
  initMetadataForObject(CtaSelected, 'CtaSelected', VOID, FeedGroupInteractionType);
  initMetadataForObject(PromotionEventSelected, 'PromotionEventSelected', VOID, FeedGroupInteractionType);
  initMetadataForObject(LottieSelected, 'LottieSelected', VOID, FeedGroupInteractionType);
  initMetadataForObject(GamificationSelected, 'GamificationSelected', VOID, FeedGroupInteractionType);
  initMetadataForClass(StoreSelected, 'StoreSelected', VOID, FeedGroupInteractionType);
  initMetadataForObject(InfoSelected, 'InfoSelected', VOID, FeedGroupInteractionType);
  initMetadataForObject(Other, 'Other', VOID, FeedGroupInteractionType);
  initMetadataForClass(FeedGroupLoaded, 'FeedGroupLoaded', VOID, Event);
  initMetadataForObject(Metadata_59, 'Metadata');
  initMetadataForClass(FeedbackCsat, 'FeedbackCsat', VOID, Screen);
  initMetadataForObject(Metadata_60, 'Metadata');
  initMetadataForClass(FeedbackCsatReasonAdded, 'FeedbackCsatReasonAdded', VOID, Event);
  initMetadataForObject(Metadata_61, 'Metadata');
  initMetadataForClass(FeedbackCsatSubmitted, 'FeedbackCsatSubmitted', VOID, Event);
  initMetadataForClass(FilterDisplayed, 'FilterDisplayed', VOID, Event);
  initMetadataForClass(FilterName, 'FilterName', VOID, Enum);
  initMetadataForClass(FilterOrigin, 'FilterOrigin', VOID, Enum);
  initMetadataForClass(Filters, 'Filters', VOID, Screen);
  initMetadataForClass(FiltersApplied, 'FiltersApplied', VOID, Event);
  initMetadataForClass(FiltersApplyResults, 'FiltersApplyResults', VOID, Screen);
  initMetadataForClass(ForgotPassword, 'ForgotPassword', ForgotPassword, Screen);
  initMetadataForClass(GiftingComponentPressed, 'GiftingComponentPressed', VOID, Event);
  initMetadataForClass(GiftingOptionDisplayed, 'GiftingOptionDisplayed', VOID, Event);
  initMetadataForClass(GiftingRecipientDetailsSaved, 'GiftingRecipientDetailsSaved', VOID, Event);
  initMetadataForObject(Metadata_62, 'Metadata');
  initMetadataForClass(GoToCheckout, 'GoToCheckout', VOID, Event);
  initMetadataForClass(Home, 'Home', Home, Screen);
  initMetadataForClass(HomeContentShown, 'HomeContentShown', VOID, Event);
  initMetadataForClass(HomeLocationErrorScreenView, 'HomeLocationErrorScreenView', HomeLocationErrorScreenView, Screen);
  initMetadataForClass(HomePageNotLoadedReason, 'HomePageNotLoadedReason', VOID, Enum);
  initMetadataForClass(HomeSource, 'HomeSource', VOID, Enum);
  initMetadataForClass(IdenticalAddressPopUpViewed, 'IdenticalAddressPopUpViewed', IdenticalAddressPopUpViewed, Screen);
  initMetadataForClass(ImpressionType, 'ImpressionType');
  initMetadataForObject(StoreCard, 'StoreCard', VOID, ImpressionType);
  initMetadataForClass(Logo, 'Logo', VOID, ImpressionType);
  initMetadataForClass(InfoButtonSource, 'InfoButtonSource', VOID, Enum);
  initMetadataForClass(InfoButtonTapped, 'InfoButtonTapped', VOID, Event);
  initMetadataForClass(InfoType, 'InfoType', VOID, Enum);
  initMetadataForObject(Metadata_63, 'Metadata');
  initMetadataForClass(InstructionAdded, 'InstructionAdded', VOID, Event);
  initMetadataForObject(Metadata_64, 'Metadata');
  initMetadataForClass(InstructionImpression, 'InstructionImpression', VOID, Event);
  initMetadataForClass(InstructionType, 'InstructionType');
  initMetadataForClass(ProductInstructionPNA, 'ProductInstructionPNA', VOID, InstructionType);
  initMetadataForClass(OrderInstructionPNA, 'OrderInstructionPNA', VOID, InstructionType);
  initMetadataForClass(OrderInstructionGifting, 'OrderInstructionGifting', VOID, InstructionType);
  initMetadataForClass(InvalidEmail, 'InvalidEmail', InvalidEmail, Event);
  initMetadataForClass(LayoutDesign, 'LayoutDesign', VOID, Enum);
  initMetadataForClass(LocationTrackingPermissionGranted, 'LocationTrackingPermissionGranted', LocationTrackingPermissionGranted, Event);
  initMetadataForClass(LogOutButtonClicked, 'LogOutButtonClicked', LogOutButtonClicked, Event);
  initMetadataForObject(Metadata_65, 'Metadata');
  initMetadataForClass(LoginScreen, 'LoginScreen', LoginScreen, Screen);
  initMetadataForClass(MbsCalculationStrategy, 'MbsCalculationStrategy', VOID, Enum);
  initMetadataForClass(MbsMoreInfoTapped, 'MbsMoreInfoTapped', VOID, Event);
  initMetadataForClass(MbsProgressBarShown, 'MbsProgressBarShown', VOID, Event);
  initMetadataForClass(MbsThresholdReached, 'MbsThresholdReached', VOID, Event);
  initMetadataForObject(Metadata_66, 'Metadata');
  initMetadataForClass(Mgm, 'Mgm', VOID, Screen);
  initMetadataForClass(MgmSource, 'MgmSource', VOID, Enum);
  initMetadataForClass(MigrationExploreButtonPressed, 'MigrationExploreButtonPressed', MigrationExploreButtonPressed, Event);
  initMetadataForClass(MigrationSucceeded, 'MigrationSucceeded', VOID, Event);
  initMetadataForClass(MigrationWelcome, 'MigrationWelcome', MigrationWelcome, Screen);
  initMetadataForClass(NavigationBarElementTapped, 'NavigationBarElementTapped', VOID, Event);
  initMetadataForClass(NavigationTabBarAppLocation, 'NavigationTabBarAppLocation', VOID, Enum);
  initMetadataForClass(NavigationTabBarElements, 'NavigationTabBarElements', VOID, Enum);
  initMetadataForClass(NavigationTabBarLoaded, 'NavigationTabBarLoaded', VOID, Event);
  initMetadataForClass(NavigationTabBarTapped, 'NavigationTabBarTapped', VOID, Event);
  initMetadataForObject(Metadata_67, 'Metadata');
  initMetadataForClass(NewBottomSheetDismissed, 'NewBottomSheetDismissed', VOID, Event);
  initMetadataForObject(Metadata_68, 'Metadata');
  initMetadataForClass(NewBottomSheetShown, 'NewBottomSheetShown', VOID, Screen);
  initMetadataForObject(Metadata_69, 'Metadata');
  initMetadataForClass(NewOrder, 'NewOrder', VOID, Screen);
  initMetadataForObject(Metadata_70, 'Metadata');
  initMetadataForClass(NewOrderContentShown, 'NewOrderContentShown', VOID, Event);
  initMetadataForObject(Metadata_71, 'Metadata');
  initMetadataForClass(NoInternetConnectionScreen, 'NoInternetConnectionScreen', NoInternetConnectionScreen, Event);
  initMetadataForObject(Metadata_72, 'Metadata');
  initMetadataForClass(NotificationConfigurationCenter, 'NotificationConfigurationCenter', VOID, Screen);
  initMetadataForObject(Metadata_73, 'Metadata');
  initMetadataForClass(NotificationConfigurationCenterButtonPressed, 'NotificationConfigurationCenterButtonPressed', VOID, Event);
  initMetadataForClass(NotificationConfigurationScreenSource, 'NotificationConfigurationScreenSource', VOID, Enum);
  initMetadataForClass(NotificationStatus, 'NotificationStatus', VOID, Enum);
  initMetadataForObject(Metadata_74, 'Metadata');
  initMetadataForClass(OngoingOrderDetailsFirstScrollDown, 'OngoingOrderDetailsFirstScrollDown', VOID, Event);
  initMetadataForObject(Metadata_75, 'Metadata');
  initMetadataForClass(OngoingOrderDetailsFirstViewed, 'OngoingOrderDetailsFirstViewed', VOID, Event);
  initMetadataForClass(OngoingOrderEditCta, 'OngoingOrderEditCta', VOID, Enum);
  initMetadataForClass(OngoingOrderEditFeature, 'OngoingOrderEditFeature', VOID, Enum);
  initMetadataForObject(Metadata_76, 'Metadata');
  initMetadataForClass(OngoingOrderEditPressed, 'OngoingOrderEditPressed', VOID, Event);
  initMetadataForObject(Metadata_77, 'Metadata');
  initMetadataForClass(OpenChatPressed, 'OpenChatPressed', VOID, Event);
  initMetadataForObject(Metadata_78, 'Metadata');
  initMetadataForClass(OpenChatsListViewed, 'OpenChatsListViewed', VOID, Screen);
  initMetadataForClass(OrderCancellationReason, 'OrderCancellationReason', VOID, Enum);
  initMetadataForObject(Metadata_79, 'Metadata');
  initMetadataForClass(OrderCancelled, 'OrderCancelled', VOID, Event);
  initMetadataForObject(Metadata_80, 'Metadata');
  initMetadataForClass(OrderConfirmationButtonPressed, 'OrderConfirmationButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_81, 'Metadata');
  initMetadataForClass(OrderCreated, 'OrderCreated', VOID, Event);
  initMetadataForObject(Metadata_82, 'Metadata');
  initMetadataForClass(OrderDetails, 'OrderDetails', VOID, Screen);
  initMetadataForClass(OrderHandlingStrategyType, 'OrderHandlingStrategyType', VOID, Enum);
  initMetadataForObject(Metadata_83, 'Metadata');
  initMetadataForClass(OrderRated, 'OrderRated', VOID, Event);
  initMetadataForObject(Metadata_84, 'Metadata');
  initMetadataForClass(OrderRating, 'OrderRating', OrderRating, Screen);
  initMetadataForClass(OrderType, 'OrderType');
  initMetadataForObject(Purchase, 'Purchase', VOID, OrderType);
  initMetadataForObject(Shipment, 'Shipment', VOID, OrderType);
  initMetadataForClass(Store, 'Store', VOID, OrderType);
  initMetadataForClass(OrderVertical, 'OrderVertical', VOID, Enum);
  initMetadataForClass(Orders, 'Orders', Orders, Screen);
  initMetadataForClass(Origins, 'Origins');
  initMetadataForClass(Category, 'Category', VOID, Origins);
  initMetadataForClass(CategoryGroup_0, 'CategoryGroup', VOID, Origins);
  initMetadataForObject(Checkout_0, 'Checkout', VOID, Origins);
  initMetadataForClass(NewBottomSheet, 'NewBottomSheet', VOID, Origins);
  initMetadataForClass(FeedGroup, 'FeedGroup', VOID, Origins);
  initMetadataForClass(FeedGroupResults, 'FeedGroupResults', VOID, Origins);
  initMetadataForClass(HomeWidget, 'HomeWidget', VOID, Origins);
  initMetadataForClass(HomeWidgetResults, 'HomeWidgetResults', VOID, Origins);
  initMetadataForClass(HomeSearchBarResults, 'HomeSearchBarResults', HomeSearchBarResults, Origins);
  initMetadataForClass(SearchNestedDishes, 'SearchNestedDishes', VOID, Origins);
  initMetadataForClass(Story, 'Story', Story, Origins);
  initMetadataForClass(Deeplink_0, 'Deeplink', VOID, Origins);
  initMetadataForObject(Direct, 'Direct', VOID, Origins);
  initMetadataForObject(Other_0, 'Other', VOID, Origins);
  initMetadataForClass(HomeBubble, 'HomeBubble', VOID, Origins);
  initMetadataForClass(CategoryGroupBubble, 'CategoryGroupBubble', VOID, Origins);
  initMetadataForClass(CategoryResults, 'CategoryResults', VOID, Origins);
  initMetadataForClass(FeedCarousel, 'FeedCarousel', VOID, Origins);
  initMetadataForClass(FeedCarouselResults, 'FeedCarouselResults', VOID, Origins);
  initMetadataForClass(CategoryGroupSearchBarResults, 'CategoryGroupSearchBarResults', VOID, Origins);
  initMetadataForClass(BannerResults, 'BannerResults', VOID, Origins);
  initMetadataForObject(FoodNearYouFeed, 'FoodNearYouFeed', VOID, Origins);
  initMetadataForObject(FilterLanding, 'FilterLanding', VOID, Origins);
  initMetadataForObject(BrandLanding, 'BrandLanding', VOID, Origins);
  initMetadataForObject(ClosedStoreSimilarStoresModal, 'ClosedStoreSimilarStoresModal', VOID, Origins);
  initMetadataForObject(Orders_0, 'Orders', VOID, Origins);
  initMetadataForObject(OutOfDeliveryPopUp, 'OutOfDeliveryPopUp', VOID, Origins);
  initMetadataForObject(DoubleGlovo, 'DoubleGlovo', VOID, Origins);
  initMetadataForClass(Widget_0, 'Widget', VOID, Origins);
  initMetadataForClass(WidgetResults, 'WidgetResults', VOID, Origins);
  initMetadataForObject(Cart, 'Cart', VOID, Origins);
  initMetadataForObject(StoreDetails, 'StoreDetails', VOID, Origins);
  initMetadataForObject(VideoPlayer, 'VideoPlayer', VOID, Origins);
  initMetadataForClass(Playlist, 'Playlist', VOID, Origins);
  initMetadataForObject(PlaylistBottomSheet, 'PlaylistBottomSheet', VOID, Origins);
  initMetadataForObject(StoreWallNestedDishes, 'StoreWallNestedDishes', VOID, Origins);
  initMetadataForObject(SearchShowAllButton, 'SearchShowAllButton', VOID, Origins);
  initMetadataForObject(Home_0, 'Home', VOID, Origins);
  initMetadataForObject(NavigationTabBar, 'NavigationTabBar', VOID, Origins);
  initMetadataForObject(Profile, 'Profile', VOID, Origins);
  initMetadataForClass(OutOfDeliveryZoneScreenView, 'OutOfDeliveryZoneScreenView', OutOfDeliveryZoneScreenView, Screen);
  initMetadataForClass(PaymentChange, 'PaymentChange', PaymentChange, Screen);
  initMetadataForClass(PaymentChangeScreenOrigin, 'PaymentChangeScreenOrigin', VOID, Enum);
  initMetadataForClass(PaymentInfo, 'PaymentInfo', VOID, Screen);
  initMetadataForClass(PaymentInfoEntered, 'PaymentInfoEntered', VOID, Event);
  initMetadataForClass(PaymentInfoFailed, 'PaymentInfoFailed', VOID, Event);
  initMetadataForClass(PaymentMethod, 'PaymentMethod');
  initMetadataForObject(Cash, 'Cash', VOID, PaymentMethod);
  initMetadataForClass(CreditCard, 'CreditCard', CreditCard, PaymentMethod);
  initMetadataForObject(DirectDebit, 'DirectDebit', VOID, PaymentMethod);
  initMetadataForObject(BankTransfer, 'BankTransfer', VOID, PaymentMethod);
  initMetadataForClass(Alternative, 'Alternative', VOID, PaymentMethod);
  initMetadataForObject(Others, 'Others', VOID, PaymentMethod);
  initMetadataForClass(PaymentMethodSelector, 'PaymentMethodSelector', PaymentMethodSelector, Screen);
  initMetadataForClass(PaymentMethodSelectorUpdated, 'PaymentMethodSelectorUpdated', VOID, Event);
  initMetadataForClass(PaymentProcessingCanceled, 'PaymentProcessingCanceled', VOID, Event);
  initMetadataForClass(PaymentProcessingFinished, 'PaymentProcessingFinished', VOID, Event);
  initMetadataForClass(PaymentProcessingStarted, 'PaymentProcessingStarted', VOID, Event);
  initMetadataForClass(PaymentProcessingStatus, 'PaymentProcessingStatus', VOID, Enum);
  initMetadataForClass(PersonalizedFilterType, 'PersonalizedFilterType', VOID, Enum);
  initMetadataForClass(PhoneScreenOrigin, 'PhoneScreenOrigin', VOID, Enum);
  initMetadataForObject(Metadata_85, 'Metadata');
  initMetadataForClass(PhoneScreenViewed, 'PhoneScreenViewed', VOID, Screen);
  initMetadataForClass(PhoneVerification, 'PhoneVerification', VOID, Screen);
  initMetadataForClass(PhoneVerificationCallRequested, 'PhoneVerificationCallRequested', VOID, Event);
  initMetadataForClass(PhoneVerificationEnterCode, 'PhoneVerificationEnterCode', VOID, Screen);
  initMetadataForClass(PhoneVerificationFailed, 'PhoneVerificationFailed', VOID, Event);
  initMetadataForClass(PhoneVerificationMethod, 'PhoneVerificationMethod', VOID, Enum);
  initMetadataForClass(PhoneVerificationMethodButtonClicked, 'PhoneVerificationMethodButtonClicked', PhoneVerificationMethodButtonClicked, Screen);
  initMetadataForClass(PhoneVerificationNoAttemptsLeft, 'PhoneVerificationNoAttemptsLeft', VOID, Screen);
  initMetadataForClass(PhoneVerificationStarted, 'PhoneVerificationStarted', VOID, Event);
  initMetadataForClass(PhoneVerified, 'PhoneVerified', VOID, Event);
  initMetadataForObject(Metadata_86, 'Metadata');
  initMetadataForClass(PopupCTAPressed, 'PopupCTAPressed', VOID, Event);
  initMetadataForClass(PreSearch, 'PreSearch', VOID, Screen);
  initMetadataForClass(PreferredLanguagePage, 'PreferredLanguagePage', PreferredLanguagePage, Screen);
  initMetadataForClass(PreferredLanguagesList, 'PreferredLanguagesList', PreferredLanguagesList, Screen);
  initMetadataForObject(Metadata_87, 'Metadata');
  initMetadataForClass(PrimeCheckoutBoxDeselected, 'PrimeCheckoutBoxDeselected', VOID, Event);
  initMetadataForObject(Metadata_88, 'Metadata');
  initMetadataForClass(PrimeCheckoutBoxSelected, 'PrimeCheckoutBoxSelected', VOID, Event);
  initMetadataForClass(PrimeOrigin, 'PrimeOrigin', VOID, Enum);
  initMetadataForObject(Metadata_89, 'Metadata');
  initMetadataForClass(PrimeSubscribeSelected, 'PrimeSubscribeSelected', VOID, Event);
  initMetadataForObject(Metadata_90, 'Metadata');
  initMetadataForClass(PrimeSubscriptionConfirmed, 'PrimeSubscriptionConfirmed', VOID, Event);
  initMetadataForClass(PrimeSubscriptionType, 'PrimeSubscriptionType', VOID, Enum);
  initMetadataForObject(Metadata_91, 'Metadata');
  initMetadataForClass(PrimeTutorialDismissed, 'PrimeTutorialDismissed', VOID, Event);
  initMetadataForObject(Metadata_92, 'Metadata');
  initMetadataForClass(PrimeTutorialShown, 'PrimeTutorialShown', VOID, Event);
  initMetadataForClass(PrimeTutorialSource, 'PrimeTutorialSource');
  initMetadataForClass(Deeplink_1, 'Deeplink', VOID, PrimeTutorialSource);
  initMetadataForObject(Profile_0, 'Profile', VOID, PrimeTutorialSource);
  initMetadataForObject(Story_0, 'Story', VOID, PrimeTutorialSource);
  initMetadataForClass(Checkout_1, 'Checkout', Checkout_1, PrimeTutorialSource);
  initMetadataForObject(Header, 'Header', VOID, PrimeTutorialSource);
  initMetadataForObject(Promocodes, 'Promocodes', VOID, PrimeTutorialSource);
  initMetadataForObject(Store_0, 'Store', VOID, PrimeTutorialSource);
  initMetadataForObject(StorePrimePromotions, 'StorePrimePromotions', VOID, PrimeTutorialSource);
  initMetadataForObject(StorePrimeBadge, 'StorePrimeBadge', VOID, PrimeTutorialSource);
  initMetadataForObject(Other_1, 'Other', VOID, PrimeTutorialSource);
  initMetadataForClass(HomeBanner, 'HomeBanner', VOID, PrimeTutorialSource);
  initMetadataForObject(PrimeLandingPage, 'PrimeLandingPage', VOID, PrimeTutorialSource);
  initMetadataForClass(OngoingOrder, 'OngoingOrder', OngoingOrder, PrimeTutorialSource);
  initMetadataForClass(StoresList, 'StoresList', StoresList, PrimeTutorialSource);
  initMetadataForObject(Filters_0, 'Filters', VOID, PrimeTutorialSource);
  initMetadataForObject(Resubscription, 'Resubscription', VOID, PrimeTutorialSource);
  initMetadataForObject(HomeScreenBenefit, 'HomeScreenBenefit', VOID, PrimeTutorialSource);
  initMetadataForObject(ProfileHeader, 'ProfileHeader', VOID, PrimeTutorialSource);
  initMetadataForObject(SurgePrice, 'SurgePrice', VOID, PrimeTutorialSource);
  initMetadataForClass(BannerResults_0, 'BannerResults', VOID, PrimeTutorialSource);
  initMetadataForObject(PaymentNotification, 'PaymentNotification', VOID, PrimeTutorialSource);
  initMetadataForClass(Guapo, 'Guapo', VOID, PrimeTutorialSource);
  initMetadataForClass(PrivacyReview, 'PrivacyReview', PrivacyReview, Screen);
  initMetadataForClass(PrivacyReviewAccepted, 'PrivacyReviewAccepted', PrivacyReviewAccepted, Event);
  initMetadataForClass(PrivacyReviewCancelled, 'PrivacyReviewCancelled', PrivacyReviewCancelled, Event);
  initMetadataForClass(ProductAdded, 'ProductAdded', VOID, Event_0);
  initMetadataForClass(ProductAddedOrigin, 'ProductAddedOrigin');
  initMetadataForClass(ProductCustomisationAddToOrder, 'ProductCustomisationAddToOrder', VOID, ProductAddedOrigin);
  initMetadataForObject(StoreMenuPlusButton, 'StoreMenuPlusButton', VOID, ProductAddedOrigin);
  initMetadataForObject(ItemDetailAddToOrder, 'ItemDetailAddToOrder', VOID, ProductAddedOrigin);
  initMetadataForObject(NewOrderPlusButton, 'NewOrderPlusButton', VOID, ProductAddedOrigin);
  initMetadataForObject(ProductUpsellPlusButton, 'ProductUpsellPlusButton', VOID, ProductAddedOrigin);
  initMetadataForObject(ProductScreenUpsellPlusButton, 'ProductScreenUpsellPlusButton', VOID, ProductAddedOrigin);
  initMetadataForObject(ProductPageUpsellingCarouselPlus, 'ProductPageUpsellingCarouselPlus', VOID, ProductAddedOrigin);
  initMetadataForObject(ProductPageUpsellingCarouselTile, 'ProductPageUpsellingCarouselTile', VOID, ProductAddedOrigin);
  initMetadataForObject(Cart_0, 'Cart', VOID, ProductAddedOrigin);
  initMetadataForObject(BasketPlusButton, 'BasketPlusButton', VOID, ProductAddedOrigin);
  initMetadataForClass(ProductAdditionalInformationClicked, 'ProductAdditionalInformationClicked', VOID, Event);
  initMetadataForClass(ProductAdditionalInformationGroupType, 'ProductAdditionalInformationGroupType', VOID, Enum);
  initMetadataForClass(ProductCustomisation, 'ProductCustomisation', VOID, Screen);
  initMetadataForClass(ProductCustomisationDismissed, 'ProductCustomisationDismissed', VOID, Event);
  initMetadataForClass(ProductCustomisationImageImpression, 'ProductCustomisationImageImpression', VOID, Event);
  initMetadataForClass(ProductCustomisationImageInteracted, 'ProductCustomisationImageInteracted', VOID, Event);
  initMetadataForClass(ProductCustomisationImageOrigin, 'ProductCustomisationImageOrigin', VOID, Enum);
  initMetadataForClass(ProductCustomisationImageZoomed, 'ProductCustomisationImageZoomed', VOID, Event);
  initMetadataForClass(ProductCustomisationItemDeselected, 'ProductCustomisationItemDeselected', VOID, Event);
  initMetadataForClass(ProductCustomisationItemSelected, 'ProductCustomisationItemSelected', VOID, Event);
  initMetadataForClass(ProductCustomizationAttributeGroupImpression, 'ProductCustomizationAttributeGroupImpression', VOID, Event);
  initMetadataForClass(ProductCustomizationOrigin, 'ProductCustomizationOrigin');
  initMetadataForObject(ProductPage, 'ProductPage', VOID, ProductCustomizationOrigin);
  initMetadataForObject(Catalogue_0, 'Catalogue', VOID, ProductCustomizationOrigin);
  initMetadataForObject(Checkout_2, 'Checkout', VOID, ProductCustomizationOrigin);
  initMetadataForObject(Search, 'Search', VOID, ProductCustomizationOrigin);
  initMetadataForClass(Widget_1, 'Widget', VOID, ProductCustomizationOrigin);
  initMetadataForObject(Cart_1, 'Cart', VOID, ProductCustomizationOrigin);
  initMetadataForObject(Basket, 'Basket', VOID, ProductCustomizationOrigin);
  initMetadataForObject(VideoPlayer_0, 'VideoPlayer', VOID, ProductCustomizationOrigin);
  initMetadataForClass(StoreWallNestedDishes_0, 'StoreWallNestedDishes', StoreWallNestedDishes_0, ProductCustomizationOrigin);
  initMetadataForObject(Other_2, 'Other', VOID, ProductCustomizationOrigin);
  initMetadataForClass(ProductImpression, 'ProductImpression', VOID, Event);
  initMetadataForClass(ProductLabelType, 'ProductLabelType', VOID, Enum);
  initMetadataForClass(ProductRemoved, 'ProductRemoved', VOID, Event_0);
  initMetadataForClass(ProductRemovedOrigin, 'ProductRemovedOrigin', VOID, Enum);
  initMetadataForClass(ProductSaleType, 'ProductSaleType', VOID, Enum);
  initMetadataForClass(ProductScreenButtonPressed, 'ProductScreenButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_93, 'Metadata');
  initMetadataForClass(ProductScreenUpsellImpression, 'ProductScreenUpsellImpression', VOID, Event);
  initMetadataForClass(ProductSearchResults, 'ProductSearchResults', VOID, Screen);
  initMetadataForClass(ProductSelected, 'ProductSelected', VOID, Event);
  initMetadataForClass(ProductSelectionOrigin, 'ProductSelectionOrigin');
  initMetadataForObject(TopSeller, 'TopSeller', VOID, ProductSelectionOrigin);
  initMetadataForClass(EasyReorder_0, 'EasyReorder', VOID, ProductSelectionOrigin);
  initMetadataForObject(SupercollectionProductsCarousel, 'SupercollectionProductsCarousel', VOID, ProductSelectionOrigin);
  initMetadataForObject(Promotions_0, 'Promotions', VOID, ProductSelectionOrigin);
  initMetadataForClass(Search_0, 'Search', VOID, ProductSelectionOrigin);
  initMetadataForObject(Catalogue_1, 'Catalogue', VOID, ProductSelectionOrigin);
  initMetadataForClass(HomeWidget_0, 'HomeWidget', VOID, ProductSelectionOrigin);
  initMetadataForObject(DoubleGlovo_0, 'DoubleGlovo', VOID, ProductSelectionOrigin);
  initMetadataForObject(InStoreBanner, 'InStoreBanner', VOID, ProductSelectionOrigin);
  initMetadataForObject(ProductPageUpsellingCarousel, 'ProductPageUpsellingCarousel', VOID, ProductSelectionOrigin);
  initMetadataForObject(Collection, 'Collection', VOID, ProductSelectionOrigin);
  initMetadataForObject(CollectionsShoppableBanner, 'CollectionsShoppableBanner', VOID, ProductSelectionOrigin);
  initMetadataForObject(CollectionGroup_0, 'CollectionGroup', VOID, ProductSelectionOrigin);
  initMetadataForObject(ShoppableBanner, 'ShoppableBanner', VOID, ProductSelectionOrigin);
  initMetadataForObject(SponsoredDeeplink, 'SponsoredDeeplink', VOID, ProductSelectionOrigin);
  initMetadataForClass(Widget_2, 'Widget', VOID, ProductSelectionOrigin);
  initMetadataForObject(Cart_2, 'Cart', VOID, ProductSelectionOrigin);
  initMetadataForObject(Basket_0, 'Basket', VOID, ProductSelectionOrigin);
  initMetadataForObject(StoreWall, 'StoreWall', VOID, ProductSelectionOrigin);
  initMetadataForClass(StoreWallNestedDishes_1, 'StoreWallNestedDishes', StoreWallNestedDishes_1, ProductSelectionOrigin);
  initMetadataForClass(SearchNestedDishes_0, 'SearchNestedDishes', VOID, ProductSelectionOrigin);
  initMetadataForClass(StoreWallMealsUnderXCollection, 'StoreWallMealsUnderXCollection', VOID, ProductSelectionOrigin);
  initMetadataForObject(Other_3, 'Other', VOID, ProductSelectionOrigin);
  initMetadataForObject(Metadata_94, 'Metadata');
  initMetadataForClass(ProductUpsellPopUpButtonPressed, 'ProductUpsellPopUpButtonPressed', VOID, Event);
  initMetadataForObject(Metadata_95, 'Metadata');
  initMetadataForClass(ProductUpsellPopUpScreen, 'ProductUpsellPopUpScreen', VOID, Screen);
  initMetadataForObject(Metadata_96, 'Metadata');
  initMetadataForClass(ProductUpsellPopUpScreenAttemptToDismiss, 'ProductUpsellPopUpScreenAttemptToDismiss', ProductUpsellPopUpScreenAttemptToDismiss, Event);
  initMetadataForObject(Metadata_97, 'Metadata');
  initMetadataForClass(ProductUpsellPopUpScreenDismissed, 'ProductUpsellPopUpScreenDismissed', ProductUpsellPopUpScreenDismissed, Event);
  initMetadataForClass(ProductUpsellPopUpScreenDismissedAction, 'ProductUpsellPopUpScreenDismissedAction', VOID, Enum);
  initMetadataForClass(ProductsSearched, 'ProductsSearched', VOID, Event);
  initMetadataForClass(Profile_1, 'Profile', Profile_1, Screen);
  initMetadataForObject(Metadata_98, 'Metadata');
  initMetadataForClass(ProfilePrimeIconClicked, 'ProfilePrimeIconClicked', VOID, Event);
  initMetadataForObject(Metadata_99, 'Metadata');
  initMetadataForClass(ProfilePrimeIconSeen, 'ProfilePrimeIconSeen', VOID, Event);
  initMetadataForClass(ProfileSection, 'ProfileSection', VOID, Enum);
  initMetadataForObject(Metadata_100, 'Metadata');
  initMetadataForClass(PromoCode, 'PromoCode', PromoCode, Screen);
  initMetadataForClass(PromotionShown, 'PromotionShown', VOID, Event);
  initMetadataForClass(PromotionSource, 'PromotionSource', VOID, Enum);
  initMetadataForClass(PromotionStoreOrigin, 'PromotionStoreOrigin', VOID, Enum);
  initMetadataForClass(PromotionType, 'PromotionType');
  initMetadataForClass(ProductDiscount, 'ProductDiscount', VOID, PromotionType);
  initMetadataForClass(DeliveryFeeDiscount, 'DeliveryFeeDiscount', VOID, PromotionType);
  initMetadataForObject(TwoForOne, 'TwoForOne', VOID, PromotionType);
  initMetadataForClass(RankingType, 'RankingType', VOID, Enum);
  initMetadataForClass(RecoveryOrigin, 'RecoveryOrigin', VOID, Enum);
  initMetadataForObject(Metadata_101, 'Metadata');
  initMetadataForClass(ReorderButtonPressed, 'ReorderButtonPressed', VOID, Event);
  initMetadataForClass(ReorderOrigin, 'ReorderOrigin', VOID, Enum);
  initMetadataForClass(ResetYourAccountStarted, 'ResetYourAccountStarted', VOID, Event);
  initMetadataForClass(ReturnPolicyBannerClicked, 'ReturnPolicyBannerClicked', VOID, Event);
  initMetadataForClass(ReturnPolicyBannerImpression, 'ReturnPolicyBannerImpression', VOID, Event);
  initMetadataForClass(ReturnPolicyOrigin, 'ReturnPolicyOrigin', VOID, Enum);
  initMetadataForClass(ReviewCollectionVersionType, 'ReviewCollectionVersionType', VOID, Enum);
  initMetadataForClass(RootContent, 'RootContent', VOID, Enum);
  initMetadataForClass(SearchAutosuggestionsShown, 'SearchAutosuggestionsShown', VOID, Event);
  initMetadataForClass(SearchOrigin, 'SearchOrigin', VOID, Enum);
  initMetadataForClass(SearchSubVertical, 'SearchSubVertical', VOID, Enum);
  initMetadataForClass(SearchSubmissionType, 'SearchSubmissionType');
  initMetadataForObject(Typed, 'Typed', VOID, SearchSubmissionType);
  initMetadataForClass(AutoSuggested, 'AutoSuggested', VOID, SearchSubmissionType);
  initMetadataForClass(RecentSearch, 'RecentSearch', VOID, SearchSubmissionType);
  initMetadataForClass(TrendingSearch, 'TrendingSearch', VOID, SearchSubmissionType);
  initMetadataForObject(Category_0, 'Category', VOID, SearchSubmissionType);
  initMetadataForObject(FilterSelected, 'FilterSelected', VOID, SearchSubmissionType);
  initMetadataForObject(SearchShowAllButton_0, 'SearchShowAllButton', VOID, SearchSubmissionType);
  initMetadataForClass(SearchType, 'SearchType');
  initMetadataForObject(Global, 'Global', VOID, SearchType);
  initMetadataForClass(CategoryGroup_1, 'CategoryGroup', VOID, SearchType);
  initMetadataForClass(Category_1, 'Category', VOID, SearchType);
  initMetadataForClass(Store_1, 'Store', VOID, SearchType);
  initMetadataForClass(StoreGroup, 'StoreGroup', VOID, SearchType);
  initMetadataForClass(FeedGroup_0, 'FeedGroup', VOID, SearchType);
  initMetadataForClass(SeenFilters, 'SeenFilters', VOID, Event);
  initMetadataForClass(SessionLocationSet, 'SessionLocationSet', SessionLocationSet, Event);
  initMetadataForClass(SignInButtonClicked, 'SignInButtonClicked', VOID, Event);
  initMetadataForClass(SignInLanding, 'SignInLanding', VOID, Screen);
  initMetadataForClass(SignInLandingOrigin, 'SignInLandingOrigin', VOID, Enum);
  initMetadataForClass(SignInSource, 'SignInSource', VOID, Enum);
  initMetadataForClass(SignUp, 'SignUp', SignUp, Screen);
  initMetadataForClass(SignUpSource, 'SignUpSource', VOID, Enum);
  initMetadataForObject(Metadata_102, 'Metadata');
  initMetadataForClass(SocialSignalsConnections, 'SocialSignalsConnections', VOID, Screen);
  initMetadataForClass(SocialSignalsSource, 'SocialSignalsSource', VOID, Enum);
  initMetadataForClass(SponsoredBubbleShown, 'SponsoredBubbleShown', VOID, Event);
  initMetadataForClass(Store_2, 'Store', VOID, Screen);
  initMetadataForClass(StoreAccessed, 'StoreAccessed', VOID, Event);
  initMetadataForClass(StoreAccessedOperation, 'StoreAccessedOperation');
  initMetadataForClass(Search_1, 'Search', VOID, StoreAccessedOperation);
  initMetadataForClass(Filters_1, 'Filters', Filters_1, StoreAccessedOperation);
  initMetadataForClass(StoreAccessedOrigin, 'StoreAccessedOrigin');
  initMetadataForClass(Category_2, 'Category', VOID, StoreAccessedOrigin);
  initMetadataForClass(CategoryGroup_2, 'CategoryGroup', VOID, StoreAccessedOrigin);
  initMetadataForObject(Checkout_3, 'Checkout', VOID, StoreAccessedOrigin);
  initMetadataForClass(FeedGroup_1, 'FeedGroup', VOID, StoreAccessedOrigin);
  initMetadataForClass(FeedGroupResults_0, 'FeedGroupResults', VOID, StoreAccessedOrigin);
  initMetadataForClass(HomeWidget_1, 'HomeWidget', VOID, StoreAccessedOrigin);
  initMetadataForClass(HomeWidgetResults_0, 'HomeWidgetResults', VOID, StoreAccessedOrigin);
  initMetadataForObject(HomeSearchBarResults_0, 'HomeSearchBarResults', VOID, StoreAccessedOrigin);
  initMetadataForClass(Story_1, 'Story', VOID, StoreAccessedOrigin);
  initMetadataForClass(SearchWidget, 'SearchWidget', VOID, StoreAccessedOrigin);
  initMetadataForObject(Deeplink_2, 'Deeplink', VOID, StoreAccessedOrigin);
  initMetadataForObject(Direct_0, 'Direct', VOID, StoreAccessedOrigin);
  initMetadataForObject(Other_4, 'Other', VOID, StoreAccessedOrigin);
  initMetadataForClass(StoreCarouselType, 'StoreCarouselType', VOID, Enum);
  initMetadataForClass(StoreFunnel, 'StoreFunnel', VOID, Screen);
  initMetadataForClass(StoreFunnelLayout, 'StoreFunnelLayout');
  initMetadataForClass(CollectionGroups, 'CollectionGroups', VOID, StoreFunnelLayout);
  initMetadataForClass(Collections, 'Collections', VOID, StoreFunnelLayout);
  initMetadataForClass(Products, 'Products', VOID, StoreFunnelLayout);
  initMetadataForObject(ProductsTopSellers, 'ProductsTopSellers', VOID, StoreFunnelLayout);
  initMetadataForObject(ProductsEasyReorder, 'ProductsEasyReorder', VOID, StoreFunnelLayout);
  initMetadataForObject(NoMenu, 'NoMenu', VOID, StoreFunnelLayout);
  initMetadataForClass(StoreFunnelOrigin, 'StoreFunnelOrigin', VOID, Enum);
  initMetadataForClass(StoreHomeMosaicImpression, 'StoreHomeMosaicImpression', VOID, Event);
  initMetadataForClass(StoreImpression, 'StoreImpression', VOID, Event);
  initMetadataForObject(Metadata_103, 'Metadata');
  initMetadataForClass(StoreInfoButtonClicked, 'StoreInfoButtonClicked', StoreInfoButtonClicked, Event);
  initMetadataForObject(Metadata_104, 'Metadata');
  initMetadataForClass(StoreInfoScreen, 'StoreInfoScreen', VOID, Screen);
  initMetadataForClass(StoreLeft, 'StoreLeft', VOID, Event);
  initMetadataForClass(StoreMobileNavigationBarImpression, 'StoreMobileNavigationBarImpression', StoreMobileNavigationBarImpression, Event);
  initMetadataForClass(Stores, 'Stores', VOID, Screen);
  initMetadataForClass(StoresOrigin, 'StoresOrigin');
  initMetadataForObject(HomeSearchBar, 'HomeSearchBar', VOID, StoresOrigin);
  initMetadataForClass(Category_3, 'Category', VOID, StoresOrigin);
  initMetadataForClass(CategoryGroup_3, 'CategoryGroup', VOID, StoresOrigin);
  initMetadataForClass(FeedGroup_2, 'FeedGroup', VOID, StoresOrigin);
  initMetadataForObject(Deeplink_3, 'Deeplink', VOID, StoresOrigin);
  initMetadataForObject(Story_2, 'Story', VOID, StoresOrigin);
  initMetadataForClass(HomeWidget_2, 'HomeWidget', VOID, StoresOrigin);
  initMetadataForClass(HomeWidgetResults_1, 'HomeWidgetResults', VOID, StoresOrigin);
  initMetadataForClass(SearchWidget_0, 'SearchWidget', VOID, StoresOrigin);
  initMetadataForObject(Other_5, 'Other', VOID, StoresOrigin);
  initMetadataForClass(SurgeBannerShown, 'SurgeBannerShown', VOID, Event);
  initMetadataForClass(TellUsYourName, 'TellUsYourName', TellUsYourName, Screen);
  initMetadataForClass(ThreeDS2AuthenticationFailed, 'ThreeDS2AuthenticationFailed', VOID, Event);
  initMetadataForClass(TokenizedAPMStatus, 'TokenizedAPMStatus', VOID, Enum);
  initMetadataForObject(Metadata_105, 'Metadata');
  initMetadataForClass(TooFarToDeliverScreenDissmissed, 'TooFarToDeliverScreenDissmissed', VOID, Event);
  initMetadataForObject(Metadata_106, 'Metadata');
  initMetadataForClass(TooFarToDeliverScreenShown, 'TooFarToDeliverScreenShown', VOID, Screen);
  initMetadataForObject(Metadata_107, 'Metadata');
  initMetadataForClass(UseCurrentLocationPressed, 'UseCurrentLocationPressed', UseCurrentLocationPressed, Event);
  initMetadataForClass(UseCurrentLocationSource, 'UseCurrentLocationSource', VOID, Enum);
  initMetadataForClass(UserLoggedIn, 'UserLoggedIn', VOID, Event);
  initMetadataForClass(UserRegistrationType, 'UserRegistrationType', VOID, Enum);
  initMetadataForClass(UserSignedUp, 'UserSignedUp', VOID, Event);
  initMetadataForClass(WebSearchType, 'WebSearchType');
  initMetadataForClass(All, 'All', VOID, WebSearchType);
  initMetadataForClass(Products_0, 'Products', VOID, WebSearchType);
  initMetadataForClass(Stores_0, 'Stores', VOID, WebSearchType);
  initMetadataForClass(WidgetContentImpression, 'WidgetContentImpression', VOID, Event);
  initMetadataForClass(WidgetContentImpressionType, 'WidgetContentImpressionType');
  initMetadataForClass(Store_3, 'Store', Store_3, WidgetContentImpressionType);
  initMetadataForClass(Product, 'Product', Product, WidgetContentImpressionType);
  initMetadataForObject(Other_6, 'Other', VOID, WidgetContentImpressionType);
  initMetadataForClass(WidgetElementsShown, 'WidgetElementsShown');
  initMetadataForClass(Stores_1, 'Stores', VOID, WidgetElementsShown);
  initMetadataForClass(Products_1, 'Products', VOID, WidgetElementsShown);
  initMetadataForClass(Videos, 'Videos', VOID, WidgetElementsShown);
  initMetadataForClass(Playlists, 'Playlists', VOID, WidgetElementsShown);
  initMetadataForClass(WidgetFilterDisplayed, 'WidgetFilterDisplayed', VOID, Event);
  initMetadataForClass(WidgetImpression, 'WidgetImpression', VOID, Event);
  initMetadataForClass(WidgetInteracted, 'WidgetInteracted', VOID, Event);
  initMetadataForClass(WidgetInteractionType, 'WidgetInteractionType');
  initMetadataForObject(CtaSelected_0, 'CtaSelected', VOID, WidgetInteractionType);
  initMetadataForClass(StoreSelected_0, 'StoreSelected', VOID, WidgetInteractionType);
  initMetadataForClass(ProductSelected_0, 'ProductSelected', VOID, WidgetInteractionType);
  initMetadataForClass(VideoSelected, 'VideoSelected', VOID, WidgetInteractionType);
  initMetadataForObject(Other_7, 'Other', VOID, WidgetInteractionType);
  initMetadataForClass(PlaylistSelected, 'PlaylistSelected', VOID, WidgetInteractionType);
  initMetadataForClass(WidgetLayout, 'WidgetLayout');
  initMetadataForObject(StoreCardCarousel, 'StoreCardCarousel', VOID, WidgetLayout);
  initMetadataForObject(ProductCarousel, 'ProductCarousel', VOID, WidgetLayout);
  initMetadataForObject(StoreLogoCarousel, 'StoreLogoCarousel', VOID, WidgetLayout);
  initMetadataForObject(VideoCarousel, 'VideoCarousel', VOID, WidgetLayout);
  initMetadataForClass(StoreLogoGrid, 'StoreLogoGrid', VOID, WidgetLayout);
  initMetadataForClass(ProductGrid, 'ProductGrid', VOID, WidgetLayout);
  initMetadataForObject(PlaylistCarousel, 'PlaylistCarousel', VOID, WidgetLayout);
  initMetadataForClass(WidgetLoaded, 'WidgetLoaded', VOID, Event);
  initMetadataForClass(WidgetStoreImpression, 'WidgetStoreImpression', VOID, Event);
  initMetadataForClass(WidgetsLoaded, 'WidgetsLoaded', VOID, Event);
  initMetadataForClass(WrongCredentials, 'WrongCredentials', WrongCredentials, Event);
  initMetadataForClass(Account, 'Account', VOID, Screen);
  initMetadataForClass(AccountSectionTapped, 'AccountSectionTapped', VOID, Event);
  initMetadataForObject(Metadata_108, 'Metadata');
  initMetadataForClass(AddDeliveryAddressOnStorePage, 'AddDeliveryAddressOnStorePage', VOID, Event);
  initMetadataForObject(Metadata_109, 'Metadata');
  initMetadataForClass(AddressCreationOnStorePage, 'AddressCreationOnStorePage', VOID, Screen);
  initMetadataForObject(Metadata_110, 'Metadata');
  initMetadataForClass(AddressOutsideStoreDeliveryZoneScreen, 'AddressOutsideStoreDeliveryZoneScreen', AddressOutsideStoreDeliveryZoneScreen, Screen);
  initMetadataForClass(AvailableButtons, 'AvailableButtons', VOID, Enum);
  initMetadataForObject(Metadata_111, 'Metadata');
  initMetadataForClass(CartScreen, 'CartScreen', VOID, Event);
  initMetadataForClass(DownloadPressed, 'DownloadPressed', VOID, Event);
  initMetadataForClass(DownloadPressedSource, 'DownloadPressedSource', VOID, Enum);
  initMetadataForObject(Metadata_112, 'Metadata');
  initMetadataForClass(FilterPromotionsCarouselShown, 'FilterPromotionsCarouselShown', VOID, Event);
  initMetadataForObject(Metadata_113, 'Metadata');
  initMetadataForClass(FreeDeliveryBanner, 'FreeDeliveryBanner', VOID, Event);
  initMetadataForObject(Metadata_114, 'Metadata');
  initMetadataForClass(GetStartedButton, 'GetStartedButton', VOID, Event);
  initMetadataForClass(GetStartedButtonSource, 'GetStartedButtonSource', VOID, Enum);
  initMetadataForClass(GoogleOneTapDisplayed, 'GoogleOneTapDisplayed', GoogleOneTapDisplayed, Event);
  initMetadataForClass(GoogleOneTapSkipped, 'GoogleOneTapSkipped', VOID, Event);
  initMetadataForClass(GoogleOneTapSkippedReason, 'GoogleOneTapSkippedReason', VOID, Enum);
  initMetadataForClass(HomeCountry, 'HomeCountry', VOID, Screen);
  initMetadataForClass(HomeGlobal, 'HomeGlobal', HomeGlobal, Screen);
  initMetadataForObject(Metadata_115, 'Metadata');
  initMetadataForClass(LogInError, 'LogInError', VOID, Event);
  initMetadataForClass(LogOutAttempted, 'LogOutAttempted', VOID, Event);
  initMetadataForClass(OsPicked, 'OsPicked', VOID, Enum);
  initMetadataForObject(Metadata_116, 'Metadata');
  initMetadataForClass(OutOfDeliveryZonePopUpClosed, 'OutOfDeliveryZonePopUpClosed', OutOfDeliveryZonePopUpClosed, Event);
  initMetadataForObject(Metadata_117, 'Metadata');
  initMetadataForClass(OutOfDeliveryZonePopUpShown, 'OutOfDeliveryZonePopUpShown', OutOfDeliveryZonePopUpShown, Screen);
  initMetadataForClass(OutsideStoreDeliveryZoneReason, 'OutsideStoreDeliveryZoneReason', VOID, Enum);
  initMetadataForObject(Metadata_118, 'Metadata');
  initMetadataForClass(ParcelInformationEdit, 'ParcelInformationEdit', VOID, Event);
  initMetadataForObject(Metadata_119, 'Metadata');
  initMetadataForClass(PrimeLandingPageInteracted, 'PrimeLandingPageInteracted', VOID, Event);
  initMetadataForClass(PrimeLandingPageInteractionType, 'PrimeLandingPageInteractionType', VOID, Enum);
  initMetadataForObject(Metadata_120, 'Metadata');
  initMetadataForClass(PrimeLandingPageScreen, 'PrimeLandingPageScreen', PrimeLandingPageScreen, Screen);
  initMetadataForObject(Metadata_121, 'Metadata');
  initMetadataForClass(ProfileSectionTapped, 'ProfileSectionTapped', VOID, Event);
  initMetadataForObject(Metadata_122, 'Metadata');
  initMetadataForClass(PromotionsCarouselClicked, 'PromotionsCarouselClicked', VOID, Event);
  initMetadataForObject(Metadata_123, 'Metadata');
  initMetadataForClass(PromotionsPageLanding, 'PromotionsPageLanding', PromotionsPageLanding, Screen);
  initMetadataForObject(Metadata_124, 'Metadata');
  initMetadataForClass(ReorderCarouselImpression, 'ReorderCarouselImpression', VOID, Event);
  initMetadataForObject(Metadata_125, 'Metadata');
  initMetadataForClass(ResetPassword, 'ResetPassword', ResetPassword, Event);
  initMetadataForObject(Metadata_126, 'Metadata');
  initMetadataForClass(ResetPasswordError, 'ResetPasswordError', VOID, Event);
  initMetadataForObject(Metadata_127, 'Metadata');
  initMetadataForClass(ScheduleButton, 'ScheduleButton', VOID, Event);
  initMetadataForObject(Metadata_128, 'Metadata');
  initMetadataForClass(ShowMorePromotionsArrowButtonOnStorePageClicked, 'ShowMorePromotionsArrowButtonOnStorePageClicked', VOID, Event);
  initMetadataForClass(SideDrawerCategoryClick, 'SideDrawerCategoryClick', VOID, Event);
  initMetadataForClass(SideDrawerClick, 'SideDrawerClick', VOID, Event);
  initMetadataForClass(SideDrawerImpression, 'SideDrawerImpression', VOID, Event);
  initMetadataForClass(SideDrawerOrigin, 'SideDrawerOrigin', VOID, Enum);
  initMetadataForObject(Metadata_129, 'Metadata');
  initMetadataForClass(SignUpError, 'SignUpError', VOID, Event);
  initMetadataForObject(Metadata_130, 'Metadata');
  initMetadataForClass(SignatureConfirmationClicked, 'SignatureConfirmationClicked', VOID, Event);
  initMetadataForObject(Metadata_131, 'Metadata');
  initMetadataForClass(SignaturePageOpened, 'SignaturePageOpened', VOID, Event);
  initMetadataForClass(SocialFeatureAddContactsClicked, 'SocialFeatureAddContactsClicked', SocialFeatureAddContactsClicked, Event);
  initMetadataForClass(SocialFeatureStartSurveyClicked, 'SocialFeatureStartSurveyClicked', SocialFeatureStartSurveyClicked, Event);
  initMetadataForObject(Metadata_132, 'Metadata');
  initMetadataForClass(TrackYourParcelSearch, 'TrackYourParcelSearch', TrackYourParcelSearch, Event);
  initMetadataForClass(WebToAppBannerType, 'WebToAppBannerType', VOID, Enum);
  initMetadataForClass(WebToAppClicked, 'WebToAppClicked', VOID, Event);
  initMetadataForClass(WebToAppDismiss, 'WebToAppDismiss', VOID, Event);
  initMetadataForClass(WebToAppImpression, 'WebToAppImpression', VOID, Event);
  initMetadataForObject(Metadata_133, 'Metadata');
  initMetadataForClass(exploreStoresFromClosedStore, 'exploreStoresFromClosedStore', VOID, Event);
  initMetadataForClass(homeCountrySource, 'homeCountrySource', VOID, Enum);
  //endregion
  var ActiveFeatures_TopSellers_instance;
  var ActiveFeatures_EasyReorder_instance;
  var ActiveFeatures_PickupToggle_instance;
  var ActiveFeatures_MenuTranslation_instance;
  var ActiveFeatures_MbsProgressBar_instance;
  var ActiveFeatures_PrimePromotions_instance;
  function values() {
    return [ActiveFeatures_TopSellers_getInstance(), ActiveFeatures_EasyReorder_getInstance(), ActiveFeatures_PickupToggle_getInstance(), ActiveFeatures_MenuTranslation_getInstance(), ActiveFeatures_MbsProgressBar_getInstance(), ActiveFeatures_PrimePromotions_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'TopSellers':
        return ActiveFeatures_TopSellers_getInstance();
      case 'EasyReorder':
        return ActiveFeatures_EasyReorder_getInstance();
      case 'PickupToggle':
        return ActiveFeatures_PickupToggle_getInstance();
      case 'MenuTranslation':
        return ActiveFeatures_MenuTranslation_getInstance();
      case 'MbsProgressBar':
        return ActiveFeatures_MbsProgressBar_getInstance();
      case 'PrimePromotions':
        return ActiveFeatures_PrimePromotions_getInstance();
      default:
        ActiveFeatures_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ActiveFeatures_entriesInitialized;
  function ActiveFeatures_initEntries() {
    if (ActiveFeatures_entriesInitialized)
      return Unit_instance;
    ActiveFeatures_entriesInitialized = true;
    ActiveFeatures_TopSellers_instance = new ActiveFeatures('TopSellers', 0, 'Top Sellers');
    ActiveFeatures_EasyReorder_instance = new ActiveFeatures('EasyReorder', 1, 'Easy Reorder');
    ActiveFeatures_PickupToggle_instance = new ActiveFeatures('PickupToggle', 2, 'Pickup Toggle');
    ActiveFeatures_MenuTranslation_instance = new ActiveFeatures('MenuTranslation', 3, 'Menu Translation');
    ActiveFeatures_MbsProgressBar_instance = new ActiveFeatures('MbsProgressBar', 4, 'Mbs Progress Bar');
    ActiveFeatures_PrimePromotions_instance = new ActiveFeatures('PrimePromotions', 5, 'Prime Promotions');
  }
  function ActiveFeatures(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ActiveFeatures).r = function () {
    return this.value;
  };
  function ActiveFeatures_TopSellers_getInstance() {
    ActiveFeatures_initEntries();
    return ActiveFeatures_TopSellers_instance;
  }
  function ActiveFeatures_EasyReorder_getInstance() {
    ActiveFeatures_initEntries();
    return ActiveFeatures_EasyReorder_instance;
  }
  function ActiveFeatures_PickupToggle_getInstance() {
    ActiveFeatures_initEntries();
    return ActiveFeatures_PickupToggle_instance;
  }
  function ActiveFeatures_MenuTranslation_getInstance() {
    ActiveFeatures_initEntries();
    return ActiveFeatures_MenuTranslation_instance;
  }
  function ActiveFeatures_MbsProgressBar_getInstance() {
    ActiveFeatures_initEntries();
    return ActiveFeatures_MbsProgressBar_instance;
  }
  function ActiveFeatures_PrimePromotions_getInstance() {
    ActiveFeatures_initEntries();
    return ActiveFeatures_PrimePromotions_instance;
  }
  function Metadata() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance;
  function Metadata_getInstance() {
    return Metadata_instance;
  }
  function AddTokenizedAPMStatus(apmName, status, statusMessage) {
    statusMessage = statusMessage === VOID ? null : statusMessage;
    var tmp = to('apmName', apmName == null ? null : get_value(apmName));
    var tmp_0 = to('status', status == null ? null : status.value);
    Event.call(this, 'Add Tokenized APM Status', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('statusMessage', statusMessage == null ? null : get_value(statusMessage))]));
  }
  function Metadata_0() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_0).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_0;
  function Metadata_getInstance_0() {
    return Metadata_instance_0;
  }
  function AddressBottomSheet(isGpsEnabled, screen) {
    isGpsEnabled = isGpsEnabled === VOID ? null : isGpsEnabled;
    screen = screen === VOID ? null : screen;
    var tmp = to('isGpsEnabled', isGpsEnabled == null ? null : get_value_0(isGpsEnabled));
    Event.call(this, 'Address Bottom Sheet', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, to('screen', screen == null ? null : get_value(screen))]));
  }
  function Metadata_1() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_1).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_1;
  function Metadata_getInstance_1() {
    return Metadata_instance_1;
  }
  function AddressBottomSheetAction(action, numberOfSavedAddresses, savedAddressPositionClick, isSavedAddressWithMissingDetails) {
    action = action === VOID ? null : action;
    savedAddressPositionClick = savedAddressPositionClick === VOID ? null : savedAddressPositionClick;
    isSavedAddressWithMissingDetails = isSavedAddressWithMissingDetails === VOID ? null : isSavedAddressWithMissingDetails;
    var tmp = to('action', action == null ? null : action.value);
    var tmp_0 = to('numberOfSavedAddresses', numberOfSavedAddresses == null ? null : get_value_1(numberOfSavedAddresses));
    var tmp_1 = to('savedAddressPositionClick', savedAddressPositionClick == null ? null : get_value_1(savedAddressPositionClick));
    Event.call(this, 'Address Bottom Sheet Action', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, tmp_1, to('isSavedAddressWithMissingDetails', isSavedAddressWithMissingDetails == null ? null : get_value_0(isSavedAddressWithMissingDetails))]));
  }
  var AddressBottomSheetActionType_Dismissed_instance;
  var AddressBottomSheetActionType_CurrentLocation_instance;
  var AddressBottomSheetActionType_SavedAddress_instance;
  var AddressBottomSheetActionType_EditSavedAddress_instance;
  var AddressBottomSheetActionType_AddAddress_instance;
  function values_0() {
    return [AddressBottomSheetActionType_Dismissed_getInstance(), AddressBottomSheetActionType_CurrentLocation_getInstance(), AddressBottomSheetActionType_SavedAddress_getInstance(), AddressBottomSheetActionType_EditSavedAddress_getInstance(), AddressBottomSheetActionType_AddAddress_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'Dismissed':
        return AddressBottomSheetActionType_Dismissed_getInstance();
      case 'CurrentLocation':
        return AddressBottomSheetActionType_CurrentLocation_getInstance();
      case 'SavedAddress':
        return AddressBottomSheetActionType_SavedAddress_getInstance();
      case 'EditSavedAddress':
        return AddressBottomSheetActionType_EditSavedAddress_getInstance();
      case 'AddAddress':
        return AddressBottomSheetActionType_AddAddress_getInstance();
      default:
        AddressBottomSheetActionType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressBottomSheetActionType_entriesInitialized;
  function AddressBottomSheetActionType_initEntries() {
    if (AddressBottomSheetActionType_entriesInitialized)
      return Unit_instance;
    AddressBottomSheetActionType_entriesInitialized = true;
    AddressBottomSheetActionType_Dismissed_instance = new AddressBottomSheetActionType('Dismissed', 0, 'Dismissed');
    AddressBottomSheetActionType_CurrentLocation_instance = new AddressBottomSheetActionType('CurrentLocation', 1, 'Current location');
    AddressBottomSheetActionType_SavedAddress_instance = new AddressBottomSheetActionType('SavedAddress', 2, 'Saved address');
    AddressBottomSheetActionType_EditSavedAddress_instance = new AddressBottomSheetActionType('EditSavedAddress', 3, 'Edit Saved address');
    AddressBottomSheetActionType_AddAddress_instance = new AddressBottomSheetActionType('AddAddress', 4, 'Add address');
  }
  function AddressBottomSheetActionType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressBottomSheetActionType).r = function () {
    return this.value;
  };
  function AddressBottomSheetActionType_Dismissed_getInstance() {
    AddressBottomSheetActionType_initEntries();
    return AddressBottomSheetActionType_Dismissed_instance;
  }
  function AddressBottomSheetActionType_CurrentLocation_getInstance() {
    AddressBottomSheetActionType_initEntries();
    return AddressBottomSheetActionType_CurrentLocation_instance;
  }
  function AddressBottomSheetActionType_SavedAddress_getInstance() {
    AddressBottomSheetActionType_initEntries();
    return AddressBottomSheetActionType_SavedAddress_instance;
  }
  function AddressBottomSheetActionType_EditSavedAddress_getInstance() {
    AddressBottomSheetActionType_initEntries();
    return AddressBottomSheetActionType_EditSavedAddress_instance;
  }
  function AddressBottomSheetActionType_AddAddress_getInstance() {
    AddressBottomSheetActionType_initEntries();
    return AddressBottomSheetActionType_AddAddress_instance;
  }
  function Metadata_2() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_2).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_2;
  function Metadata_getInstance_2() {
    return Metadata_instance_2;
  }
  function AddressCheck(coordinatesLatitude, coordinatesLongitude, addressStatusSuccessful, checkType, query, generatedAddress) {
    query = query === VOID ? null : query;
    generatedAddress = generatedAddress === VOID ? null : generatedAddress;
    var tmp = to('coordinatesLatitude', coordinatesLatitude == null ? null : get_value_1(coordinatesLatitude));
    var tmp_0 = to('coordinatesLongitude', coordinatesLongitude == null ? null : get_value_1(coordinatesLongitude));
    var tmp_1 = to('addressStatusSuccessful', addressStatusSuccessful == null ? null : get_value_0(addressStatusSuccessful));
    var tmp_2 = to('checkType', checkType == null ? null : checkType.value);
    var tmp_3 = to('query', query == null ? null : get_value(query));
    Event.call(this, 'Address Check', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('generatedAddress', generatedAddress == null ? null : get_value(generatedAddress))]));
  }
  var AddressCheckType_Search_instance;
  var AddressCheckType_Map_instance;
  function values_1() {
    return [AddressCheckType_Search_getInstance(), AddressCheckType_Map_getInstance()];
  }
  function valueOf_1(value) {
    switch (value) {
      case 'Search':
        return AddressCheckType_Search_getInstance();
      case 'Map':
        return AddressCheckType_Map_getInstance();
      default:
        AddressCheckType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressCheckType_entriesInitialized;
  function AddressCheckType_initEntries() {
    if (AddressCheckType_entriesInitialized)
      return Unit_instance;
    AddressCheckType_entriesInitialized = true;
    AddressCheckType_Search_instance = new AddressCheckType('Search', 0, 'Search');
    AddressCheckType_Map_instance = new AddressCheckType('Map', 1, 'Map');
  }
  function AddressCheckType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressCheckType).r = function () {
    return this.value;
  };
  function AddressCheckType_Search_getInstance() {
    AddressCheckType_initEntries();
    return AddressCheckType_Search_instance;
  }
  function AddressCheckType_Map_getInstance() {
    AddressCheckType_initEntries();
    return AddressCheckType_Map_instance;
  }
  function Metadata_3() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_3).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_3;
  function Metadata_getInstance_3() {
    return Metadata_instance_3;
  }
  function AddressCreationSucceeded(addressType, source, historicAddress, mapUsed, addressNotes, isGpsEnabled, isAddressRefined, coordinatesLatitude, coordinatesLongitude, addressLine, entrySource, addressSource, addressId, isStreetNameMissing, isStreetNumberMissing, isFloorMissing, isDoorMissing, isAdditionalInformationMissing, addressLabel, addressKind) {
    addressType = addressType === VOID ? null : addressType;
    source = source === VOID ? null : source;
    historicAddress = historicAddress === VOID ? null : historicAddress;
    mapUsed = mapUsed === VOID ? null : mapUsed;
    addressNotes = addressNotes === VOID ? null : addressNotes;
    isGpsEnabled = isGpsEnabled === VOID ? null : isGpsEnabled;
    isAddressRefined = isAddressRefined === VOID ? null : isAddressRefined;
    coordinatesLatitude = coordinatesLatitude === VOID ? null : coordinatesLatitude;
    coordinatesLongitude = coordinatesLongitude === VOID ? null : coordinatesLongitude;
    addressLine = addressLine === VOID ? null : addressLine;
    entrySource = entrySource === VOID ? null : entrySource;
    addressSource = addressSource === VOID ? null : addressSource;
    addressId = addressId === VOID ? null : addressId;
    isStreetNameMissing = isStreetNameMissing === VOID ? null : isStreetNameMissing;
    isStreetNumberMissing = isStreetNumberMissing === VOID ? null : isStreetNumberMissing;
    isFloorMissing = isFloorMissing === VOID ? null : isFloorMissing;
    isDoorMissing = isDoorMissing === VOID ? null : isDoorMissing;
    isAdditionalInformationMissing = isAdditionalInformationMissing === VOID ? null : isAdditionalInformationMissing;
    addressLabel = addressLabel === VOID ? null : addressLabel;
    addressKind = addressKind === VOID ? null : addressKind;
    var tmp = to('addressType', addressType == null ? null : addressType.value);
    var tmp_0 = to('source', source == null ? null : source.value);
    var tmp_1 = to('historicAddress', historicAddress == null ? null : get_value_0(historicAddress));
    var tmp_2 = to('mapUsed', mapUsed == null ? null : get_value_0(mapUsed));
    var tmp_3 = to('addressNotes', addressNotes == null ? null : get_value(addressNotes));
    var tmp_4 = to('isGpsEnabled', isGpsEnabled == null ? null : get_value_0(isGpsEnabled));
    var tmp_5 = to('isAddressRefined', isAddressRefined == null ? null : get_value_0(isAddressRefined));
    var tmp_6 = to('coordinatesLatitude', coordinatesLatitude == null ? null : get_value_1(coordinatesLatitude));
    var tmp_7 = to('coordinatesLongitude', coordinatesLongitude == null ? null : get_value_1(coordinatesLongitude));
    var tmp_8 = to('addressLine', addressLine == null ? null : get_value(addressLine));
    var tmp_9 = to('entrySource', entrySource == null ? null : entrySource.value);
    var tmp_10 = to('addressSource', addressSource == null ? null : addressSource.value);
    var tmp_11 = to('addressId', addressId == null ? null : get_value_1(addressId));
    var tmp_12 = to('isStreetNameMissing', isStreetNameMissing == null ? null : get_value_0(isStreetNameMissing));
    var tmp_13 = to('isStreetNumberMissing', isStreetNumberMissing == null ? null : get_value_0(isStreetNumberMissing));
    var tmp_14 = to('isFloorMissing', isFloorMissing == null ? null : get_value_0(isFloorMissing));
    var tmp_15 = to('isDoorMissing', isDoorMissing == null ? null : get_value_0(isDoorMissing));
    var tmp_16 = to('isAdditionalInformationMissing', isAdditionalInformationMissing == null ? null : get_value_0(isAdditionalInformationMissing));
    var tmp_17 = to('addressLabel', addressLabel == null ? null : get_value(addressLabel));
    Event.call(this, 'Address Creation Succeeded', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, to('addressKind', addressKind == null ? null : get_value(addressKind))]));
  }
  function Metadata_4() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_4).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_4;
  function Metadata_getInstance_4() {
    return Metadata_instance_4;
  }
  function AddressDetails(addressDetailsSource, addressKind, isAddressFaulty, addressLine, coordinatesLatitude, coordinatesLongitude) {
    var tmp = to('addressDetailsSource', addressDetailsSource == null ? null : addressDetailsSource.value);
    var tmp_0 = to('addressKind', addressKind == null ? null : get_value(addressKind));
    var tmp_1 = to('isAddressFaulty', isAddressFaulty == null ? null : get_value_0(isAddressFaulty));
    var tmp_2 = to('addressLine', addressLine == null ? null : get_value(addressLine));
    var tmp_3 = to('coordinatesLatitude', coordinatesLatitude == null ? null : get_value_1(coordinatesLatitude));
    Screen.call(this, 'Address Details', 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('coordinatesLongitude', coordinatesLongitude == null ? null : get_value_1(coordinatesLongitude))]));
  }
  var AddressDetailsSource_SavedAddressEdit_instance;
  var AddressDetailsSource_DraftEdit_instance;
  var AddressDetailsSource_PinOnMap_instance;
  var AddressDetailsSource_Search_instance;
  var AddressDetailsSource_UnsavedCurrentLocation_instance;
  function values_2() {
    return [AddressDetailsSource_SavedAddressEdit_getInstance(), AddressDetailsSource_DraftEdit_getInstance(), AddressDetailsSource_PinOnMap_getInstance(), AddressDetailsSource_Search_getInstance(), AddressDetailsSource_UnsavedCurrentLocation_getInstance()];
  }
  function valueOf_2(value) {
    switch (value) {
      case 'SavedAddressEdit':
        return AddressDetailsSource_SavedAddressEdit_getInstance();
      case 'DraftEdit':
        return AddressDetailsSource_DraftEdit_getInstance();
      case 'PinOnMap':
        return AddressDetailsSource_PinOnMap_getInstance();
      case 'Search':
        return AddressDetailsSource_Search_getInstance();
      case 'UnsavedCurrentLocation':
        return AddressDetailsSource_UnsavedCurrentLocation_getInstance();
      default:
        AddressDetailsSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressDetailsSource_entriesInitialized;
  function AddressDetailsSource_initEntries() {
    if (AddressDetailsSource_entriesInitialized)
      return Unit_instance;
    AddressDetailsSource_entriesInitialized = true;
    AddressDetailsSource_SavedAddressEdit_instance = new AddressDetailsSource('SavedAddressEdit', 0, 'Saved address Edit');
    AddressDetailsSource_DraftEdit_instance = new AddressDetailsSource('DraftEdit', 1, 'Draft Edit');
    AddressDetailsSource_PinOnMap_instance = new AddressDetailsSource('PinOnMap', 2, 'Pin On Map');
    AddressDetailsSource_Search_instance = new AddressDetailsSource('Search', 3, 'Search');
    AddressDetailsSource_UnsavedCurrentLocation_instance = new AddressDetailsSource('UnsavedCurrentLocation', 4, 'Unsaved Current Location');
  }
  function AddressDetailsSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressDetailsSource).r = function () {
    return this.value;
  };
  function AddressDetailsSource_SavedAddressEdit_getInstance() {
    AddressDetailsSource_initEntries();
    return AddressDetailsSource_SavedAddressEdit_instance;
  }
  function AddressDetailsSource_DraftEdit_getInstance() {
    AddressDetailsSource_initEntries();
    return AddressDetailsSource_DraftEdit_instance;
  }
  function AddressDetailsSource_PinOnMap_getInstance() {
    AddressDetailsSource_initEntries();
    return AddressDetailsSource_PinOnMap_instance;
  }
  function AddressDetailsSource_Search_getInstance() {
    AddressDetailsSource_initEntries();
    return AddressDetailsSource_Search_instance;
  }
  function AddressDetailsSource_UnsavedCurrentLocation_getInstance() {
    AddressDetailsSource_initEntries();
    return AddressDetailsSource_UnsavedCurrentLocation_instance;
  }
  function Metadata_5() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_5).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_5;
  function Metadata_getInstance_5() {
    return Metadata_instance_5;
  }
  function AddressFlowLandingScreen(source, isGpsEnabled, categoryId) {
    isGpsEnabled = isGpsEnabled === VOID ? true : isGpsEnabled;
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('source', source == null ? null : source.value);
    var tmp_0 = to('isGpsEnabled', isGpsEnabled == null ? null : get_value_0(isGpsEnabled));
    Screen.call(this, 'Address Flow Landing Screen', 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  var AddressLandingOption_PinOnMap_instance;
  var AddressLandingOption_SavedAddress_instance;
  var AddressLandingOption_DraftAddress_instance;
  var AddressLandingOption_CurrentLocation_instance;
  var AddressLandingOption_NewAddress_instance;
  var AddressLandingOption_Dismiss_instance;
  function values_3() {
    return [AddressLandingOption_PinOnMap_getInstance(), AddressLandingOption_SavedAddress_getInstance(), AddressLandingOption_DraftAddress_getInstance(), AddressLandingOption_CurrentLocation_getInstance(), AddressLandingOption_NewAddress_getInstance(), AddressLandingOption_Dismiss_getInstance()];
  }
  function valueOf_3(value) {
    switch (value) {
      case 'PinOnMap':
        return AddressLandingOption_PinOnMap_getInstance();
      case 'SavedAddress':
        return AddressLandingOption_SavedAddress_getInstance();
      case 'DraftAddress':
        return AddressLandingOption_DraftAddress_getInstance();
      case 'CurrentLocation':
        return AddressLandingOption_CurrentLocation_getInstance();
      case 'NewAddress':
        return AddressLandingOption_NewAddress_getInstance();
      case 'Dismiss':
        return AddressLandingOption_Dismiss_getInstance();
      default:
        AddressLandingOption_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressLandingOption_entriesInitialized;
  function AddressLandingOption_initEntries() {
    if (AddressLandingOption_entriesInitialized)
      return Unit_instance;
    AddressLandingOption_entriesInitialized = true;
    AddressLandingOption_PinOnMap_instance = new AddressLandingOption('PinOnMap', 0, 'Pin On Map');
    AddressLandingOption_SavedAddress_instance = new AddressLandingOption('SavedAddress', 1, 'Saved Address');
    AddressLandingOption_DraftAddress_instance = new AddressLandingOption('DraftAddress', 2, 'Draft Address');
    AddressLandingOption_CurrentLocation_instance = new AddressLandingOption('CurrentLocation', 3, 'Current Location');
    AddressLandingOption_NewAddress_instance = new AddressLandingOption('NewAddress', 4, 'New Address');
    AddressLandingOption_Dismiss_instance = new AddressLandingOption('Dismiss', 5, 'Dismiss');
  }
  function AddressLandingOption(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressLandingOption).r = function () {
    return this.value;
  };
  function AddressLandingOption_PinOnMap_getInstance() {
    AddressLandingOption_initEntries();
    return AddressLandingOption_PinOnMap_instance;
  }
  function AddressLandingOption_SavedAddress_getInstance() {
    AddressLandingOption_initEntries();
    return AddressLandingOption_SavedAddress_instance;
  }
  function AddressLandingOption_DraftAddress_getInstance() {
    AddressLandingOption_initEntries();
    return AddressLandingOption_DraftAddress_instance;
  }
  function AddressLandingOption_CurrentLocation_getInstance() {
    AddressLandingOption_initEntries();
    return AddressLandingOption_CurrentLocation_instance;
  }
  function AddressLandingOption_NewAddress_getInstance() {
    AddressLandingOption_initEntries();
    return AddressLandingOption_NewAddress_instance;
  }
  function AddressLandingOption_Dismiss_getInstance() {
    AddressLandingOption_initEntries();
    return AddressLandingOption_Dismiss_instance;
  }
  function Metadata_6() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_6).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_6;
  function Metadata_getInstance_6() {
    return Metadata_instance_6;
  }
  function AddressLandingOptionClicked(addressOption, source) {
    var tmp = to('addressOption', addressOption == null ? null : addressOption.value);
    Event.call(this, 'Address Landing Option Clicked', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, to('source', source == null ? null : source.value)]));
  }
  function Metadata_7() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_7).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_7;
  function Metadata_getInstance_7() {
    return Metadata_instance_7;
  }
  function AddressMapSearchFailed(mapSelectedLocationLatitude, mapSelectedLocationLongitude) {
    var tmp = to('mapSelectedLocationLatitude', mapSelectedLocationLatitude == null ? null : get_value_1(mapSelectedLocationLatitude));
    Event.call(this, 'Address Map Search Failed Event', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, to('mapSelectedLocationLongitude', mapSelectedLocationLongitude == null ? null : get_value_1(mapSelectedLocationLongitude))]));
  }
  function Metadata_8() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_8).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_8;
  function Metadata_getInstance_8() {
    return Metadata_instance_8;
  }
  function AddressSearchFailed(query) {
    Event.call(this, 'Address Search Failed', VOID, 'TREX: Tracking and Reviews Experience', mapOf_0(to('query', query == null ? null : get_value(query))));
  }
  var AddressSearchSource_NewOrder_instance;
  var AddressSearchSource_Home_instance;
  var AddressSearchSource_SelfAddressChange_instance;
  var AddressSearchSource_StorePage_instance;
  var AddressSearchSource_Category_instance;
  var AddressSearchSource_Other_instance;
  var AddressSearchSource_OrderWarning_instance;
  var AddressSearchSource_HomeGlobalSearchBar_instance;
  var AddressSearchSource_HomeGlobalTopBrands_instance;
  var AddressSearchSource_HomeGlobalExploreRestaurants_instance;
  var AddressSearchSource_HomeCountrySearchBar_instance;
  var AddressSearchSource_HomeCountryTopBrands_instance;
  var AddressSearchSource_HomeCountryExploreRestaurants_instance;
  var AddressSearchSource_Onboarding_instance;
  var AddressSearchSource_HomeBottomSheet_instance;
  var AddressSearchSource_AddressLandingScreen_instance;
  var AddressSearchSource_CheckoutTemplate_instance;
  function values_4() {
    return [AddressSearchSource_NewOrder_getInstance(), AddressSearchSource_Home_getInstance(), AddressSearchSource_SelfAddressChange_getInstance(), AddressSearchSource_StorePage_getInstance(), AddressSearchSource_Category_getInstance(), AddressSearchSource_Other_getInstance(), AddressSearchSource_OrderWarning_getInstance(), AddressSearchSource_HomeGlobalSearchBar_getInstance(), AddressSearchSource_HomeGlobalTopBrands_getInstance(), AddressSearchSource_HomeGlobalExploreRestaurants_getInstance(), AddressSearchSource_HomeCountrySearchBar_getInstance(), AddressSearchSource_HomeCountryTopBrands_getInstance(), AddressSearchSource_HomeCountryExploreRestaurants_getInstance(), AddressSearchSource_Onboarding_getInstance(), AddressSearchSource_HomeBottomSheet_getInstance(), AddressSearchSource_AddressLandingScreen_getInstance(), AddressSearchSource_CheckoutTemplate_getInstance()];
  }
  function valueOf_4(value) {
    switch (value) {
      case 'NewOrder':
        return AddressSearchSource_NewOrder_getInstance();
      case 'Home':
        return AddressSearchSource_Home_getInstance();
      case 'SelfAddressChange':
        return AddressSearchSource_SelfAddressChange_getInstance();
      case 'StorePage':
        return AddressSearchSource_StorePage_getInstance();
      case 'Category':
        return AddressSearchSource_Category_getInstance();
      case 'Other':
        return AddressSearchSource_Other_getInstance();
      case 'OrderWarning':
        return AddressSearchSource_OrderWarning_getInstance();
      case 'HomeGlobalSearchBar':
        return AddressSearchSource_HomeGlobalSearchBar_getInstance();
      case 'HomeGlobalTopBrands':
        return AddressSearchSource_HomeGlobalTopBrands_getInstance();
      case 'HomeGlobalExploreRestaurants':
        return AddressSearchSource_HomeGlobalExploreRestaurants_getInstance();
      case 'HomeCountrySearchBar':
        return AddressSearchSource_HomeCountrySearchBar_getInstance();
      case 'HomeCountryTopBrands':
        return AddressSearchSource_HomeCountryTopBrands_getInstance();
      case 'HomeCountryExploreRestaurants':
        return AddressSearchSource_HomeCountryExploreRestaurants_getInstance();
      case 'Onboarding':
        return AddressSearchSource_Onboarding_getInstance();
      case 'HomeBottomSheet':
        return AddressSearchSource_HomeBottomSheet_getInstance();
      case 'AddressLandingScreen':
        return AddressSearchSource_AddressLandingScreen_getInstance();
      case 'CheckoutTemplate':
        return AddressSearchSource_CheckoutTemplate_getInstance();
      default:
        AddressSearchSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressSearchSource_entriesInitialized;
  function AddressSearchSource_initEntries() {
    if (AddressSearchSource_entriesInitialized)
      return Unit_instance;
    AddressSearchSource_entriesInitialized = true;
    AddressSearchSource_NewOrder_instance = new AddressSearchSource('NewOrder', 0, 'New Order');
    AddressSearchSource_Home_instance = new AddressSearchSource('Home', 1, 'Home');
    AddressSearchSource_SelfAddressChange_instance = new AddressSearchSource('SelfAddressChange', 2, 'Self Address Change');
    AddressSearchSource_StorePage_instance = new AddressSearchSource('StorePage', 3, 'Store Page');
    AddressSearchSource_Category_instance = new AddressSearchSource('Category', 4, 'Category');
    AddressSearchSource_Other_instance = new AddressSearchSource('Other', 5, 'Other');
    AddressSearchSource_OrderWarning_instance = new AddressSearchSource('OrderWarning', 6, 'OrderWarning');
    AddressSearchSource_HomeGlobalSearchBar_instance = new AddressSearchSource('HomeGlobalSearchBar', 7, 'HomeGlobalSearchBar');
    AddressSearchSource_HomeGlobalTopBrands_instance = new AddressSearchSource('HomeGlobalTopBrands', 8, 'HomeGlobalTopBrands');
    AddressSearchSource_HomeGlobalExploreRestaurants_instance = new AddressSearchSource('HomeGlobalExploreRestaurants', 9, 'HomeGlobalExploreRestaurants');
    AddressSearchSource_HomeCountrySearchBar_instance = new AddressSearchSource('HomeCountrySearchBar', 10, 'HomeCountrySearchBar');
    AddressSearchSource_HomeCountryTopBrands_instance = new AddressSearchSource('HomeCountryTopBrands', 11, 'HomeCountryTopBrands');
    AddressSearchSource_HomeCountryExploreRestaurants_instance = new AddressSearchSource('HomeCountryExploreRestaurants', 12, 'HomeCountryExploreRestaurants');
    AddressSearchSource_Onboarding_instance = new AddressSearchSource('Onboarding', 13, 'Onboarding');
    AddressSearchSource_HomeBottomSheet_instance = new AddressSearchSource('HomeBottomSheet', 14, 'HomeBottomSheet');
    AddressSearchSource_AddressLandingScreen_instance = new AddressSearchSource('AddressLandingScreen', 15, 'AddressLandingScreen');
    AddressSearchSource_CheckoutTemplate_instance = new AddressSearchSource('CheckoutTemplate', 16, 'CheckoutTemplate');
  }
  function AddressSearchSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressSearchSource).r = function () {
    return this.value;
  };
  function AddressSearchSource_NewOrder_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_NewOrder_instance;
  }
  function AddressSearchSource_Home_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_Home_instance;
  }
  function AddressSearchSource_SelfAddressChange_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_SelfAddressChange_instance;
  }
  function AddressSearchSource_StorePage_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_StorePage_instance;
  }
  function AddressSearchSource_Category_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_Category_instance;
  }
  function AddressSearchSource_Other_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_Other_instance;
  }
  function AddressSearchSource_OrderWarning_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_OrderWarning_instance;
  }
  function AddressSearchSource_HomeGlobalSearchBar_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeGlobalSearchBar_instance;
  }
  function AddressSearchSource_HomeGlobalTopBrands_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeGlobalTopBrands_instance;
  }
  function AddressSearchSource_HomeGlobalExploreRestaurants_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeGlobalExploreRestaurants_instance;
  }
  function AddressSearchSource_HomeCountrySearchBar_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeCountrySearchBar_instance;
  }
  function AddressSearchSource_HomeCountryTopBrands_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeCountryTopBrands_instance;
  }
  function AddressSearchSource_HomeCountryExploreRestaurants_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeCountryExploreRestaurants_instance;
  }
  function AddressSearchSource_Onboarding_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_Onboarding_instance;
  }
  function AddressSearchSource_HomeBottomSheet_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_HomeBottomSheet_instance;
  }
  function AddressSearchSource_AddressLandingScreen_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_AddressLandingScreen_instance;
  }
  function AddressSearchSource_CheckoutTemplate_getInstance() {
    AddressSearchSource_initEntries();
    return AddressSearchSource_CheckoutTemplate_instance;
  }
  var AddressSource_SearchResult_instance;
  var AddressSource_PinOnMap_instance;
  var AddressSource_PastDeliveryAddress_instance;
  var AddressSource_NewOrder_instance;
  var AddressSource_EditDeliveryInfo_instance;
  function values_5() {
    return [AddressSource_SearchResult_getInstance(), AddressSource_PinOnMap_getInstance(), AddressSource_PastDeliveryAddress_getInstance(), AddressSource_NewOrder_getInstance(), AddressSource_EditDeliveryInfo_getInstance()];
  }
  function valueOf_5(value) {
    switch (value) {
      case 'SearchResult':
        return AddressSource_SearchResult_getInstance();
      case 'PinOnMap':
        return AddressSource_PinOnMap_getInstance();
      case 'PastDeliveryAddress':
        return AddressSource_PastDeliveryAddress_getInstance();
      case 'NewOrder':
        return AddressSource_NewOrder_getInstance();
      case 'EditDeliveryInfo':
        return AddressSource_EditDeliveryInfo_getInstance();
      default:
        AddressSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressSource_entriesInitialized;
  function AddressSource_initEntries() {
    if (AddressSource_entriesInitialized)
      return Unit_instance;
    AddressSource_entriesInitialized = true;
    AddressSource_SearchResult_instance = new AddressSource('SearchResult', 0, 'Search Result');
    AddressSource_PinOnMap_instance = new AddressSource('PinOnMap', 1, 'Pin On Map');
    AddressSource_PastDeliveryAddress_instance = new AddressSource('PastDeliveryAddress', 2, 'Past Delivery Address');
    AddressSource_NewOrder_instance = new AddressSource('NewOrder', 3, 'NewOrder');
    AddressSource_EditDeliveryInfo_instance = new AddressSource('EditDeliveryInfo', 4, 'Edit Delivery Info');
  }
  function AddressSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressSource).r = function () {
    return this.value;
  };
  function AddressSource_SearchResult_getInstance() {
    AddressSource_initEntries();
    return AddressSource_SearchResult_instance;
  }
  function AddressSource_PinOnMap_getInstance() {
    AddressSource_initEntries();
    return AddressSource_PinOnMap_instance;
  }
  function AddressSource_PastDeliveryAddress_getInstance() {
    AddressSource_initEntries();
    return AddressSource_PastDeliveryAddress_instance;
  }
  function AddressSource_NewOrder_getInstance() {
    AddressSource_initEntries();
    return AddressSource_NewOrder_instance;
  }
  function AddressSource_EditDeliveryInfo_getInstance() {
    AddressSource_initEntries();
    return AddressSource_EditDeliveryInfo_instance;
  }
  function Metadata_9() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_9).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_9;
  function Metadata_getInstance_9() {
    return Metadata_instance_9;
  }
  function AddressTooFarErrorFired(isSameCity) {
    Event.call(this, 'Address Too Far Error Fired', VOID, 'CK: Checkout', mapOf_0(to('isSameCity', isSameCity == null ? null : get_value_0(isSameCity))));
  }
  var AddressType_Regular_instance;
  var AddressType_Custom_instance;
  function values_6() {
    return [AddressType_Regular_getInstance(), AddressType_Custom_getInstance()];
  }
  function valueOf_6(value) {
    switch (value) {
      case 'Regular':
        return AddressType_Regular_getInstance();
      case 'Custom':
        return AddressType_Custom_getInstance();
      default:
        AddressType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AddressType_entriesInitialized;
  function AddressType_initEntries() {
    if (AddressType_entriesInitialized)
      return Unit_instance;
    AddressType_entriesInitialized = true;
    AddressType_Regular_instance = new AddressType('Regular', 0, 'Regular');
    AddressType_Custom_instance = new AddressType('Custom', 1, 'Custom');
  }
  function AddressType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AddressType).r = function () {
    return this.value;
  };
  function AddressType_Regular_getInstance() {
    AddressType_initEntries();
    return AddressType_Regular_instance;
  }
  function AddressType_Custom_getInstance() {
    AddressType_initEntries();
    return AddressType_Custom_instance;
  }
  function AllFiltersCleared(filters, categoryId) {
    filters = filters === VOID ? null : filters;
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('filters', filters == null ? null : get_value_2(filters));
    Event.call(this, 'All Filters Cleared', VOID, VOID, mapOf([tmp, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  function ApplePay() {
    ApplePay_instance = this;
    AlternativePlatformNameType.call(this, 'ApplePay');
  }
  protoOf(ApplePay).toString = function () {
    return 'ApplePay(value=' + this.value + ')';
  };
  var ApplePay_instance;
  function ApplePay_getInstance() {
    if (ApplePay_instance == null)
      new ApplePay();
    return ApplePay_instance;
  }
  function GooglePay() {
    GooglePay_instance = this;
    AlternativePlatformNameType.call(this, 'GooglePay');
  }
  protoOf(GooglePay).toString = function () {
    return 'GooglePay(value=' + this.value + ')';
  };
  var GooglePay_instance;
  function GooglePay_getInstance() {
    if (GooglePay_instance == null)
      new GooglePay();
    return GooglePay_instance;
  }
  function DotPay() {
    DotPay_instance = this;
    AlternativePlatformNameType.call(this, 'DotPay');
  }
  protoOf(DotPay).toString = function () {
    return 'DotPay(value=' + this.value + ')';
  };
  var DotPay_instance;
  function DotPay_getInstance() {
    if (DotPay_instance == null)
      new DotPay();
    return DotPay_instance;
  }
  function PayPal() {
    PayPal_instance = this;
    AlternativePlatformNameType.call(this, 'PayPal');
  }
  protoOf(PayPal).toString = function () {
    return 'PayPal(value=' + this.value + ')';
  };
  var PayPal_instance;
  function PayPal_getInstance() {
    if (PayPal_instance == null)
      new PayPal();
    return PayPal_instance;
  }
  function Edenred() {
    Edenred_instance = this;
    AlternativePlatformNameType.call(this, 'Edenred');
  }
  protoOf(Edenred).toString = function () {
    return 'Edenred(value=' + this.value + ')';
  };
  var Edenred_instance;
  function Edenred_getInstance() {
    if (Edenred_instance == null)
      new Edenred();
    return Edenred_instance;
  }
  function BalanceCredit() {
    BalanceCredit_instance = this;
    AlternativePlatformNameType.call(this, 'BalanceCredit');
  }
  protoOf(BalanceCredit).toString = function () {
    return 'BalanceCredit(value=' + this.value + ')';
  };
  var BalanceCredit_instance;
  function BalanceCredit_getInstance() {
    if (BalanceCredit_instance == null)
      new BalanceCredit();
    return BalanceCredit_instance;
  }
  function WebPayment(displayName) {
    AlternativePlatformNameType.call(this, 'WebPayment', mapOf_0(to('displayName', displayName == null ? null : get_value(displayName))));
  }
  protoOf(WebPayment).toString = function () {
    return 'WebPayment(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function NativePayment(name) {
    AlternativePlatformNameType.call(this, 'NativePayment', mapOf_0(to('name', name == null ? null : get_value(name))));
  }
  protoOf(NativePayment).toString = function () {
    return 'NativePayment(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Unknown() {
    Unknown_instance = this;
    AlternativePlatformNameType.call(this, 'Unknown');
  }
  protoOf(Unknown).toString = function () {
    return 'Unknown(value=' + this.value + ')';
  };
  var Unknown_instance;
  function Unknown_getInstance() {
    if (Unknown_instance == null)
      new Unknown();
    return Unknown_instance;
  }
  function AlternativePlatformNameType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(AlternativePlatformNameType).r = function () {
    return this.value;
  };
  protoOf(AlternativePlatformNameType).qa = function () {
    return this.data;
  };
  protoOf(AlternativePlatformNameType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(AlternativePlatformNameType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof AlternativePlatformNameType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var AppliedFilterOrigin_TopShortcuts_instance;
  var AppliedFilterOrigin_FiltersScreen_instance;
  var AppliedFilterOrigin_TogglePrime_instance;
  var AppliedFilterOrigin_TogglePickUp_instance;
  function values_7() {
    return [AppliedFilterOrigin_TopShortcuts_getInstance(), AppliedFilterOrigin_FiltersScreen_getInstance(), AppliedFilterOrigin_TogglePrime_getInstance(), AppliedFilterOrigin_TogglePickUp_getInstance()];
  }
  function valueOf_7(value) {
    switch (value) {
      case 'TopShortcuts':
        return AppliedFilterOrigin_TopShortcuts_getInstance();
      case 'FiltersScreen':
        return AppliedFilterOrigin_FiltersScreen_getInstance();
      case 'TogglePrime':
        return AppliedFilterOrigin_TogglePrime_getInstance();
      case 'TogglePickUp':
        return AppliedFilterOrigin_TogglePickUp_getInstance();
      default:
        AppliedFilterOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AppliedFilterOrigin_entriesInitialized;
  function AppliedFilterOrigin_initEntries() {
    if (AppliedFilterOrigin_entriesInitialized)
      return Unit_instance;
    AppliedFilterOrigin_entriesInitialized = true;
    AppliedFilterOrigin_TopShortcuts_instance = new AppliedFilterOrigin('TopShortcuts', 0, 'TopShortcuts');
    AppliedFilterOrigin_FiltersScreen_instance = new AppliedFilterOrigin('FiltersScreen', 1, 'FiltersScreen');
    AppliedFilterOrigin_TogglePrime_instance = new AppliedFilterOrigin('TogglePrime', 2, 'TogglePrime');
    AppliedFilterOrigin_TogglePickUp_instance = new AppliedFilterOrigin('TogglePickUp', 3, 'TogglePickUp');
  }
  function AppliedFilterOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AppliedFilterOrigin).r = function () {
    return this.value;
  };
  function AppliedFilterOrigin_TopShortcuts_getInstance() {
    AppliedFilterOrigin_initEntries();
    return AppliedFilterOrigin_TopShortcuts_instance;
  }
  function AppliedFilterOrigin_FiltersScreen_getInstance() {
    AppliedFilterOrigin_initEntries();
    return AppliedFilterOrigin_FiltersScreen_instance;
  }
  function AppliedFilterOrigin_TogglePrime_getInstance() {
    AppliedFilterOrigin_initEntries();
    return AppliedFilterOrigin_TogglePrime_instance;
  }
  function AppliedFilterOrigin_TogglePickUp_getInstance() {
    AppliedFilterOrigin_initEntries();
    return AppliedFilterOrigin_TogglePickUp_instance;
  }
  function Metadata_10() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_10).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_10;
  function Metadata_getInstance_10() {
    return Metadata_instance_10;
  }
  function ApplyConsent(handlerName, properties) {
    var tmp = mapOf_0(to('handlerName', handlerName == null ? null : get_value(handlerName)));
    var tmp2_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Apply Consent', VOID, 'GRO: Growth', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  var AuthenticationOption_PhoneOTP_instance;
  var AuthenticationOption_Email_instance;
  var AuthenticationOption_Facebook_instance;
  var AuthenticationOption_Apple_instance;
  var AuthenticationOption_Google_instance;
  var AuthenticationOption_Password_instance;
  function values_8() {
    return [AuthenticationOption_PhoneOTP_getInstance(), AuthenticationOption_Email_getInstance(), AuthenticationOption_Facebook_getInstance(), AuthenticationOption_Apple_getInstance(), AuthenticationOption_Google_getInstance(), AuthenticationOption_Password_getInstance()];
  }
  function valueOf_8(value) {
    switch (value) {
      case 'PhoneOTP':
        return AuthenticationOption_PhoneOTP_getInstance();
      case 'Email':
        return AuthenticationOption_Email_getInstance();
      case 'Facebook':
        return AuthenticationOption_Facebook_getInstance();
      case 'Apple':
        return AuthenticationOption_Apple_getInstance();
      case 'Google':
        return AuthenticationOption_Google_getInstance();
      case 'Password':
        return AuthenticationOption_Password_getInstance();
      default:
        AuthenticationOption_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AuthenticationOption_entriesInitialized;
  function AuthenticationOption_initEntries() {
    if (AuthenticationOption_entriesInitialized)
      return Unit_instance;
    AuthenticationOption_entriesInitialized = true;
    AuthenticationOption_PhoneOTP_instance = new AuthenticationOption('PhoneOTP', 0, 'PhoneOTP');
    AuthenticationOption_Email_instance = new AuthenticationOption('Email', 1, 'Email');
    AuthenticationOption_Facebook_instance = new AuthenticationOption('Facebook', 2, 'Facebook');
    AuthenticationOption_Apple_instance = new AuthenticationOption('Apple', 3, 'Apple');
    AuthenticationOption_Google_instance = new AuthenticationOption('Google', 4, 'Google');
    AuthenticationOption_Password_instance = new AuthenticationOption('Password', 5, 'Password');
  }
  function AuthenticationOption(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AuthenticationOption).r = function () {
    return this.value;
  };
  function AuthenticationOption_PhoneOTP_getInstance() {
    AuthenticationOption_initEntries();
    return AuthenticationOption_PhoneOTP_instance;
  }
  function AuthenticationOption_Email_getInstance() {
    AuthenticationOption_initEntries();
    return AuthenticationOption_Email_instance;
  }
  function AuthenticationOption_Facebook_getInstance() {
    AuthenticationOption_initEntries();
    return AuthenticationOption_Facebook_instance;
  }
  function AuthenticationOption_Apple_getInstance() {
    AuthenticationOption_initEntries();
    return AuthenticationOption_Apple_instance;
  }
  function AuthenticationOption_Google_getInstance() {
    AuthenticationOption_initEntries();
    return AuthenticationOption_Google_instance;
  }
  function AuthenticationOption_Password_getInstance() {
    AuthenticationOption_initEntries();
    return AuthenticationOption_Password_instance;
  }
  function AuthenticationOptionSelected(isNewUser, option) {
    var tmp = to('isNewUser', isNewUser == null ? null : get_value_0(isNewUser));
    Event.call(this, 'Authentication Option Selected', VOID, VOID, mapOf([tmp, to('option', option == null ? null : option.value)]));
  }
  function AuthenticationOptionsScreen(isNewUser, options) {
    var tmp = to('isNewUser', isNewUser == null ? null : get_value_0(isNewUser));
    Screen.call(this, 'Authentication Options', VOID, mapOf([tmp, to('options', options == null ? null : get_value_2(options))]));
  }
  function Closed(openingOrSchedulableTime) {
    AvailabilityStatus.call(this, 'Closed', mapOf_0(to('openingOrSchedulableTime', openingOrSchedulableTime == null ? null : get_value_1(openingOrSchedulableTime))));
  }
  protoOf(Closed).toString = function () {
    return 'Closed(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Unavailable(openingOrSchedulableTime) {
    AvailabilityStatus.call(this, 'Unavailable', mapOf_0(to('openingOrSchedulableTime', openingOrSchedulableTime == null ? null : get_value_1(openingOrSchedulableTime))));
  }
  protoOf(Unavailable).toString = function () {
    return 'Unavailable(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Schedulable(openingOrSchedulableTime) {
    AvailabilityStatus.call(this, 'Schedulable', mapOf_0(to('openingOrSchedulableTime', openingOrSchedulableTime == null ? null : get_value_1(openingOrSchedulableTime))));
  }
  protoOf(Schedulable).toString = function () {
    return 'Schedulable(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Asap() {
    Asap_instance = this;
    AvailabilityStatus.call(this, 'Asap');
  }
  protoOf(Asap).toString = function () {
    return 'Asap(value=' + this.value + ')';
  };
  var Asap_instance;
  function Asap_getInstance() {
    if (Asap_instance == null)
      new Asap();
    return Asap_instance;
  }
  function OutOfDeliveryZone() {
    OutOfDeliveryZone_instance = this;
    AvailabilityStatus.call(this, 'OutOfDeliveryZone');
  }
  protoOf(OutOfDeliveryZone).toString = function () {
    return 'OutOfDeliveryZone(value=' + this.value + ')';
  };
  var OutOfDeliveryZone_instance;
  function OutOfDeliveryZone_getInstance() {
    if (OutOfDeliveryZone_instance == null)
      new OutOfDeliveryZone();
    return OutOfDeliveryZone_instance;
  }
  function AvailabilityStatus(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(AvailabilityStatus).r = function () {
    return this.value;
  };
  protoOf(AvailabilityStatus).qa = function () {
    return this.data;
  };
  protoOf(AvailabilityStatus).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(AvailabilityStatus).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof AvailabilityStatus) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Metadata_11() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_11).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_11;
  function Metadata_getInstance_11() {
    return Metadata_instance_11;
  }
  function BackToBasketScreenFromCheckout(basketId, storeId, storeAddressId) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Back To Basket Screen From Checkout', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  var BadgeType_Taste_instance;
  var BadgeType_Price_instance;
  var BadgeType_PortionSize_instance;
  function values_9() {
    return [BadgeType_Taste_getInstance(), BadgeType_Price_getInstance(), BadgeType_PortionSize_getInstance()];
  }
  function valueOf_9(value) {
    switch (value) {
      case 'Taste':
        return BadgeType_Taste_getInstance();
      case 'Price':
        return BadgeType_Price_getInstance();
      case 'PortionSize':
        return BadgeType_PortionSize_getInstance();
      default:
        BadgeType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BadgeType_entriesInitialized;
  function BadgeType_initEntries() {
    if (BadgeType_entriesInitialized)
      return Unit_instance;
    BadgeType_entriesInitialized = true;
    BadgeType_Taste_instance = new BadgeType('Taste', 0, 'Taste');
    BadgeType_Price_instance = new BadgeType('Price', 1, 'Price');
    BadgeType_PortionSize_instance = new BadgeType('PortionSize', 2, 'Portion Size');
  }
  function BadgeType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(BadgeType).r = function () {
    return this.value;
  };
  function BadgeType_Taste_getInstance() {
    BadgeType_initEntries();
    return BadgeType_Taste_instance;
  }
  function BadgeType_Price_getInstance() {
    BadgeType_initEntries();
    return BadgeType_Price_instance;
  }
  function BadgeType_PortionSize_getInstance() {
    BadgeType_initEntries();
    return BadgeType_PortionSize_instance;
  }
  function Metadata_12() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_12).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_12;
  function Metadata_getInstance_12() {
    return Metadata_instance_12;
  }
  function BasketCreated(basketId, storeId, storeAddressId, basketCreationOrigin) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_1 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Basket Created', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, to('basketCreationOrigin', basketCreationOrigin == null ? null : basketCreationOrigin.value)]));
  }
  var BasketCreationOrigin_StoreView_instance;
  var BasketCreationOrigin_ProductDetailsView_instance;
  function values_10() {
    return [BasketCreationOrigin_StoreView_getInstance(), BasketCreationOrigin_ProductDetailsView_getInstance()];
  }
  function valueOf_10(value) {
    switch (value) {
      case 'StoreView':
        return BasketCreationOrigin_StoreView_getInstance();
      case 'ProductDetailsView':
        return BasketCreationOrigin_ProductDetailsView_getInstance();
      default:
        BasketCreationOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BasketCreationOrigin_entriesInitialized;
  function BasketCreationOrigin_initEntries() {
    if (BasketCreationOrigin_entriesInitialized)
      return Unit_instance;
    BasketCreationOrigin_entriesInitialized = true;
    BasketCreationOrigin_StoreView_instance = new BasketCreationOrigin('StoreView', 0, 'Store View');
    BasketCreationOrigin_ProductDetailsView_instance = new BasketCreationOrigin('ProductDetailsView', 1, 'Product Details View');
  }
  function BasketCreationOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(BasketCreationOrigin).r = function () {
    return this.value;
  };
  function BasketCreationOrigin_StoreView_getInstance() {
    BasketCreationOrigin_initEntries();
    return BasketCreationOrigin_StoreView_instance;
  }
  function BasketCreationOrigin_ProductDetailsView_getInstance() {
    BasketCreationOrigin_initEntries();
    return BasketCreationOrigin_ProductDetailsView_instance;
  }
  function Metadata_13() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_13).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_13;
  function Metadata_getInstance_13() {
    return Metadata_instance_13;
  }
  function BasketDeleted(basketId, storeId, storeAddressId, isBasketDeletionExplicit) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_1 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Basket Deleted', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, to('isBasketDeletionExplicit', isBasketDeletionExplicit == null ? null : get_value_0(isBasketDeletionExplicit))]));
  }
  function Metadata_14() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_14).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_14;
  function Metadata_getInstance_14() {
    return Metadata_instance_14;
  }
  function BasketError(basketId, storeId, storeAddressId, basketErrorName) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_1 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Basket Error', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, to('basketErrorName', basketErrorName == null ? null : get_value(basketErrorName))]));
  }
  var BasketOrigin_BasketEntryPoint_instance;
  var BasketOrigin_StoreView_instance;
  var BasketOrigin_OrderHistory_instance;
  var BasketOrigin_LoyaltyProgram_instance;
  var BasketOrigin_NavigationTabBar_instance;
  function values_11() {
    return [BasketOrigin_BasketEntryPoint_getInstance(), BasketOrigin_StoreView_getInstance(), BasketOrigin_OrderHistory_getInstance(), BasketOrigin_LoyaltyProgram_getInstance(), BasketOrigin_NavigationTabBar_getInstance()];
  }
  function valueOf_11(value) {
    switch (value) {
      case 'BasketEntryPoint':
        return BasketOrigin_BasketEntryPoint_getInstance();
      case 'StoreView':
        return BasketOrigin_StoreView_getInstance();
      case 'OrderHistory':
        return BasketOrigin_OrderHistory_getInstance();
      case 'LoyaltyProgram':
        return BasketOrigin_LoyaltyProgram_getInstance();
      case 'NavigationTabBar':
        return BasketOrigin_NavigationTabBar_getInstance();
      default:
        BasketOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BasketOrigin_entriesInitialized;
  function BasketOrigin_initEntries() {
    if (BasketOrigin_entriesInitialized)
      return Unit_instance;
    BasketOrigin_entriesInitialized = true;
    BasketOrigin_BasketEntryPoint_instance = new BasketOrigin('BasketEntryPoint', 0, 'Basket Entry Point');
    BasketOrigin_StoreView_instance = new BasketOrigin('StoreView', 1, 'Store View');
    BasketOrigin_OrderHistory_instance = new BasketOrigin('OrderHistory', 2, 'Order History');
    BasketOrigin_LoyaltyProgram_instance = new BasketOrigin('LoyaltyProgram', 3, 'Loyalty Program');
    BasketOrigin_NavigationTabBar_instance = new BasketOrigin('NavigationTabBar', 4, 'Navigation Tab Bar');
  }
  function BasketOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(BasketOrigin).r = function () {
    return this.value;
  };
  function BasketOrigin_BasketEntryPoint_getInstance() {
    BasketOrigin_initEntries();
    return BasketOrigin_BasketEntryPoint_instance;
  }
  function BasketOrigin_StoreView_getInstance() {
    BasketOrigin_initEntries();
    return BasketOrigin_StoreView_instance;
  }
  function BasketOrigin_OrderHistory_getInstance() {
    BasketOrigin_initEntries();
    return BasketOrigin_OrderHistory_instance;
  }
  function BasketOrigin_LoyaltyProgram_getInstance() {
    BasketOrigin_initEntries();
    return BasketOrigin_LoyaltyProgram_instance;
  }
  function BasketOrigin_NavigationTabBar_getInstance() {
    BasketOrigin_initEntries();
    return BasketOrigin_NavigationTabBar_instance;
  }
  function Metadata_15() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_15).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_15;
  function Metadata_getInstance_15() {
    return Metadata_instance_15;
  }
  function BasketRecovered(basketId, storeId, storeAddressId, recoveryOrigin) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_1 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Basket Recovered', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, to('recoveryOrigin', recoveryOrigin == null ? null : recoveryOrigin.value)]));
  }
  function Metadata_16() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_16).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_16;
  function Metadata_getInstance_16() {
    return Metadata_instance_16;
  }
  function BasketScreen(basketId, storeId, storeAddressId, basketOrigin, hasWeightedProduct) {
    basketId = basketId === VOID ? null : basketId;
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    hasWeightedProduct = hasWeightedProduct === VOID ? null : hasWeightedProduct;
    var tmp = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_1 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_2 = to('basketOrigin', basketOrigin == null ? null : basketOrigin.value);
    Screen.call(this, 'Basket Screen', 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('hasWeightedProduct', hasWeightedProduct == null ? null : get_value_0(hasWeightedProduct))]));
  }
  var BottomSheetScreen_Checkout_instance;
  var BottomSheetScreen_StoresWall_instance;
  var BottomSheetScreen_StoreView_instance;
  var BottomSheetScreen_Home_instance;
  var BottomSheetScreen_LoyaltyProgram_instance;
  function values_12() {
    return [BottomSheetScreen_Checkout_getInstance(), BottomSheetScreen_StoresWall_getInstance(), BottomSheetScreen_StoreView_getInstance(), BottomSheetScreen_Home_getInstance(), BottomSheetScreen_LoyaltyProgram_getInstance()];
  }
  function valueOf_12(value) {
    switch (value) {
      case 'Checkout':
        return BottomSheetScreen_Checkout_getInstance();
      case 'StoresWall':
        return BottomSheetScreen_StoresWall_getInstance();
      case 'StoreView':
        return BottomSheetScreen_StoreView_getInstance();
      case 'Home':
        return BottomSheetScreen_Home_getInstance();
      case 'LoyaltyProgram':
        return BottomSheetScreen_LoyaltyProgram_getInstance();
      default:
        BottomSheetScreen_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BottomSheetScreen_entriesInitialized;
  function BottomSheetScreen_initEntries() {
    if (BottomSheetScreen_entriesInitialized)
      return Unit_instance;
    BottomSheetScreen_entriesInitialized = true;
    BottomSheetScreen_Checkout_instance = new BottomSheetScreen('Checkout', 0, 'Checkout');
    BottomSheetScreen_StoresWall_instance = new BottomSheetScreen('StoresWall', 1, 'StoresWall');
    BottomSheetScreen_StoreView_instance = new BottomSheetScreen('StoreView', 2, 'StoreView');
    BottomSheetScreen_Home_instance = new BottomSheetScreen('Home', 3, 'Home');
    BottomSheetScreen_LoyaltyProgram_instance = new BottomSheetScreen('LoyaltyProgram', 4, 'LoyaltyProgram');
  }
  function BottomSheetScreen(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(BottomSheetScreen).r = function () {
    return this.value;
  };
  function BottomSheetScreen_Checkout_getInstance() {
    BottomSheetScreen_initEntries();
    return BottomSheetScreen_Checkout_instance;
  }
  function BottomSheetScreen_StoresWall_getInstance() {
    BottomSheetScreen_initEntries();
    return BottomSheetScreen_StoresWall_instance;
  }
  function BottomSheetScreen_StoreView_getInstance() {
    BottomSheetScreen_initEntries();
    return BottomSheetScreen_StoreView_instance;
  }
  function BottomSheetScreen_Home_getInstance() {
    BottomSheetScreen_initEntries();
    return BottomSheetScreen_Home_instance;
  }
  function BottomSheetScreen_LoyaltyProgram_getInstance() {
    BottomSheetScreen_initEntries();
    return BottomSheetScreen_LoyaltyProgram_instance;
  }
  function BottomSheetShown(source, infoType, properties, screen, storeId) {
    storeId = storeId === VOID ? null : storeId;
    var tmp = to('source', source == null ? null : source.value);
    var tmp_0 = to('infoType', infoType == null ? null : infoType.value);
    var tmp_1 = to('screen', screen == null ? null : screen.value);
    var tmp_2 = mapOf([tmp, tmp_0, tmp_1, to('storeId', storeId == null ? null : get_value_1(storeId))]);
    var tmp5_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Bottom Sheet Shown', VOID, VOID, plus(tmp_2, tmp5_elvis_lhs == null ? emptyMap() : tmp5_elvis_lhs));
  }
  var BottomSheetSource_InfoButton_instance;
  var BottomSheetSource_Banner_instance;
  var BottomSheetSource_Icon_instance;
  function values_13() {
    return [BottomSheetSource_InfoButton_getInstance(), BottomSheetSource_Banner_getInstance(), BottomSheetSource_Icon_getInstance()];
  }
  function valueOf_13(value) {
    switch (value) {
      case 'InfoButton':
        return BottomSheetSource_InfoButton_getInstance();
      case 'Banner':
        return BottomSheetSource_Banner_getInstance();
      case 'Icon':
        return BottomSheetSource_Icon_getInstance();
      default:
        BottomSheetSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var BottomSheetSource_entriesInitialized;
  function BottomSheetSource_initEntries() {
    if (BottomSheetSource_entriesInitialized)
      return Unit_instance;
    BottomSheetSource_entriesInitialized = true;
    BottomSheetSource_InfoButton_instance = new BottomSheetSource('InfoButton', 0, 'InfoButton');
    BottomSheetSource_Banner_instance = new BottomSheetSource('Banner', 1, 'Banner');
    BottomSheetSource_Icon_instance = new BottomSheetSource('Icon', 2, 'Icon');
  }
  function BottomSheetSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(BottomSheetSource).r = function () {
    return this.value;
  };
  function BottomSheetSource_InfoButton_getInstance() {
    BottomSheetSource_initEntries();
    return BottomSheetSource_InfoButton_instance;
  }
  function BottomSheetSource_Banner_getInstance() {
    BottomSheetSource_initEntries();
    return BottomSheetSource_Banner_instance;
  }
  function BottomSheetSource_Icon_getInstance() {
    BottomSheetSource_initEntries();
    return BottomSheetSource_Icon_instance;
  }
  function CheckoutErrorHandling(errorName, allowSuggestedStores, allowEditAddress, allowBrowseSimilarStores) {
    var tmp = to('errorName', errorName == null ? null : get_value(errorName));
    var tmp_0 = to('allowSuggestedStores', allowSuggestedStores == null ? null : get_value_0(allowSuggestedStores));
    var tmp_1 = to('allowEditAddress', allowEditAddress == null ? null : get_value_0(allowEditAddress));
    BottomSheetType.call(this, 'CheckoutErrorHandling', mapOf([tmp, tmp_0, tmp_1, to('allowBrowseSimilarStores', allowBrowseSimilarStores == null ? null : get_value_0(allowBrowseSimilarStores))]));
  }
  protoOf(CheckoutErrorHandling).toString = function () {
    return 'CheckoutErrorHandling(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function BottomSheetType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(BottomSheetType).r = function () {
    return this.value;
  };
  protoOf(BottomSheetType).qa = function () {
    return this.data;
  };
  protoOf(BottomSheetType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(BottomSheetType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof BottomSheetType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var CCChatProvider_Smooch_instance;
  var CCChatProvider_SendBird_instance;
  function values_14() {
    return [CCChatProvider_Smooch_getInstance(), CCChatProvider_SendBird_getInstance()];
  }
  function valueOf_14(value) {
    switch (value) {
      case 'Smooch':
        return CCChatProvider_Smooch_getInstance();
      case 'SendBird':
        return CCChatProvider_SendBird_getInstance();
      default:
        CCChatProvider_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CCChatProvider_entriesInitialized;
  function CCChatProvider_initEntries() {
    if (CCChatProvider_entriesInitialized)
      return Unit_instance;
    CCChatProvider_entriesInitialized = true;
    CCChatProvider_Smooch_instance = new CCChatProvider('Smooch', 0, 'Smooch');
    CCChatProvider_SendBird_instance = new CCChatProvider('SendBird', 1, 'SendBird');
  }
  function CCChatProvider(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(CCChatProvider).r = function () {
    return this.value;
  };
  function CCChatProvider_Smooch_getInstance() {
    CCChatProvider_initEntries();
    return CCChatProvider_Smooch_instance;
  }
  function CCChatProvider_SendBird_getInstance() {
    CCChatProvider_initEntries();
    return CCChatProvider_SendBird_instance;
  }
  var CTA_CancelOrder_instance;
  var CTA_ChangePhoneNumber_instance;
  var CTA_CloseContactTree_instance;
  var CTA_CourierChat_instance;
  var CTA_Email_instance;
  var CTA_FaqLink_instance;
  var CTA_Form_instance;
  var CTA_LegalBook_instance;
  var CTA_MultiSelectForm_instance;
  var CTA_NoAction_instance;
  var CTA_Node_instance;
  var CTA_OnDemand_instance;
  var CTA_PhoneCall_instance;
  var CTA_Popup_instance;
  var CTA_ProductSelector_instance;
  var CTA_Reorder_instance;
  var CTA_SupportChat_instance;
  var CTA_WebLink_instance;
  function values_15() {
    return [CTA_CancelOrder_getInstance(), CTA_ChangePhoneNumber_getInstance(), CTA_CloseContactTree_getInstance(), CTA_CourierChat_getInstance(), CTA_Email_getInstance(), CTA_FaqLink_getInstance(), CTA_Form_getInstance(), CTA_LegalBook_getInstance(), CTA_MultiSelectForm_getInstance(), CTA_NoAction_getInstance(), CTA_Node_getInstance(), CTA_OnDemand_getInstance(), CTA_PhoneCall_getInstance(), CTA_Popup_getInstance(), CTA_ProductSelector_getInstance(), CTA_Reorder_getInstance(), CTA_SupportChat_getInstance(), CTA_WebLink_getInstance()];
  }
  function valueOf_15(value) {
    switch (value) {
      case 'CancelOrder':
        return CTA_CancelOrder_getInstance();
      case 'ChangePhoneNumber':
        return CTA_ChangePhoneNumber_getInstance();
      case 'CloseContactTree':
        return CTA_CloseContactTree_getInstance();
      case 'CourierChat':
        return CTA_CourierChat_getInstance();
      case 'Email':
        return CTA_Email_getInstance();
      case 'FaqLink':
        return CTA_FaqLink_getInstance();
      case 'Form':
        return CTA_Form_getInstance();
      case 'LegalBook':
        return CTA_LegalBook_getInstance();
      case 'MultiSelectForm':
        return CTA_MultiSelectForm_getInstance();
      case 'NoAction':
        return CTA_NoAction_getInstance();
      case 'Node':
        return CTA_Node_getInstance();
      case 'OnDemand':
        return CTA_OnDemand_getInstance();
      case 'PhoneCall':
        return CTA_PhoneCall_getInstance();
      case 'Popup':
        return CTA_Popup_getInstance();
      case 'ProductSelector':
        return CTA_ProductSelector_getInstance();
      case 'Reorder':
        return CTA_Reorder_getInstance();
      case 'SupportChat':
        return CTA_SupportChat_getInstance();
      case 'WebLink':
        return CTA_WebLink_getInstance();
      default:
        CTA_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CTA_entriesInitialized;
  function CTA_initEntries() {
    if (CTA_entriesInitialized)
      return Unit_instance;
    CTA_entriesInitialized = true;
    CTA_CancelOrder_instance = new CTA('CancelOrder', 0, 'CancelOrder');
    CTA_ChangePhoneNumber_instance = new CTA('ChangePhoneNumber', 1, 'ChangePhoneNumber');
    CTA_CloseContactTree_instance = new CTA('CloseContactTree', 2, 'CloseContactTree');
    CTA_CourierChat_instance = new CTA('CourierChat', 3, 'CourierChat');
    CTA_Email_instance = new CTA('Email', 4, 'Email');
    CTA_FaqLink_instance = new CTA('FaqLink', 5, 'FaqLink');
    CTA_Form_instance = new CTA('Form', 6, 'Form');
    CTA_LegalBook_instance = new CTA('LegalBook', 7, 'LegalBook');
    CTA_MultiSelectForm_instance = new CTA('MultiSelectForm', 8, 'MultiSelectForm');
    CTA_NoAction_instance = new CTA('NoAction', 9, 'NoAction');
    CTA_Node_instance = new CTA('Node', 10, 'Node');
    CTA_OnDemand_instance = new CTA('OnDemand', 11, 'OnDemand');
    CTA_PhoneCall_instance = new CTA('PhoneCall', 12, 'PhoneCall');
    CTA_Popup_instance = new CTA('Popup', 13, 'Popup');
    CTA_ProductSelector_instance = new CTA('ProductSelector', 14, 'ProductSelector');
    CTA_Reorder_instance = new CTA('Reorder', 15, 'Reorder');
    CTA_SupportChat_instance = new CTA('SupportChat', 16, 'Chat');
    CTA_WebLink_instance = new CTA('WebLink', 17, 'WebLink');
  }
  function CTA(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(CTA).r = function () {
    return this.value;
  };
  function CTA_CancelOrder_getInstance() {
    CTA_initEntries();
    return CTA_CancelOrder_instance;
  }
  function CTA_ChangePhoneNumber_getInstance() {
    CTA_initEntries();
    return CTA_ChangePhoneNumber_instance;
  }
  function CTA_CloseContactTree_getInstance() {
    CTA_initEntries();
    return CTA_CloseContactTree_instance;
  }
  function CTA_CourierChat_getInstance() {
    CTA_initEntries();
    return CTA_CourierChat_instance;
  }
  function CTA_Email_getInstance() {
    CTA_initEntries();
    return CTA_Email_instance;
  }
  function CTA_FaqLink_getInstance() {
    CTA_initEntries();
    return CTA_FaqLink_instance;
  }
  function CTA_Form_getInstance() {
    CTA_initEntries();
    return CTA_Form_instance;
  }
  function CTA_LegalBook_getInstance() {
    CTA_initEntries();
    return CTA_LegalBook_instance;
  }
  function CTA_MultiSelectForm_getInstance() {
    CTA_initEntries();
    return CTA_MultiSelectForm_instance;
  }
  function CTA_NoAction_getInstance() {
    CTA_initEntries();
    return CTA_NoAction_instance;
  }
  function CTA_Node_getInstance() {
    CTA_initEntries();
    return CTA_Node_instance;
  }
  function CTA_OnDemand_getInstance() {
    CTA_initEntries();
    return CTA_OnDemand_instance;
  }
  function CTA_PhoneCall_getInstance() {
    CTA_initEntries();
    return CTA_PhoneCall_instance;
  }
  function CTA_Popup_getInstance() {
    CTA_initEntries();
    return CTA_Popup_instance;
  }
  function CTA_ProductSelector_getInstance() {
    CTA_initEntries();
    return CTA_ProductSelector_instance;
  }
  function CTA_Reorder_getInstance() {
    CTA_initEntries();
    return CTA_Reorder_instance;
  }
  function CTA_SupportChat_getInstance() {
    CTA_initEntries();
    return CTA_SupportChat_instance;
  }
  function CTA_WebLink_getInstance() {
    CTA_initEntries();
    return CTA_WebLink_instance;
  }
  var CarouselScrollDirection_Left_instance;
  var CarouselScrollDirection_Right_instance;
  function values_16() {
    return [CarouselScrollDirection_Left_getInstance(), CarouselScrollDirection_Right_getInstance()];
  }
  function valueOf_16(value) {
    switch (value) {
      case 'Left':
        return CarouselScrollDirection_Left_getInstance();
      case 'Right':
        return CarouselScrollDirection_Right_getInstance();
      default:
        CarouselScrollDirection_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CarouselScrollDirection_entriesInitialized;
  function CarouselScrollDirection_initEntries() {
    if (CarouselScrollDirection_entriesInitialized)
      return Unit_instance;
    CarouselScrollDirection_entriesInitialized = true;
    CarouselScrollDirection_Left_instance = new CarouselScrollDirection('Left', 0, 'Left');
    CarouselScrollDirection_Right_instance = new CarouselScrollDirection('Right', 1, 'Right');
  }
  function CarouselScrollDirection(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(CarouselScrollDirection).r = function () {
    return this.value;
  };
  function CarouselScrollDirection_Left_getInstance() {
    CarouselScrollDirection_initEntries();
    return CarouselScrollDirection_Left_instance;
  }
  function CarouselScrollDirection_Right_getInstance() {
    CarouselScrollDirection_initEntries();
    return CarouselScrollDirection_Right_instance;
  }
  function CarouselScrolled(storeAddressId, categoryId, scrollDirection, carouselType) {
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('scrollDirection', scrollDirection == null ? null : scrollDirection.value);
    Event.call(this, 'Carousel Scrolled', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('carouselType', carouselType == null ? null : carouselType.value)]));
  }
  function Metadata_17() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_17).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_17;
  function Metadata_getInstance_17() {
    return Metadata_instance_17;
  }
  function CartEntryPointImpression(cartId, storeAddressId, creationSessionId) {
    var tmp = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Cart Entry Point Impression', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId))]));
  }
  function Metadata_18() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_18).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_18;
  function Metadata_getInstance_18() {
    return Metadata_instance_18;
  }
  function CartEntryPointNavigationClick(cartId, storeAddressId, creationSessionId) {
    var tmp = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Cart Entry Point Navigation Click', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId))]));
  }
  function Metadata_19() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_19).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_19;
  function Metadata_getInstance_19() {
    return Metadata_instance_19;
  }
  function CartExpired(storeAddressId, total, categoryId, numberOfProducts, cartId, creationSessionId) {
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('total', total == null ? null : get_value_1(total));
    var tmp_1 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_2 = to('numberOfProducts', numberOfProducts == null ? null : get_value_1(numberOfProducts));
    var tmp_3 = to('cartId', cartId == null ? null : get_value(cartId));
    Event.call(this, 'Cart Expired', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId))]));
  }
  function Metadata_20() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_20).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_20;
  function Metadata_getInstance_20() {
    return Metadata_instance_20;
  }
  function CartInteracted(cartId, cartInteractionType, numberOfProducts) {
    var tmp = to('cartId', cartId == null ? null : get_value_1(cartId));
    var tmp_0 = to('cartInteractionType', cartInteractionType == null ? null : cartInteractionType.value);
    var tmp_1 = mapOf([tmp, tmp_0, to('numberOfProducts', numberOfProducts == null ? null : get_value_1(numberOfProducts))]);
    var tmp4_elvis_lhs = cartInteractionType == null ? null : cartInteractionType.data;
    Event.call(this, 'Cart Interacted', VOID, 'CK: Checkout', plus(tmp_1, tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs));
  }
  function HelpClicked() {
    HelpClicked_instance = this;
    CartInteractionType.call(this, 'HelpClicked');
  }
  protoOf(HelpClicked).toString = function () {
    return 'HelpClicked(value=' + this.value + ')';
  };
  var HelpClicked_instance;
  function HelpClicked_getInstance() {
    if (HelpClicked_instance == null)
      new HelpClicked();
    return HelpClicked_instance;
  }
  function GoBack() {
    GoBack_instance = this;
    CartInteractionType.call(this, 'GoBack');
  }
  protoOf(GoBack).toString = function () {
    return 'GoBack(value=' + this.value + ')';
  };
  var GoBack_instance;
  function GoBack_getInstance() {
    if (GoBack_instance == null)
      new GoBack();
    return GoBack_instance;
  }
  function AddRemoveQuantityClicked(isAddition, productId, storeProductId) {
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('isAddition', isAddition == null ? null : get_value_0(isAddition));
    var tmp_0 = to('productId', productId == null ? null : get_value_1(productId));
    CartInteractionType.call(this, 'AddRemoveQuantityClicked', mapOf([tmp, tmp_0, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  protoOf(AddRemoveQuantityClicked).toString = function () {
    return 'AddRemoveQuantityClicked(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function RemoveProductClicked(productId, storeProductId) {
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    CartInteractionType.call(this, 'RemoveProductClicked', mapOf([tmp, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  protoOf(RemoveProductClicked).toString = function () {
    return 'RemoveProductClicked(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function GoCheckout() {
    GoCheckout_instance = this;
    CartInteractionType.call(this, 'GoCheckout');
  }
  protoOf(GoCheckout).toString = function () {
    return 'GoCheckout(value=' + this.value + ')';
  };
  var GoCheckout_instance;
  function GoCheckout_getInstance() {
    if (GoCheckout_instance == null)
      new GoCheckout();
    return GoCheckout_instance;
  }
  function GoPNAInstructions() {
    GoPNAInstructions_instance = this;
    CartInteractionType.call(this, 'GoPNAInstructions');
  }
  protoOf(GoPNAInstructions).toString = function () {
    return 'GoPNAInstructions(value=' + this.value + ')';
  };
  var GoPNAInstructions_instance;
  function GoPNAInstructions_getInstance() {
    if (GoPNAInstructions_instance == null)
      new GoPNAInstructions();
    return GoPNAInstructions_instance;
  }
  function GoGiftingOptions() {
    GoGiftingOptions_instance = this;
    CartInteractionType.call(this, 'GoGiftingOptions');
  }
  protoOf(GoGiftingOptions).toString = function () {
    return 'GoGiftingOptions(value=' + this.value + ')';
  };
  var GoGiftingOptions_instance;
  function GoGiftingOptions_getInstance() {
    if (GoGiftingOptions_instance == null)
      new GoGiftingOptions();
    return GoGiftingOptions_instance;
  }
  function CartInteractionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(CartInteractionType).r = function () {
    return this.value;
  };
  protoOf(CartInteractionType).qa = function () {
    return this.data;
  };
  protoOf(CartInteractionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(CartInteractionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof CartInteractionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Metadata_21() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_21).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_21;
  function Metadata_getInstance_21() {
    return Metadata_instance_21;
  }
  function CartLoaded(cartId, help, cartType, origin, hasWeightedProduct) {
    hasWeightedProduct = hasWeightedProduct === VOID ? null : hasWeightedProduct;
    var tmp = to('cartId', cartId == null ? null : get_value_1(cartId));
    var tmp_0 = to('help', help == null ? null : get_value_0(help));
    var tmp_1 = to('cartType', cartType == null ? null : cartType.value);
    var tmp_2 = to('origin', origin == null ? null : origin.value);
    var tmp_3 = mapOf([tmp, tmp_0, tmp_1, tmp_2, to('hasWeightedProduct', hasWeightedProduct == null ? null : get_value_0(hasWeightedProduct))]);
    var tmp6_elvis_lhs = cartType == null ? null : cartType.data;
    var tmp_4 = plus(tmp_3, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs);
    var tmp8_elvis_lhs = origin == null ? null : origin.data;
    Event.call(this, 'CartLoaded', VOID, 'CK: Checkout', plus(tmp_4, tmp8_elvis_lhs == null ? emptyMap() : tmp8_elvis_lhs));
  }
  function Metadata_22() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_22).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_22;
  function Metadata_getInstance_22() {
    return Metadata_instance_22;
  }
  function CartProductImpression(productId, productExternalId, cartId, cartType, storeAddressId, productPosition, description, price, hasPicture, promotionId, categoryId, isSponsored, isLastProduct, storeProductId) {
    productExternalId = productExternalId === VOID ? null : productExternalId;
    productPosition = productPosition === VOID ? null : productPosition;
    description = description === VOID ? null : description;
    promotionId = promotionId === VOID ? null : promotionId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('productExternalId', productExternalId == null ? null : get_value(productExternalId));
    var tmp_1 = to('cartId', cartId == null ? null : get_value_1(cartId));
    var tmp_2 = to('cartType', cartType == null ? null : cartType.value);
    var tmp_3 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_4 = to('productPosition', productPosition == null ? null : get_value_1(productPosition));
    var tmp_5 = to('description', description == null ? null : get_value(description));
    var tmp_6 = to('price', price == null ? null : get_value_1(price));
    var tmp_7 = to('hasPicture', hasPicture == null ? null : get_value_0(hasPicture));
    var tmp_8 = to('promotionId', promotionId == null ? null : get_value_1(promotionId));
    var tmp_9 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_10 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_11 = to('isLastProduct', isLastProduct == null ? null : get_value_0(isLastProduct));
    var tmp_12 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]);
    var tmp15_elvis_lhs = cartType == null ? null : cartType.data;
    Event.call(this, 'Cart Product Impression', VOID, 'CK: Checkout', plus(tmp_12, tmp15_elvis_lhs == null ? emptyMap() : tmp15_elvis_lhs));
  }
  function Metadata_23() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_23).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_23;
  function Metadata_getInstance_23() {
    return Metadata_instance_23;
  }
  function CartRecoveryStarted(storeAddressId, total, categoryId, numberOfProducts, cartId, creationSessionId, timeElapsed) {
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('total', total == null ? null : get_value_1(total));
    var tmp_1 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_2 = to('numberOfProducts', numberOfProducts == null ? null : get_value_1(numberOfProducts));
    var tmp_3 = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_4 = to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId));
    Event.call(this, 'Cart Recovery Started', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('timeElapsed', timeElapsed == null ? null : get_value_1(timeElapsed))]));
  }
  function Metadata_24() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_24).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_24;
  function Metadata_getInstance_24() {
    return Metadata_instance_24;
  }
  function CartRemovalButtonClicked(cartId, storeAddressId, creationSessionId) {
    var tmp = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Cart Removal Button Clicked', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId))]));
  }
  function Metadata_25() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_25).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_25;
  function Metadata_getInstance_25() {
    return Metadata_instance_25;
  }
  function CartRemovalModalConfirmed(cartId, storeAddressId, creationSessionId) {
    var tmp = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Cart Removal Modal Confirmed', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId))]));
  }
  function Metadata_26() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_26).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_26;
  function Metadata_getInstance_26() {
    return Metadata_instance_26;
  }
  function CartRemovalModalDenied(cartId, storeAddressId, creationSessionId) {
    var tmp = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Cart Removal Modal Denied.', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId))]));
  }
  function ProductNotAvailable(productIds, productExternalIds, productQuantities, productPrices, storeProductIds, pnaInstructions) {
    productIds = productIds === VOID ? null : productIds;
    productExternalIds = productExternalIds === VOID ? null : productExternalIds;
    productQuantities = productQuantities === VOID ? null : productQuantities;
    productPrices = productPrices === VOID ? null : productPrices;
    storeProductIds = storeProductIds === VOID ? null : storeProductIds;
    pnaInstructions = pnaInstructions === VOID ? null : pnaInstructions;
    var tmp = to('productIds', productIds == null ? null : get_value_2(productIds));
    var tmp_0 = to('productExternalIds', productExternalIds == null ? null : get_value_2(productExternalIds));
    var tmp_1 = to('productQuantities', productQuantities == null ? null : get_value_2(productQuantities));
    var tmp_2 = to('productPrices', productPrices == null ? null : get_value_2(productPrices));
    var tmp_3 = to('storeProductIds', storeProductIds == null ? null : get_value_2(storeProductIds));
    CartType.call(this, 'ProductNotAvailable', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('pnaInstructions', pnaInstructions == null ? null : get_value_2(pnaInstructions))]));
  }
  protoOf(ProductNotAvailable).toString = function () {
    return 'ProductNotAvailable(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function ProductList(productIds, productExternalIds, productQuantities, productPrices, storeProductIds, pnaInstructions) {
    productIds = productIds === VOID ? null : productIds;
    productExternalIds = productExternalIds === VOID ? null : productExternalIds;
    productQuantities = productQuantities === VOID ? null : productQuantities;
    productPrices = productPrices === VOID ? null : productPrices;
    storeProductIds = storeProductIds === VOID ? null : storeProductIds;
    pnaInstructions = pnaInstructions === VOID ? null : pnaInstructions;
    var tmp = to('productIds', productIds == null ? null : get_value_2(productIds));
    var tmp_0 = to('productExternalIds', productExternalIds == null ? null : get_value_2(productExternalIds));
    var tmp_1 = to('productQuantities', productQuantities == null ? null : get_value_2(productQuantities));
    var tmp_2 = to('productPrices', productPrices == null ? null : get_value_2(productPrices));
    var tmp_3 = to('storeProductIds', storeProductIds == null ? null : get_value_2(storeProductIds));
    CartType.call(this, 'ProductList', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('pnaInstructions', pnaInstructions == null ? null : get_value_2(pnaInstructions))]));
  }
  protoOf(ProductList).toString = function () {
    return 'ProductList(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function EmptyCart() {
    EmptyCart_instance = this;
    CartType.call(this, 'EmptyCart');
  }
  protoOf(EmptyCart).toString = function () {
    return 'EmptyCart(value=' + this.value + ')';
  };
  var EmptyCart_instance;
  function EmptyCart_getInstance() {
    if (EmptyCart_instance == null)
      new EmptyCart();
    return EmptyCart_instance;
  }
  function CartType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(CartType).r = function () {
    return this.value;
  };
  protoOf(CartType).qa = function () {
    return this.data;
  };
  protoOf(CartType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(CartType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof CartType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Metadata_27() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_27).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_27;
  function Metadata_getInstance_27() {
    return Metadata_instance_27;
  }
  function CashAmountConfirmed(checkoutSessionId, totalOrderValue, cashAmount, exactAmountSelected, isPaymentPickup) {
    var tmp = to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId));
    var tmp_0 = to('totalOrderValue', totalOrderValue == null ? null : get_value_1(totalOrderValue));
    var tmp_1 = to('cashAmount', cashAmount == null ? null : get_value_1(cashAmount));
    var tmp_2 = to('exactAmountSelected', exactAmountSelected == null ? null : get_value_0(exactAmountSelected));
    Event.call(this, 'Cash Amount Confirmed', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('isPaymentPickup', isPaymentPickup == null ? null : get_value_0(isPaymentPickup))]));
  }
  function Metadata_28() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_28).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_28;
  function Metadata_getInstance_28() {
    return Metadata_instance_28;
  }
  function CashAmountScreen(checkoutSessionId) {
    Screen.call(this, 'Cash Amount Screen', 'CK: Checkout', mapOf_0(to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))));
  }
  function CategoryGroup(groupId, groupName) {
    var tmp = to('groupId', groupId == null ? null : get_value_1(groupId));
    Screen.call(this, 'Category Group', VOID, mapOf([tmp, to('groupName', groupName == null ? null : get_value(groupName))]));
  }
  function CategoryGroupContentShown(groupId, groupName, loadedCategories, inactiveCategories, loadedStoreGroupCategories, inactiveStoreGroupCategories, loadedStoreCategories, inactiveStoreCategories, bubbleStates, sponsoredStoreCategories) {
    bubbleStates = bubbleStates === VOID ? null : bubbleStates;
    sponsoredStoreCategories = sponsoredStoreCategories === VOID ? null : sponsoredStoreCategories;
    var tmp = to('groupId', groupId == null ? null : get_value_1(groupId));
    var tmp_0 = to('groupName', groupName == null ? null : get_value(groupName));
    var tmp_1 = to('loadedCategories', loadedCategories == null ? null : get_value_2(loadedCategories));
    var tmp_2 = to('inactiveCategories', inactiveCategories == null ? null : get_value_2(inactiveCategories));
    var tmp_3 = to('loadedStoreGroupCategories', loadedStoreGroupCategories == null ? null : get_value_2(loadedStoreGroupCategories));
    var tmp_4 = to('inactiveStoreGroupCategories', inactiveStoreGroupCategories == null ? null : get_value_2(inactiveStoreGroupCategories));
    var tmp_5 = to('loadedStoreCategories', loadedStoreCategories == null ? null : get_value_2(loadedStoreCategories));
    var tmp_6 = to('inactiveStoreCategories', inactiveStoreCategories == null ? null : get_value_2(inactiveStoreCategories));
    var tmp_7 = to('bubbleStates', bubbleStates == null ? null : get_value_2(bubbleStates));
    Event.call(this, 'Category Group Content Shown', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, to('sponsoredStoreCategories', sponsoredStoreCategories == null ? null : get_value_2(sponsoredStoreCategories))]));
  }
  function CategoryGroupOpened(groupId, groupName) {
    var tmp = to('groupId', groupId == null ? null : get_value_1(groupId));
    Event.call(this, 'Category Group Opened', VOID, VOID, mapOf([tmp, to('groupName', groupName == null ? null : get_value(groupName))]));
  }
  function CategoryOpened(categoryId, categoryName, isSponsored, properties) {
    isSponsored = isSponsored === VOID ? null : isSponsored;
    properties = properties === VOID ? null : properties;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('categoryName', categoryName == null ? null : get_value(categoryName));
    var tmp_1 = mapOf([tmp, tmp_0, to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored))]);
    var tmp4_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Category Opened', VOID, VOID, plus(tmp_1, tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs));
  }
  var ChatNotificationType_CustomerCourier_instance;
  var ChatNotificationType_Proactive_instance;
  var ChatNotificationType_Support_instance;
  function values_17() {
    return [ChatNotificationType_CustomerCourier_getInstance(), ChatNotificationType_Proactive_getInstance(), ChatNotificationType_Support_getInstance()];
  }
  function valueOf_17(value) {
    switch (value) {
      case 'CustomerCourier':
        return ChatNotificationType_CustomerCourier_getInstance();
      case 'Proactive':
        return ChatNotificationType_Proactive_getInstance();
      case 'Support':
        return ChatNotificationType_Support_getInstance();
      default:
        ChatNotificationType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ChatNotificationType_entriesInitialized;
  function ChatNotificationType_initEntries() {
    if (ChatNotificationType_entriesInitialized)
      return Unit_instance;
    ChatNotificationType_entriesInitialized = true;
    ChatNotificationType_CustomerCourier_instance = new ChatNotificationType('CustomerCourier', 0, 'CUSTOMER-COURIER');
    ChatNotificationType_Proactive_instance = new ChatNotificationType('Proactive', 1, 'PROACTIVE');
    ChatNotificationType_Support_instance = new ChatNotificationType('Support', 2, 'SUPPORT');
  }
  function ChatNotificationType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ChatNotificationType).r = function () {
    return this.value;
  };
  function ChatNotificationType_CustomerCourier_getInstance() {
    ChatNotificationType_initEntries();
    return ChatNotificationType_CustomerCourier_instance;
  }
  function ChatNotificationType_Proactive_getInstance() {
    ChatNotificationType_initEntries();
    return ChatNotificationType_Proactive_instance;
  }
  function ChatNotificationType_Support_getInstance() {
    ChatNotificationType_initEntries();
    return ChatNotificationType_Support_instance;
  }
  var ChatProvider_Kustomer_instance;
  var ChatProvider_Smooch_instance;
  var ChatProvider_SendBird_instance;
  function values_18() {
    return [ChatProvider_Kustomer_getInstance(), ChatProvider_Smooch_getInstance(), ChatProvider_SendBird_getInstance()];
  }
  function valueOf_18(value) {
    switch (value) {
      case 'Kustomer':
        return ChatProvider_Kustomer_getInstance();
      case 'Smooch':
        return ChatProvider_Smooch_getInstance();
      case 'SendBird':
        return ChatProvider_SendBird_getInstance();
      default:
        ChatProvider_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ChatProvider_entriesInitialized;
  function ChatProvider_initEntries() {
    if (ChatProvider_entriesInitialized)
      return Unit_instance;
    ChatProvider_entriesInitialized = true;
    ChatProvider_Kustomer_instance = new ChatProvider('Kustomer', 0, 'Kustomer');
    ChatProvider_Smooch_instance = new ChatProvider('Smooch', 1, 'Smooch');
    ChatProvider_SendBird_instance = new ChatProvider('SendBird', 2, 'SendBird');
  }
  function ChatProvider(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ChatProvider).r = function () {
    return this.value;
  };
  function ChatProvider_Kustomer_getInstance() {
    ChatProvider_initEntries();
    return ChatProvider_Kustomer_instance;
  }
  function ChatProvider_Smooch_getInstance() {
    ChatProvider_initEntries();
    return ChatProvider_Smooch_instance;
  }
  function ChatProvider_SendBird_getInstance() {
    ChatProvider_initEntries();
    return ChatProvider_SendBird_instance;
  }
  var ChatType_Kustomer_instance;
  var ChatType_Smooch_instance;
  var ChatType_Support_instance;
  var ChatType_CCchat_instance;
  function values_19() {
    return [ChatType_Kustomer_getInstance(), ChatType_Smooch_getInstance(), ChatType_Support_getInstance(), ChatType_CCchat_getInstance()];
  }
  function valueOf_19(value) {
    switch (value) {
      case 'Kustomer':
        return ChatType_Kustomer_getInstance();
      case 'Smooch':
        return ChatType_Smooch_getInstance();
      case 'Support':
        return ChatType_Support_getInstance();
      case 'CCchat':
        return ChatType_CCchat_getInstance();
      default:
        ChatType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ChatType_entriesInitialized;
  function ChatType_initEntries() {
    if (ChatType_entriesInitialized)
      return Unit_instance;
    ChatType_entriesInitialized = true;
    ChatType_Kustomer_instance = new ChatType('Kustomer', 0, 'Kustomer');
    ChatType_Smooch_instance = new ChatType('Smooch', 1, 'Smooch');
    ChatType_Support_instance = new ChatType('Support', 2, 'Support');
    ChatType_CCchat_instance = new ChatType('CCchat', 3, 'CCchat');
  }
  function ChatType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ChatType).r = function () {
    return this.value;
  };
  function ChatType_Kustomer_getInstance() {
    ChatType_initEntries();
    return ChatType_Kustomer_instance;
  }
  function ChatType_Smooch_getInstance() {
    ChatType_initEntries();
    return ChatType_Smooch_instance;
  }
  function ChatType_Support_getInstance() {
    ChatType_initEntries();
    return ChatType_Support_instance;
  }
  function ChatType_CCchat_getInstance() {
    ChatType_initEntries();
    return ChatType_CCchat_instance;
  }
  function Metadata_29() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_29).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_29;
  function Metadata_getInstance_29() {
    return Metadata_instance_29;
  }
  function Checkout(orderType, categoryId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('orderType', orderType == null ? null : orderType.value);
    var tmp_0 = mapOf([tmp, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]);
    var tmp3_elvis_lhs = orderType == null ? null : orderType.data;
    Screen.call(this, 'Checkout', 'CK: Checkout', plus(tmp_0, tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs));
  }
  function Metadata_30() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_30).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_30;
  function Metadata_getInstance_30() {
    return Metadata_instance_30;
  }
  function CheckoutComponentShown(componentId, versionId, checkoutSessionId, visualizationVariant, storeId, storeAddressId) {
    visualizationVariant = visualizationVariant === VOID ? null : visualizationVariant;
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('componentId', componentId == null ? null : get_value(componentId));
    var tmp_0 = to('versionId', versionId == null ? null : get_value(versionId));
    var tmp_1 = to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId));
    var tmp_2 = to('visualizationVariant', visualizationVariant == null ? null : get_value(visualizationVariant));
    var tmp_3 = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Checkout Component Shown', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  function Metadata_31() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_31).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_31;
  function Metadata_getInstance_31() {
    return Metadata_instance_31;
  }
  function CheckoutConfirmationButtonPressed(orderType, categoryId, isValid, invalidComponentIds, checkoutId, templateId, versionId) {
    categoryId = categoryId === VOID ? null : categoryId;
    invalidComponentIds = invalidComponentIds === VOID ? null : invalidComponentIds;
    var tmp = to('orderType', orderType == null ? null : orderType.value);
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('isValid', isValid == null ? null : get_value_0(isValid));
    var tmp_2 = to('invalidComponentIds', invalidComponentIds == null ? null : get_value_2(invalidComponentIds));
    var tmp_3 = to('checkoutId', checkoutId == null ? null : get_value(checkoutId));
    var tmp_4 = to('templateId', templateId == null ? null : get_value_1(templateId));
    var tmp_5 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('versionId', versionId == null ? null : get_value_1(versionId))]);
    var tmp8_elvis_lhs = orderType == null ? null : orderType.data;
    Event.call(this, 'Checkout Confirmation Button Pressed', VOID, 'CK: Checkout', plus(tmp_5, tmp8_elvis_lhs == null ? emptyMap() : tmp8_elvis_lhs));
  }
  function Metadata_32() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_32).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_32;
  function Metadata_getInstance_32() {
    return Metadata_instance_32;
  }
  function CheckoutContentShown(orderType, categoryId, templateId, versionId, checkoutId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('orderType', orderType == null ? null : orderType.value);
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('templateId', templateId == null ? null : get_value_1(templateId));
    var tmp_2 = to('versionId', versionId == null ? null : get_value_1(versionId));
    var tmp_3 = mapOf([tmp, tmp_0, tmp_1, tmp_2, to('checkoutId', checkoutId == null ? null : get_value(checkoutId))]);
    var tmp6_elvis_lhs = orderType == null ? null : orderType.data;
    Event.call(this, 'Checkout Content Shown', VOID, 'CK: Checkout', plus(tmp_3, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs));
  }
  function Metadata_33() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_33).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_33;
  function Metadata_getInstance_33() {
    return Metadata_instance_33;
  }
  function CheckoutCountdownContinueButtonPressed(checkoutSessionId) {
    Event.call(this, 'Checkout Countdown Continue Button Pressed', VOID, 'CK: Checkout', mapOf_0(to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))));
  }
  function Metadata_34() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_34).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_34;
  function Metadata_getInstance_34() {
    return Metadata_instance_34;
  }
  function CheckoutCountdownFinished(checkoutSessionId, isForeground) {
    var tmp = to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId));
    Event.call(this, 'Checkout Countdown Finished', VOID, 'CK: Checkout', mapOf([tmp, to('isForeground', isForeground == null ? null : get_value_0(isForeground))]));
  }
  function Metadata_35() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_35).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_35;
  function Metadata_getInstance_35() {
    return Metadata_instance_35;
  }
  function CheckoutCountdownModifyButtonPressed(checkoutSessionId) {
    Event.call(this, 'Checkout Countdown Modify Button Pressed', VOID, 'CK: Checkout', mapOf_0(to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))));
  }
  function Metadata_36() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_36).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_36;
  function Metadata_getInstance_36() {
    return Metadata_instance_36;
  }
  function CheckoutCountdownScreenShown(checkoutSessionId) {
    Screen.call(this, 'Checkout Countdown Screen Shown', 'CK: Checkout', mapOf_0(to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))));
  }
  function Metadata_37() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_37).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_37;
  function Metadata_getInstance_37() {
    return Metadata_instance_37;
  }
  function CheckoutMapHyperlinkClicked(storeAddressId, coordinatesLatitude, coordinatesLongitude) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    coordinatesLatitude = coordinatesLatitude === VOID ? null : coordinatesLatitude;
    coordinatesLongitude = coordinatesLongitude === VOID ? null : coordinatesLongitude;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('coordinatesLatitude', coordinatesLatitude == null ? null : get_value_1(coordinatesLatitude));
    Event.call(this, 'Checkout Map Hyperlink Clicked', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, to('coordinatesLongitude', coordinatesLongitude == null ? null : get_value_1(coordinatesLongitude))]));
  }
  function Metadata_38() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_38).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_38;
  function Metadata_getInstance_38() {
    return Metadata_instance_38;
  }
  function CheckoutOrderButtonPressed(properties, validationErrors, orderSubmitted, paymentMethod, origin, isReorder, searchId) {
    validationErrors = validationErrors === VOID ? null : validationErrors;
    paymentMethod = paymentMethod === VOID ? null : paymentMethod;
    origin = origin === VOID ? null : origin;
    isReorder = isReorder === VOID ? null : isReorder;
    searchId = searchId === VOID ? null : searchId;
    var tmp = to('validationErrors', validationErrors == null ? null : get_value(validationErrors));
    var tmp_0 = to('orderSubmitted', orderSubmitted == null ? null : get_value_0(orderSubmitted));
    var tmp_1 = to('paymentMethod', paymentMethod == null ? null : paymentMethod.value);
    var tmp_2 = to('origin', origin == null ? null : origin.value);
    var tmp_3 = to('isReorder', isReorder == null ? null : get_value_0(isReorder));
    var tmp_4 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('searchId', searchId == null ? null : get_value(searchId))]);
    var tmp7_elvis_lhs = properties == null ? null : get_data(properties);
    var tmp_5 = plus(tmp_4, tmp7_elvis_lhs == null ? emptyMap() : tmp7_elvis_lhs);
    var tmp9_elvis_lhs = paymentMethod == null ? null : paymentMethod.data;
    Event.call(this, 'Checkout Order Button Pressed', VOID, 'CK: Checkout', plus(tmp_5, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs));
  }
  function Metadata_39() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_39).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_39;
  function Metadata_getInstance_39() {
    return Metadata_instance_39;
  }
  function CheckoutOrderConfirmation(properties) {
    var tmp1_elvis_lhs = properties == null ? null : get_data(properties);
    Screen.call(this, 'Checkout Order Confirmation', 'CK: Checkout', tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs);
  }
  function Metadata_40() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_40).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_40;
  function Metadata_getInstance_40() {
    return Metadata_instance_40;
  }
  function CheckoutPrimeBannerShown(properties) {
    var tmp1_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Checkout Prime Banner Shown', VOID, 'CK: Checkout', tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs);
  }
  function Metadata_41() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_41).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_41;
  function Metadata_getInstance_41() {
    return Metadata_instance_41;
  }
  function CheckoutTemplateReceived(properties) {
    var tmp1_elvis_lhs = properties == null ? null : get_data(properties);
    Screen.call(this, 'Checkout Template Received', 'CK: Checkout', tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs);
  }
  function CollectionGroupImpression(collectionGroupId, storeAddressId, hasPicture, collectionGroupPosition, collectionGroupHorizontalPosition, categoryId, numberOfCollections) {
    hasPicture = hasPicture === VOID ? null : hasPicture;
    collectionGroupHorizontalPosition = collectionGroupHorizontalPosition === VOID ? null : collectionGroupHorizontalPosition;
    categoryId = categoryId === VOID ? null : categoryId;
    numberOfCollections = numberOfCollections === VOID ? null : numberOfCollections;
    var tmp = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('hasPicture', hasPicture == null ? null : get_value_0(hasPicture));
    var tmp_2 = to('collectionGroupPosition', collectionGroupPosition == null ? null : get_value_1(collectionGroupPosition));
    var tmp_3 = to('collectionGroupHorizontalPosition', collectionGroupHorizontalPosition == null ? null : get_value_1(collectionGroupHorizontalPosition));
    var tmp_4 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Event.call(this, 'Collection Group Impression', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('numberOfCollections', numberOfCollections == null ? null : get_value_1(numberOfCollections))]));
  }
  function CollectionGroupOpened(collectionGroupId, storeAddressId, collectionIds, categoryId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('collectionIds', collectionIds == null ? null : get_value_2(collectionIds));
    Event.call(this, 'Collection Group Opened', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  function CollectionImpression(collectionGroupId, storeAddressId, numberOfPictures, collectionPosition, collectionOrigin, collectionType, categoryId, widgetId) {
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    numberOfPictures = numberOfPictures === VOID ? null : numberOfPictures;
    collectionPosition = collectionPosition === VOID ? null : collectionPosition;
    collectionType = collectionType === VOID ? null : collectionType;
    categoryId = categoryId === VOID ? null : categoryId;
    widgetId = widgetId === VOID ? null : widgetId;
    var tmp = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('numberOfPictures', numberOfPictures == null ? null : get_value_1(numberOfPictures));
    var tmp_2 = to('collectionPosition', collectionPosition == null ? null : get_value_1(collectionPosition));
    var tmp_3 = to('collectionOrigin', collectionOrigin == null ? null : collectionOrigin.value);
    var tmp_4 = to('collectionType', collectionType == null ? null : collectionType.value);
    var tmp_5 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_6 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('widgetId', widgetId == null ? null : get_value(widgetId))]);
    var tmp9_elvis_lhs = collectionOrigin == null ? null : collectionOrigin.data;
    var tmp_7 = plus(tmp_6, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs);
    var tmp11_elvis_lhs = collectionType == null ? null : collectionType.data;
    Event.call(this, 'Collection Impression', VOID, VOID, plus(tmp_7, tmp11_elvis_lhs == null ? emptyMap() : tmp11_elvis_lhs));
  }
  function CollectionOpened(storeAddressId, categoryId, collectionGroupId, collectionType, collectionOpenedOrigin, collectionName, collectionGroupName, collectionGroupType, positionRow, positionColumn, numberOfProducts, storeAddressIds) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    categoryId = categoryId === VOID ? null : categoryId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    collectionType = collectionType === VOID ? null : collectionType;
    collectionOpenedOrigin = collectionOpenedOrigin === VOID ? null : collectionOpenedOrigin;
    collectionName = collectionName === VOID ? null : collectionName;
    collectionGroupName = collectionGroupName === VOID ? null : collectionGroupName;
    collectionGroupType = collectionGroupType === VOID ? null : collectionGroupType;
    positionRow = positionRow === VOID ? null : positionRow;
    positionColumn = positionColumn === VOID ? null : positionColumn;
    numberOfProducts = numberOfProducts === VOID ? null : numberOfProducts;
    storeAddressIds = storeAddressIds === VOID ? null : storeAddressIds;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_2 = to('collectionType', collectionType == null ? null : collectionType.value);
    var tmp_3 = to('collectionOpenedOrigin', collectionOpenedOrigin == null ? null : collectionOpenedOrigin.value);
    var tmp_4 = to('collectionName', collectionName == null ? null : get_value(collectionName));
    var tmp_5 = to('collectionGroupName', collectionGroupName == null ? null : get_value(collectionGroupName));
    var tmp_6 = to('collectionGroupType', collectionGroupType == null ? null : get_value(collectionGroupType));
    var tmp_7 = to('positionRow', positionRow == null ? null : get_value_1(positionRow));
    var tmp_8 = to('positionColumn', positionColumn == null ? null : get_value_1(positionColumn));
    var tmp_9 = to('numberOfProducts', numberOfProducts == null ? null : get_value(numberOfProducts));
    var tmp_10 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, to('storeAddressIds', storeAddressIds == null ? null : get_value_2(storeAddressIds))]);
    var tmp13_elvis_lhs = collectionType == null ? null : collectionType.data;
    var tmp_11 = plus(tmp_10, tmp13_elvis_lhs == null ? emptyMap() : tmp13_elvis_lhs);
    var tmp15_elvis_lhs = collectionOpenedOrigin == null ? null : collectionOpenedOrigin.data;
    Event.call(this, 'Collection Opened', VOID, VOID, plus(tmp_11, tmp15_elvis_lhs == null ? emptyMap() : tmp15_elvis_lhs));
  }
  function CollectionGroup() {
    CollectionGroup_instance = this;
    CollectionOrigin.call(this, 'CollectionGroup');
  }
  protoOf(CollectionGroup).toString = function () {
    return 'CollectionGroup(value=' + this.value + ')';
  };
  var CollectionGroup_instance;
  function CollectionGroup_getInstance() {
    if (CollectionGroup_instance == null)
      new CollectionGroup();
    return CollectionGroup_instance;
  }
  function NestedCollectionGroup() {
    NestedCollectionGroup_instance = this;
    CollectionOrigin.call(this, 'NestedCollectionGroup');
  }
  protoOf(NestedCollectionGroup).toString = function () {
    return 'NestedCollectionGroup(value=' + this.value + ')';
  };
  var NestedCollectionGroup_instance;
  function NestedCollectionGroup_getInstance() {
    if (NestedCollectionGroup_instance == null)
      new NestedCollectionGroup();
    return NestedCollectionGroup_instance;
  }
  function NavigationMenu() {
    NavigationMenu_instance = this;
    CollectionOrigin.call(this, 'NavigationMenu');
  }
  protoOf(NavigationMenu).toString = function () {
    return 'NavigationMenu(value=' + this.value + ')';
  };
  var NavigationMenu_instance;
  function NavigationMenu_getInstance() {
    if (NavigationMenu_instance == null)
      new NavigationMenu();
    return NavigationMenu_instance;
  }
  function ContentExpansionButton() {
    ContentExpansionButton_instance = this;
    CollectionOrigin.call(this, 'ContentExpansionButton');
  }
  protoOf(ContentExpansionButton).toString = function () {
    return 'ContentExpansionButton(value=' + this.value + ')';
  };
  var ContentExpansionButton_instance;
  function ContentExpansionButton_getInstance() {
    if (ContentExpansionButton_instance == null)
      new ContentExpansionButton();
    return ContentExpansionButton_instance;
  }
  function StoreHomeMosaic() {
    StoreHomeMosaic_instance = this;
    CollectionOrigin.call(this, 'StoreHomeMosaic');
  }
  protoOf(StoreHomeMosaic).toString = function () {
    return 'StoreHomeMosaic(value=' + this.value + ')';
  };
  var StoreHomeMosaic_instance;
  function StoreHomeMosaic_getInstance() {
    if (StoreHomeMosaic_instance == null)
      new StoreHomeMosaic();
    return StoreHomeMosaic_instance;
  }
  function SearchArrow() {
    SearchArrow_instance = this;
    CollectionOrigin.call(this, 'SearchArrow');
  }
  protoOf(SearchArrow).toString = function () {
    return 'SearchArrow(value=' + this.value + ')';
  };
  var SearchArrow_instance;
  function SearchArrow_getInstance() {
    if (SearchArrow_instance == null)
      new SearchArrow();
    return SearchArrow_instance;
  }
  function Deeplink() {
    Deeplink_instance = this;
    CollectionOrigin.call(this, 'Deeplink');
  }
  protoOf(Deeplink).toString = function () {
    return 'Deeplink(value=' + this.value + ')';
  };
  var Deeplink_instance;
  function Deeplink_getInstance() {
    if (Deeplink_instance == null)
      new Deeplink();
    return Deeplink_instance;
  }
  function Widget(widgetId, widgetAppLocation) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    CollectionOrigin.call(this, 'Widget', mapOf([tmp, to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation))]));
  }
  protoOf(Widget).toString = function () {
    return 'Widget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CollectionOrigin(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(CollectionOrigin).r = function () {
    return this.value;
  };
  protoOf(CollectionOrigin).qa = function () {
    return this.data;
  };
  protoOf(CollectionOrigin).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(CollectionOrigin).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof CollectionOrigin) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Catalogue(collectionId) {
    CollectionType.call(this, 'Catalogue', mapOf_0(to('collectionId', collectionId == null ? null : get_value_1(collectionId))));
  }
  protoOf(Catalogue).toString = function () {
    return 'Catalogue(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function EasyReorder() {
    EasyReorder_instance = this;
    CollectionType.call(this, 'EasyReorder');
  }
  protoOf(EasyReorder).toString = function () {
    return 'EasyReorder(value=' + this.value + ')';
  };
  var EasyReorder_instance;
  function EasyReorder_getInstance() {
    if (EasyReorder_instance == null)
      new EasyReorder();
    return EasyReorder_instance;
  }
  function TopSellers() {
    TopSellers_instance = this;
    CollectionType.call(this, 'TopSellers');
  }
  protoOf(TopSellers).toString = function () {
    return 'TopSellers(value=' + this.value + ')';
  };
  var TopSellers_instance;
  function TopSellers_getInstance() {
    if (TopSellers_instance == null)
      new TopSellers();
    return TopSellers_instance;
  }
  function Promotions() {
    Promotions_instance = this;
    CollectionType.call(this, 'Promotions');
  }
  protoOf(Promotions).toString = function () {
    return 'Promotions(value=' + this.value + ')';
  };
  var Promotions_instance;
  function Promotions_getInstance() {
    if (Promotions_instance == null)
      new Promotions();
    return Promotions_instance;
  }
  function MealsUnderX() {
    MealsUnderX_instance = this;
    CollectionType.call(this, 'MealsUnderX');
  }
  protoOf(MealsUnderX).toString = function () {
    return 'MealsUnderX(value=' + this.value + ')';
  };
  var MealsUnderX_instance;
  function MealsUnderX_getInstance() {
    if (MealsUnderX_instance == null)
      new MealsUnderX();
    return MealsUnderX_instance;
  }
  function CollectionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(CollectionType).r = function () {
    return this.value;
  };
  protoOf(CollectionType).qa = function () {
    return this.data;
  };
  protoOf(CollectionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(CollectionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof CollectionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var ConnectionSource_Profile_instance;
  var ConnectionSource_PushNotification_instance;
  var ConnectionSource_BottomSheet_instance;
  var ConnectionSource_FLPBanner_instance;
  function values_20() {
    return [ConnectionSource_Profile_getInstance(), ConnectionSource_PushNotification_getInstance(), ConnectionSource_BottomSheet_getInstance(), ConnectionSource_FLPBanner_getInstance()];
  }
  function valueOf_20(value) {
    switch (value) {
      case 'Profile':
        return ConnectionSource_Profile_getInstance();
      case 'PushNotification':
        return ConnectionSource_PushNotification_getInstance();
      case 'BottomSheet':
        return ConnectionSource_BottomSheet_getInstance();
      case 'FLPBanner':
        return ConnectionSource_FLPBanner_getInstance();
      default:
        ConnectionSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ConnectionSource_entriesInitialized;
  function ConnectionSource_initEntries() {
    if (ConnectionSource_entriesInitialized)
      return Unit_instance;
    ConnectionSource_entriesInitialized = true;
    ConnectionSource_Profile_instance = new ConnectionSource('Profile', 0, 'profile');
    ConnectionSource_PushNotification_instance = new ConnectionSource('PushNotification', 1, 'push_notification');
    ConnectionSource_BottomSheet_instance = new ConnectionSource('BottomSheet', 2, 'bottom_sheet');
    ConnectionSource_FLPBanner_instance = new ConnectionSource('FLPBanner', 3, 'flp_banner');
  }
  function ConnectionSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ConnectionSource).r = function () {
    return this.value;
  };
  function ConnectionSource_Profile_getInstance() {
    ConnectionSource_initEntries();
    return ConnectionSource_Profile_instance;
  }
  function ConnectionSource_PushNotification_getInstance() {
    ConnectionSource_initEntries();
    return ConnectionSource_PushNotification_instance;
  }
  function ConnectionSource_BottomSheet_getInstance() {
    ConnectionSource_initEntries();
    return ConnectionSource_BottomSheet_instance;
  }
  function ConnectionSource_FLPBanner_getInstance() {
    ConnectionSource_initEntries();
    return ConnectionSource_FLPBanner_instance;
  }
  function Metadata_42() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_42).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_42;
  function Metadata_getInstance_42() {
    return Metadata_instance_42;
  }
  function ConsentFirstLayerApplied(isInEU, properties) {
    var tmp = mapOf_0(to('isInEU', isInEU == null ? null : get_value_0(isInEU)));
    var tmp2_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Consent First Layer Applied', VOID, 'GRO: Growth', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function Metadata_43() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_43).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_43;
  function Metadata_getInstance_43() {
    return Metadata_instance_43;
  }
  function ConsentFirstLayerNotNeeded(isInEU, properties) {
    var tmp = mapOf_0(to('isInEU', isInEU == null ? null : get_value_0(isInEU)));
    var tmp2_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Consent First Layer Not Needed', VOID, 'GRO: Growth', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function Metadata_44() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_44).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_44;
  function Metadata_getInstance_44() {
    return Metadata_instance_44;
  }
  function ConsentFirstLayerShown() {
    Event.call(this, 'Consent First Layer Shown', VOID, 'GRO: Growth');
  }
  function Metadata_45() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_45).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_45;
  function Metadata_getInstance_45() {
    return Metadata_instance_45;
  }
  function ConsentSecondLayerApplied(isInEU, properties) {
    var tmp = mapOf_0(to('isInEU', isInEU == null ? null : get_value_0(isInEU)));
    var tmp2_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Consent Second Layer Applied', VOID, 'GRO: Growth', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function Metadata_46() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_46).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_46;
  function Metadata_getInstance_46() {
    return Metadata_instance_46;
  }
  function ConsentSecondLayerShown() {
    Event.call(this, 'Consent Second Layer Shown', VOID, 'GRO: Growth');
  }
  function ContactCourier(orderId, cityId, courierId) {
    orderId = orderId === VOID ? null : orderId;
    cityId = cityId === VOID ? null : cityId;
    courierId = courierId === VOID ? null : courierId;
    var tmp = to('orderId', orderId == null ? null : get_value(orderId));
    var tmp_0 = to('cityId', cityId == null ? null : get_value(cityId));
    Screen.call(this, 'Contact Courier', VOID, mapOf([tmp, tmp_0, to('courierId', courierId == null ? null : get_value(courierId))]));
  }
  var ContactReason_CourierNotMoving_instance;
  var ContactReason_NoCourierOnMap_instance;
  var ContactReason_OrderLate_instance;
  var ContactReason_ChangePaymentMethod_instance;
  var ContactReason_ChangePhoneNumber_instance;
  var ContactReason_ChangeDeliveryAddress_instance;
  var ContactReason_ChangeItems_instance;
  var ContactReason_PromocodeNotValid_instance;
  var ContactReason_PromocodeNotApplied_instance;
  var ContactReason_CheckBalance_instance;
  var ContactReason_NotDelivered_instance;
  var ContactReason_PastOrderLate_instance;
  var ContactReason_OrderCancelled_instance;
  var ContactReason_TastedBad_instance;
  var ContactReason_IncorrectTemperature_instance;
  var ContactReason_PoorQuality_instance;
  var ContactReason_PackagingIssues_instance;
  var ContactReason_AllergyNotConsidered_instance;
  var ContactReason_MissingExtras_instance;
  var ContactReason_MissingProducts_instance;
  var ContactReason_WrongProducts_instance;
  var ContactReason_DidNotMatchPhoto_instance;
  var ContactReason_RudeOrDisrespectful_instance;
  var ContactReason_SanitaryEquipment_instance;
  var ContactReason_RemoveTip_instance;
  var ContactReason_TransportedImproperly_instance;
  var ContactReason_ChargedMultipleTimes_instance;
  var ContactReason_ChargedWrongAmount_instance;
  var ContactReason_ProblemWithCash_instance;
  var ContactReason_PromoCode_instance;
  var ContactReason_SpecialStorePromos_instance;
  var ContactReason_GlovoPrimeBecomeMember_instance;
  var ContactReason_GlovoPrimeHowItWorks_instance;
  var ContactReason_GlovoePrimePaymentIssue_instance;
  var ContactReason_GlovoePrimeUnsuscribe_instance;
  var ContactReason_ChangeEmailAddress_instance;
  var ContactReason_ChangePassword_instance;
  var ContactReason_DeleteAccount_instance;
  var ContactReason_VerifyIdentity_instance;
  var ContactReason_ReceiveGlovoNews_instance;
  var ContactReason_UnsubscribeGlovoNews_instance;
  var ContactReason_HowToOrder_instance;
  var ContactReason_DeliveryArea_instance;
  var ContactReason_ServiceHours_instance;
  var ContactReason_AppAdvantages_instance;
  var ContactReason_DeliveryCosts_instance;
  var ContactReason_PaymentMethods_instance;
  var ContactReason_VehiclesInformation_instance;
  var ContactReason_BecomeGlover_instance;
  var ContactReason_BecomePartner_instance;
  var ContactReason_BecomeColleague_instance;
  var ContactReason_ContactBusinessUnit_instance;
  var ContactReason_ContactPressTeam_instance;
  var ContactReason_RightOfAccess_instance;
  var ContactReason_RightOfModification_instance;
  var ContactReason_PersonalDataRestriction_instance;
  var ContactReason_CancelAccount_instance;
  var ContactReason_RightOfOpposition_instance;
  var ContactReason_TermsAndConditions_instance;
  var ContactReason_PrivacyPolicy_instance;
  function values_21() {
    return [ContactReason_CourierNotMoving_getInstance(), ContactReason_NoCourierOnMap_getInstance(), ContactReason_OrderLate_getInstance(), ContactReason_ChangePaymentMethod_getInstance(), ContactReason_ChangePhoneNumber_getInstance(), ContactReason_ChangeDeliveryAddress_getInstance(), ContactReason_ChangeItems_getInstance(), ContactReason_PromocodeNotValid_getInstance(), ContactReason_PromocodeNotApplied_getInstance(), ContactReason_CheckBalance_getInstance(), ContactReason_NotDelivered_getInstance(), ContactReason_PastOrderLate_getInstance(), ContactReason_OrderCancelled_getInstance(), ContactReason_TastedBad_getInstance(), ContactReason_IncorrectTemperature_getInstance(), ContactReason_PoorQuality_getInstance(), ContactReason_PackagingIssues_getInstance(), ContactReason_AllergyNotConsidered_getInstance(), ContactReason_MissingExtras_getInstance(), ContactReason_MissingProducts_getInstance(), ContactReason_WrongProducts_getInstance(), ContactReason_DidNotMatchPhoto_getInstance(), ContactReason_RudeOrDisrespectful_getInstance(), ContactReason_SanitaryEquipment_getInstance(), ContactReason_RemoveTip_getInstance(), ContactReason_TransportedImproperly_getInstance(), ContactReason_ChargedMultipleTimes_getInstance(), ContactReason_ChargedWrongAmount_getInstance(), ContactReason_ProblemWithCash_getInstance(), ContactReason_PromoCode_getInstance(), ContactReason_SpecialStorePromos_getInstance(), ContactReason_GlovoPrimeBecomeMember_getInstance(), ContactReason_GlovoPrimeHowItWorks_getInstance(), ContactReason_GlovoePrimePaymentIssue_getInstance(), ContactReason_GlovoePrimeUnsuscribe_getInstance(), ContactReason_ChangeEmailAddress_getInstance(), ContactReason_ChangePassword_getInstance(), ContactReason_DeleteAccount_getInstance(), ContactReason_VerifyIdentity_getInstance(), ContactReason_ReceiveGlovoNews_getInstance(), ContactReason_UnsubscribeGlovoNews_getInstance(), ContactReason_HowToOrder_getInstance(), ContactReason_DeliveryArea_getInstance(), ContactReason_ServiceHours_getInstance(), ContactReason_AppAdvantages_getInstance(), ContactReason_DeliveryCosts_getInstance(), ContactReason_PaymentMethods_getInstance(), ContactReason_VehiclesInformation_getInstance(), ContactReason_BecomeGlover_getInstance(), ContactReason_BecomePartner_getInstance(), ContactReason_BecomeColleague_getInstance(), ContactReason_ContactBusinessUnit_getInstance(), ContactReason_ContactPressTeam_getInstance(), ContactReason_RightOfAccess_getInstance(), ContactReason_RightOfModification_getInstance(), ContactReason_PersonalDataRestriction_getInstance(), ContactReason_CancelAccount_getInstance(), ContactReason_RightOfOpposition_getInstance(), ContactReason_TermsAndConditions_getInstance(), ContactReason_PrivacyPolicy_getInstance()];
  }
  function valueOf_21(value) {
    switch (value) {
      case 'CourierNotMoving':
        return ContactReason_CourierNotMoving_getInstance();
      case 'NoCourierOnMap':
        return ContactReason_NoCourierOnMap_getInstance();
      case 'OrderLate':
        return ContactReason_OrderLate_getInstance();
      case 'ChangePaymentMethod':
        return ContactReason_ChangePaymentMethod_getInstance();
      case 'ChangePhoneNumber':
        return ContactReason_ChangePhoneNumber_getInstance();
      case 'ChangeDeliveryAddress':
        return ContactReason_ChangeDeliveryAddress_getInstance();
      case 'ChangeItems':
        return ContactReason_ChangeItems_getInstance();
      case 'PromocodeNotValid':
        return ContactReason_PromocodeNotValid_getInstance();
      case 'PromocodeNotApplied':
        return ContactReason_PromocodeNotApplied_getInstance();
      case 'CheckBalance':
        return ContactReason_CheckBalance_getInstance();
      case 'NotDelivered':
        return ContactReason_NotDelivered_getInstance();
      case 'PastOrderLate':
        return ContactReason_PastOrderLate_getInstance();
      case 'OrderCancelled':
        return ContactReason_OrderCancelled_getInstance();
      case 'TastedBad':
        return ContactReason_TastedBad_getInstance();
      case 'IncorrectTemperature':
        return ContactReason_IncorrectTemperature_getInstance();
      case 'PoorQuality':
        return ContactReason_PoorQuality_getInstance();
      case 'PackagingIssues':
        return ContactReason_PackagingIssues_getInstance();
      case 'AllergyNotConsidered':
        return ContactReason_AllergyNotConsidered_getInstance();
      case 'MissingExtras':
        return ContactReason_MissingExtras_getInstance();
      case 'MissingProducts':
        return ContactReason_MissingProducts_getInstance();
      case 'WrongProducts':
        return ContactReason_WrongProducts_getInstance();
      case 'DidNotMatchPhoto':
        return ContactReason_DidNotMatchPhoto_getInstance();
      case 'RudeOrDisrespectful':
        return ContactReason_RudeOrDisrespectful_getInstance();
      case 'SanitaryEquipment':
        return ContactReason_SanitaryEquipment_getInstance();
      case 'RemoveTip':
        return ContactReason_RemoveTip_getInstance();
      case 'TransportedImproperly':
        return ContactReason_TransportedImproperly_getInstance();
      case 'ChargedMultipleTimes':
        return ContactReason_ChargedMultipleTimes_getInstance();
      case 'ChargedWrongAmount':
        return ContactReason_ChargedWrongAmount_getInstance();
      case 'ProblemWithCash':
        return ContactReason_ProblemWithCash_getInstance();
      case 'PromoCode':
        return ContactReason_PromoCode_getInstance();
      case 'SpecialStorePromos':
        return ContactReason_SpecialStorePromos_getInstance();
      case 'GlovoPrimeBecomeMember':
        return ContactReason_GlovoPrimeBecomeMember_getInstance();
      case 'GlovoPrimeHowItWorks':
        return ContactReason_GlovoPrimeHowItWorks_getInstance();
      case 'GlovoePrimePaymentIssue':
        return ContactReason_GlovoePrimePaymentIssue_getInstance();
      case 'GlovoePrimeUnsuscribe':
        return ContactReason_GlovoePrimeUnsuscribe_getInstance();
      case 'ChangeEmailAddress':
        return ContactReason_ChangeEmailAddress_getInstance();
      case 'ChangePassword':
        return ContactReason_ChangePassword_getInstance();
      case 'DeleteAccount':
        return ContactReason_DeleteAccount_getInstance();
      case 'VerifyIdentity':
        return ContactReason_VerifyIdentity_getInstance();
      case 'ReceiveGlovoNews':
        return ContactReason_ReceiveGlovoNews_getInstance();
      case 'UnsubscribeGlovoNews':
        return ContactReason_UnsubscribeGlovoNews_getInstance();
      case 'HowToOrder':
        return ContactReason_HowToOrder_getInstance();
      case 'DeliveryArea':
        return ContactReason_DeliveryArea_getInstance();
      case 'ServiceHours':
        return ContactReason_ServiceHours_getInstance();
      case 'AppAdvantages':
        return ContactReason_AppAdvantages_getInstance();
      case 'DeliveryCosts':
        return ContactReason_DeliveryCosts_getInstance();
      case 'PaymentMethods':
        return ContactReason_PaymentMethods_getInstance();
      case 'VehiclesInformation':
        return ContactReason_VehiclesInformation_getInstance();
      case 'BecomeGlover':
        return ContactReason_BecomeGlover_getInstance();
      case 'BecomePartner':
        return ContactReason_BecomePartner_getInstance();
      case 'BecomeColleague':
        return ContactReason_BecomeColleague_getInstance();
      case 'ContactBusinessUnit':
        return ContactReason_ContactBusinessUnit_getInstance();
      case 'ContactPressTeam':
        return ContactReason_ContactPressTeam_getInstance();
      case 'RightOfAccess':
        return ContactReason_RightOfAccess_getInstance();
      case 'RightOfModification':
        return ContactReason_RightOfModification_getInstance();
      case 'PersonalDataRestriction':
        return ContactReason_PersonalDataRestriction_getInstance();
      case 'CancelAccount':
        return ContactReason_CancelAccount_getInstance();
      case 'RightOfOpposition':
        return ContactReason_RightOfOpposition_getInstance();
      case 'TermsAndConditions':
        return ContactReason_TermsAndConditions_getInstance();
      case 'PrivacyPolicy':
        return ContactReason_PrivacyPolicy_getInstance();
      default:
        ContactReason_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ContactReason_entriesInitialized;
  function ContactReason_initEntries() {
    if (ContactReason_entriesInitialized)
      return Unit_instance;
    ContactReason_entriesInitialized = true;
    ContactReason_CourierNotMoving_instance = new ContactReason('CourierNotMoving', 0, 'customers.ongoing_order1.order_status.not_moving');
    ContactReason_NoCourierOnMap_instance = new ContactReason('NoCourierOnMap', 1, 'customers.ongoing_order1.order_status.no_courier_on_map');
    ContactReason_OrderLate_instance = new ContactReason('OrderLate', 2, 'customers.ongoing_order1.order_status.late3');
    ContactReason_ChangePaymentMethod_instance = new ContactReason('ChangePaymentMethod', 3, 'customers.my_account.change_payment_method');
    ContactReason_ChangePhoneNumber_instance = new ContactReason('ChangePhoneNumber', 4, 'customers.my_account.change_phone_number');
    ContactReason_ChangeDeliveryAddress_instance = new ContactReason('ChangeDeliveryAddress', 5, 'customers.ongoing_order1.change_add_items.delivery_address');
    ContactReason_ChangeItems_instance = new ContactReason('ChangeItems', 6, 'customers.ongoing_order1.change_add_items.change_add_items1');
    ContactReason_PromocodeNotValid_instance = new ContactReason('PromocodeNotValid', 7, 'customers.promotions.not_valid');
    ContactReason_PromocodeNotApplied_instance = new ContactReason('PromocodeNotApplied', 8, 'customers.promotions.not_applied');
    ContactReason_CheckBalance_instance = new ContactReason('CheckBalance', 9, 'customers.check_balance');
    ContactReason_NotDelivered_instance = new ContactReason('NotDelivered', 10, 'customers.past_order.didnt_arrived');
    ContactReason_PastOrderLate_instance = new ContactReason('PastOrderLate', 11, 'customers.past_order.late');
    ContactReason_OrderCancelled_instance = new ContactReason('OrderCancelled', 12, 'customers.past_order.cancelled');
    ContactReason_TastedBad_instance = new ContactReason('TastedBad', 13, 'customers.past_order.mistreated_quality.poor_quality.tasted_bad');
    ContactReason_IncorrectTemperature_instance = new ContactReason('IncorrectTemperature', 14, 'customers.past_order.mistreated_quality.poor_quality.incorrect_temperature');
    ContactReason_PoorQuality_instance = new ContactReason('PoorQuality', 15, 'customers.past_order.mistreated_quality.poor_quality');
    ContactReason_PackagingIssues_instance = new ContactReason('PackagingIssues', 16, 'customers.past_order.mistreated_quality.poor_quality.packaging_issues');
    ContactReason_AllergyNotConsidered_instance = new ContactReason('AllergyNotConsidered', 17, 'customers.past_order.mistreated_quality.poor_quality.allergy_information_ignored');
    ContactReason_MissingExtras_instance = new ContactReason('MissingExtras', 18, 'customers.past_order.missing_extras');
    ContactReason_MissingProducts_instance = new ContactReason('MissingProducts', 19, 'customers.past_order.missing_items');
    ContactReason_WrongProducts_instance = new ContactReason('WrongProducts', 20, 'customers.past_order.mistaken_wrong_items');
    ContactReason_DidNotMatchPhoto_instance = new ContactReason('DidNotMatchPhoto', 21, 'customers.past_order.glover_behavior.profile_mismatch');
    ContactReason_RudeOrDisrespectful_instance = new ContactReason('RudeOrDisrespectful', 22, 'customers.past_order.glover_behavior.poor_courier_service');
    ContactReason_SanitaryEquipment_instance = new ContactReason('SanitaryEquipment', 23, 'customers.past_order.courier_without_mask3');
    ContactReason_RemoveTip_instance = new ContactReason('RemoveTip', 24, 'customers.past_order.remove_tip');
    ContactReason_TransportedImproperly_instance = new ContactReason('TransportedImproperly', 25, 'customers.past_order.mistreated_quality.mistreated1');
    ContactReason_ChargedMultipleTimes_instance = new ContactReason('ChargedMultipleTimes', 26, 'customers.past_order.payments1.multiple_charges');
    ContactReason_ChargedWrongAmount_instance = new ContactReason('ChargedWrongAmount', 27, 'customers.past_order.payments1.wrong_amount1');
    ContactReason_ProblemWithCash_instance = new ContactReason('ProblemWithCash', 28, 'customers.past_order.payments1.problem_with_cash');
    ContactReason_PromoCode_instance = new ContactReason('PromoCode', 29, 'customers.past_order.promocode.promo_problem');
    ContactReason_SpecialStorePromos_instance = new ContactReason('SpecialStorePromos', 30, 'customers.past_order.promocode.special_store_problem');
    ContactReason_GlovoPrimeBecomeMember_instance = new ContactReason('GlovoPrimeBecomeMember', 31, 'customers.glovo_prime.become_member');
    ContactReason_GlovoPrimeHowItWorks_instance = new ContactReason('GlovoPrimeHowItWorks', 32, 'customers.glovo_prime.how_it_works');
    ContactReason_GlovoePrimePaymentIssue_instance = new ContactReason('GlovoePrimePaymentIssue', 33, 'customers.glovo_prime.payment_issue');
    ContactReason_GlovoePrimeUnsuscribe_instance = new ContactReason('GlovoePrimeUnsuscribe', 34, 'customers.glovo_prime.unsubscribe');
    ContactReason_ChangeEmailAddress_instance = new ContactReason('ChangeEmailAddress', 35, 'customers.my_account.change_email_address');
    ContactReason_ChangePassword_instance = new ContactReason('ChangePassword', 36, 'customers.my_account.change_password');
    ContactReason_DeleteAccount_instance = new ContactReason('DeleteAccount', 37, 'customers.my_account.delete_account');
    ContactReason_VerifyIdentity_instance = new ContactReason('VerifyIdentity', 38, 'customers.my_account.verify_identity_fraud');
    ContactReason_ReceiveGlovoNews_instance = new ContactReason('ReceiveGlovoNews', 39, 'customers.glovo_newsletter.subscribe');
    ContactReason_UnsubscribeGlovoNews_instance = new ContactReason('UnsubscribeGlovoNews', 40, 'customers.glovo_newsletter.unsubscribe');
    ContactReason_HowToOrder_instance = new ContactReason('HowToOrder', 41, 'customers.information.how_to_order');
    ContactReason_DeliveryArea_instance = new ContactReason('DeliveryArea', 42, 'customers.information.delivery_area');
    ContactReason_ServiceHours_instance = new ContactReason('ServiceHours', 43, 'customers.information.service_hours');
    ContactReason_AppAdvantages_instance = new ContactReason('AppAdvantages', 44, 'customers.information.app_advantages');
    ContactReason_DeliveryCosts_instance = new ContactReason('DeliveryCosts', 45, 'customers.information.delivery_costs');
    ContactReason_PaymentMethods_instance = new ContactReason('PaymentMethods', 46, 'customers.information.payment_methods');
    ContactReason_VehiclesInformation_instance = new ContactReason('VehiclesInformation', 47, 'customers.information.vehicles_information');
    ContactReason_BecomeGlover_instance = new ContactReason('BecomeGlover', 48, 'customers.work_with_us.become_glover');
    ContactReason_BecomePartner_instance = new ContactReason('BecomePartner', 49, 'customers.work_with_us.become_partner');
    ContactReason_BecomeColleague_instance = new ContactReason('BecomeColleague', 50, 'customers.work_with_us');
    ContactReason_ContactBusinessUnit_instance = new ContactReason('ContactBusinessUnit', 51, 'customers.work_with_us.contact_business_unit');
    ContactReason_ContactPressTeam_instance = new ContactReason('ContactPressTeam', 52, 'customers.work_with_us');
    ContactReason_RightOfAccess_instance = new ContactReason('RightOfAccess', 53, 'customers.my_account.personal_data_rights.right_of_access');
    ContactReason_RightOfModification_instance = new ContactReason('RightOfModification', 54, 'customers.my_account.personal_data_rights.right_of_modification');
    ContactReason_PersonalDataRestriction_instance = new ContactReason('PersonalDataRestriction', 55, 'customers.my_account.personal_data_rights.personal_data_treatment_limitation_right_only_legal_form');
    ContactReason_CancelAccount_instance = new ContactReason('CancelAccount', 56, 'customers.my_account.cancel_account.right_of_account_cancellation_only_legal_form');
    ContactReason_RightOfOpposition_instance = new ContactReason('RightOfOpposition', 57, 'customers.my_account.personal_data_rights.right_of_opposition');
    ContactReason_TermsAndConditions_instance = new ContactReason('TermsAndConditions', 58, 'customers.my_account.policies.terms_and_conditions');
    ContactReason_PrivacyPolicy_instance = new ContactReason('PrivacyPolicy', 59, 'customers.my_account.policies.privacy_policy');
  }
  function ContactReason(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ContactReason).r = function () {
    return this.value;
  };
  function ContactReason_CourierNotMoving_getInstance() {
    ContactReason_initEntries();
    return ContactReason_CourierNotMoving_instance;
  }
  function ContactReason_NoCourierOnMap_getInstance() {
    ContactReason_initEntries();
    return ContactReason_NoCourierOnMap_instance;
  }
  function ContactReason_OrderLate_getInstance() {
    ContactReason_initEntries();
    return ContactReason_OrderLate_instance;
  }
  function ContactReason_ChangePaymentMethod_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChangePaymentMethod_instance;
  }
  function ContactReason_ChangePhoneNumber_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChangePhoneNumber_instance;
  }
  function ContactReason_ChangeDeliveryAddress_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChangeDeliveryAddress_instance;
  }
  function ContactReason_ChangeItems_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChangeItems_instance;
  }
  function ContactReason_PromocodeNotValid_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PromocodeNotValid_instance;
  }
  function ContactReason_PromocodeNotApplied_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PromocodeNotApplied_instance;
  }
  function ContactReason_CheckBalance_getInstance() {
    ContactReason_initEntries();
    return ContactReason_CheckBalance_instance;
  }
  function ContactReason_NotDelivered_getInstance() {
    ContactReason_initEntries();
    return ContactReason_NotDelivered_instance;
  }
  function ContactReason_PastOrderLate_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PastOrderLate_instance;
  }
  function ContactReason_OrderCancelled_getInstance() {
    ContactReason_initEntries();
    return ContactReason_OrderCancelled_instance;
  }
  function ContactReason_TastedBad_getInstance() {
    ContactReason_initEntries();
    return ContactReason_TastedBad_instance;
  }
  function ContactReason_IncorrectTemperature_getInstance() {
    ContactReason_initEntries();
    return ContactReason_IncorrectTemperature_instance;
  }
  function ContactReason_PoorQuality_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PoorQuality_instance;
  }
  function ContactReason_PackagingIssues_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PackagingIssues_instance;
  }
  function ContactReason_AllergyNotConsidered_getInstance() {
    ContactReason_initEntries();
    return ContactReason_AllergyNotConsidered_instance;
  }
  function ContactReason_MissingExtras_getInstance() {
    ContactReason_initEntries();
    return ContactReason_MissingExtras_instance;
  }
  function ContactReason_MissingProducts_getInstance() {
    ContactReason_initEntries();
    return ContactReason_MissingProducts_instance;
  }
  function ContactReason_WrongProducts_getInstance() {
    ContactReason_initEntries();
    return ContactReason_WrongProducts_instance;
  }
  function ContactReason_DidNotMatchPhoto_getInstance() {
    ContactReason_initEntries();
    return ContactReason_DidNotMatchPhoto_instance;
  }
  function ContactReason_RudeOrDisrespectful_getInstance() {
    ContactReason_initEntries();
    return ContactReason_RudeOrDisrespectful_instance;
  }
  function ContactReason_SanitaryEquipment_getInstance() {
    ContactReason_initEntries();
    return ContactReason_SanitaryEquipment_instance;
  }
  function ContactReason_RemoveTip_getInstance() {
    ContactReason_initEntries();
    return ContactReason_RemoveTip_instance;
  }
  function ContactReason_TransportedImproperly_getInstance() {
    ContactReason_initEntries();
    return ContactReason_TransportedImproperly_instance;
  }
  function ContactReason_ChargedMultipleTimes_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChargedMultipleTimes_instance;
  }
  function ContactReason_ChargedWrongAmount_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChargedWrongAmount_instance;
  }
  function ContactReason_ProblemWithCash_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ProblemWithCash_instance;
  }
  function ContactReason_PromoCode_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PromoCode_instance;
  }
  function ContactReason_SpecialStorePromos_getInstance() {
    ContactReason_initEntries();
    return ContactReason_SpecialStorePromos_instance;
  }
  function ContactReason_GlovoPrimeBecomeMember_getInstance() {
    ContactReason_initEntries();
    return ContactReason_GlovoPrimeBecomeMember_instance;
  }
  function ContactReason_GlovoPrimeHowItWorks_getInstance() {
    ContactReason_initEntries();
    return ContactReason_GlovoPrimeHowItWorks_instance;
  }
  function ContactReason_GlovoePrimePaymentIssue_getInstance() {
    ContactReason_initEntries();
    return ContactReason_GlovoePrimePaymentIssue_instance;
  }
  function ContactReason_GlovoePrimeUnsuscribe_getInstance() {
    ContactReason_initEntries();
    return ContactReason_GlovoePrimeUnsuscribe_instance;
  }
  function ContactReason_ChangeEmailAddress_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChangeEmailAddress_instance;
  }
  function ContactReason_ChangePassword_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ChangePassword_instance;
  }
  function ContactReason_DeleteAccount_getInstance() {
    ContactReason_initEntries();
    return ContactReason_DeleteAccount_instance;
  }
  function ContactReason_VerifyIdentity_getInstance() {
    ContactReason_initEntries();
    return ContactReason_VerifyIdentity_instance;
  }
  function ContactReason_ReceiveGlovoNews_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ReceiveGlovoNews_instance;
  }
  function ContactReason_UnsubscribeGlovoNews_getInstance() {
    ContactReason_initEntries();
    return ContactReason_UnsubscribeGlovoNews_instance;
  }
  function ContactReason_HowToOrder_getInstance() {
    ContactReason_initEntries();
    return ContactReason_HowToOrder_instance;
  }
  function ContactReason_DeliveryArea_getInstance() {
    ContactReason_initEntries();
    return ContactReason_DeliveryArea_instance;
  }
  function ContactReason_ServiceHours_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ServiceHours_instance;
  }
  function ContactReason_AppAdvantages_getInstance() {
    ContactReason_initEntries();
    return ContactReason_AppAdvantages_instance;
  }
  function ContactReason_DeliveryCosts_getInstance() {
    ContactReason_initEntries();
    return ContactReason_DeliveryCosts_instance;
  }
  function ContactReason_PaymentMethods_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PaymentMethods_instance;
  }
  function ContactReason_VehiclesInformation_getInstance() {
    ContactReason_initEntries();
    return ContactReason_VehiclesInformation_instance;
  }
  function ContactReason_BecomeGlover_getInstance() {
    ContactReason_initEntries();
    return ContactReason_BecomeGlover_instance;
  }
  function ContactReason_BecomePartner_getInstance() {
    ContactReason_initEntries();
    return ContactReason_BecomePartner_instance;
  }
  function ContactReason_BecomeColleague_getInstance() {
    ContactReason_initEntries();
    return ContactReason_BecomeColleague_instance;
  }
  function ContactReason_ContactBusinessUnit_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ContactBusinessUnit_instance;
  }
  function ContactReason_ContactPressTeam_getInstance() {
    ContactReason_initEntries();
    return ContactReason_ContactPressTeam_instance;
  }
  function ContactReason_RightOfAccess_getInstance() {
    ContactReason_initEntries();
    return ContactReason_RightOfAccess_instance;
  }
  function ContactReason_RightOfModification_getInstance() {
    ContactReason_initEntries();
    return ContactReason_RightOfModification_instance;
  }
  function ContactReason_PersonalDataRestriction_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PersonalDataRestriction_instance;
  }
  function ContactReason_CancelAccount_getInstance() {
    ContactReason_initEntries();
    return ContactReason_CancelAccount_instance;
  }
  function ContactReason_RightOfOpposition_getInstance() {
    ContactReason_initEntries();
    return ContactReason_RightOfOpposition_instance;
  }
  function ContactReason_TermsAndConditions_getInstance() {
    ContactReason_initEntries();
    return ContactReason_TermsAndConditions_instance;
  }
  function ContactReason_PrivacyPolicy_getInstance() {
    ContactReason_initEntries();
    return ContactReason_PrivacyPolicy_instance;
  }
  function Metadata_47() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_47).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_47;
  function Metadata_getInstance_47() {
    return Metadata_instance_47;
  }
  function ContactSupportPressed(origin, contactReason) {
    contactReason = contactReason === VOID ? null : contactReason;
    var tmp = to('origin', origin == null ? null : origin.value);
    Event.call(this, 'Contact Support Pressed', VOID, 'CF: Contact Flow', mapOf([tmp, to('contactReason', contactReason == null ? null : get_value(contactReason))]));
  }
  function Metadata_48() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_48).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_48;
  function Metadata_getInstance_48() {
    return Metadata_instance_48;
  }
  function ContactTreeNodePopup(contactReason, orderId) {
    orderId = orderId === VOID ? null : orderId;
    var tmp = to('contactReason', contactReason == null ? null : contactReason.value);
    Screen.call(this, 'Contact Tree Node Popup', 'CF: Contact Flow', mapOf([tmp, to('orderId', orderId == null ? null : get_value_1(orderId))]));
  }
  function Metadata_49() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_49).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_49;
  function Metadata_getInstance_49() {
    return Metadata_instance_49;
  }
  function ContactTreeNodeSelected(eventName, properties) {
    var tmp = mapOf_0(to('eventName', eventName == null ? null : get_value(eventName)));
    var tmp2_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Contact Tree Node Selected', VOID, 'CF: Contact Flow', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function ContactTreeOpened(treeId, traceId, origin, treeVariation) {
    var tmp = to('treeId', treeId == null ? null : get_value(treeId));
    var tmp_0 = to('traceId', traceId == null ? null : get_value(traceId));
    var tmp_1 = to('origin', origin == null ? null : get_value(origin));
    Event.call(this, 'Contact Tree Opened', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('treeVariation', treeVariation == null ? null : get_value(treeVariation))]));
  }
  function ContactTreeSelectedNode(treeId, traceId, nodeId, properties, outcome) {
    outcome = outcome === VOID ? null : outcome;
    var tmp = to('treeId', treeId == null ? null : get_value(treeId));
    var tmp_0 = to('traceId', traceId == null ? null : get_value(traceId));
    var tmp_1 = mapOf([tmp, tmp_0, to('nodeId', nodeId == null ? null : get_value(nodeId))]);
    var tmp4_elvis_lhs = properties == null ? null : get_data(properties);
    var tmp_2 = plus(tmp_1, tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs);
    var tmp6_elvis_lhs = outcome == null ? null : get_data(outcome);
    Event.call(this, 'Contact Tree Selected Node', VOID, VOID, plus(tmp_2, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs));
  }
  var ContactUsOrigin_Profile_instance;
  var ContactUsOrigin_Order_instance;
  var ContactUsOrigin_OutstandingPayments_instance;
  var ContactUsOrigin_OrderRating_instance;
  var ContactUsOrigin_InvalidCard_instance;
  var ContactUsOrigin_OrderCancelled_instance;
  var ContactUsOrigin_FraudWarning_instance;
  var ContactUsOrigin_Checkout_instance;
  var ContactUsOrigin_Cancel_instance;
  function values_22() {
    return [ContactUsOrigin_Profile_getInstance(), ContactUsOrigin_Order_getInstance(), ContactUsOrigin_OutstandingPayments_getInstance(), ContactUsOrigin_OrderRating_getInstance(), ContactUsOrigin_InvalidCard_getInstance(), ContactUsOrigin_OrderCancelled_getInstance(), ContactUsOrigin_FraudWarning_getInstance(), ContactUsOrigin_Checkout_getInstance(), ContactUsOrigin_Cancel_getInstance()];
  }
  function valueOf_22(value) {
    switch (value) {
      case 'Profile':
        return ContactUsOrigin_Profile_getInstance();
      case 'Order':
        return ContactUsOrigin_Order_getInstance();
      case 'OutstandingPayments':
        return ContactUsOrigin_OutstandingPayments_getInstance();
      case 'OrderRating':
        return ContactUsOrigin_OrderRating_getInstance();
      case 'InvalidCard':
        return ContactUsOrigin_InvalidCard_getInstance();
      case 'OrderCancelled':
        return ContactUsOrigin_OrderCancelled_getInstance();
      case 'FraudWarning':
        return ContactUsOrigin_FraudWarning_getInstance();
      case 'Checkout':
        return ContactUsOrigin_Checkout_getInstance();
      case 'Cancel':
        return ContactUsOrigin_Cancel_getInstance();
      default:
        ContactUsOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ContactUsOrigin_entriesInitialized;
  function ContactUsOrigin_initEntries() {
    if (ContactUsOrigin_entriesInitialized)
      return Unit_instance;
    ContactUsOrigin_entriesInitialized = true;
    ContactUsOrigin_Profile_instance = new ContactUsOrigin('Profile', 0, 'Profile Screen');
    ContactUsOrigin_Order_instance = new ContactUsOrigin('Order', 1, 'Order Screen');
    ContactUsOrigin_OutstandingPayments_instance = new ContactUsOrigin('OutstandingPayments', 2, 'Outstanding Payments Screen');
    ContactUsOrigin_OrderRating_instance = new ContactUsOrigin('OrderRating', 3, 'Order Rating Feedback Screen');
    ContactUsOrigin_InvalidCard_instance = new ContactUsOrigin('InvalidCard', 4, 'Invalid Card Screen');
    ContactUsOrigin_OrderCancelled_instance = new ContactUsOrigin('OrderCancelled', 5, 'Order Cancelled Screen');
    ContactUsOrigin_FraudWarning_instance = new ContactUsOrigin('FraudWarning', 6, 'User marked as Fraud Screen');
    ContactUsOrigin_Checkout_instance = new ContactUsOrigin('Checkout', 7, 'Checkout Screen');
    ContactUsOrigin_Cancel_instance = new ContactUsOrigin('Cancel', 8, 'Cancel Order Screen');
  }
  function ContactUsOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ContactUsOrigin).r = function () {
    return this.value;
  };
  function ContactUsOrigin_Profile_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_Profile_instance;
  }
  function ContactUsOrigin_Order_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_Order_instance;
  }
  function ContactUsOrigin_OutstandingPayments_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_OutstandingPayments_instance;
  }
  function ContactUsOrigin_OrderRating_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_OrderRating_instance;
  }
  function ContactUsOrigin_InvalidCard_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_InvalidCard_instance;
  }
  function ContactUsOrigin_OrderCancelled_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_OrderCancelled_instance;
  }
  function ContactUsOrigin_FraudWarning_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_FraudWarning_instance;
  }
  function ContactUsOrigin_Checkout_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_Checkout_instance;
  }
  function ContactUsOrigin_Cancel_getInstance() {
    ContactUsOrigin_initEntries();
    return ContactUsOrigin_Cancel_instance;
  }
  function Metadata_50() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_50).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_50;
  function Metadata_getInstance_50() {
    return Metadata_instance_50;
  }
  function ContactUsUsed(origin, orderId) {
    orderId = orderId === VOID ? null : orderId;
    var tmp = to('origin', origin == null ? null : origin.value);
    Event.call(this, 'Contact Us Used', VOID, 'CF: Contact Flow', mapOf([tmp, to('orderId', orderId == null ? null : get_value_1(orderId))]));
  }
  var ContentTranslatedAction_Translate_instance;
  var ContentTranslatedAction_Untranslate_instance;
  function values_23() {
    return [ContentTranslatedAction_Translate_getInstance(), ContentTranslatedAction_Untranslate_getInstance()];
  }
  function valueOf_23(value) {
    switch (value) {
      case 'Translate':
        return ContentTranslatedAction_Translate_getInstance();
      case 'Untranslate':
        return ContentTranslatedAction_Untranslate_getInstance();
      default:
        ContentTranslatedAction_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ContentTranslatedAction_entriesInitialized;
  function ContentTranslatedAction_initEntries() {
    if (ContentTranslatedAction_entriesInitialized)
      return Unit_instance;
    ContentTranslatedAction_entriesInitialized = true;
    ContentTranslatedAction_Translate_instance = new ContentTranslatedAction('Translate', 0, 'Translate');
    ContentTranslatedAction_Untranslate_instance = new ContentTranslatedAction('Untranslate', 1, 'Untranslate');
  }
  function ContentTranslatedAction(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ContentTranslatedAction).r = function () {
    return this.value;
  };
  function ContentTranslatedAction_Translate_getInstance() {
    ContentTranslatedAction_initEntries();
    return ContentTranslatedAction_Translate_instance;
  }
  function ContentTranslatedAction_Untranslate_getInstance() {
    ContentTranslatedAction_initEntries();
    return ContentTranslatedAction_Untranslate_instance;
  }
  function CreatePassword() {
    Screen.call(this, 'Create Password');
  }
  var CsatReason_NoAgent_instance;
  var CsatReason_NotRelevant_instance;
  var CsatReason_TooManySteps_instance;
  function values_24() {
    return [CsatReason_NoAgent_getInstance(), CsatReason_NotRelevant_getInstance(), CsatReason_TooManySteps_getInstance()];
  }
  function valueOf_24(value) {
    switch (value) {
      case 'NoAgent':
        return CsatReason_NoAgent_getInstance();
      case 'NotRelevant':
        return CsatReason_NotRelevant_getInstance();
      case 'TooManySteps':
        return CsatReason_TooManySteps_getInstance();
      default:
        CsatReason_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CsatReason_entriesInitialized;
  function CsatReason_initEntries() {
    if (CsatReason_entriesInitialized)
      return Unit_instance;
    CsatReason_entriesInitialized = true;
    CsatReason_NoAgent_instance = new CsatReason('NoAgent', 0, 'NoAgent');
    CsatReason_NotRelevant_instance = new CsatReason('NotRelevant', 1, 'NotRelevant');
    CsatReason_TooManySteps_instance = new CsatReason('TooManySteps', 2, 'TooManySteps');
  }
  function CsatReason(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(CsatReason).r = function () {
    return this.value;
  };
  function CsatReason_NoAgent_getInstance() {
    CsatReason_initEntries();
    return CsatReason_NoAgent_instance;
  }
  function CsatReason_NotRelevant_getInstance() {
    CsatReason_initEntries();
    return CsatReason_NotRelevant_instance;
  }
  function CsatReason_TooManySteps_getInstance() {
    CsatReason_initEntries();
    return CsatReason_TooManySteps_instance;
  }
  var CsatSide_Right_instance;
  var CsatSide_Left_instance;
  function values_25() {
    return [CsatSide_Right_getInstance(), CsatSide_Left_getInstance()];
  }
  function valueOf_25(value) {
    switch (value) {
      case 'Right':
        return CsatSide_Right_getInstance();
      case 'Left':
        return CsatSide_Left_getInstance();
      default:
        CsatSide_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var CsatSide_entriesInitialized;
  function CsatSide_initEntries() {
    if (CsatSide_entriesInitialized)
      return Unit_instance;
    CsatSide_entriesInitialized = true;
    CsatSide_Right_instance = new CsatSide('Right', 0, 'Right');
    CsatSide_Left_instance = new CsatSide('Left', 1, 'Left');
  }
  function CsatSide(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(CsatSide).r = function () {
    return this.value;
  };
  function CsatSide_Right_getInstance() {
    CsatSide_initEntries();
    return CsatSide_Right_instance;
  }
  function CsatSide_Left_getInstance() {
    CsatSide_initEntries();
    return CsatSide_Left_instance;
  }
  function Metadata_51() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_51).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_51;
  function Metadata_getInstance_51() {
    return Metadata_instance_51;
  }
  function DeliveryOptionSelected(deliveryType, deliveryFee, eta, storeId, storeAddressId) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('deliveryType', deliveryType == null ? null : get_value(deliveryType));
    var tmp_0 = to('deliveryFee', deliveryFee == null ? null : get_value(deliveryFee));
    var tmp_1 = to('eta', eta == null ? null : get_value(eta));
    var tmp_2 = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Delivery Option Selected', VOID, 'GRO: Growth', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  function Metadata_52() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_52).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_52;
  function Metadata_getInstance_52() {
    return Metadata_instance_52;
  }
  function DeliveryOptionsAvailable(deliveryTypes, eta, deliveryFee, storeId, storeAddressId) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('deliveryTypes', deliveryTypes == null ? null : get_value_2(deliveryTypes));
    var tmp_0 = to('eta', eta == null ? null : get_value_2(eta));
    var tmp_1 = to('deliveryFee', deliveryFee == null ? null : get_value_2(deliveryFee));
    var tmp_2 = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Delivery Options Available', VOID, 'GRO: Growth', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  function Metadata_53() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_53).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_53;
  function Metadata_getInstance_53() {
    return Metadata_instance_53;
  }
  function DeliveryOptionsDescriptionViewed(storeId, storeAddressId) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Delivery Options Description Viewed', VOID, 'GRO: Growth', mapOf([tmp, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  function Metadata_54() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_54).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_54;
  function Metadata_getInstance_54() {
    return Metadata_instance_54;
  }
  function DeliveryOptionsExpandableListChanged(expanded, storeId, storeAddressId) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('expanded', expanded == null ? null : get_value_0(expanded));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Delivery Options Expandable List Changed', VOID, 'GRO: Growth', mapOf([tmp, tmp_0, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  function DynamicSessionStarted(inactivityPeriodSeconds, inactivityThresholdSeconds, deviceId, utmMedium, utmSource, utmCampaign, utmContent, systemNotificationsEnabled, userSelectedLanguage) {
    utmMedium = utmMedium === VOID ? null : utmMedium;
    utmSource = utmSource === VOID ? null : utmSource;
    utmCampaign = utmCampaign === VOID ? null : utmCampaign;
    utmContent = utmContent === VOID ? null : utmContent;
    systemNotificationsEnabled = systemNotificationsEnabled === VOID ? null : systemNotificationsEnabled;
    userSelectedLanguage = userSelectedLanguage === VOID ? null : userSelectedLanguage;
    var tmp = to('inactivityPeriod', inactivityPeriodSeconds == null ? null : get_value_1(inactivityPeriodSeconds));
    var tmp_0 = to('inactivityThreshold', inactivityThresholdSeconds == null ? null : get_value_1(inactivityThresholdSeconds));
    var tmp_1 = to('deviceId', deviceId == null ? null : get_value_1(deviceId));
    var tmp_2 = to('utmMedium', utmMedium == null ? null : get_value(utmMedium));
    var tmp_3 = to('utmSource', utmSource == null ? null : get_value(utmSource));
    var tmp_4 = to('utmCampaign', utmCampaign == null ? null : get_value(utmCampaign));
    var tmp_5 = to('utmContent', utmContent == null ? null : get_value(utmContent));
    var tmp_6 = to('systemNotificationsEnabled', systemNotificationsEnabled == null ? null : get_value_0(systemNotificationsEnabled));
    Event.call(this, 'Dynamic Session Started', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, to('userSelectedLanguage', userSelectedLanguage == null ? null : get_value(userSelectedLanguage))]));
  }
  var EasyReorderScreenType_EasyReorderCarousel_instance;
  var EasyReorderScreenType_EasyReorderSection_instance;
  var EasyReorderScreenType_EasyReorderAllOptions_instance;
  function values_26() {
    return [EasyReorderScreenType_EasyReorderCarousel_getInstance(), EasyReorderScreenType_EasyReorderSection_getInstance(), EasyReorderScreenType_EasyReorderAllOptions_getInstance()];
  }
  function valueOf_26(value) {
    switch (value) {
      case 'EasyReorderCarousel':
        return EasyReorderScreenType_EasyReorderCarousel_getInstance();
      case 'EasyReorderSection':
        return EasyReorderScreenType_EasyReorderSection_getInstance();
      case 'EasyReorderAllOptions':
        return EasyReorderScreenType_EasyReorderAllOptions_getInstance();
      default:
        EasyReorderScreenType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var EasyReorderScreenType_entriesInitialized;
  function EasyReorderScreenType_initEntries() {
    if (EasyReorderScreenType_entriesInitialized)
      return Unit_instance;
    EasyReorderScreenType_entriesInitialized = true;
    EasyReorderScreenType_EasyReorderCarousel_instance = new EasyReorderScreenType('EasyReorderCarousel', 0, 'EasyReorderCarousel');
    EasyReorderScreenType_EasyReorderSection_instance = new EasyReorderScreenType('EasyReorderSection', 1, 'EasyReorderSection');
    EasyReorderScreenType_EasyReorderAllOptions_instance = new EasyReorderScreenType('EasyReorderAllOptions', 2, 'EasyReorderAllOptions');
  }
  function EasyReorderScreenType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(EasyReorderScreenType).r = function () {
    return this.value;
  };
  function EasyReorderScreenType_EasyReorderCarousel_getInstance() {
    EasyReorderScreenType_initEntries();
    return EasyReorderScreenType_EasyReorderCarousel_instance;
  }
  function EasyReorderScreenType_EasyReorderSection_getInstance() {
    EasyReorderScreenType_initEntries();
    return EasyReorderScreenType_EasyReorderSection_instance;
  }
  function EasyReorderScreenType_EasyReorderAllOptions_getInstance() {
    EasyReorderScreenType_initEntries();
    return EasyReorderScreenType_EasyReorderAllOptions_instance;
  }
  function Metadata_55() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_55).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_55;
  function Metadata_getInstance_55() {
    return Metadata_instance_55;
  }
  function EditAddressButtonPressed(origin) {
    Event.call(this, 'Edit Address Button Pressed', VOID, 'TREX: Tracking and Reviews Experience', mapOf_0(to('origin', origin == null ? null : origin.value)));
  }
  function Metadata_56() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_56).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_56;
  function Metadata_getInstance_56() {
    return Metadata_instance_56;
  }
  function EditAddressClicked(isSameCity) {
    Event.call(this, 'Edit Address Clicked', VOID, 'CK: Checkout', mapOf_0(to('isSameCity', isSameCity == null ? null : get_value_0(isSameCity))));
  }
  var EditAddressOrigins_OutOfDeliveryPopup_instance;
  var EditAddressOrigins_NewOrder_instance;
  var EditAddressOrigins_Home_instance;
  var EditAddressOrigins_SelfAddressChange_instance;
  var EditAddressOrigins_StorePage_instance;
  var EditAddressOrigins_Category_instance;
  var EditAddressOrigins_Other_instance;
  function values_27() {
    return [EditAddressOrigins_OutOfDeliveryPopup_getInstance(), EditAddressOrigins_NewOrder_getInstance(), EditAddressOrigins_Home_getInstance(), EditAddressOrigins_SelfAddressChange_getInstance(), EditAddressOrigins_StorePage_getInstance(), EditAddressOrigins_Category_getInstance(), EditAddressOrigins_Other_getInstance()];
  }
  function valueOf_27(value) {
    switch (value) {
      case 'OutOfDeliveryPopup':
        return EditAddressOrigins_OutOfDeliveryPopup_getInstance();
      case 'NewOrder':
        return EditAddressOrigins_NewOrder_getInstance();
      case 'Home':
        return EditAddressOrigins_Home_getInstance();
      case 'SelfAddressChange':
        return EditAddressOrigins_SelfAddressChange_getInstance();
      case 'StorePage':
        return EditAddressOrigins_StorePage_getInstance();
      case 'Category':
        return EditAddressOrigins_Category_getInstance();
      case 'Other':
        return EditAddressOrigins_Other_getInstance();
      default:
        EditAddressOrigins_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var EditAddressOrigins_entriesInitialized;
  function EditAddressOrigins_initEntries() {
    if (EditAddressOrigins_entriesInitialized)
      return Unit_instance;
    EditAddressOrigins_entriesInitialized = true;
    EditAddressOrigins_OutOfDeliveryPopup_instance = new EditAddressOrigins('OutOfDeliveryPopup', 0, 'OutOfDeliveryPopup');
    EditAddressOrigins_NewOrder_instance = new EditAddressOrigins('NewOrder', 1, 'New Order');
    EditAddressOrigins_Home_instance = new EditAddressOrigins('Home', 2, 'Home');
    EditAddressOrigins_SelfAddressChange_instance = new EditAddressOrigins('SelfAddressChange', 3, 'Self Address Change');
    EditAddressOrigins_StorePage_instance = new EditAddressOrigins('StorePage', 4, 'Store Page');
    EditAddressOrigins_Category_instance = new EditAddressOrigins('Category', 5, 'Category');
    EditAddressOrigins_Other_instance = new EditAddressOrigins('Other', 6, 'Other');
  }
  function EditAddressOrigins(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(EditAddressOrigins).r = function () {
    return this.value;
  };
  function EditAddressOrigins_OutOfDeliveryPopup_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_OutOfDeliveryPopup_instance;
  }
  function EditAddressOrigins_NewOrder_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_NewOrder_instance;
  }
  function EditAddressOrigins_Home_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_Home_instance;
  }
  function EditAddressOrigins_SelfAddressChange_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_SelfAddressChange_instance;
  }
  function EditAddressOrigins_StorePage_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_StorePage_instance;
  }
  function EditAddressOrigins_Category_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_Category_instance;
  }
  function EditAddressOrigins_Other_getInstance() {
    EditAddressOrigins_initEntries();
    return EditAddressOrigins_Other_instance;
  }
  var ElementAction_Dismissal_instance;
  function values_28() {
    return [ElementAction_Dismissal_getInstance()];
  }
  function valueOf_28(value) {
    if (value === 'Dismissal')
      return ElementAction_Dismissal_getInstance();
    else {
      ElementAction_initEntries();
      THROW_IAE('No enum constant value.');
    }
  }
  var ElementAction_entriesInitialized;
  function ElementAction_initEntries() {
    if (ElementAction_entriesInitialized)
      return Unit_instance;
    ElementAction_entriesInitialized = true;
    ElementAction_Dismissal_instance = new ElementAction('Dismissal', 0, 'Dismissal');
  }
  function ElementAction(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ElementAction).r = function () {
    return this.value;
  };
  function ElementAction_Dismissal_getInstance() {
    ElementAction_initEntries();
    return ElementAction_Dismissal_instance;
  }
  var ElementScreen_StoresWall_instance;
  var ElementScreen_StoreView_instance;
  var ElementScreen_Home_instance;
  function values_29() {
    return [ElementScreen_StoresWall_getInstance(), ElementScreen_StoreView_getInstance(), ElementScreen_Home_getInstance()];
  }
  function valueOf_29(value) {
    switch (value) {
      case 'StoresWall':
        return ElementScreen_StoresWall_getInstance();
      case 'StoreView':
        return ElementScreen_StoreView_getInstance();
      case 'Home':
        return ElementScreen_Home_getInstance();
      default:
        ElementScreen_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ElementScreen_entriesInitialized;
  function ElementScreen_initEntries() {
    if (ElementScreen_entriesInitialized)
      return Unit_instance;
    ElementScreen_entriesInitialized = true;
    ElementScreen_StoresWall_instance = new ElementScreen('StoresWall', 0, 'StoresWall');
    ElementScreen_StoreView_instance = new ElementScreen('StoreView', 1, 'StoreView');
    ElementScreen_Home_instance = new ElementScreen('Home', 2, 'Home');
  }
  function ElementScreen(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ElementScreen).r = function () {
    return this.value;
  };
  function ElementScreen_StoresWall_getInstance() {
    ElementScreen_initEntries();
    return ElementScreen_StoresWall_instance;
  }
  function ElementScreen_StoreView_getInstance() {
    ElementScreen_initEntries();
    return ElementScreen_StoreView_instance;
  }
  function ElementScreen_Home_getInstance() {
    ElementScreen_initEntries();
    return ElementScreen_Home_instance;
  }
  var ElementSource_Banner_instance;
  var ElementSource_Icon_instance;
  var ElementSource_BottomSheet_instance;
  function values_30() {
    return [ElementSource_Banner_getInstance(), ElementSource_Icon_getInstance(), ElementSource_BottomSheet_getInstance()];
  }
  function valueOf_30(value) {
    switch (value) {
      case 'Banner':
        return ElementSource_Banner_getInstance();
      case 'Icon':
        return ElementSource_Icon_getInstance();
      case 'BottomSheet':
        return ElementSource_BottomSheet_getInstance();
      default:
        ElementSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ElementSource_entriesInitialized;
  function ElementSource_initEntries() {
    if (ElementSource_entriesInitialized)
      return Unit_instance;
    ElementSource_entriesInitialized = true;
    ElementSource_Banner_instance = new ElementSource('Banner', 0, 'Banner');
    ElementSource_Icon_instance = new ElementSource('Icon', 1, 'Icon');
    ElementSource_BottomSheet_instance = new ElementSource('BottomSheet', 2, 'BottomSheet');
  }
  function ElementSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ElementSource).r = function () {
    return this.value;
  };
  function ElementSource_Banner_getInstance() {
    ElementSource_initEntries();
    return ElementSource_Banner_instance;
  }
  function ElementSource_Icon_getInstance() {
    ElementSource_initEntries();
    return ElementSource_Icon_instance;
  }
  function ElementSource_BottomSheet_getInstance() {
    ElementSource_initEntries();
    return ElementSource_BottomSheet_instance;
  }
  function ElementTapped(type, source, screen, actionType) {
    var tmp = to('type', type == null ? null : type.value);
    var tmp_0 = to('source', source == null ? null : source.value);
    var tmp_1 = to('screen', screen == null ? null : screen.value);
    Event.call(this, 'Element Tapped', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('actionType', actionType == null ? null : actionType.value)]));
  }
  var ElementType_Surge_instance;
  var ElementType_Promotion_instance;
  function values_31() {
    return [ElementType_Surge_getInstance(), ElementType_Promotion_getInstance()];
  }
  function valueOf_31(value) {
    switch (value) {
      case 'Surge':
        return ElementType_Surge_getInstance();
      case 'Promotion':
        return ElementType_Promotion_getInstance();
      default:
        ElementType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ElementType_entriesInitialized;
  function ElementType_initEntries() {
    if (ElementType_entriesInitialized)
      return Unit_instance;
    ElementType_entriesInitialized = true;
    ElementType_Surge_instance = new ElementType('Surge', 0, 'Surge');
    ElementType_Promotion_instance = new ElementType('Promotion', 1, 'Promotion');
  }
  function ElementType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ElementType).r = function () {
    return this.value;
  };
  function ElementType_Surge_getInstance() {
    ElementType_initEntries();
    return ElementType_Surge_instance;
  }
  function ElementType_Promotion_getInstance() {
    ElementType_initEntries();
    return ElementType_Promotion_instance;
  }
  var EnterEmailOrigin_Unification_instance;
  var EnterEmailOrigin_PhoneLogin_instance;
  var EnterEmailOrigin_PhoneSignup_instance;
  function values_32() {
    return [EnterEmailOrigin_Unification_getInstance(), EnterEmailOrigin_PhoneLogin_getInstance(), EnterEmailOrigin_PhoneSignup_getInstance()];
  }
  function valueOf_32(value) {
    switch (value) {
      case 'Unification':
        return EnterEmailOrigin_Unification_getInstance();
      case 'PhoneLogin':
        return EnterEmailOrigin_PhoneLogin_getInstance();
      case 'PhoneSignup':
        return EnterEmailOrigin_PhoneSignup_getInstance();
      default:
        EnterEmailOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var EnterEmailOrigin_entriesInitialized;
  function EnterEmailOrigin_initEntries() {
    if (EnterEmailOrigin_entriesInitialized)
      return Unit_instance;
    EnterEmailOrigin_entriesInitialized = true;
    EnterEmailOrigin_Unification_instance = new EnterEmailOrigin('Unification', 0, 'Unification');
    EnterEmailOrigin_PhoneLogin_instance = new EnterEmailOrigin('PhoneLogin', 1, 'PhoneLogin');
    EnterEmailOrigin_PhoneSignup_instance = new EnterEmailOrigin('PhoneSignup', 2, 'PhoneSignup');
  }
  function EnterEmailOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(EnterEmailOrigin).r = function () {
    return this.value;
  };
  function EnterEmailOrigin_Unification_getInstance() {
    EnterEmailOrigin_initEntries();
    return EnterEmailOrigin_Unification_instance;
  }
  function EnterEmailOrigin_PhoneLogin_getInstance() {
    EnterEmailOrigin_initEntries();
    return EnterEmailOrigin_PhoneLogin_instance;
  }
  function EnterEmailOrigin_PhoneSignup_getInstance() {
    EnterEmailOrigin_initEntries();
    return EnterEmailOrigin_PhoneSignup_instance;
  }
  function EnterEmailScreen(origin) {
    Screen.call(this, 'Enter Email', VOID, mapOf_0(to('origin', origin == null ? null : origin.value)));
  }
  function EnterPassword() {
    Screen.call(this, 'Enter Password');
  }
  function Metadata_57() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_57).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_57;
  function Metadata_getInstance_57() {
    return Metadata_instance_57;
  }
  function ExploreStoresButtonClicked(isSameCity) {
    Event.call(this, 'Explore Stores Button Clicked', VOID, 'CK: Checkout', mapOf_0(to('isSameCity', isSameCity == null ? null : get_value_0(isSameCity))));
  }
  function Metadata_58() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_58).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_58;
  function Metadata_getInstance_58() {
    return Metadata_instance_58;
  }
  function FAQ() {
    Screen.call(this, 'FAQ', 'CF: Contact Flow');
  }
  function FeedGroupImpression(groupId, storeAddresses, position) {
    var tmp = to('groupId', groupId == null ? null : get_value(groupId));
    var tmp_0 = to('storeAddresses', storeAddresses == null ? null : get_value_2(storeAddresses));
    Event.call(this, 'Feed Group Impression', VOID, VOID, mapOf([tmp, tmp_0, to('position', position == null ? null : get_value_1(position))]));
  }
  function FeedGroupInteracted(feedGroupId, feedGroupInteractionType, position) {
    var tmp = to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId));
    var tmp_0 = to('feedGroupInteractionType', feedGroupInteractionType == null ? null : feedGroupInteractionType.value);
    var tmp_1 = mapOf([tmp, tmp_0, to('position', position == null ? null : get_value_1(position))]);
    var tmp4_elvis_lhs = feedGroupInteractionType == null ? null : feedGroupInteractionType.data;
    Event.call(this, 'Feedgroup Interacted', VOID, VOID, plus(tmp_1, tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs));
  }
  function CtaSelected() {
    CtaSelected_instance = this;
    FeedGroupInteractionType.call(this, 'CtaSelected');
  }
  protoOf(CtaSelected).toString = function () {
    return 'CtaSelected(value=' + this.value + ')';
  };
  var CtaSelected_instance;
  function CtaSelected_getInstance() {
    if (CtaSelected_instance == null)
      new CtaSelected();
    return CtaSelected_instance;
  }
  function PromotionEventSelected() {
    PromotionEventSelected_instance = this;
    FeedGroupInteractionType.call(this, 'PromotionEventSelected');
  }
  protoOf(PromotionEventSelected).toString = function () {
    return 'PromotionEventSelected(value=' + this.value + ')';
  };
  var PromotionEventSelected_instance;
  function PromotionEventSelected_getInstance() {
    if (PromotionEventSelected_instance == null)
      new PromotionEventSelected();
    return PromotionEventSelected_instance;
  }
  function LottieSelected() {
    LottieSelected_instance = this;
    FeedGroupInteractionType.call(this, 'LottieSelected');
  }
  protoOf(LottieSelected).toString = function () {
    return 'LottieSelected(value=' + this.value + ')';
  };
  var LottieSelected_instance;
  function LottieSelected_getInstance() {
    if (LottieSelected_instance == null)
      new LottieSelected();
    return LottieSelected_instance;
  }
  function GamificationSelected() {
    GamificationSelected_instance = this;
    FeedGroupInteractionType.call(this, 'GamificationSelected');
  }
  protoOf(GamificationSelected).toString = function () {
    return 'GamificationSelected(value=' + this.value + ')';
  };
  var GamificationSelected_instance;
  function GamificationSelected_getInstance() {
    if (GamificationSelected_instance == null)
      new GamificationSelected();
    return GamificationSelected_instance;
  }
  function StoreSelected(storeAddressId, storeId, horizontalPosition) {
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('storeId', storeId == null ? null : get_value_1(storeId));
    FeedGroupInteractionType.call(this, 'StoreSelected', mapOf([tmp, tmp_0, to('horizontalPosition', horizontalPosition == null ? null : get_value_1(horizontalPosition))]));
  }
  protoOf(StoreSelected).toString = function () {
    return 'StoreSelected(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function InfoSelected() {
    InfoSelected_instance = this;
    FeedGroupInteractionType.call(this, 'InfoSelected');
  }
  protoOf(InfoSelected).toString = function () {
    return 'InfoSelected(value=' + this.value + ')';
  };
  var InfoSelected_instance;
  function InfoSelected_getInstance() {
    if (InfoSelected_instance == null)
      new InfoSelected();
    return InfoSelected_instance;
  }
  function Other() {
    Other_instance = this;
    FeedGroupInteractionType.call(this, 'Other');
  }
  protoOf(Other).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance;
  function Other_getInstance() {
    if (Other_instance == null)
      new Other();
    return Other_instance;
  }
  function FeedGroupInteractionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(FeedGroupInteractionType).r = function () {
    return this.value;
  };
  protoOf(FeedGroupInteractionType).qa = function () {
    return this.data;
  };
  protoOf(FeedGroupInteractionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(FeedGroupInteractionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof FeedGroupInteractionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function FeedGroupLoaded(groupId, storeAddresses, position) {
    var tmp = to('groupId', groupId == null ? null : get_value(groupId));
    var tmp_0 = to('storeAddresses', storeAddresses == null ? null : get_value_2(storeAddresses));
    Event.call(this, 'Feed Group Loaded', VOID, VOID, mapOf([tmp, tmp_0, to('position', position == null ? null : get_value_1(position))]));
  }
  function Metadata_59() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_59).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_59;
  function Metadata_getInstance_59() {
    return Metadata_instance_59;
  }
  function FeedbackCsat(feedbackId) {
    Screen.call(this, 'Feedback Csat', 'CF: Contact Flow', mapOf_0(to('feedbackId', feedbackId == null ? null : get_value_1(feedbackId))));
  }
  function Metadata_60() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_60).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_60;
  function Metadata_getInstance_60() {
    return Metadata_instance_60;
  }
  function FeedbackCsatReasonAdded(feedbackId, reason) {
    var tmp = to('feedbackId', feedbackId == null ? null : get_value_1(feedbackId));
    Event.call(this, 'Feedback Csat Reason Added', VOID, 'CF: Contact Flow', mapOf([tmp, to('reason', reason == null ? null : reason.value)]));
  }
  function Metadata_61() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_61).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_61;
  function Metadata_getInstance_61() {
    return Metadata_instance_61;
  }
  function FeedbackCsatSubmitted(feedbackId, rating, side) {
    side = side === VOID ? null : side;
    var tmp = to('feedbackId', feedbackId == null ? null : get_value_1(feedbackId));
    var tmp_0 = to('rating', rating == null ? null : get_value_1(rating));
    Event.call(this, 'Feedback Csat Submitted', VOID, 'CF: Contact Flow', mapOf([tmp, tmp_0, to('side', side == null ? null : side.value)]));
  }
  function FilterDisplayed(filterName, attributeName, horizontalPosition, searchId) {
    attributeName = attributeName === VOID ? null : attributeName;
    searchId = searchId === VOID ? null : searchId;
    var tmp = to('filterName', filterName == null ? null : filterName.value);
    var tmp_0 = to('attributeName', attributeName == null ? null : get_value(attributeName));
    var tmp_1 = to('horizontalPosition', horizontalPosition == null ? null : get_value_1(horizontalPosition));
    Event.call(this, 'Filter Displayed', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('searchId', searchId == null ? null : get_value(searchId))]));
  }
  var FilterName_StoreType_instance;
  var FilterName_Sorting_instance;
  var FilterName_Price_instance;
  var FilterName_Promotions_instance;
  var FilterName_EdenRed_instance;
  var FilterName_TopPerformers_instance;
  var FilterName_EasyReorder_instance;
  function values_33() {
    return [FilterName_StoreType_getInstance(), FilterName_Sorting_getInstance(), FilterName_Price_getInstance(), FilterName_Promotions_getInstance(), FilterName_EdenRed_getInstance(), FilterName_TopPerformers_getInstance(), FilterName_EasyReorder_getInstance()];
  }
  function valueOf_33(value) {
    switch (value) {
      case 'StoreType':
        return FilterName_StoreType_getInstance();
      case 'Sorting':
        return FilterName_Sorting_getInstance();
      case 'Price':
        return FilterName_Price_getInstance();
      case 'Promotions':
        return FilterName_Promotions_getInstance();
      case 'EdenRed':
        return FilterName_EdenRed_getInstance();
      case 'TopPerformers':
        return FilterName_TopPerformers_getInstance();
      case 'EasyReorder':
        return FilterName_EasyReorder_getInstance();
      default:
        FilterName_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var FilterName_entriesInitialized;
  function FilterName_initEntries() {
    if (FilterName_entriesInitialized)
      return Unit_instance;
    FilterName_entriesInitialized = true;
    FilterName_StoreType_instance = new FilterName('StoreType', 0, 'StoreType');
    FilterName_Sorting_instance = new FilterName('Sorting', 1, 'Sorting');
    FilterName_Price_instance = new FilterName('Price', 2, 'Price');
    FilterName_Promotions_instance = new FilterName('Promotions', 3, 'Promotions');
    FilterName_EdenRed_instance = new FilterName('EdenRed', 4, 'EdenRed');
    FilterName_TopPerformers_instance = new FilterName('TopPerformers', 5, 'TopPerformers');
    FilterName_EasyReorder_instance = new FilterName('EasyReorder', 6, 'EasyReorder');
  }
  function FilterName(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(FilterName).r = function () {
    return this.value;
  };
  function FilterName_StoreType_getInstance() {
    FilterName_initEntries();
    return FilterName_StoreType_instance;
  }
  function FilterName_Sorting_getInstance() {
    FilterName_initEntries();
    return FilterName_Sorting_instance;
  }
  function FilterName_Price_getInstance() {
    FilterName_initEntries();
    return FilterName_Price_instance;
  }
  function FilterName_Promotions_getInstance() {
    FilterName_initEntries();
    return FilterName_Promotions_instance;
  }
  function FilterName_EdenRed_getInstance() {
    FilterName_initEntries();
    return FilterName_EdenRed_instance;
  }
  function FilterName_TopPerformers_getInstance() {
    FilterName_initEntries();
    return FilterName_TopPerformers_instance;
  }
  function FilterName_EasyReorder_getInstance() {
    FilterName_initEntries();
    return FilterName_EasyReorder_instance;
  }
  var FilterOrigin_Shortcut_instance;
  var FilterOrigin_Pill_instance;
  var FilterOrigin_BottomSheet_instance;
  function values_34() {
    return [FilterOrigin_Shortcut_getInstance(), FilterOrigin_Pill_getInstance(), FilterOrigin_BottomSheet_getInstance()];
  }
  function valueOf_34(value) {
    switch (value) {
      case 'Shortcut':
        return FilterOrigin_Shortcut_getInstance();
      case 'Pill':
        return FilterOrigin_Pill_getInstance();
      case 'BottomSheet':
        return FilterOrigin_BottomSheet_getInstance();
      default:
        FilterOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var FilterOrigin_entriesInitialized;
  function FilterOrigin_initEntries() {
    if (FilterOrigin_entriesInitialized)
      return Unit_instance;
    FilterOrigin_entriesInitialized = true;
    FilterOrigin_Shortcut_instance = new FilterOrigin('Shortcut', 0, 'Shortcut');
    FilterOrigin_Pill_instance = new FilterOrigin('Pill', 1, 'Pill');
    FilterOrigin_BottomSheet_instance = new FilterOrigin('BottomSheet', 2, 'BottomSheet');
  }
  function FilterOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(FilterOrigin).r = function () {
    return this.value;
  };
  function FilterOrigin_Shortcut_getInstance() {
    FilterOrigin_initEntries();
    return FilterOrigin_Shortcut_instance;
  }
  function FilterOrigin_Pill_getInstance() {
    FilterOrigin_initEntries();
    return FilterOrigin_Pill_instance;
  }
  function FilterOrigin_BottomSheet_getInstance() {
    FilterOrigin_initEntries();
    return FilterOrigin_BottomSheet_instance;
  }
  function Filters(types, sortings, highlights, personalizedFilters, pricingFilters) {
    var tmp = to('types', types == null ? null : get_value_2(types));
    var tmp_0 = to('sortings', sortings == null ? null : get_value_2(sortings));
    var tmp_1 = to('highlights', highlights == null ? null : get_value_2(highlights));
    var tmp_2 = to('personalizedFilters', personalizedFilters == null ? null : get_value_2(personalizedFilters));
    Screen.call(this, 'Filters', VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, to('pricingFilters', pricingFilters == null ? null : get_value_2(pricingFilters))]));
  }
  function FiltersApplied(type, sortingId, prime, personalizedFilterType, origin, toggleValue, pricingId, personalizedFilterPosition, categoryId, newStoreWall, pageTemplate, filterOrigin, filters, searchId) {
    type = type === VOID ? null : type;
    sortingId = sortingId === VOID ? null : sortingId;
    personalizedFilterType = personalizedFilterType === VOID ? null : personalizedFilterType;
    pricingId = pricingId === VOID ? null : pricingId;
    personalizedFilterPosition = personalizedFilterPosition === VOID ? null : personalizedFilterPosition;
    categoryId = categoryId === VOID ? null : categoryId;
    newStoreWall = newStoreWall === VOID ? null : newStoreWall;
    pageTemplate = pageTemplate === VOID ? null : pageTemplate;
    filterOrigin = filterOrigin === VOID ? null : filterOrigin;
    filters = filters === VOID ? null : filters;
    searchId = searchId === VOID ? null : searchId;
    var tmp = EventType_Search_getInstance();
    var tmp_0 = to('type', type == null ? null : get_value(type));
    var tmp_1 = to('sortingId', sortingId == null ? null : get_value_1(sortingId));
    var tmp_2 = to('prime', prime == null ? null : get_value_0(prime));
    var tmp_3 = to('personalizedFilterType', personalizedFilterType == null ? null : personalizedFilterType.value);
    var tmp_4 = to('origin', origin == null ? null : origin.value);
    var tmp_5 = to('toggleValue', toggleValue == null ? null : get_value_0(toggleValue));
    var tmp_6 = to('pricingId', pricingId == null ? null : get_value_1(pricingId));
    var tmp_7 = to('personalizedFilterPosition', personalizedFilterPosition == null ? null : get_value_1(personalizedFilterPosition));
    var tmp_8 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_9 = to('newStoreWall', newStoreWall == null ? null : get_value_0(newStoreWall));
    var tmp_10 = to('pageTemplate', pageTemplate == null ? null : get_value(pageTemplate));
    var tmp_11 = to('filterOrigin', filterOrigin == null ? null : filterOrigin.value);
    var tmp_12 = to('filters', filters == null ? null : get_value_2(filters));
    Event.call(this, 'Filters Applied', tmp, VOID, mapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, to('searchId', searchId == null ? null : get_value(searchId))]));
  }
  function FiltersApplyResults(origin, categoryId, type, prime, storesResultsCount, pricingId, filters, searchId) {
    categoryId = categoryId === VOID ? null : categoryId;
    pricingId = pricingId === VOID ? null : pricingId;
    filters = filters === VOID ? null : filters;
    searchId = searchId === VOID ? null : searchId;
    var tmp = to('origin', origin == null ? null : origin.value);
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('type', type == null ? null : get_value(type));
    var tmp_2 = to('prime', prime == null ? null : get_value_0(prime));
    var tmp_3 = to('storesResultsCount', storesResultsCount == null ? null : get_value_1(storesResultsCount));
    var tmp_4 = to('pricingId', pricingId == null ? null : get_value_1(pricingId));
    var tmp_5 = to('filters', filters == null ? null : get_value_2(filters));
    Screen.call(this, 'Filters Apply Results', VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('searchId', searchId == null ? null : get_value(searchId))]));
  }
  function ForgotPassword() {
    Screen.call(this, 'Forgot Password');
  }
  function GiftingComponentPressed(storeAddressId, checkoutSessionId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Gifting Component Pressed', VOID, VOID, mapOf([tmp, to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))]));
  }
  function GiftingOptionDisplayed(storeAddressId, checkoutSessionId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Gifting Option Displayed', VOID, VOID, mapOf([tmp, to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))]));
  }
  function GiftingRecipientDetailsSaved(storeAddressId, checkoutSessionId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Gifting Recipient Details Saved', VOID, VOID, mapOf([tmp, to('checkoutSessionId', checkoutSessionId == null ? null : get_value(checkoutSessionId))]));
  }
  function Metadata_62() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_62).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_62;
  function Metadata_getInstance_62() {
    return Metadata_instance_62;
  }
  function GoToCheckout(storeAddressId, categoryId, productsValue, productsResultsCount, productIds, storeProductIds) {
    categoryId = categoryId === VOID ? null : categoryId;
    storeProductIds = storeProductIds === VOID ? null : storeProductIds;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('productsValue', productsValue == null ? null : get_value_1(productsValue));
    var tmp_2 = to('productsResultsCount', productsResultsCount == null ? null : get_value_1(productsResultsCount));
    var tmp_3 = to('productIds', productIds == null ? null : get_value_2(productIds));
    Event.call(this, 'Go To Checkout', VOID, 'WASP: Web Acquisition Store Page', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('storeProductIds', storeProductIds == null ? null : get_value_2(storeProductIds))]));
  }
  function Home(homeSource, cityCode, isSourceCurrentLocation, addressId, locationSource, isGpsEnabled) {
    homeSource = homeSource === VOID ? null : homeSource;
    cityCode = cityCode === VOID ? null : cityCode;
    isSourceCurrentLocation = isSourceCurrentLocation === VOID ? null : isSourceCurrentLocation;
    addressId = addressId === VOID ? null : addressId;
    locationSource = locationSource === VOID ? null : locationSource;
    isGpsEnabled = isGpsEnabled === VOID ? null : isGpsEnabled;
    var tmp = to('homeSource', homeSource == null ? null : homeSource.value);
    var tmp_0 = to('cityCode', cityCode == null ? null : get_value(cityCode));
    var tmp_1 = to('isSourceCurrentLocation', isSourceCurrentLocation == null ? null : get_value_0(isSourceCurrentLocation));
    var tmp_2 = to('addressId', addressId == null ? null : get_value_1(addressId));
    var tmp_3 = to('locationSource', locationSource == null ? null : get_value(locationSource));
    Screen.call(this, 'Home', VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('isGpsEnabled', isGpsEnabled == null ? null : get_value_0(isGpsEnabled))]));
  }
  function HomeContentShown(loadedCategories, inactiveCategories, storiesVisible, loadedCategoryGroups, inactiveCategoryGroups, loadedStoreGroupCategories, inactiveStoreGroupCategories, loadedStoreCategories, inactiveStoreCategories, bubbleStates, renderedCategories, addressId, locationSource, isGpsEnabled, didGpsTimeout) {
    bubbleStates = bubbleStates === VOID ? null : bubbleStates;
    addressId = addressId === VOID ? null : addressId;
    locationSource = locationSource === VOID ? null : locationSource;
    isGpsEnabled = isGpsEnabled === VOID ? null : isGpsEnabled;
    didGpsTimeout = didGpsTimeout === VOID ? null : didGpsTimeout;
    var tmp = to('loadedCategories', loadedCategories == null ? null : get_value_2(loadedCategories));
    var tmp_0 = to('inactiveCategories', inactiveCategories == null ? null : get_value_2(inactiveCategories));
    var tmp_1 = to('storiesVisible', storiesVisible == null ? null : get_value_0(storiesVisible));
    var tmp_2 = to('loadedCategoryGroups', loadedCategoryGroups == null ? null : get_value_2(loadedCategoryGroups));
    var tmp_3 = to('inactiveCategoryGroups', inactiveCategoryGroups == null ? null : get_value_2(inactiveCategoryGroups));
    var tmp_4 = to('loadedStoreGroupCategories', loadedStoreGroupCategories == null ? null : get_value_2(loadedStoreGroupCategories));
    var tmp_5 = to('inactiveStoreGroupCategories', inactiveStoreGroupCategories == null ? null : get_value_2(inactiveStoreGroupCategories));
    var tmp_6 = to('loadedStoreCategories', loadedStoreCategories == null ? null : get_value_2(loadedStoreCategories));
    var tmp_7 = to('inactiveStoreCategories', inactiveStoreCategories == null ? null : get_value_2(inactiveStoreCategories));
    var tmp_8 = to('bubbleStates', bubbleStates == null ? null : get_value_2(bubbleStates));
    var tmp_9 = to('renderedCategories', renderedCategories == null ? null : get_value_2(renderedCategories));
    var tmp_10 = to('addressId', addressId == null ? null : get_value_1(addressId));
    var tmp_11 = to('locationSource', locationSource == null ? null : get_value(locationSource));
    var tmp_12 = to('isGpsEnabled', isGpsEnabled == null ? null : get_value_0(isGpsEnabled));
    Event.call(this, 'Home Content Shown', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, to('didGpsTimeout', didGpsTimeout == null ? null : get_value_0(didGpsTimeout))]));
  }
  function HomeLocationErrorScreenView(reason, coordinatesLatitude, coordinatesLongitude, isGpsEnabled) {
    reason = reason === VOID ? null : reason;
    coordinatesLatitude = coordinatesLatitude === VOID ? null : coordinatesLatitude;
    coordinatesLongitude = coordinatesLongitude === VOID ? null : coordinatesLongitude;
    isGpsEnabled = isGpsEnabled === VOID ? null : isGpsEnabled;
    var tmp = to('reason', reason == null ? null : reason.value);
    var tmp_0 = to('coordinatesLatitude', coordinatesLatitude == null ? null : get_value_1(coordinatesLatitude));
    var tmp_1 = to('coordinatesLongitude', coordinatesLongitude == null ? null : get_value_1(coordinatesLongitude));
    Screen.call(this, 'HomeLocation Error Screen View', VOID, mapOf([tmp, tmp_0, tmp_1, to('isGpsEnabled', isGpsEnabled == null ? null : get_value_0(isGpsEnabled))]));
  }
  var HomePageNotLoadedReason_OutOfDeliveryZone_instance;
  var HomePageNotLoadedReason_FailureToFetchGpsWhileOn_instance;
  var HomePageNotLoadedReason_CannotFindAddress_instance;
  function values_35() {
    return [HomePageNotLoadedReason_OutOfDeliveryZone_getInstance(), HomePageNotLoadedReason_FailureToFetchGpsWhileOn_getInstance(), HomePageNotLoadedReason_CannotFindAddress_getInstance()];
  }
  function valueOf_35(value) {
    switch (value) {
      case 'OutOfDeliveryZone':
        return HomePageNotLoadedReason_OutOfDeliveryZone_getInstance();
      case 'FailureToFetchGpsWhileOn':
        return HomePageNotLoadedReason_FailureToFetchGpsWhileOn_getInstance();
      case 'CannotFindAddress':
        return HomePageNotLoadedReason_CannotFindAddress_getInstance();
      default:
        HomePageNotLoadedReason_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var HomePageNotLoadedReason_entriesInitialized;
  function HomePageNotLoadedReason_initEntries() {
    if (HomePageNotLoadedReason_entriesInitialized)
      return Unit_instance;
    HomePageNotLoadedReason_entriesInitialized = true;
    HomePageNotLoadedReason_OutOfDeliveryZone_instance = new HomePageNotLoadedReason('OutOfDeliveryZone', 0, 'OutOfDeliveryZone');
    HomePageNotLoadedReason_FailureToFetchGpsWhileOn_instance = new HomePageNotLoadedReason('FailureToFetchGpsWhileOn', 1, 'FailureToFetchGpsWhileOn');
    HomePageNotLoadedReason_CannotFindAddress_instance = new HomePageNotLoadedReason('CannotFindAddress', 2, 'CannotFindAddress');
  }
  function HomePageNotLoadedReason(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(HomePageNotLoadedReason).r = function () {
    return this.value;
  };
  function HomePageNotLoadedReason_OutOfDeliveryZone_getInstance() {
    HomePageNotLoadedReason_initEntries();
    return HomePageNotLoadedReason_OutOfDeliveryZone_instance;
  }
  function HomePageNotLoadedReason_FailureToFetchGpsWhileOn_getInstance() {
    HomePageNotLoadedReason_initEntries();
    return HomePageNotLoadedReason_FailureToFetchGpsWhileOn_instance;
  }
  function HomePageNotLoadedReason_CannotFindAddress_getInstance() {
    HomePageNotLoadedReason_initEntries();
    return HomePageNotLoadedReason_CannotFindAddress_instance;
  }
  var HomeSource_Direct_instance;
  var HomeSource_HomeGlobal_instance;
  var HomeSource_HomeCountry_instance;
  var HomeSource_StoresList_instance;
  var HomeSource_StoreMenu_instance;
  var HomeSource_NavigationTabBar_instance;
  function values_36() {
    return [HomeSource_Direct_getInstance(), HomeSource_HomeGlobal_getInstance(), HomeSource_HomeCountry_getInstance(), HomeSource_StoresList_getInstance(), HomeSource_StoreMenu_getInstance(), HomeSource_NavigationTabBar_getInstance()];
  }
  function valueOf_36(value) {
    switch (value) {
      case 'Direct':
        return HomeSource_Direct_getInstance();
      case 'HomeGlobal':
        return HomeSource_HomeGlobal_getInstance();
      case 'HomeCountry':
        return HomeSource_HomeCountry_getInstance();
      case 'StoresList':
        return HomeSource_StoresList_getInstance();
      case 'StoreMenu':
        return HomeSource_StoreMenu_getInstance();
      case 'NavigationTabBar':
        return HomeSource_NavigationTabBar_getInstance();
      default:
        HomeSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var HomeSource_entriesInitialized;
  function HomeSource_initEntries() {
    if (HomeSource_entriesInitialized)
      return Unit_instance;
    HomeSource_entriesInitialized = true;
    HomeSource_Direct_instance = new HomeSource('Direct', 0, 'Direct');
    HomeSource_HomeGlobal_instance = new HomeSource('HomeGlobal', 1, 'Home Global');
    HomeSource_HomeCountry_instance = new HomeSource('HomeCountry', 2, 'Home Country');
    HomeSource_StoresList_instance = new HomeSource('StoresList', 3, 'Stores List');
    HomeSource_StoreMenu_instance = new HomeSource('StoreMenu', 4, 'Store Menu');
    HomeSource_NavigationTabBar_instance = new HomeSource('NavigationTabBar', 5, 'NavigationTabBar');
  }
  function HomeSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(HomeSource).r = function () {
    return this.value;
  };
  function HomeSource_Direct_getInstance() {
    HomeSource_initEntries();
    return HomeSource_Direct_instance;
  }
  function HomeSource_HomeGlobal_getInstance() {
    HomeSource_initEntries();
    return HomeSource_HomeGlobal_instance;
  }
  function HomeSource_HomeCountry_getInstance() {
    HomeSource_initEntries();
    return HomeSource_HomeCountry_instance;
  }
  function HomeSource_StoresList_getInstance() {
    HomeSource_initEntries();
    return HomeSource_StoresList_instance;
  }
  function HomeSource_StoreMenu_getInstance() {
    HomeSource_initEntries();
    return HomeSource_StoreMenu_instance;
  }
  function HomeSource_NavigationTabBar_getInstance() {
    HomeSource_initEntries();
    return HomeSource_NavigationTabBar_instance;
  }
  function IdenticalAddressPopUpViewed() {
    Screen.call(this, 'Identical Address Pop Up Viewed');
  }
  function StoreCard() {
    StoreCard_instance = this;
    ImpressionType.call(this, 'StoreCard');
  }
  protoOf(StoreCard).toString = function () {
    return 'StoreCard(value=' + this.value + ')';
  };
  var StoreCard_instance;
  function StoreCard_getInstance() {
    if (StoreCard_instance == null)
      new StoreCard();
    return StoreCard_instance;
  }
  function Logo(isPlaceHolder) {
    ImpressionType.call(this, 'Logo', mapOf_0(to('isPlaceHolder', isPlaceHolder == null ? null : get_value_0(isPlaceHolder))));
  }
  protoOf(Logo).toString = function () {
    return 'Logo(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function ImpressionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(ImpressionType).r = function () {
    return this.value;
  };
  protoOf(ImpressionType).qa = function () {
    return this.data;
  };
  protoOf(ImpressionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(ImpressionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ImpressionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var InfoButtonSource_Checkout_instance;
  function values_37() {
    return [InfoButtonSource_Checkout_getInstance()];
  }
  function valueOf_37(value) {
    if (value === 'Checkout')
      return InfoButtonSource_Checkout_getInstance();
    else {
      InfoButtonSource_initEntries();
      THROW_IAE('No enum constant value.');
    }
  }
  var InfoButtonSource_entriesInitialized;
  function InfoButtonSource_initEntries() {
    if (InfoButtonSource_entriesInitialized)
      return Unit_instance;
    InfoButtonSource_entriesInitialized = true;
    InfoButtonSource_Checkout_instance = new InfoButtonSource('Checkout', 0, 'Checkout');
  }
  function InfoButtonSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(InfoButtonSource).r = function () {
    return this.value;
  };
  function InfoButtonSource_Checkout_getInstance() {
    InfoButtonSource_initEntries();
    return InfoButtonSource_Checkout_instance;
  }
  function InfoButtonTapped(source, infoType) {
    var tmp = to('source', source == null ? null : source.value);
    Event.call(this, 'Info Button Tapped', VOID, VOID, mapOf([tmp, to('infoType', infoType == null ? null : infoType.value)]));
  }
  var InfoType_Fee_instance;
  var InfoType_Partner_instance;
  var InfoType_BusyAreaFeesInfo_instance;
  var InfoType_DeliveryCosts_instance;
  var InfoType_DeliveryCostsBusyAreaFeesInfo_instance;
  var InfoType_PromoMoreInfo_instance;
  var InfoType_StoreMembershipDisconnect_instance;
  function values_38() {
    return [InfoType_Fee_getInstance(), InfoType_Partner_getInstance(), InfoType_BusyAreaFeesInfo_getInstance(), InfoType_DeliveryCosts_getInstance(), InfoType_DeliveryCostsBusyAreaFeesInfo_getInstance(), InfoType_PromoMoreInfo_getInstance(), InfoType_StoreMembershipDisconnect_getInstance()];
  }
  function valueOf_38(value) {
    switch (value) {
      case 'Fee':
        return InfoType_Fee_getInstance();
      case 'Partner':
        return InfoType_Partner_getInstance();
      case 'BusyAreaFeesInfo':
        return InfoType_BusyAreaFeesInfo_getInstance();
      case 'DeliveryCosts':
        return InfoType_DeliveryCosts_getInstance();
      case 'DeliveryCostsBusyAreaFeesInfo':
        return InfoType_DeliveryCostsBusyAreaFeesInfo_getInstance();
      case 'PromoMoreInfo':
        return InfoType_PromoMoreInfo_getInstance();
      case 'StoreMembershipDisconnect':
        return InfoType_StoreMembershipDisconnect_getInstance();
      default:
        InfoType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var InfoType_entriesInitialized;
  function InfoType_initEntries() {
    if (InfoType_entriesInitialized)
      return Unit_instance;
    InfoType_entriesInitialized = true;
    InfoType_Fee_instance = new InfoType('Fee', 0, 'Fee');
    InfoType_Partner_instance = new InfoType('Partner', 1, 'Partner');
    InfoType_BusyAreaFeesInfo_instance = new InfoType('BusyAreaFeesInfo', 2, 'BusyAreaFeesInfo');
    InfoType_DeliveryCosts_instance = new InfoType('DeliveryCosts', 3, 'DeliveryCosts');
    InfoType_DeliveryCostsBusyAreaFeesInfo_instance = new InfoType('DeliveryCostsBusyAreaFeesInfo', 4, 'DeliveryCostsBusyAreaFeesInfo');
    InfoType_PromoMoreInfo_instance = new InfoType('PromoMoreInfo', 5, 'PromoMoreInfo');
    InfoType_StoreMembershipDisconnect_instance = new InfoType('StoreMembershipDisconnect', 6, 'StoreMembershipDisconnect');
  }
  function InfoType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(InfoType).r = function () {
    return this.value;
  };
  function InfoType_Fee_getInstance() {
    InfoType_initEntries();
    return InfoType_Fee_instance;
  }
  function InfoType_Partner_getInstance() {
    InfoType_initEntries();
    return InfoType_Partner_instance;
  }
  function InfoType_BusyAreaFeesInfo_getInstance() {
    InfoType_initEntries();
    return InfoType_BusyAreaFeesInfo_instance;
  }
  function InfoType_DeliveryCosts_getInstance() {
    InfoType_initEntries();
    return InfoType_DeliveryCosts_instance;
  }
  function InfoType_DeliveryCostsBusyAreaFeesInfo_getInstance() {
    InfoType_initEntries();
    return InfoType_DeliveryCostsBusyAreaFeesInfo_instance;
  }
  function InfoType_PromoMoreInfo_getInstance() {
    InfoType_initEntries();
    return InfoType_PromoMoreInfo_instance;
  }
  function InfoType_StoreMembershipDisconnect_getInstance() {
    InfoType_initEntries();
    return InfoType_StoreMembershipDisconnect_instance;
  }
  function Metadata_63() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_63).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_63;
  function Metadata_getInstance_63() {
    return Metadata_instance_63;
  }
  function InstructionAdded(instructionType, screen) {
    var tmp = to('instructionType', instructionType == null ? null : instructionType.value);
    var tmp_0 = mapOf([tmp, to('screen', screen == null ? null : get_value(screen))]);
    var tmp3_elvis_lhs = instructionType == null ? null : instructionType.data;
    Event.call(this, 'Instruction Added', VOID, 'CK: Checkout', plus(tmp_0, tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs));
  }
  function Metadata_64() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_64).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_64;
  function Metadata_getInstance_64() {
    return Metadata_instance_64;
  }
  function InstructionImpression(instructionType, screen) {
    var tmp = to('instructionType', instructionType == null ? null : instructionType.value);
    var tmp_0 = mapOf([tmp, to('screen', screen == null ? null : get_value(screen))]);
    var tmp3_elvis_lhs = instructionType == null ? null : instructionType.data;
    Event.call(this, 'Instruction Impression', VOID, 'CK: Checkout', plus(tmp_0, tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs));
  }
  function ProductInstructionPNA(productId, productExternalId, storeProductId, instructionAdded, replacerProductExternalId, replacerStoreProductId, listPossibleReplacerExternalId, listPossibleReplacerStoreProductId, isAvailable, isSelected) {
    productId = productId === VOID ? null : productId;
    productExternalId = productExternalId === VOID ? null : productExternalId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    replacerProductExternalId = replacerProductExternalId === VOID ? null : replacerProductExternalId;
    replacerStoreProductId = replacerStoreProductId === VOID ? null : replacerStoreProductId;
    listPossibleReplacerExternalId = listPossibleReplacerExternalId === VOID ? null : listPossibleReplacerExternalId;
    listPossibleReplacerStoreProductId = listPossibleReplacerStoreProductId === VOID ? null : listPossibleReplacerStoreProductId;
    isAvailable = isAvailable === VOID ? null : isAvailable;
    isSelected = isSelected === VOID ? null : isSelected;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('productExternalId', productExternalId == null ? null : get_value(productExternalId));
    var tmp_1 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp_2 = to('instructionAdded', instructionAdded == null ? null : get_value(instructionAdded));
    var tmp_3 = to('replacerProductExternalId', replacerProductExternalId == null ? null : get_value(replacerProductExternalId));
    var tmp_4 = to('replacerStoreProductId', replacerStoreProductId == null ? null : get_value(replacerStoreProductId));
    var tmp_5 = to('listPossibleReplacerExternalId', listPossibleReplacerExternalId == null ? null : get_value_2(listPossibleReplacerExternalId));
    var tmp_6 = to('listPossibleReplacerStoreProductId', listPossibleReplacerStoreProductId == null ? null : get_value_2(listPossibleReplacerStoreProductId));
    var tmp_7 = to('isAvailable', isAvailable == null ? null : get_value_0(isAvailable));
    InstructionType.call(this, 'ProductInstructionPNA', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, to('isSelected', isSelected == null ? null : get_value_0(isSelected))]));
  }
  protoOf(ProductInstructionPNA).toString = function () {
    return 'ProductInstructionPNA(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function OrderInstructionPNA(instructionAdded) {
    InstructionType.call(this, 'OrderInstructionPNA', mapOf_0(to('instructionAdded', instructionAdded == null ? null : get_value(instructionAdded))));
  }
  protoOf(OrderInstructionPNA).toString = function () {
    return 'OrderInstructionPNA(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function OrderInstructionGifting(giftingTicket, personalisedInstructions) {
    var tmp = to('giftingTicket', giftingTicket == null ? null : get_value_0(giftingTicket));
    InstructionType.call(this, 'OrderInstructionGifting', mapOf([tmp, to('personalisedInstructions', personalisedInstructions == null ? null : get_value_0(personalisedInstructions))]));
  }
  protoOf(OrderInstructionGifting).toString = function () {
    return 'OrderInstructionGifting(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function InstructionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(InstructionType).r = function () {
    return this.value;
  };
  protoOf(InstructionType).qa = function () {
    return this.data;
  };
  protoOf(InstructionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(InstructionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof InstructionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function InvalidEmail() {
    Event.call(this, 'Invalid Email');
  }
  var LayoutDesign_ListView_instance;
  var LayoutDesign_GridView_instance;
  function values_39() {
    return [LayoutDesign_ListView_getInstance(), LayoutDesign_GridView_getInstance()];
  }
  function valueOf_39(value) {
    switch (value) {
      case 'ListView':
        return LayoutDesign_ListView_getInstance();
      case 'GridView':
        return LayoutDesign_GridView_getInstance();
      default:
        LayoutDesign_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var LayoutDesign_entriesInitialized;
  function LayoutDesign_initEntries() {
    if (LayoutDesign_entriesInitialized)
      return Unit_instance;
    LayoutDesign_entriesInitialized = true;
    LayoutDesign_ListView_instance = new LayoutDesign('ListView', 0, 'List View');
    LayoutDesign_GridView_instance = new LayoutDesign('GridView', 1, 'Grid View');
  }
  function LayoutDesign(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(LayoutDesign).r = function () {
    return this.value;
  };
  function LayoutDesign_ListView_getInstance() {
    LayoutDesign_initEntries();
    return LayoutDesign_ListView_instance;
  }
  function LayoutDesign_GridView_getInstance() {
    LayoutDesign_initEntries();
    return LayoutDesign_GridView_instance;
  }
  function LocationTrackingPermissionGranted() {
    Event.call(this, 'Location Tracking Permission Granted');
  }
  function LogOutButtonClicked(origin, successful) {
    origin = origin === VOID ? null : origin;
    successful = successful === VOID ? null : successful;
    var tmp = to('origin', origin == null ? null : origin.value);
    var tmp_0 = mapOf([tmp, to('successful', successful == null ? null : get_value_0(successful))]);
    var tmp3_elvis_lhs = origin == null ? null : origin.data;
    Event.call(this, 'Log Out Button Clicked', VOID, VOID, plus(tmp_0, tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs));
  }
  function Metadata_65() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_65).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_65;
  function Metadata_getInstance_65() {
    return Metadata_instance_65;
  }
  function LoginScreen() {
    Screen.call(this, 'Login Screen', 'WASP: Web Acquisition Store Page');
  }
  var MbsCalculationStrategy_Standard_instance;
  var MbsCalculationStrategy_Capped_instance;
  function values_40() {
    return [MbsCalculationStrategy_Standard_getInstance(), MbsCalculationStrategy_Capped_getInstance()];
  }
  function valueOf_40(value) {
    switch (value) {
      case 'Standard':
        return MbsCalculationStrategy_Standard_getInstance();
      case 'Capped':
        return MbsCalculationStrategy_Capped_getInstance();
      default:
        MbsCalculationStrategy_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var MbsCalculationStrategy_entriesInitialized;
  function MbsCalculationStrategy_initEntries() {
    if (MbsCalculationStrategy_entriesInitialized)
      return Unit_instance;
    MbsCalculationStrategy_entriesInitialized = true;
    MbsCalculationStrategy_Standard_instance = new MbsCalculationStrategy('Standard', 0, 'Standard');
    MbsCalculationStrategy_Capped_instance = new MbsCalculationStrategy('Capped', 1, 'Capped');
  }
  function MbsCalculationStrategy(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(MbsCalculationStrategy).r = function () {
    return this.value;
  };
  function MbsCalculationStrategy_Standard_getInstance() {
    MbsCalculationStrategy_initEntries();
    return MbsCalculationStrategy_Standard_instance;
  }
  function MbsCalculationStrategy_Capped_getInstance() {
    MbsCalculationStrategy_initEntries();
    return MbsCalculationStrategy_Capped_instance;
  }
  function MbsMoreInfoTapped(storeAddressId, thresholdSurcharge, currentBasketAmount, isPrimeMbs) {
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('thresholdSurcharge', thresholdSurcharge == null ? null : get_value_1(thresholdSurcharge));
    var tmp_1 = to('currentBasketAmount', currentBasketAmount == null ? null : get_value_1(currentBasketAmount));
    Event.call(this, 'MBS More Info Tapped', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('isPrimeMbs', isPrimeMbs == null ? null : get_value_0(isPrimeMbs))]));
  }
  function MbsProgressBarShown(isPrimeMbs, thresholdSurcharge) {
    var tmp = to('isPrimeMbs', isPrimeMbs == null ? null : get_value_0(isPrimeMbs));
    Event.call(this, 'MBS Progress Bar Shown', VOID, VOID, mapOf([tmp, to('thresholdSurcharge', thresholdSurcharge == null ? null : get_value_1(thresholdSurcharge))]));
  }
  function MbsThresholdReached(storeAddressId, productId, thresholdSurcharge, isPrimeMbs, currentBasketAmount, purchasesThreshold, valueSurcharge, calculationStrategy, storeProductId) {
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_1 = to('thresholdSurcharge', thresholdSurcharge == null ? null : get_value_1(thresholdSurcharge));
    var tmp_2 = to('isPrimeMbs', isPrimeMbs == null ? null : get_value_0(isPrimeMbs));
    var tmp_3 = to('currentBasketAmount', currentBasketAmount == null ? null : get_value_1(currentBasketAmount));
    var tmp_4 = to('purchasesThreshold', purchasesThreshold == null ? null : get_value_1(purchasesThreshold));
    var tmp_5 = to('valueSurcharge', valueSurcharge == null ? null : get_value_1(valueSurcharge));
    var tmp_6 = to('calculationStrategy', calculationStrategy == null ? null : calculationStrategy.value);
    Event.call(this, 'MBS Threshold Reached', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  function Metadata_66() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_66).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_66;
  function Metadata_getInstance_66() {
    return Metadata_instance_66;
  }
  function Mgm(source, promotionId) {
    var tmp = to('source', source == null ? null : source.value);
    Screen.call(this, 'Mgm', 'GRO: Growth', mapOf([tmp, to('promotionId', promotionId == null ? null : get_value_1(promotionId))]));
  }
  var MgmSource_Banner_instance;
  var MgmSource_Home_instance;
  var MgmSource_Deeplink_instance;
  var MgmSource_Profile_instance;
  var MgmSource_Story_instance;
  function values_41() {
    return [MgmSource_Banner_getInstance(), MgmSource_Home_getInstance(), MgmSource_Deeplink_getInstance(), MgmSource_Profile_getInstance(), MgmSource_Story_getInstance()];
  }
  function valueOf_41(value) {
    switch (value) {
      case 'Banner':
        return MgmSource_Banner_getInstance();
      case 'Home':
        return MgmSource_Home_getInstance();
      case 'Deeplink':
        return MgmSource_Deeplink_getInstance();
      case 'Profile':
        return MgmSource_Profile_getInstance();
      case 'Story':
        return MgmSource_Story_getInstance();
      default:
        MgmSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var MgmSource_entriesInitialized;
  function MgmSource_initEntries() {
    if (MgmSource_entriesInitialized)
      return Unit_instance;
    MgmSource_entriesInitialized = true;
    MgmSource_Banner_instance = new MgmSource('Banner', 0, 'Banner');
    MgmSource_Home_instance = new MgmSource('Home', 1, 'Home');
    MgmSource_Deeplink_instance = new MgmSource('Deeplink', 2, 'Deeplink');
    MgmSource_Profile_instance = new MgmSource('Profile', 3, 'Profile');
    MgmSource_Story_instance = new MgmSource('Story', 4, 'Story');
  }
  function MgmSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(MgmSource).r = function () {
    return this.value;
  };
  function MgmSource_Banner_getInstance() {
    MgmSource_initEntries();
    return MgmSource_Banner_instance;
  }
  function MgmSource_Home_getInstance() {
    MgmSource_initEntries();
    return MgmSource_Home_instance;
  }
  function MgmSource_Deeplink_getInstance() {
    MgmSource_initEntries();
    return MgmSource_Deeplink_instance;
  }
  function MgmSource_Profile_getInstance() {
    MgmSource_initEntries();
    return MgmSource_Profile_instance;
  }
  function MgmSource_Story_getInstance() {
    MgmSource_initEntries();
    return MgmSource_Story_instance;
  }
  function MigrationExploreButtonPressed() {
    Event.call(this, 'Migration Explore Button Pressed');
  }
  function MigrationSucceeded(userId) {
    Event.call(this, 'Migration Succeeded', VOID, VOID, mapOf_0(to('userId', userId == null ? null : get_value_1(userId))));
  }
  function MigrationWelcome() {
    Screen.call(this, 'Migration Welcome');
  }
  function NavigationBarElementTapped(level, position, collectionGroupId, collectionId, sectionID, collectionType, searchId) {
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    collectionId = collectionId === VOID ? null : collectionId;
    sectionID = sectionID === VOID ? null : sectionID;
    collectionType = collectionType === VOID ? null : collectionType;
    searchId = searchId === VOID ? null : searchId;
    var tmp = to('level', level == null ? null : get_value_1(level));
    var tmp_0 = to('position', position == null ? null : get_value_1(position));
    var tmp_1 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_2 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_3 = to('sectionID', sectionID == null ? null : get_value_1(sectionID));
    var tmp_4 = to('collectionType', collectionType == null ? null : collectionType.value);
    var tmp_5 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('searchId', searchId == null ? null : get_value(searchId))]);
    var tmp8_elvis_lhs = collectionType == null ? null : collectionType.data;
    Event.call(this, 'Navigation Bar Element Tapped', VOID, VOID, plus(tmp_5, tmp8_elvis_lhs == null ? emptyMap() : tmp8_elvis_lhs));
  }
  var NavigationTabBarAppLocation_Home_instance;
  var NavigationTabBarAppLocation_StoreWall_instance;
  var NavigationTabBarAppLocation_Profile_instance;
  var NavigationTabBarAppLocation_Cart_instance;
  var NavigationTabBarAppLocation_Search_instance;
  var NavigationTabBarAppLocation_Orders_instance;
  var NavigationTabBarAppLocation_Account_instance;
  var NavigationTabBarAppLocation_Promocodes_instance;
  var NavigationTabBarAppLocation_Language_instance;
  var NavigationTabBarAppLocation_FAQ_instance;
  var NavigationTabBarAppLocation_Notifications_instance;
  var NavigationTabBarAppLocation_Other_instance;
  function values_42() {
    return [NavigationTabBarAppLocation_Home_getInstance(), NavigationTabBarAppLocation_StoreWall_getInstance(), NavigationTabBarAppLocation_Profile_getInstance(), NavigationTabBarAppLocation_Cart_getInstance(), NavigationTabBarAppLocation_Search_getInstance(), NavigationTabBarAppLocation_Orders_getInstance(), NavigationTabBarAppLocation_Account_getInstance(), NavigationTabBarAppLocation_Promocodes_getInstance(), NavigationTabBarAppLocation_Language_getInstance(), NavigationTabBarAppLocation_FAQ_getInstance(), NavigationTabBarAppLocation_Notifications_getInstance(), NavigationTabBarAppLocation_Other_getInstance()];
  }
  function valueOf_42(value) {
    switch (value) {
      case 'Home':
        return NavigationTabBarAppLocation_Home_getInstance();
      case 'StoreWall':
        return NavigationTabBarAppLocation_StoreWall_getInstance();
      case 'Profile':
        return NavigationTabBarAppLocation_Profile_getInstance();
      case 'Cart':
        return NavigationTabBarAppLocation_Cart_getInstance();
      case 'Search':
        return NavigationTabBarAppLocation_Search_getInstance();
      case 'Orders':
        return NavigationTabBarAppLocation_Orders_getInstance();
      case 'Account':
        return NavigationTabBarAppLocation_Account_getInstance();
      case 'Promocodes':
        return NavigationTabBarAppLocation_Promocodes_getInstance();
      case 'Language':
        return NavigationTabBarAppLocation_Language_getInstance();
      case 'FAQ':
        return NavigationTabBarAppLocation_FAQ_getInstance();
      case 'Notifications':
        return NavigationTabBarAppLocation_Notifications_getInstance();
      case 'Other':
        return NavigationTabBarAppLocation_Other_getInstance();
      default:
        NavigationTabBarAppLocation_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var NavigationTabBarAppLocation_entriesInitialized;
  function NavigationTabBarAppLocation_initEntries() {
    if (NavigationTabBarAppLocation_entriesInitialized)
      return Unit_instance;
    NavigationTabBarAppLocation_entriesInitialized = true;
    NavigationTabBarAppLocation_Home_instance = new NavigationTabBarAppLocation('Home', 0, 'Home');
    NavigationTabBarAppLocation_StoreWall_instance = new NavigationTabBarAppLocation('StoreWall', 1, 'StoreWall');
    NavigationTabBarAppLocation_Profile_instance = new NavigationTabBarAppLocation('Profile', 2, 'Profile');
    NavigationTabBarAppLocation_Cart_instance = new NavigationTabBarAppLocation('Cart', 3, 'Cart');
    NavigationTabBarAppLocation_Search_instance = new NavigationTabBarAppLocation('Search', 4, 'Search');
    NavigationTabBarAppLocation_Orders_instance = new NavigationTabBarAppLocation('Orders', 5, 'Orders');
    NavigationTabBarAppLocation_Account_instance = new NavigationTabBarAppLocation('Account', 6, 'Account');
    NavigationTabBarAppLocation_Promocodes_instance = new NavigationTabBarAppLocation('Promocodes', 7, 'Promocodes');
    NavigationTabBarAppLocation_Language_instance = new NavigationTabBarAppLocation('Language', 8, 'Language');
    NavigationTabBarAppLocation_FAQ_instance = new NavigationTabBarAppLocation('FAQ', 9, 'FAQ');
    NavigationTabBarAppLocation_Notifications_instance = new NavigationTabBarAppLocation('Notifications', 10, 'Notifications');
    NavigationTabBarAppLocation_Other_instance = new NavigationTabBarAppLocation('Other', 11, 'Other');
  }
  function NavigationTabBarAppLocation(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(NavigationTabBarAppLocation).r = function () {
    return this.value;
  };
  function NavigationTabBarAppLocation_Home_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Home_instance;
  }
  function NavigationTabBarAppLocation_StoreWall_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_StoreWall_instance;
  }
  function NavigationTabBarAppLocation_Profile_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Profile_instance;
  }
  function NavigationTabBarAppLocation_Cart_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Cart_instance;
  }
  function NavigationTabBarAppLocation_Search_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Search_instance;
  }
  function NavigationTabBarAppLocation_Orders_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Orders_instance;
  }
  function NavigationTabBarAppLocation_Account_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Account_instance;
  }
  function NavigationTabBarAppLocation_Promocodes_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Promocodes_instance;
  }
  function NavigationTabBarAppLocation_Language_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Language_instance;
  }
  function NavigationTabBarAppLocation_FAQ_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_FAQ_instance;
  }
  function NavigationTabBarAppLocation_Notifications_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Notifications_instance;
  }
  function NavigationTabBarAppLocation_Other_getInstance() {
    NavigationTabBarAppLocation_initEntries();
    return NavigationTabBarAppLocation_Other_instance;
  }
  var NavigationTabBarElements_Home_instance;
  var NavigationTabBarElements_Cart_instance;
  var NavigationTabBarElements_Profile_instance;
  var NavigationTabBarElements_Search_instance;
  function values_43() {
    return [NavigationTabBarElements_Home_getInstance(), NavigationTabBarElements_Cart_getInstance(), NavigationTabBarElements_Profile_getInstance(), NavigationTabBarElements_Search_getInstance()];
  }
  function valueOf_43(value) {
    switch (value) {
      case 'Home':
        return NavigationTabBarElements_Home_getInstance();
      case 'Cart':
        return NavigationTabBarElements_Cart_getInstance();
      case 'Profile':
        return NavigationTabBarElements_Profile_getInstance();
      case 'Search':
        return NavigationTabBarElements_Search_getInstance();
      default:
        NavigationTabBarElements_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var NavigationTabBarElements_entriesInitialized;
  function NavigationTabBarElements_initEntries() {
    if (NavigationTabBarElements_entriesInitialized)
      return Unit_instance;
    NavigationTabBarElements_entriesInitialized = true;
    NavigationTabBarElements_Home_instance = new NavigationTabBarElements('Home', 0, 'Home');
    NavigationTabBarElements_Cart_instance = new NavigationTabBarElements('Cart', 1, 'Cart');
    NavigationTabBarElements_Profile_instance = new NavigationTabBarElements('Profile', 2, 'Profile');
    NavigationTabBarElements_Search_instance = new NavigationTabBarElements('Search', 3, 'Search');
  }
  function NavigationTabBarElements(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(NavigationTabBarElements).r = function () {
    return this.value;
  };
  function NavigationTabBarElements_Home_getInstance() {
    NavigationTabBarElements_initEntries();
    return NavigationTabBarElements_Home_instance;
  }
  function NavigationTabBarElements_Cart_getInstance() {
    NavigationTabBarElements_initEntries();
    return NavigationTabBarElements_Cart_instance;
  }
  function NavigationTabBarElements_Profile_getInstance() {
    NavigationTabBarElements_initEntries();
    return NavigationTabBarElements_Profile_instance;
  }
  function NavigationTabBarElements_Search_getInstance() {
    NavigationTabBarElements_initEntries();
    return NavigationTabBarElements_Search_instance;
  }
  function NavigationTabBarLoaded(navigationTabBarAppLocation, navigationTabBarElementsShown, navigationTabBarSelectedElement, navigationTabBarBadgeElements) {
    var tmp = to('navigationTabBarAppLocation', navigationTabBarAppLocation == null ? null : navigationTabBarAppLocation.value);
    var tmp_0 = to('navigationTabBarElementsShown', navigationTabBarElementsShown == null ? null : get_value_2(navigationTabBarElementsShown));
    var tmp_1 = to('navigationTabBarSelectedElement', navigationTabBarSelectedElement == null ? null : navigationTabBarSelectedElement.value);
    Event.call(this, 'Navigation Tab Bar Loaded', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('navigationTabBarBadgeElements', navigationTabBarBadgeElements == null ? null : get_value_2(navigationTabBarBadgeElements))]));
  }
  function NavigationTabBarTapped(navigationTabBarAppLocation, navigationTabBarElementTapped, navigationTabBarSelectedElement, navigationTabBarBadgeElements) {
    var tmp = to('navigationTabBarAppLocation', navigationTabBarAppLocation == null ? null : navigationTabBarAppLocation.value);
    var tmp_0 = to('navigationTabBarElementTapped', navigationTabBarElementTapped == null ? null : navigationTabBarElementTapped.value);
    var tmp_1 = to('navigationTabBarSelectedElement', navigationTabBarSelectedElement == null ? null : navigationTabBarSelectedElement.value);
    Event.call(this, 'Navigation Tab Bar Tapped', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('navigationTabBarBadgeElements', navigationTabBarBadgeElements == null ? null : get_value_2(navigationTabBarBadgeElements))]));
  }
  function Metadata_67() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_67).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_67;
  function Metadata_getInstance_67() {
    return Metadata_instance_67;
  }
  function NewBottomSheetDismissed(bottomSheet) {
    var tmp = mapOf_0(to('bottomSheet', bottomSheet == null ? null : bottomSheet.value));
    var tmp2_elvis_lhs = bottomSheet == null ? null : bottomSheet.data;
    Event.call(this, 'Bottom sheet screen dismissed', VOID, 'CK: Checkout', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function Metadata_68() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_68).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_68;
  function Metadata_getInstance_68() {
    return Metadata_instance_68;
  }
  function NewBottomSheetShown(bottomSheet) {
    var tmp = mapOf_0(to('bottomSheet', bottomSheet == null ? null : bottomSheet.value));
    var tmp2_elvis_lhs = bottomSheet == null ? null : bottomSheet.data;
    Screen.call(this, 'Bottom sheet screen shown.', 'CK: Checkout', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function Metadata_69() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_69).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_69;
  function Metadata_getInstance_69() {
    return Metadata_instance_69;
  }
  function NewOrder(orderType, categoryId, isReorder, baseOrderId, handlingStrategyType) {
    baseOrderId = baseOrderId === VOID ? null : baseOrderId;
    var tmp = to('orderType', orderType == null ? null : orderType.value);
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('isReorder', isReorder == null ? null : get_value_0(isReorder));
    var tmp_2 = to('baseOrderId', baseOrderId == null ? null : get_value_1(baseOrderId));
    var tmp_3 = mapOf([tmp, tmp_0, tmp_1, tmp_2, to('handlingStrategyType', handlingStrategyType == null ? null : handlingStrategyType.value)]);
    var tmp6_elvis_lhs = orderType == null ? null : orderType.data;
    Screen.call(this, 'New Order', 'CK: Checkout', plus(tmp_3, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs));
  }
  function Metadata_70() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_70).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_70;
  function Metadata_getInstance_70() {
    return Metadata_instance_70;
  }
  function NewOrderContentShown(orderType, categoryId, isReorder, baseOrderId, handlingStrategyType, productsValue, hasLegalCheck, etaLowerBound, etaUpperBound, outstandingDebt, paymentMethod, hasAddress, hasPhone) {
    baseOrderId = baseOrderId === VOID ? null : baseOrderId;
    etaLowerBound = etaLowerBound === VOID ? null : etaLowerBound;
    etaUpperBound = etaUpperBound === VOID ? null : etaUpperBound;
    outstandingDebt = outstandingDebt === VOID ? null : outstandingDebt;
    paymentMethod = paymentMethod === VOID ? null : paymentMethod;
    var tmp = to('orderType', orderType == null ? null : orderType.value);
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('isReorder', isReorder == null ? null : get_value_0(isReorder));
    var tmp_2 = to('baseOrderId', baseOrderId == null ? null : get_value_1(baseOrderId));
    var tmp_3 = to('handlingStrategyType', handlingStrategyType == null ? null : handlingStrategyType.value);
    var tmp_4 = to('productsValue', productsValue == null ? null : get_value_1(productsValue));
    var tmp_5 = to('hasLegalCheck', hasLegalCheck == null ? null : get_value_0(hasLegalCheck));
    var tmp_6 = to('etaLowerBound', etaLowerBound == null ? null : get_value_1(etaLowerBound));
    var tmp_7 = to('etaUpperBound', etaUpperBound == null ? null : get_value_1(etaUpperBound));
    var tmp_8 = to('outstandingDebt', outstandingDebt == null ? null : get_value(outstandingDebt));
    var tmp_9 = to('paymentMethod', paymentMethod == null ? null : paymentMethod.value);
    var tmp_10 = to('hasAddress', hasAddress == null ? null : get_value_0(hasAddress));
    var tmp_11 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, to('hasPhone', hasPhone == null ? null : get_value_0(hasPhone))]);
    var tmp14_elvis_lhs = orderType == null ? null : orderType.data;
    var tmp_12 = plus(tmp_11, tmp14_elvis_lhs == null ? emptyMap() : tmp14_elvis_lhs);
    var tmp16_elvis_lhs = paymentMethod == null ? null : paymentMethod.data;
    Event.call(this, 'New Order Content Shown', VOID, 'CK: Checkout', plus(tmp_12, tmp16_elvis_lhs == null ? emptyMap() : tmp16_elvis_lhs));
  }
  function Metadata_71() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_71).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_71;
  function Metadata_getInstance_71() {
    return Metadata_instance_71;
  }
  function NoInternetConnectionScreen() {
    Event.call(this, 'No Internet Connection Screen', VOID, 'TREX: Tracking and Reviews Experience');
  }
  function Metadata_72() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_72).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_72;
  function Metadata_getInstance_72() {
    return Metadata_instance_72;
  }
  function NotificationConfigurationCenter(source, systemNotificationsEnabled, enabledNotifications) {
    var tmp = to('source', source == null ? null : source.value);
    var tmp_0 = to('systemNotificationsEnabled', systemNotificationsEnabled == null ? null : get_value_0(systemNotificationsEnabled));
    Screen.call(this, 'Notification Configuration Screen', 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, to('enabledNotifications', enabledNotifications == null ? null : get_value_2(enabledNotifications))]));
  }
  function Metadata_73() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_73).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_73;
  function Metadata_getInstance_73() {
    return Metadata_instance_73;
  }
  function NotificationConfigurationCenterButtonPressed(clickLabel, isEnabled) {
    var tmp = to('clickLabel', clickLabel == null ? null : get_value(clickLabel));
    Event.call(this, 'Notification Configuration Button Clicked', VOID, 'TREX: Tracking and Reviews Experience', mapOf([tmp, to('isEnabled', isEnabled == null ? null : get_value_0(isEnabled))]));
  }
  var NotificationConfigurationScreenSource_Settings_instance;
  var NotificationConfigurationScreenSource_OngoingOrderPopup_instance;
  function values_44() {
    return [NotificationConfigurationScreenSource_Settings_getInstance(), NotificationConfigurationScreenSource_OngoingOrderPopup_getInstance()];
  }
  function valueOf_44(value) {
    switch (value) {
      case 'Settings':
        return NotificationConfigurationScreenSource_Settings_getInstance();
      case 'OngoingOrderPopup':
        return NotificationConfigurationScreenSource_OngoingOrderPopup_getInstance();
      default:
        NotificationConfigurationScreenSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var NotificationConfigurationScreenSource_entriesInitialized;
  function NotificationConfigurationScreenSource_initEntries() {
    if (NotificationConfigurationScreenSource_entriesInitialized)
      return Unit_instance;
    NotificationConfigurationScreenSource_entriesInitialized = true;
    NotificationConfigurationScreenSource_Settings_instance = new NotificationConfigurationScreenSource('Settings', 0, 'settings');
    NotificationConfigurationScreenSource_OngoingOrderPopup_instance = new NotificationConfigurationScreenSource('OngoingOrderPopup', 1, 'ongoing order popup');
  }
  function NotificationConfigurationScreenSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(NotificationConfigurationScreenSource).r = function () {
    return this.value;
  };
  function NotificationConfigurationScreenSource_Settings_getInstance() {
    NotificationConfigurationScreenSource_initEntries();
    return NotificationConfigurationScreenSource_Settings_instance;
  }
  function NotificationConfigurationScreenSource_OngoingOrderPopup_getInstance() {
    NotificationConfigurationScreenSource_initEntries();
    return NotificationConfigurationScreenSource_OngoingOrderPopup_instance;
  }
  var NotificationStatus_Enabled_instance;
  var NotificationStatus_Disabled_instance;
  function values_45() {
    return [NotificationStatus_Enabled_getInstance(), NotificationStatus_Disabled_getInstance()];
  }
  function valueOf_45(value) {
    switch (value) {
      case 'Enabled':
        return NotificationStatus_Enabled_getInstance();
      case 'Disabled':
        return NotificationStatus_Disabled_getInstance();
      default:
        NotificationStatus_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var NotificationStatus_entriesInitialized;
  function NotificationStatus_initEntries() {
    if (NotificationStatus_entriesInitialized)
      return Unit_instance;
    NotificationStatus_entriesInitialized = true;
    NotificationStatus_Enabled_instance = new NotificationStatus('Enabled', 0, 'enabled');
    NotificationStatus_Disabled_instance = new NotificationStatus('Disabled', 1, 'disabled');
  }
  function NotificationStatus(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(NotificationStatus).r = function () {
    return this.value;
  };
  function NotificationStatus_Enabled_getInstance() {
    NotificationStatus_initEntries();
    return NotificationStatus_Enabled_instance;
  }
  function NotificationStatus_Disabled_getInstance() {
    NotificationStatus_initEntries();
    return NotificationStatus_Disabled_instance;
  }
  function Metadata_74() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_74).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_74;
  function Metadata_getInstance_74() {
    return Metadata_instance_74;
  }
  function OngoingOrderDetailsFirstScrollDown(orderId) {
    Event.call(this, 'Ongoing Order Details First Scroll Down', VOID, 'CS: Customer Solutions', mapOf_0(to('orderId', orderId == null ? null : get_value_1(orderId))));
  }
  function Metadata_75() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_75).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_75;
  function Metadata_getInstance_75() {
    return Metadata_instance_75;
  }
  function OngoingOrderDetailsFirstViewed(orderId) {
    Event.call(this, 'Ongoing Order Details First Viewed', VOID, 'CS: Customer Solutions', mapOf_0(to('orderId', orderId == null ? null : get_value_1(orderId))));
  }
  var OngoingOrderEditCta_Phone_instance;
  var OngoingOrderEditCta_Link_instance;
  function values_46() {
    return [OngoingOrderEditCta_Phone_getInstance(), OngoingOrderEditCta_Link_getInstance()];
  }
  function valueOf_46(value) {
    switch (value) {
      case 'Phone':
        return OngoingOrderEditCta_Phone_getInstance();
      case 'Link':
        return OngoingOrderEditCta_Link_getInstance();
      default:
        OngoingOrderEditCta_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OngoingOrderEditCta_entriesInitialized;
  function OngoingOrderEditCta_initEntries() {
    if (OngoingOrderEditCta_entriesInitialized)
      return Unit_instance;
    OngoingOrderEditCta_entriesInitialized = true;
    OngoingOrderEditCta_Phone_instance = new OngoingOrderEditCta('Phone', 0, 'Phone');
    OngoingOrderEditCta_Link_instance = new OngoingOrderEditCta('Link', 1, 'Link');
  }
  function OngoingOrderEditCta(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OngoingOrderEditCta).r = function () {
    return this.value;
  };
  function OngoingOrderEditCta_Phone_getInstance() {
    OngoingOrderEditCta_initEntries();
    return OngoingOrderEditCta_Phone_instance;
  }
  function OngoingOrderEditCta_Link_getInstance() {
    OngoingOrderEditCta_initEntries();
    return OngoingOrderEditCta_Link_instance;
  }
  var OngoingOrderEditFeature_Address_instance;
  var OngoingOrderEditFeature_Products_instance;
  function values_47() {
    return [OngoingOrderEditFeature_Address_getInstance(), OngoingOrderEditFeature_Products_getInstance()];
  }
  function valueOf_47(value) {
    switch (value) {
      case 'Address':
        return OngoingOrderEditFeature_Address_getInstance();
      case 'Products':
        return OngoingOrderEditFeature_Products_getInstance();
      default:
        OngoingOrderEditFeature_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OngoingOrderEditFeature_entriesInitialized;
  function OngoingOrderEditFeature_initEntries() {
    if (OngoingOrderEditFeature_entriesInitialized)
      return Unit_instance;
    OngoingOrderEditFeature_entriesInitialized = true;
    OngoingOrderEditFeature_Address_instance = new OngoingOrderEditFeature('Address', 0, 'Address');
    OngoingOrderEditFeature_Products_instance = new OngoingOrderEditFeature('Products', 1, 'Products');
  }
  function OngoingOrderEditFeature(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OngoingOrderEditFeature).r = function () {
    return this.value;
  };
  function OngoingOrderEditFeature_Address_getInstance() {
    OngoingOrderEditFeature_initEntries();
    return OngoingOrderEditFeature_Address_instance;
  }
  function OngoingOrderEditFeature_Products_getInstance() {
    OngoingOrderEditFeature_initEntries();
    return OngoingOrderEditFeature_Products_instance;
  }
  function Metadata_76() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_76).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_76;
  function Metadata_getInstance_76() {
    return Metadata_instance_76;
  }
  function OngoingOrderEditPressed(orderId, feature) {
    var tmp = to('orderId', orderId == null ? null : get_value_1(orderId));
    Event.call(this, 'Ongoing Order Edit Pressed', VOID, 'CS: Customer Solutions', mapOf([tmp, to('feature', feature == null ? null : feature.value)]));
  }
  function Metadata_77() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_77).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_77;
  function Metadata_getInstance_77() {
    return Metadata_instance_77;
  }
  function OpenChatPressed(isUnread, conversationId, courierId, orderId, chatType) {
    conversationId = conversationId === VOID ? null : conversationId;
    courierId = courierId === VOID ? null : courierId;
    orderId = orderId === VOID ? null : orderId;
    var tmp = to('isUnread', isUnread == null ? null : get_value_0(isUnread));
    var tmp_0 = to('conversationId', conversationId == null ? null : get_value(conversationId));
    var tmp_1 = to('courierId', courierId == null ? null : get_value_1(courierId));
    var tmp_2 = to('orderId', orderId == null ? null : get_value_1(orderId));
    Event.call(this, 'Open Chat Pressed', VOID, 'CF: Contact Flow', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('chatType', chatType == null ? null : chatType.value)]));
  }
  function Metadata_78() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_78).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_78;
  function Metadata_getInstance_78() {
    return Metadata_instance_78;
  }
  function OpenChatsListViewed(isUnread, conversationId, courierId, orderId, chatType) {
    conversationId = conversationId === VOID ? null : conversationId;
    courierId = courierId === VOID ? null : courierId;
    orderId = orderId === VOID ? null : orderId;
    var tmp = to('isUnread', isUnread == null ? null : get_value_2(isUnread));
    var tmp_0 = to('conversationId', conversationId == null ? null : get_value_2(conversationId));
    var tmp_1 = to('courierId', courierId == null ? null : get_value_2(courierId));
    var tmp_2 = to('orderId', orderId == null ? null : get_value_2(orderId));
    Screen.call(this, 'Open Chat List Viewed', 'CF: Contact Flow', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('chatType', chatType == null ? null : get_value_2(chatType))]));
  }
  var OrderCancellationReason_ByUser_instance;
  var OrderCancellationReason_OrderDelayed_instance;
  function values_48() {
    return [OrderCancellationReason_ByUser_getInstance(), OrderCancellationReason_OrderDelayed_getInstance()];
  }
  function valueOf_48(value) {
    switch (value) {
      case 'ByUser':
        return OrderCancellationReason_ByUser_getInstance();
      case 'OrderDelayed':
        return OrderCancellationReason_OrderDelayed_getInstance();
      default:
        OrderCancellationReason_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OrderCancellationReason_entriesInitialized;
  function OrderCancellationReason_initEntries() {
    if (OrderCancellationReason_entriesInitialized)
      return Unit_instance;
    OrderCancellationReason_entriesInitialized = true;
    OrderCancellationReason_ByUser_instance = new OrderCancellationReason('ByUser', 0, 'User');
    OrderCancellationReason_OrderDelayed_instance = new OrderCancellationReason('OrderDelayed', 1, 'Order Delayed Notification');
  }
  function OrderCancellationReason(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OrderCancellationReason).r = function () {
    return this.value;
  };
  function OrderCancellationReason_ByUser_getInstance() {
    OrderCancellationReason_initEntries();
    return OrderCancellationReason_ByUser_instance;
  }
  function OrderCancellationReason_OrderDelayed_getInstance() {
    OrderCancellationReason_initEntries();
    return OrderCancellationReason_OrderDelayed_instance;
  }
  function Metadata_79() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_79).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_79;
  function Metadata_getInstance_79() {
    return Metadata_instance_79;
  }
  function OrderCancelled(orderId, pickupTime, partnerOrder, cityCode, storeId, storeName, activationTime, paymentMethodType, cardProvider, orderTotal, cancellationTotal, reason) {
    pickupTime = pickupTime === VOID ? null : pickupTime;
    storeId = storeId === VOID ? null : storeId;
    storeName = storeName === VOID ? null : storeName;
    activationTime = activationTime === VOID ? null : activationTime;
    paymentMethodType = paymentMethodType === VOID ? null : paymentMethodType;
    cardProvider = cardProvider === VOID ? null : cardProvider;
    cancellationTotal = cancellationTotal === VOID ? null : cancellationTotal;
    var tmp = to('orderId', orderId == null ? null : get_value_1(orderId));
    var tmp_0 = to('pickupTime', pickupTime == null ? null : get_value_1(pickupTime));
    var tmp_1 = to('partnerOrder', partnerOrder == null ? null : get_value_0(partnerOrder));
    var tmp_2 = to('cityCode', cityCode == null ? null : get_value(cityCode));
    var tmp_3 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_4 = to('storeName', storeName == null ? null : get_value(storeName));
    var tmp_5 = to('activationTime', activationTime == null ? null : get_value_1(activationTime));
    var tmp_6 = to('paymentMethodType', paymentMethodType == null ? null : get_value(paymentMethodType));
    var tmp_7 = to('cardProvider', cardProvider == null ? null : get_value(cardProvider));
    var tmp_8 = to('orderTotal', orderTotal == null ? null : get_value_1(orderTotal));
    var tmp_9 = to('cancellationTotal', cancellationTotal == null ? null : get_value_1(cancellationTotal));
    Event.call(this, 'Order Cancelled', VOID, 'CS: Customer Solutions', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, to('reason', reason == null ? null : reason.value)]));
  }
  function Metadata_80() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_80).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_80;
  function Metadata_getInstance_80() {
    return Metadata_instance_80;
  }
  function OrderConfirmationButtonPressed(orderType, categoryId, isReorder, productsTotal, hasLegalCheck, etaLowerBound, etaUpperBound, outstandingDebt) {
    etaLowerBound = etaLowerBound === VOID ? null : etaLowerBound;
    etaUpperBound = etaUpperBound === VOID ? null : etaUpperBound;
    outstandingDebt = outstandingDebt === VOID ? null : outstandingDebt;
    var tmp = to('orderType', orderType == null ? null : orderType.value);
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_1 = to('isReorder', isReorder == null ? null : get_value_0(isReorder));
    var tmp_2 = to('productsTotal', productsTotal == null ? null : get_value_1(productsTotal));
    var tmp_3 = to('hasLegalCheck', hasLegalCheck == null ? null : get_value_0(hasLegalCheck));
    var tmp_4 = to('etaLowerBound', etaLowerBound == null ? null : get_value_1(etaLowerBound));
    var tmp_5 = to('etaUpperBound', etaUpperBound == null ? null : get_value_1(etaUpperBound));
    var tmp_6 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('outstandingDebt', outstandingDebt == null ? null : get_value(outstandingDebt))]);
    var tmp9_elvis_lhs = orderType == null ? null : orderType.data;
    Event.call(this, 'Order Confirmation Button Pressed', VOID, 'CK: Checkout', plus(tmp_6, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs));
  }
  function Metadata_81() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_81).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_81;
  function Metadata_getInstance_81() {
    return Metadata_instance_81;
  }
  function OrderCreated(orderId, orderType, categoryId, outstandingDebt, paymentMethod, handlingStrategyType, promotionId, promotionType, promotionValue, isPrimePromotion, isFirstOrder, addressId, pickupAddressId, userSelectedLanguage, isReorderLastSixMonths, isReorderLastYear, isLoyaltyCardAdded, searchId, isFavorites, playlistIds, basketId, hasWeightedProduct) {
    categoryId = categoryId === VOID ? null : categoryId;
    outstandingDebt = outstandingDebt === VOID ? null : outstandingDebt;
    paymentMethod = paymentMethod === VOID ? null : paymentMethod;
    handlingStrategyType = handlingStrategyType === VOID ? null : handlingStrategyType;
    promotionId = promotionId === VOID ? null : promotionId;
    promotionType = promotionType === VOID ? null : promotionType;
    promotionValue = promotionValue === VOID ? null : promotionValue;
    isPrimePromotion = isPrimePromotion === VOID ? null : isPrimePromotion;
    isFirstOrder = isFirstOrder === VOID ? null : isFirstOrder;
    addressId = addressId === VOID ? null : addressId;
    pickupAddressId = pickupAddressId === VOID ? null : pickupAddressId;
    userSelectedLanguage = userSelectedLanguage === VOID ? null : userSelectedLanguage;
    isReorderLastSixMonths = isReorderLastSixMonths === VOID ? null : isReorderLastSixMonths;
    isReorderLastYear = isReorderLastYear === VOID ? null : isReorderLastYear;
    isLoyaltyCardAdded = isLoyaltyCardAdded === VOID ? null : isLoyaltyCardAdded;
    searchId = searchId === VOID ? null : searchId;
    isFavorites = isFavorites === VOID ? null : isFavorites;
    playlistIds = playlistIds === VOID ? null : playlistIds;
    hasWeightedProduct = hasWeightedProduct === VOID ? null : hasWeightedProduct;
    var tmp = to('orderId', orderId == null ? null : get_value_1(orderId));
    var tmp_0 = to('orderType', orderType == null ? null : orderType.value);
    var tmp_1 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_2 = to('outstandingDebt', outstandingDebt == null ? null : get_value(outstandingDebt));
    var tmp_3 = to('paymentMethod', paymentMethod == null ? null : paymentMethod.value);
    var tmp_4 = to('handlingStrategyType', handlingStrategyType == null ? null : handlingStrategyType.value);
    var tmp_5 = to('promotionId', promotionId == null ? null : get_value_1(promotionId));
    var tmp_6 = to('promotionType', promotionType == null ? null : get_value(promotionType));
    var tmp_7 = to('promotionValue', promotionValue == null ? null : get_value(promotionValue));
    var tmp_8 = to('isPrimePromotion', isPrimePromotion == null ? null : get_value_0(isPrimePromotion));
    var tmp_9 = to('isFirstOrder', isFirstOrder == null ? null : get_value_0(isFirstOrder));
    var tmp_10 = to('addressId', addressId == null ? null : get_value_1(addressId));
    var tmp_11 = to('pickupAddressId', pickupAddressId == null ? null : get_value_1(pickupAddressId));
    var tmp_12 = to('userSelectedLanguage', userSelectedLanguage == null ? null : get_value(userSelectedLanguage));
    var tmp_13 = to('isReorderLastSixMonths', isReorderLastSixMonths == null ? null : get_value_0(isReorderLastSixMonths));
    var tmp_14 = to('isReorderLastYear', isReorderLastYear == null ? null : get_value_0(isReorderLastYear));
    var tmp_15 = to('isLoyaltyCardAdded', isLoyaltyCardAdded == null ? null : get_value_0(isLoyaltyCardAdded));
    var tmp_16 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_17 = to('isFavorites', isFavorites == null ? null : get_value_0(isFavorites));
    var tmp_18 = to('playlistIds', playlistIds == null ? null : get_value_2(playlistIds));
    var tmp_19 = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_20 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, to('hasWeightedProduct', hasWeightedProduct == null ? null : get_value_0(hasWeightedProduct))]);
    var tmp23_elvis_lhs = orderType == null ? null : orderType.data;
    var tmp_21 = plus(tmp_20, tmp23_elvis_lhs == null ? emptyMap() : tmp23_elvis_lhs);
    var tmp25_elvis_lhs = paymentMethod == null ? null : paymentMethod.data;
    Event.call(this, 'Order Created', VOID, 'CK: Checkout', plus(tmp_21, tmp25_elvis_lhs == null ? emptyMap() : tmp25_elvis_lhs));
  }
  function Metadata_82() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_82).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_82;
  function Metadata_getInstance_82() {
    return Metadata_instance_82;
  }
  function OrderDetails(orderId, orderStatus, origin) {
    orderStatus = orderStatus === VOID ? null : orderStatus;
    origin = origin === VOID ? null : origin;
    var tmp = to('orderId', orderId == null ? null : get_value_1(orderId));
    var tmp_0 = to('orderStatus', orderStatus == null ? null : get_value(orderStatus));
    Screen.call(this, 'Order Details', 'CS: Customer Solutions', mapOf([tmp, tmp_0, to('origin', origin == null ? null : origin.value)]));
  }
  var OrderHandlingStrategyType_InStore_instance;
  var OrderHandlingStrategyType_Delivery_instance;
  var OrderHandlingStrategyType_Pickup_instance;
  function values_49() {
    return [OrderHandlingStrategyType_InStore_getInstance(), OrderHandlingStrategyType_Delivery_getInstance(), OrderHandlingStrategyType_Pickup_getInstance()];
  }
  function valueOf_49(value) {
    switch (value) {
      case 'InStore':
        return OrderHandlingStrategyType_InStore_getInstance();
      case 'Delivery':
        return OrderHandlingStrategyType_Delivery_getInstance();
      case 'Pickup':
        return OrderHandlingStrategyType_Pickup_getInstance();
      default:
        OrderHandlingStrategyType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OrderHandlingStrategyType_entriesInitialized;
  function OrderHandlingStrategyType_initEntries() {
    if (OrderHandlingStrategyType_entriesInitialized)
      return Unit_instance;
    OrderHandlingStrategyType_entriesInitialized = true;
    OrderHandlingStrategyType_InStore_instance = new OrderHandlingStrategyType('InStore', 0, 'IN_STORE');
    OrderHandlingStrategyType_Delivery_instance = new OrderHandlingStrategyType('Delivery', 1, 'DELIVERY');
    OrderHandlingStrategyType_Pickup_instance = new OrderHandlingStrategyType('Pickup', 2, 'PICKUP');
  }
  function OrderHandlingStrategyType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OrderHandlingStrategyType).r = function () {
    return this.value;
  };
  function OrderHandlingStrategyType_InStore_getInstance() {
    OrderHandlingStrategyType_initEntries();
    return OrderHandlingStrategyType_InStore_instance;
  }
  function OrderHandlingStrategyType_Delivery_getInstance() {
    OrderHandlingStrategyType_initEntries();
    return OrderHandlingStrategyType_Delivery_instance;
  }
  function OrderHandlingStrategyType_Pickup_getInstance() {
    OrderHandlingStrategyType_initEntries();
    return OrderHandlingStrategyType_Pickup_instance;
  }
  function Metadata_83() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_83).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_83;
  function Metadata_getInstance_83() {
    return Metadata_instance_83;
  }
  function OrderRated(orderId, courierRating, productRating) {
    courierRating = courierRating === VOID ? null : courierRating;
    productRating = productRating === VOID ? null : productRating;
    var tmp = to('orderId', orderId == null ? null : get_value_1(orderId));
    var tmp_0 = to('courierRating', courierRating == null ? null : get_value_1(courierRating));
    Event.call(this, 'Order Rated', VOID, 'CF: Contact Flow', mapOf([tmp, tmp_0, to('productRating', productRating == null ? null : get_value_1(productRating))]));
  }
  function Metadata_84() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_84).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_84;
  function Metadata_getInstance_84() {
    return Metadata_instance_84;
  }
  function OrderRating(orderId, versionType) {
    orderId = orderId === VOID ? null : orderId;
    versionType = versionType === VOID ? null : versionType;
    var tmp = to('orderId', orderId == null ? null : get_value_1(orderId));
    Screen.call(this, 'Order Rating', 'TREX: Tracking and Reviews Experience', mapOf([tmp, to('versionType', versionType == null ? null : versionType.value)]));
  }
  function Purchase() {
    Purchase_instance = this;
    OrderType.call(this, 'Custom Purchase');
  }
  protoOf(Purchase).toString = function () {
    return 'Purchase(value=' + this.value + ')';
  };
  var Purchase_instance;
  function Purchase_getInstance() {
    if (Purchase_instance == null)
      new Purchase();
    return Purchase_instance;
  }
  function Shipment() {
    Shipment_instance = this;
    OrderType.call(this, 'Shipment');
  }
  protoOf(Shipment).toString = function () {
    return 'Shipment(value=' + this.value + ')';
  };
  var Shipment_instance;
  function Shipment_getInstance() {
    if (Shipment_instance == null)
      new Shipment();
    return Shipment_instance;
  }
  function Store(storeId, storeAddressId) {
    var tmp = to('storeId', storeId == null ? null : get_value_1(storeId));
    OrderType.call(this, 'Store', mapOf([tmp, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  protoOf(Store).toString = function () {
    return 'Store(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function OrderType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(OrderType).r = function () {
    return this.value;
  };
  protoOf(OrderType).qa = function () {
    return this.data;
  };
  protoOf(OrderType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(OrderType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof OrderType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var OrderVertical_Partner_instance;
  var OrderVertical_FakePartner_instance;
  var OrderVertical_Courier_instance;
  var OrderVertical_Quiero_instance;
  var OrderVertical_Marketplace_instance;
  function values_50() {
    return [OrderVertical_Partner_getInstance(), OrderVertical_FakePartner_getInstance(), OrderVertical_Courier_getInstance(), OrderVertical_Quiero_getInstance(), OrderVertical_Marketplace_getInstance()];
  }
  function valueOf_50(value) {
    switch (value) {
      case 'Partner':
        return OrderVertical_Partner_getInstance();
      case 'FakePartner':
        return OrderVertical_FakePartner_getInstance();
      case 'Courier':
        return OrderVertical_Courier_getInstance();
      case 'Quiero':
        return OrderVertical_Quiero_getInstance();
      case 'Marketplace':
        return OrderVertical_Marketplace_getInstance();
      default:
        OrderVertical_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OrderVertical_entriesInitialized;
  function OrderVertical_initEntries() {
    if (OrderVertical_entriesInitialized)
      return Unit_instance;
    OrderVertical_entriesInitialized = true;
    OrderVertical_Partner_instance = new OrderVertical('Partner', 0, 'Partner');
    OrderVertical_FakePartner_instance = new OrderVertical('FakePartner', 1, 'FakePartner');
    OrderVertical_Courier_instance = new OrderVertical('Courier', 2, 'Courier');
    OrderVertical_Quiero_instance = new OrderVertical('Quiero', 3, 'Quiero');
    OrderVertical_Marketplace_instance = new OrderVertical('Marketplace', 4, 'Marketplace');
  }
  function OrderVertical(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OrderVertical).r = function () {
    return this.value;
  };
  function OrderVertical_Partner_getInstance() {
    OrderVertical_initEntries();
    return OrderVertical_Partner_instance;
  }
  function OrderVertical_FakePartner_getInstance() {
    OrderVertical_initEntries();
    return OrderVertical_FakePartner_instance;
  }
  function OrderVertical_Courier_getInstance() {
    OrderVertical_initEntries();
    return OrderVertical_Courier_instance;
  }
  function OrderVertical_Quiero_getInstance() {
    OrderVertical_initEntries();
    return OrderVertical_Quiero_instance;
  }
  function OrderVertical_Marketplace_getInstance() {
    OrderVertical_initEntries();
    return OrderVertical_Marketplace_instance;
  }
  function Orders() {
    Screen.call(this, 'Orders');
  }
  function Category(categoryId) {
    Origins.call(this, 'Category', mapOf_0(to('categoryId', categoryId == null ? null : get_value_1(categoryId))));
  }
  protoOf(Category).toString = function () {
    return 'Category(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CategoryGroup_0(categoryGroupId) {
    Origins.call(this, 'CategoryGroup', mapOf_0(to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))));
  }
  protoOf(CategoryGroup_0).toString = function () {
    return 'CategoryGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Checkout_0() {
    Checkout_instance = this;
    Origins.call(this, 'Checkout');
  }
  protoOf(Checkout_0).toString = function () {
    return 'Checkout(value=' + this.value + ')';
  };
  var Checkout_instance;
  function Checkout_getInstance() {
    if (Checkout_instance == null)
      new Checkout_0();
    return Checkout_instance;
  }
  function NewBottomSheet(bottomSheet) {
    var tmp = mapOf_0(to('bottomSheet', bottomSheet == null ? null : bottomSheet.value));
    var tmp2_elvis_lhs = bottomSheet == null ? null : bottomSheet.data;
    Origins.call(this, 'NewBottomSheet', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  protoOf(NewBottomSheet).toString = function () {
    return 'NewBottomSheet(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedGroup(feedGroupId) {
    Origins.call(this, 'FeedGroup', mapOf_0(to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId))));
  }
  protoOf(FeedGroup).toString = function () {
    return 'FeedGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedGroupResults(feedGroupId) {
    Origins.call(this, 'FeedGroupResults', mapOf_0(to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId))));
  }
  protoOf(FeedGroupResults).toString = function () {
    return 'FeedGroupResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeWidget(widgetId, widgetName) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    Origins.call(this, 'HomeWidget', mapOf([tmp, to('widgetName', widgetName == null ? null : get_value(widgetName))]));
  }
  protoOf(HomeWidget).toString = function () {
    return 'HomeWidget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeWidgetResults(widgetId, widgetName) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    Origins.call(this, 'HomeWidgetResults', mapOf([tmp, to('widgetName', widgetName == null ? null : get_value(widgetName))]));
  }
  protoOf(HomeWidgetResults).toString = function () {
    return 'HomeWidgetResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeSearchBarResults(searchId, tapPoint, nestedDishHorizontalPosition) {
    searchId = searchId === VOID ? null : searchId;
    tapPoint = tapPoint === VOID ? null : tapPoint;
    nestedDishHorizontalPosition = nestedDishHorizontalPosition === VOID ? null : nestedDishHorizontalPosition;
    var tmp = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_0 = to('tapPoint', tapPoint == null ? null : get_value(tapPoint));
    Origins.call(this, 'HomeSearchBarResults', mapOf([tmp, tmp_0, to('nestedDishHorizontalPosition', nestedDishHorizontalPosition == null ? null : get_value_1(nestedDishHorizontalPosition))]));
  }
  protoOf(HomeSearchBarResults).toString = function () {
    return 'HomeSearchBarResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function SearchNestedDishes(searchId, nestedDishHorizontalPosition) {
    var tmp = to('searchId', searchId == null ? null : get_value(searchId));
    Origins.call(this, 'SearchNestedDishes', mapOf([tmp, to('nestedDishHorizontalPosition', nestedDishHorizontalPosition == null ? null : get_value_1(nestedDishHorizontalPosition))]));
  }
  protoOf(SearchNestedDishes).toString = function () {
    return 'SearchNestedDishes(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Story(storyId) {
    storyId = storyId === VOID ? null : storyId;
    Origins.call(this, 'Story', mapOf_0(to('storyId', storyId == null ? null : get_value(storyId))));
  }
  protoOf(Story).toString = function () {
    return 'Story(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Deeplink_0(url) {
    Origins.call(this, 'Deeplink', mapOf_0(to('url', url == null ? null : get_value(url))));
  }
  protoOf(Deeplink_0).toString = function () {
    return 'Deeplink(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Direct() {
    Direct_instance = this;
    Origins.call(this, 'Direct');
  }
  protoOf(Direct).toString = function () {
    return 'Direct(value=' + this.value + ')';
  };
  var Direct_instance;
  function Direct_getInstance() {
    if (Direct_instance == null)
      new Direct();
    return Direct_instance;
  }
  function Other_0() {
    Other_instance_0 = this;
    Origins.call(this, 'Other');
  }
  protoOf(Other_0).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_0;
  function Other_getInstance_0() {
    if (Other_instance_0 == null)
      new Other_0();
    return Other_instance_0;
  }
  function HomeBubble(categoryId) {
    Origins.call(this, 'HomeBubble', mapOf_0(to('categoryId', categoryId == null ? null : get_value_1(categoryId))));
  }
  protoOf(HomeBubble).toString = function () {
    return 'HomeBubble(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CategoryGroupBubble(categoryId, categoryGroupId) {
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Origins.call(this, 'CategoryGroupBubble', mapOf([tmp, to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))]));
  }
  protoOf(CategoryGroupBubble).toString = function () {
    return 'CategoryGroupBubble(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CategoryResults(categoryId, filterId, searchId, filters, tapPoint, nestedDishHorizontalPosition) {
    filterId = filterId === VOID ? null : filterId;
    searchId = searchId === VOID ? null : searchId;
    filters = filters === VOID ? null : filters;
    tapPoint = tapPoint === VOID ? null : tapPoint;
    nestedDishHorizontalPosition = nestedDishHorizontalPosition === VOID ? null : nestedDishHorizontalPosition;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('filterId', filterId == null ? null : get_value_1(filterId));
    var tmp_1 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_2 = to('filters', filters == null ? null : get_value_2(filters));
    var tmp_3 = to('tapPoint', tapPoint == null ? null : get_value(tapPoint));
    Origins.call(this, 'CategoryResults', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('nestedDishHorizontalPosition', nestedDishHorizontalPosition == null ? null : get_value_1(nestedDishHorizontalPosition))]));
  }
  protoOf(CategoryResults).toString = function () {
    return 'CategoryResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedCarousel(feedGroupId, categoryId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId));
    Origins.call(this, 'FeedCarousel', mapOf([tmp, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  protoOf(FeedCarousel).toString = function () {
    return 'FeedCarousel(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedCarouselResults(feedGroupId, categoryId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId));
    Origins.call(this, 'FeedCarouselResults', mapOf([tmp, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  protoOf(FeedCarouselResults).toString = function () {
    return 'FeedCarouselResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CategoryGroupSearchBarResults(categoryGroupId, searchId, tapPoint, nestedDishHorizontalPosition) {
    searchId = searchId === VOID ? null : searchId;
    tapPoint = tapPoint === VOID ? null : tapPoint;
    nestedDishHorizontalPosition = nestedDishHorizontalPosition === VOID ? null : nestedDishHorizontalPosition;
    var tmp = to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId));
    var tmp_0 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_1 = to('tapPoint', tapPoint == null ? null : get_value(tapPoint));
    Origins.call(this, 'CategoryGroupSearchBarResults', mapOf([tmp, tmp_0, tmp_1, to('nestedDishHorizontalPosition', nestedDishHorizontalPosition == null ? null : get_value_1(nestedDishHorizontalPosition))]));
  }
  protoOf(CategoryGroupSearchBarResults).toString = function () {
    return 'CategoryGroupSearchBarResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function BannerResults(categoryId, bannerId, assetId) {
    bannerId = bannerId === VOID ? null : bannerId;
    assetId = assetId === VOID ? null : assetId;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('bannerId', bannerId == null ? null : get_value(bannerId));
    Origins.call(this, 'BannerResults', mapOf([tmp, tmp_0, to('assetId', assetId == null ? null : get_value_1(assetId))]));
  }
  protoOf(BannerResults).toString = function () {
    return 'BannerResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FoodNearYouFeed() {
    FoodNearYouFeed_instance = this;
    Origins.call(this, 'FoodNearYouFeed');
  }
  protoOf(FoodNearYouFeed).toString = function () {
    return 'FoodNearYouFeed(value=' + this.value + ')';
  };
  var FoodNearYouFeed_instance;
  function FoodNearYouFeed_getInstance() {
    if (FoodNearYouFeed_instance == null)
      new FoodNearYouFeed();
    return FoodNearYouFeed_instance;
  }
  function FilterLanding() {
    FilterLanding_instance = this;
    Origins.call(this, 'FilterLanding');
  }
  protoOf(FilterLanding).toString = function () {
    return 'FilterLanding(value=' + this.value + ')';
  };
  var FilterLanding_instance;
  function FilterLanding_getInstance() {
    if (FilterLanding_instance == null)
      new FilterLanding();
    return FilterLanding_instance;
  }
  function BrandLanding() {
    BrandLanding_instance = this;
    Origins.call(this, 'BrandLanding');
  }
  protoOf(BrandLanding).toString = function () {
    return 'BrandLanding(value=' + this.value + ')';
  };
  var BrandLanding_instance;
  function BrandLanding_getInstance() {
    if (BrandLanding_instance == null)
      new BrandLanding();
    return BrandLanding_instance;
  }
  function ClosedStoreSimilarStoresModal() {
    ClosedStoreSimilarStoresModal_instance = this;
    Origins.call(this, 'ClosedStoreSimilarStoresModal');
  }
  protoOf(ClosedStoreSimilarStoresModal).toString = function () {
    return 'ClosedStoreSimilarStoresModal(value=' + this.value + ')';
  };
  var ClosedStoreSimilarStoresModal_instance;
  function ClosedStoreSimilarStoresModal_getInstance() {
    if (ClosedStoreSimilarStoresModal_instance == null)
      new ClosedStoreSimilarStoresModal();
    return ClosedStoreSimilarStoresModal_instance;
  }
  function Orders_0() {
    Orders_instance = this;
    Origins.call(this, 'Orders');
  }
  protoOf(Orders_0).toString = function () {
    return 'Orders(value=' + this.value + ')';
  };
  var Orders_instance;
  function Orders_getInstance() {
    if (Orders_instance == null)
      new Orders_0();
    return Orders_instance;
  }
  function OutOfDeliveryPopUp() {
    OutOfDeliveryPopUp_instance = this;
    Origins.call(this, 'OutOfDeliveryPopUp');
  }
  protoOf(OutOfDeliveryPopUp).toString = function () {
    return 'OutOfDeliveryPopUp(value=' + this.value + ')';
  };
  var OutOfDeliveryPopUp_instance;
  function OutOfDeliveryPopUp_getInstance() {
    if (OutOfDeliveryPopUp_instance == null)
      new OutOfDeliveryPopUp();
    return OutOfDeliveryPopUp_instance;
  }
  function DoubleGlovo() {
    DoubleGlovo_instance = this;
    Origins.call(this, 'DoubleGlovo');
  }
  protoOf(DoubleGlovo).toString = function () {
    return 'DoubleGlovo(value=' + this.value + ')';
  };
  var DoubleGlovo_instance;
  function DoubleGlovo_getInstance() {
    if (DoubleGlovo_instance == null)
      new DoubleGlovo();
    return DoubleGlovo_instance;
  }
  function Widget_0(widgetId, widgetAppLocation, widgetName, categoryId, searchId, categoryGroupId) {
    categoryId = categoryId === VOID ? null : categoryId;
    searchId = searchId === VOID ? null : searchId;
    categoryGroupId = categoryGroupId === VOID ? null : categoryGroupId;
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation));
    var tmp_1 = to('widgetName', widgetName == null ? null : get_value(widgetName));
    var tmp_2 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_3 = to('searchId', searchId == null ? null : get_value(searchId));
    Origins.call(this, 'Widget', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))]));
  }
  protoOf(Widget_0).toString = function () {
    return 'Widget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function WidgetResults(widgetId, widgetAppLocation, widgetName, categoryId, searchId, categoryGroupId) {
    categoryId = categoryId === VOID ? null : categoryId;
    searchId = searchId === VOID ? null : searchId;
    categoryGroupId = categoryGroupId === VOID ? null : categoryGroupId;
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation));
    var tmp_1 = to('widgetName', widgetName == null ? null : get_value(widgetName));
    var tmp_2 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_3 = to('searchId', searchId == null ? null : get_value(searchId));
    Origins.call(this, 'WidgetResults', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))]));
  }
  protoOf(WidgetResults).toString = function () {
    return 'WidgetResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Cart() {
    Cart_instance = this;
    Origins.call(this, 'Cart');
  }
  protoOf(Cart).toString = function () {
    return 'Cart(value=' + this.value + ')';
  };
  var Cart_instance;
  function Cart_getInstance() {
    if (Cart_instance == null)
      new Cart();
    return Cart_instance;
  }
  function StoreDetails() {
    StoreDetails_instance = this;
    Origins.call(this, 'StoreDetails');
  }
  protoOf(StoreDetails).toString = function () {
    return 'StoreDetails(value=' + this.value + ')';
  };
  var StoreDetails_instance;
  function StoreDetails_getInstance() {
    if (StoreDetails_instance == null)
      new StoreDetails();
    return StoreDetails_instance;
  }
  function VideoPlayer() {
    VideoPlayer_instance = this;
    Origins.call(this, 'VideoPlayer');
  }
  protoOf(VideoPlayer).toString = function () {
    return 'VideoPlayer(value=' + this.value + ')';
  };
  var VideoPlayer_instance;
  function VideoPlayer_getInstance() {
    if (VideoPlayer_instance == null)
      new VideoPlayer();
    return VideoPlayer_instance;
  }
  function Playlist(playlistId) {
    Origins.call(this, 'Playlist', mapOf_0(to('playlistId', playlistId == null ? null : get_value(playlistId))));
  }
  protoOf(Playlist).toString = function () {
    return 'Playlist(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function PlaylistBottomSheet() {
    PlaylistBottomSheet_instance = this;
    Origins.call(this, 'PlaylistBottomSheet');
  }
  protoOf(PlaylistBottomSheet).toString = function () {
    return 'PlaylistBottomSheet(value=' + this.value + ')';
  };
  var PlaylistBottomSheet_instance;
  function PlaylistBottomSheet_getInstance() {
    if (PlaylistBottomSheet_instance == null)
      new PlaylistBottomSheet();
    return PlaylistBottomSheet_instance;
  }
  function StoreWallNestedDishes() {
    StoreWallNestedDishes_instance = this;
    Origins.call(this, 'StoreWallNestedDishes');
  }
  protoOf(StoreWallNestedDishes).toString = function () {
    return 'StoreWallNestedDishes(value=' + this.value + ')';
  };
  var StoreWallNestedDishes_instance;
  function StoreWallNestedDishes_getInstance() {
    if (StoreWallNestedDishes_instance == null)
      new StoreWallNestedDishes();
    return StoreWallNestedDishes_instance;
  }
  function SearchShowAllButton() {
    SearchShowAllButton_instance = this;
    Origins.call(this, 'SearchShowAllButton');
  }
  protoOf(SearchShowAllButton).toString = function () {
    return 'SearchShowAllButton(value=' + this.value + ')';
  };
  var SearchShowAllButton_instance;
  function SearchShowAllButton_getInstance() {
    if (SearchShowAllButton_instance == null)
      new SearchShowAllButton();
    return SearchShowAllButton_instance;
  }
  function Home_0() {
    Home_instance = this;
    Origins.call(this, 'Home');
  }
  protoOf(Home_0).toString = function () {
    return 'Home(value=' + this.value + ')';
  };
  var Home_instance;
  function Home_getInstance() {
    if (Home_instance == null)
      new Home_0();
    return Home_instance;
  }
  function NavigationTabBar() {
    NavigationTabBar_instance = this;
    Origins.call(this, 'NavigationTabBar');
  }
  protoOf(NavigationTabBar).toString = function () {
    return 'NavigationTabBar(value=' + this.value + ')';
  };
  var NavigationTabBar_instance;
  function NavigationTabBar_getInstance() {
    if (NavigationTabBar_instance == null)
      new NavigationTabBar();
    return NavigationTabBar_instance;
  }
  function Profile() {
    Profile_instance = this;
    Origins.call(this, 'Profile');
  }
  protoOf(Profile).toString = function () {
    return 'Profile(value=' + this.value + ')';
  };
  var Profile_instance;
  function Profile_getInstance() {
    if (Profile_instance == null)
      new Profile();
    return Profile_instance;
  }
  function Origins(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(Origins).r = function () {
    return this.value;
  };
  protoOf(Origins).qa = function () {
    return this.data;
  };
  protoOf(Origins).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(Origins).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof Origins) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function OutOfDeliveryZoneScreenView(coordinatesLatitude, coordinatesLongitude) {
    coordinatesLatitude = coordinatesLatitude === VOID ? null : coordinatesLatitude;
    coordinatesLongitude = coordinatesLongitude === VOID ? null : coordinatesLongitude;
    var tmp = to('coordinatesLatitude', coordinatesLatitude == null ? null : get_value_1(coordinatesLatitude));
    Screen.call(this, 'Out of Delivery Error Zone Screen View', VOID, mapOf([tmp, to('coordinatesLongitude', coordinatesLongitude == null ? null : get_value_1(coordinatesLongitude))]));
  }
  function PaymentChange() {
    Screen.call(this, 'Payment Change');
  }
  var PaymentChangeScreenOrigin_Profile_instance;
  var PaymentChangeScreenOrigin_Checkout_instance;
  var PaymentChangeScreenOrigin_Prime_instance;
  var PaymentChangeScreenOrigin_Recovery_instance;
  var PaymentChangeScreenOrigin_Debt_instance;
  function values_51() {
    return [PaymentChangeScreenOrigin_Profile_getInstance(), PaymentChangeScreenOrigin_Checkout_getInstance(), PaymentChangeScreenOrigin_Prime_getInstance(), PaymentChangeScreenOrigin_Recovery_getInstance(), PaymentChangeScreenOrigin_Debt_getInstance()];
  }
  function valueOf_51(value) {
    switch (value) {
      case 'Profile':
        return PaymentChangeScreenOrigin_Profile_getInstance();
      case 'Checkout':
        return PaymentChangeScreenOrigin_Checkout_getInstance();
      case 'Prime':
        return PaymentChangeScreenOrigin_Prime_getInstance();
      case 'Recovery':
        return PaymentChangeScreenOrigin_Recovery_getInstance();
      case 'Debt':
        return PaymentChangeScreenOrigin_Debt_getInstance();
      default:
        PaymentChangeScreenOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PaymentChangeScreenOrigin_entriesInitialized;
  function PaymentChangeScreenOrigin_initEntries() {
    if (PaymentChangeScreenOrigin_entriesInitialized)
      return Unit_instance;
    PaymentChangeScreenOrigin_entriesInitialized = true;
    PaymentChangeScreenOrigin_Profile_instance = new PaymentChangeScreenOrigin('Profile', 0, 'Profile');
    PaymentChangeScreenOrigin_Checkout_instance = new PaymentChangeScreenOrigin('Checkout', 1, 'Checkout');
    PaymentChangeScreenOrigin_Prime_instance = new PaymentChangeScreenOrigin('Prime', 2, 'Prime');
    PaymentChangeScreenOrigin_Recovery_instance = new PaymentChangeScreenOrigin('Recovery', 3, 'Recovery');
    PaymentChangeScreenOrigin_Debt_instance = new PaymentChangeScreenOrigin('Debt', 4, 'Debt');
  }
  function PaymentChangeScreenOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PaymentChangeScreenOrigin).r = function () {
    return this.value;
  };
  function PaymentChangeScreenOrigin_Profile_getInstance() {
    PaymentChangeScreenOrigin_initEntries();
    return PaymentChangeScreenOrigin_Profile_instance;
  }
  function PaymentChangeScreenOrigin_Checkout_getInstance() {
    PaymentChangeScreenOrigin_initEntries();
    return PaymentChangeScreenOrigin_Checkout_instance;
  }
  function PaymentChangeScreenOrigin_Prime_getInstance() {
    PaymentChangeScreenOrigin_initEntries();
    return PaymentChangeScreenOrigin_Prime_instance;
  }
  function PaymentChangeScreenOrigin_Recovery_getInstance() {
    PaymentChangeScreenOrigin_initEntries();
    return PaymentChangeScreenOrigin_Recovery_instance;
  }
  function PaymentChangeScreenOrigin_Debt_getInstance() {
    PaymentChangeScreenOrigin_initEntries();
    return PaymentChangeScreenOrigin_Debt_instance;
  }
  function PaymentInfo(origin, provider) {
    provider = provider === VOID ? null : provider;
    var tmp = to('origin', origin == null ? null : get_value(origin));
    Screen.call(this, 'Payment Info', VOID, mapOf([tmp, to('provider', provider == null ? null : get_value(provider))]));
  }
  function PaymentInfoEntered(origin, cardId, nicknameAvailable, provider) {
    cardId = cardId === VOID ? null : cardId;
    nicknameAvailable = nicknameAvailable === VOID ? null : nicknameAvailable;
    provider = provider === VOID ? null : provider;
    var tmp = to('origin', origin == null ? null : get_value(origin));
    var tmp_0 = to('cardId', cardId == null ? null : get_value_1(cardId));
    var tmp_1 = to('nicknameAvailable', nicknameAvailable == null ? null : get_value_0(nicknameAvailable));
    Event.call(this, 'Payment Info Entered', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('provider', provider == null ? null : get_value(provider))]));
  }
  function PaymentInfoFailed(origin, errorCode, errorMessage, provider) {
    provider = provider === VOID ? null : provider;
    var tmp = to('origin', origin == null ? null : get_value(origin));
    var tmp_0 = to('errorCode', errorCode == null ? null : get_value(errorCode));
    var tmp_1 = to('errorMessage', errorMessage == null ? null : get_value(errorMessage));
    Event.call(this, 'Payment Info Failed', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('provider', provider == null ? null : get_value(provider))]));
  }
  function Cash() {
    Cash_instance = this;
    PaymentMethod.call(this, 'Cash');
  }
  protoOf(Cash).toString = function () {
    return 'Cash(value=' + this.value + ')';
  };
  var Cash_instance;
  function Cash_getInstance() {
    if (Cash_instance == null)
      new Cash();
    return Cash_instance;
  }
  function CreditCard(cardProvider, cardId, nicknameAvailable) {
    cardProvider = cardProvider === VOID ? null : cardProvider;
    cardId = cardId === VOID ? null : cardId;
    nicknameAvailable = nicknameAvailable === VOID ? null : nicknameAvailable;
    var tmp = to('cardProvider', cardProvider == null ? null : get_value(cardProvider));
    var tmp_0 = to('cardId', cardId == null ? null : get_value_1(cardId));
    PaymentMethod.call(this, 'CreditCard', mapOf([tmp, tmp_0, to('nicknameAvailable', nicknameAvailable == null ? null : get_value_0(nicknameAvailable))]));
  }
  protoOf(CreditCard).toString = function () {
    return 'CreditCard(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function DirectDebit() {
    DirectDebit_instance = this;
    PaymentMethod.call(this, 'DirectDebit');
  }
  protoOf(DirectDebit).toString = function () {
    return 'DirectDebit(value=' + this.value + ')';
  };
  var DirectDebit_instance;
  function DirectDebit_getInstance() {
    if (DirectDebit_instance == null)
      new DirectDebit();
    return DirectDebit_instance;
  }
  function BankTransfer() {
    BankTransfer_instance = this;
    PaymentMethod.call(this, 'BankTransfer');
  }
  protoOf(BankTransfer).toString = function () {
    return 'BankTransfer(value=' + this.value + ')';
  };
  var BankTransfer_instance;
  function BankTransfer_getInstance() {
    if (BankTransfer_instance == null)
      new BankTransfer();
    return BankTransfer_instance;
  }
  function Alternative(platformName) {
    var tmp = mapOf_0(to('platformName', platformName == null ? null : platformName.value));
    var tmp2_elvis_lhs = platformName == null ? null : platformName.data;
    PaymentMethod.call(this, 'Alternative', plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  protoOf(Alternative).toString = function () {
    return 'Alternative(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Others() {
    Others_instance = this;
    PaymentMethod.call(this, 'Others');
  }
  protoOf(Others).toString = function () {
    return 'Others(value=' + this.value + ')';
  };
  var Others_instance;
  function Others_getInstance() {
    if (Others_instance == null)
      new Others();
    return Others_instance;
  }
  function PaymentMethod(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(PaymentMethod).r = function () {
    return this.value;
  };
  protoOf(PaymentMethod).qa = function () {
    return this.data;
  };
  protoOf(PaymentMethod).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(PaymentMethod).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof PaymentMethod) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function PaymentMethodSelector(origin) {
    origin = origin === VOID ? null : origin;
    Screen.call(this, 'Payment Method Selector', VOID, mapOf_0(to('origin', origin == null ? null : origin.value)));
  }
  function PaymentMethodSelectorUpdated(origin, newPaymentMethod, prevPaymentMethod) {
    prevPaymentMethod = prevPaymentMethod === VOID ? null : prevPaymentMethod;
    var tmp = to('origin', origin == null ? null : origin.value);
    var tmp_0 = to('newPaymentMethod', newPaymentMethod == null ? null : newPaymentMethod.value);
    var tmp_1 = mapOf([tmp, tmp_0, to('prevPaymentMethod', prevPaymentMethod == null ? null : get_value(prevPaymentMethod))]);
    var tmp4_elvis_lhs = newPaymentMethod == null ? null : newPaymentMethod.data;
    Event.call(this, 'Payment Method Selector Updated', VOID, VOID, plus(tmp_1, tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs));
  }
  function PaymentProcessingCanceled(origin) {
    Event.call(this, 'Payment Processing Canceled', VOID, VOID, mapOf_0(to('origin', origin == null ? null : origin.value)));
  }
  function PaymentProcessingFinished(origin, status) {
    var tmp = to('origin', origin == null ? null : origin.value);
    Event.call(this, 'Payment Processing Finished', VOID, VOID, mapOf([tmp, to('status', status == null ? null : status.value)]));
  }
  function PaymentProcessingStarted(origin) {
    Event.call(this, 'Payment Processing Started', VOID, VOID, mapOf_0(to('origin', origin == null ? null : origin.value)));
  }
  var PaymentProcessingStatus_Success_instance;
  var PaymentProcessingStatus_Failure_instance;
  var PaymentProcessingStatus_Canceled_instance;
  function values_52() {
    return [PaymentProcessingStatus_Success_getInstance(), PaymentProcessingStatus_Failure_getInstance(), PaymentProcessingStatus_Canceled_getInstance()];
  }
  function valueOf_52(value) {
    switch (value) {
      case 'Success':
        return PaymentProcessingStatus_Success_getInstance();
      case 'Failure':
        return PaymentProcessingStatus_Failure_getInstance();
      case 'Canceled':
        return PaymentProcessingStatus_Canceled_getInstance();
      default:
        PaymentProcessingStatus_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PaymentProcessingStatus_entriesInitialized;
  function PaymentProcessingStatus_initEntries() {
    if (PaymentProcessingStatus_entriesInitialized)
      return Unit_instance;
    PaymentProcessingStatus_entriesInitialized = true;
    PaymentProcessingStatus_Success_instance = new PaymentProcessingStatus('Success', 0, 'Success');
    PaymentProcessingStatus_Failure_instance = new PaymentProcessingStatus('Failure', 1, 'Failure');
    PaymentProcessingStatus_Canceled_instance = new PaymentProcessingStatus('Canceled', 2, 'Canceled');
  }
  function PaymentProcessingStatus(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PaymentProcessingStatus).r = function () {
    return this.value;
  };
  function PaymentProcessingStatus_Success_getInstance() {
    PaymentProcessingStatus_initEntries();
    return PaymentProcessingStatus_Success_instance;
  }
  function PaymentProcessingStatus_Failure_getInstance() {
    PaymentProcessingStatus_initEntries();
    return PaymentProcessingStatus_Failure_instance;
  }
  function PaymentProcessingStatus_Canceled_getInstance() {
    PaymentProcessingStatus_initEntries();
    return PaymentProcessingStatus_Canceled_instance;
  }
  var PersonalizedFilterType_User_instance;
  var PersonalizedFilterType_City_instance;
  function values_53() {
    return [PersonalizedFilterType_User_getInstance(), PersonalizedFilterType_City_getInstance()];
  }
  function valueOf_53(value) {
    switch (value) {
      case 'User':
        return PersonalizedFilterType_User_getInstance();
      case 'City':
        return PersonalizedFilterType_City_getInstance();
      default:
        PersonalizedFilterType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PersonalizedFilterType_entriesInitialized;
  function PersonalizedFilterType_initEntries() {
    if (PersonalizedFilterType_entriesInitialized)
      return Unit_instance;
    PersonalizedFilterType_entriesInitialized = true;
    PersonalizedFilterType_User_instance = new PersonalizedFilterType('User', 0, 'User');
    PersonalizedFilterType_City_instance = new PersonalizedFilterType('City', 1, 'City');
  }
  function PersonalizedFilterType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PersonalizedFilterType).r = function () {
    return this.value;
  };
  function PersonalizedFilterType_User_getInstance() {
    PersonalizedFilterType_initEntries();
    return PersonalizedFilterType_User_instance;
  }
  function PersonalizedFilterType_City_getInstance() {
    PersonalizedFilterType_initEntries();
    return PersonalizedFilterType_City_instance;
  }
  var PhoneScreenOrigin_Profile_instance;
  var PhoneScreenOrigin_ContactTree_instance;
  function values_54() {
    return [PhoneScreenOrigin_Profile_getInstance(), PhoneScreenOrigin_ContactTree_getInstance()];
  }
  function valueOf_54(value) {
    switch (value) {
      case 'Profile':
        return PhoneScreenOrigin_Profile_getInstance();
      case 'ContactTree':
        return PhoneScreenOrigin_ContactTree_getInstance();
      default:
        PhoneScreenOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PhoneScreenOrigin_entriesInitialized;
  function PhoneScreenOrigin_initEntries() {
    if (PhoneScreenOrigin_entriesInitialized)
      return Unit_instance;
    PhoneScreenOrigin_entriesInitialized = true;
    PhoneScreenOrigin_Profile_instance = new PhoneScreenOrigin('Profile', 0, 'Profile');
    PhoneScreenOrigin_ContactTree_instance = new PhoneScreenOrigin('ContactTree', 1, 'Contact tree');
  }
  function PhoneScreenOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PhoneScreenOrigin).r = function () {
    return this.value;
  };
  function PhoneScreenOrigin_Profile_getInstance() {
    PhoneScreenOrigin_initEntries();
    return PhoneScreenOrigin_Profile_instance;
  }
  function PhoneScreenOrigin_ContactTree_getInstance() {
    PhoneScreenOrigin_initEntries();
    return PhoneScreenOrigin_ContactTree_instance;
  }
  function Metadata_85() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_85).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_85;
  function Metadata_getInstance_85() {
    return Metadata_instance_85;
  }
  function PhoneScreenViewed(origin, orderId) {
    orderId = orderId === VOID ? null : orderId;
    var tmp = to('origin', origin == null ? null : origin.value);
    Screen.call(this, 'Phone Screen Viewed', 'CF: Contact Flow', mapOf([tmp, to('orderId', orderId == null ? null : get_value_1(orderId))]));
  }
  function PhoneVerification(origin) {
    Screen.call(this, 'Phone Verification', VOID, mapOf_0(to('origin', origin == null ? null : get_value(origin))));
  }
  function PhoneVerificationCallRequested(phone, origin) {
    var tmp = to('phone', phone == null ? null : get_value(phone));
    Event.call(this, 'Phone Verification Call Requested', VOID, VOID, mapOf([tmp, to('origin', origin == null ? null : get_value(origin))]));
  }
  function PhoneVerificationEnterCode(phone, origin) {
    var tmp = to('phone', phone == null ? null : get_value(phone));
    Screen.call(this, 'Enter Code', VOID, mapOf([tmp, to('origin', origin == null ? null : get_value(origin))]));
  }
  function PhoneVerificationFailed(phone, reason, errorCode, errorMessage, origin) {
    var tmp = to('phone', phone == null ? null : get_value(phone));
    var tmp_0 = to('reason', reason == null ? null : get_value(reason));
    var tmp_1 = to('errorCode', errorCode == null ? null : get_value(errorCode));
    var tmp_2 = to('errorMessage', errorMessage == null ? null : get_value(errorMessage));
    Event.call(this, 'Phone Verification Failed', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, to('origin', origin == null ? null : get_value(origin))]));
  }
  var PhoneVerificationMethod_SMS_instance;
  var PhoneVerificationMethod_Whatsapp_instance;
  function values_55() {
    return [PhoneVerificationMethod_SMS_getInstance(), PhoneVerificationMethod_Whatsapp_getInstance()];
  }
  function valueOf_55(value) {
    switch (value) {
      case 'SMS':
        return PhoneVerificationMethod_SMS_getInstance();
      case 'Whatsapp':
        return PhoneVerificationMethod_Whatsapp_getInstance();
      default:
        PhoneVerificationMethod_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PhoneVerificationMethod_entriesInitialized;
  function PhoneVerificationMethod_initEntries() {
    if (PhoneVerificationMethod_entriesInitialized)
      return Unit_instance;
    PhoneVerificationMethod_entriesInitialized = true;
    PhoneVerificationMethod_SMS_instance = new PhoneVerificationMethod('SMS', 0, 'SMS');
    PhoneVerificationMethod_Whatsapp_instance = new PhoneVerificationMethod('Whatsapp', 1, 'Whatsapp');
  }
  function PhoneVerificationMethod(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PhoneVerificationMethod).r = function () {
    return this.value;
  };
  function PhoneVerificationMethod_SMS_getInstance() {
    PhoneVerificationMethod_initEntries();
    return PhoneVerificationMethod_SMS_instance;
  }
  function PhoneVerificationMethod_Whatsapp_getInstance() {
    PhoneVerificationMethod_initEntries();
    return PhoneVerificationMethod_Whatsapp_instance;
  }
  function PhoneVerificationMethodButtonClicked(source, preferredVerificationMethod) {
    source = source === VOID ? null : source;
    preferredVerificationMethod = preferredVerificationMethod === VOID ? null : preferredVerificationMethod;
    var tmp = to('source', source == null ? null : source.value);
    Screen.call(this, 'Phone Verification Method Button Clicked', VOID, mapOf([tmp, to('preferredVerificationMethod', preferredVerificationMethod == null ? null : preferredVerificationMethod.value)]));
  }
  function PhoneVerificationNoAttemptsLeft(origin) {
    Screen.call(this, 'Phone Verification No Attempts Left', VOID, mapOf_0(to('origin', origin == null ? null : get_value(origin))));
  }
  function PhoneVerificationStarted(phone, origin) {
    var tmp = to('phone', phone == null ? null : get_value(phone));
    Event.call(this, 'Phone Verification Started', VOID, VOID, mapOf([tmp, to('origin', origin == null ? null : get_value(origin))]));
  }
  function PhoneVerified(phone, wasInUse, origin) {
    var tmp = to('phone', phone == null ? null : get_value(phone));
    var tmp_0 = to('wasInUse', wasInUse == null ? null : get_value_0(wasInUse));
    Event.call(this, 'Phone Verified', VOID, VOID, mapOf([tmp, tmp_0, to('origin', origin == null ? null : get_value(origin))]));
  }
  function Metadata_86() {
    this.OWNER = 'CF: Contact Flow';
  }
  protoOf(Metadata_86).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_86;
  function Metadata_getInstance_86() {
    return Metadata_instance_86;
  }
  function PopupCTAPressed(contactReason, orderId, cta) {
    orderId = orderId === VOID ? null : orderId;
    var tmp = to('contactReason', contactReason == null ? null : contactReason.value);
    var tmp_0 = to('orderId', orderId == null ? null : get_value_1(orderId));
    Event.call(this, 'Popup CTA Pressed', VOID, 'CF: Contact Flow', mapOf([tmp, tmp_0, to('cta', cta == null ? null : cta.value)]));
  }
  function PreSearch(searchType, recentSearches, recentSearchesCount, trendingSearches, loadedWidgetsIds, categoryGroupId, categoryId, keyboardOn) {
    recentSearches = recentSearches === VOID ? null : recentSearches;
    recentSearchesCount = recentSearchesCount === VOID ? null : recentSearchesCount;
    trendingSearches = trendingSearches === VOID ? null : trendingSearches;
    loadedWidgetsIds = loadedWidgetsIds === VOID ? null : loadedWidgetsIds;
    categoryGroupId = categoryGroupId === VOID ? null : categoryGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    keyboardOn = keyboardOn === VOID ? null : keyboardOn;
    var tmp = to('searchType', searchType == null ? null : searchType.value);
    var tmp_0 = to('recentSearches', recentSearches == null ? null : get_value_2(recentSearches));
    var tmp_1 = to('recentSearchesCount', recentSearchesCount == null ? null : get_value_2(recentSearchesCount));
    var tmp_2 = to('trendingSearches', trendingSearches == null ? null : get_value_2(trendingSearches));
    var tmp_3 = to('loadedWidgetsIds', loadedWidgetsIds == null ? null : get_value_2(loadedWidgetsIds));
    var tmp_4 = to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId));
    var tmp_5 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_6 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('keyboardOn', keyboardOn == null ? null : get_value_0(keyboardOn))]);
    var tmp9_elvis_lhs = searchType == null ? null : searchType.data;
    Screen.call(this, 'Pre Search', VOID, plus(tmp_6, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs));
  }
  function PreferredLanguagePage() {
    Screen.call(this, 'Preferred Language Page');
  }
  function PreferredLanguagesList() {
    Screen.call(this, 'Preferred Languages List');
  }
  function Metadata_87() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_87).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_87;
  function Metadata_getInstance_87() {
    return Metadata_instance_87;
  }
  function PrimeCheckoutBoxDeselected(subscriptionId) {
    Event.call(this, 'Prime Checkout Box Deselected', VOID, 'GRO: Growth', mapOf_0(to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId))));
  }
  function Metadata_88() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_88).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_88;
  function Metadata_getInstance_88() {
    return Metadata_instance_88;
  }
  function PrimeCheckoutBoxSelected(subscriptionId) {
    Event.call(this, 'Prime Checkout Box Selected', VOID, 'GRO: Growth', mapOf_0(to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId))));
  }
  var PrimeOrigin_Tutorial_instance;
  var PrimeOrigin_Checkout_instance;
  var PrimeOrigin_Resubscription_instance;
  function values_56() {
    return [PrimeOrigin_Tutorial_getInstance(), PrimeOrigin_Checkout_getInstance(), PrimeOrigin_Resubscription_getInstance()];
  }
  function valueOf_56(value) {
    switch (value) {
      case 'Tutorial':
        return PrimeOrigin_Tutorial_getInstance();
      case 'Checkout':
        return PrimeOrigin_Checkout_getInstance();
      case 'Resubscription':
        return PrimeOrigin_Resubscription_getInstance();
      default:
        PrimeOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PrimeOrigin_entriesInitialized;
  function PrimeOrigin_initEntries() {
    if (PrimeOrigin_entriesInitialized)
      return Unit_instance;
    PrimeOrigin_entriesInitialized = true;
    PrimeOrigin_Tutorial_instance = new PrimeOrigin('Tutorial', 0, 'Tutorial');
    PrimeOrigin_Checkout_instance = new PrimeOrigin('Checkout', 1, 'Checkout');
    PrimeOrigin_Resubscription_instance = new PrimeOrigin('Resubscription', 2, 'Resubscription');
  }
  function PrimeOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PrimeOrigin).r = function () {
    return this.value;
  };
  function PrimeOrigin_Tutorial_getInstance() {
    PrimeOrigin_initEntries();
    return PrimeOrigin_Tutorial_instance;
  }
  function PrimeOrigin_Checkout_getInstance() {
    PrimeOrigin_initEntries();
    return PrimeOrigin_Checkout_instance;
  }
  function PrimeOrigin_Resubscription_getInstance() {
    PrimeOrigin_initEntries();
    return PrimeOrigin_Resubscription_instance;
  }
  function Metadata_89() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_89).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_89;
  function Metadata_getInstance_89() {
    return Metadata_instance_89;
  }
  function PrimeSubscribeSelected(source, paymentCardAlreadyAvailable, freeTrial, carrouselContentType, subscriptionId) {
    var tmp = to('source', source == null ? null : source.value);
    var tmp_0 = to('paymentCardAlreadyAvailable', paymentCardAlreadyAvailable == null ? null : get_value_0(paymentCardAlreadyAvailable));
    var tmp_1 = to('freeTrial', freeTrial == null ? null : get_value_0(freeTrial));
    var tmp_2 = to('carrouselContentType', carrouselContentType == null ? null : get_value(carrouselContentType));
    var tmp_3 = mapOf([tmp, tmp_0, tmp_1, tmp_2, to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId))]);
    var tmp6_elvis_lhs = source == null ? null : source.data;
    Event.call(this, 'Prime Subscribe Selected', VOID, 'GRO: Growth', plus(tmp_3, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs));
  }
  function Metadata_90() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_90).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_90;
  function Metadata_getInstance_90() {
    return Metadata_instance_90;
  }
  function PrimeSubscriptionConfirmed(subscriptionId, origin, freeTrial, subscriptionType, source, chosenTenure, chosenTier, isUpgrade) {
    chosenTenure = chosenTenure === VOID ? null : chosenTenure;
    chosenTier = chosenTier === VOID ? null : chosenTier;
    isUpgrade = isUpgrade === VOID ? null : isUpgrade;
    var tmp = to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId));
    var tmp_0 = to('origin', origin == null ? null : origin.value);
    var tmp_1 = to('freeTrial', freeTrial == null ? null : get_value_0(freeTrial));
    var tmp_2 = to('subscriptionType', subscriptionType == null ? null : subscriptionType.value);
    var tmp_3 = to('source', source == null ? null : source.value);
    var tmp_4 = to('chosenTenure', chosenTenure == null ? null : get_value(chosenTenure));
    var tmp_5 = to('chosenTier', chosenTier == null ? null : get_value(chosenTier));
    var tmp_6 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('isUpgrade', isUpgrade == null ? null : get_value_0(isUpgrade))]);
    var tmp9_elvis_lhs = source == null ? null : source.data;
    Event.call(this, 'Prime Subscription Confirmed', VOID, 'GRO: Growth', plus(tmp_6, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs));
  }
  var PrimeSubscriptionType_General_instance;
  var PrimeSubscriptionType_Sponsored_instance;
  function values_57() {
    return [PrimeSubscriptionType_General_getInstance(), PrimeSubscriptionType_Sponsored_getInstance()];
  }
  function valueOf_57(value) {
    switch (value) {
      case 'General':
        return PrimeSubscriptionType_General_getInstance();
      case 'Sponsored':
        return PrimeSubscriptionType_Sponsored_getInstance();
      default:
        PrimeSubscriptionType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PrimeSubscriptionType_entriesInitialized;
  function PrimeSubscriptionType_initEntries() {
    if (PrimeSubscriptionType_entriesInitialized)
      return Unit_instance;
    PrimeSubscriptionType_entriesInitialized = true;
    PrimeSubscriptionType_General_instance = new PrimeSubscriptionType('General', 0, 'General');
    PrimeSubscriptionType_Sponsored_instance = new PrimeSubscriptionType('Sponsored', 1, 'Sponsored');
  }
  function PrimeSubscriptionType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PrimeSubscriptionType).r = function () {
    return this.value;
  };
  function PrimeSubscriptionType_General_getInstance() {
    PrimeSubscriptionType_initEntries();
    return PrimeSubscriptionType_General_instance;
  }
  function PrimeSubscriptionType_Sponsored_getInstance() {
    PrimeSubscriptionType_initEntries();
    return PrimeSubscriptionType_Sponsored_instance;
  }
  function Metadata_91() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_91).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_91;
  function Metadata_getInstance_91() {
    return Metadata_instance_91;
  }
  function PrimeTutorialDismissed(subscriptionId) {
    Event.call(this, 'Prime Tutorial Dismissed', VOID, 'GRO: Growth', mapOf_0(to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId))));
  }
  function Metadata_92() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_92).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_92;
  function Metadata_getInstance_92() {
    return Metadata_instance_92;
  }
  function PrimeTutorialShown(source, subscriptionId, darkMode, potentialSavingsAmount, potentialSavingsType) {
    darkMode = darkMode === VOID ? false : darkMode;
    potentialSavingsAmount = potentialSavingsAmount === VOID ? null : potentialSavingsAmount;
    potentialSavingsType = potentialSavingsType === VOID ? null : potentialSavingsType;
    var tmp = to('source', source == null ? null : source.value);
    var tmp_0 = to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId));
    var tmp_1 = to('darkMode', darkMode == null ? null : get_value_0(darkMode));
    var tmp_2 = to('potentialSavingsAmount', potentialSavingsAmount == null ? null : get_value(potentialSavingsAmount));
    var tmp_3 = mapOf([tmp, tmp_0, tmp_1, tmp_2, to('potentialSavingsType', potentialSavingsType == null ? null : get_value(potentialSavingsType))]);
    var tmp6_elvis_lhs = source == null ? null : source.data;
    Event.call(this, 'Prime Tutorial Shown', VOID, 'GRO: Growth', plus(tmp_3, tmp6_elvis_lhs == null ? emptyMap() : tmp6_elvis_lhs));
  }
  function Deeplink_1(uri) {
    PrimeTutorialSource.call(this, 'Deeplink', mapOf_0(to('uri', uri == null ? null : get_value(uri))));
  }
  protoOf(Deeplink_1).toString = function () {
    return 'Deeplink(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Profile_0() {
    Profile_instance_0 = this;
    PrimeTutorialSource.call(this, 'Profile');
  }
  protoOf(Profile_0).toString = function () {
    return 'Profile(value=' + this.value + ')';
  };
  var Profile_instance_0;
  function Profile_getInstance_0() {
    if (Profile_instance_0 == null)
      new Profile_0();
    return Profile_instance_0;
  }
  function Story_0() {
    Story_instance = this;
    PrimeTutorialSource.call(this, 'Story');
  }
  protoOf(Story_0).toString = function () {
    return 'Story(value=' + this.value + ')';
  };
  var Story_instance;
  function Story_getInstance() {
    if (Story_instance == null)
      new Story_0();
    return Story_instance;
  }
  function Checkout_1(isUpgrade) {
    isUpgrade = isUpgrade === VOID ? null : isUpgrade;
    PrimeTutorialSource.call(this, 'Checkout', mapOf_0(to('isUpgrade', isUpgrade == null ? null : get_value_0(isUpgrade))));
  }
  protoOf(Checkout_1).toString = function () {
    return 'Checkout(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Header() {
    Header_instance = this;
    PrimeTutorialSource.call(this, 'Header');
  }
  protoOf(Header).toString = function () {
    return 'Header(value=' + this.value + ')';
  };
  var Header_instance;
  function Header_getInstance() {
    if (Header_instance == null)
      new Header();
    return Header_instance;
  }
  function Promocodes() {
    Promocodes_instance = this;
    PrimeTutorialSource.call(this, 'Promocodes');
  }
  protoOf(Promocodes).toString = function () {
    return 'Promocodes(value=' + this.value + ')';
  };
  var Promocodes_instance;
  function Promocodes_getInstance() {
    if (Promocodes_instance == null)
      new Promocodes();
    return Promocodes_instance;
  }
  function Store_0() {
    Store_instance = this;
    PrimeTutorialSource.call(this, 'Store');
  }
  protoOf(Store_0).toString = function () {
    return 'Store(value=' + this.value + ')';
  };
  var Store_instance;
  function Store_getInstance() {
    if (Store_instance == null)
      new Store_0();
    return Store_instance;
  }
  function StorePrimePromotions() {
    StorePrimePromotions_instance = this;
    PrimeTutorialSource.call(this, 'StorePrimePromotions');
  }
  protoOf(StorePrimePromotions).toString = function () {
    return 'StorePrimePromotions(value=' + this.value + ')';
  };
  var StorePrimePromotions_instance;
  function StorePrimePromotions_getInstance() {
    if (StorePrimePromotions_instance == null)
      new StorePrimePromotions();
    return StorePrimePromotions_instance;
  }
  function StorePrimeBadge() {
    StorePrimeBadge_instance = this;
    PrimeTutorialSource.call(this, 'StorePrimeBadge');
  }
  protoOf(StorePrimeBadge).toString = function () {
    return 'StorePrimeBadge(value=' + this.value + ')';
  };
  var StorePrimeBadge_instance;
  function StorePrimeBadge_getInstance() {
    if (StorePrimeBadge_instance == null)
      new StorePrimeBadge();
    return StorePrimeBadge_instance;
  }
  function Other_1() {
    Other_instance_1 = this;
    PrimeTutorialSource.call(this, 'Other');
  }
  protoOf(Other_1).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_1;
  function Other_getInstance_1() {
    if (Other_instance_1 == null)
      new Other_1();
    return Other_instance_1;
  }
  function HomeBanner(widgetId) {
    PrimeTutorialSource.call(this, 'HomeBanner', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(HomeBanner).toString = function () {
    return 'HomeBanner(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function PrimeLandingPage() {
    PrimeLandingPage_instance = this;
    PrimeTutorialSource.call(this, 'PrimeLandingPage');
  }
  protoOf(PrimeLandingPage).toString = function () {
    return 'PrimeLandingPage(value=' + this.value + ')';
  };
  var PrimeLandingPage_instance;
  function PrimeLandingPage_getInstance() {
    if (PrimeLandingPage_instance == null)
      new PrimeLandingPage();
    return PrimeLandingPage_instance;
  }
  function OngoingOrder(bannerId) {
    bannerId = bannerId === VOID ? null : bannerId;
    PrimeTutorialSource.call(this, 'OngoingOrder', mapOf_0(to('bannerId', bannerId == null ? null : get_value(bannerId))));
  }
  protoOf(OngoingOrder).toString = function () {
    return 'OngoingOrder(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function StoresList(newStoreWall, isUpgrade) {
    newStoreWall = newStoreWall === VOID ? null : newStoreWall;
    isUpgrade = isUpgrade === VOID ? null : isUpgrade;
    var tmp = to('newStoreWall', newStoreWall == null ? null : get_value_0(newStoreWall));
    PrimeTutorialSource.call(this, 'StoresList', mapOf([tmp, to('isUpgrade', isUpgrade == null ? null : get_value_0(isUpgrade))]));
  }
  protoOf(StoresList).toString = function () {
    return 'StoresList(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Filters_0() {
    Filters_instance = this;
    PrimeTutorialSource.call(this, 'Filters');
  }
  protoOf(Filters_0).toString = function () {
    return 'Filters(value=' + this.value + ')';
  };
  var Filters_instance;
  function Filters_getInstance() {
    if (Filters_instance == null)
      new Filters_0();
    return Filters_instance;
  }
  function Resubscription() {
    Resubscription_instance = this;
    PrimeTutorialSource.call(this, 'Resubscription');
  }
  protoOf(Resubscription).toString = function () {
    return 'Resubscription(value=' + this.value + ')';
  };
  var Resubscription_instance;
  function Resubscription_getInstance() {
    if (Resubscription_instance == null)
      new Resubscription();
    return Resubscription_instance;
  }
  function HomeScreenBenefit() {
    HomeScreenBenefit_instance = this;
    PrimeTutorialSource.call(this, 'HomeScreenBenefit');
  }
  protoOf(HomeScreenBenefit).toString = function () {
    return 'HomeScreenBenefit(value=' + this.value + ')';
  };
  var HomeScreenBenefit_instance;
  function HomeScreenBenefit_getInstance() {
    if (HomeScreenBenefit_instance == null)
      new HomeScreenBenefit();
    return HomeScreenBenefit_instance;
  }
  function ProfileHeader() {
    ProfileHeader_instance = this;
    PrimeTutorialSource.call(this, 'ProfileHeader');
  }
  protoOf(ProfileHeader).toString = function () {
    return 'ProfileHeader(value=' + this.value + ')';
  };
  var ProfileHeader_instance;
  function ProfileHeader_getInstance() {
    if (ProfileHeader_instance == null)
      new ProfileHeader();
    return ProfileHeader_instance;
  }
  function SurgePrice() {
    SurgePrice_instance = this;
    PrimeTutorialSource.call(this, 'SurgePrice');
  }
  protoOf(SurgePrice).toString = function () {
    return 'SurgePrice(value=' + this.value + ')';
  };
  var SurgePrice_instance;
  function SurgePrice_getInstance() {
    if (SurgePrice_instance == null)
      new SurgePrice();
    return SurgePrice_instance;
  }
  function BannerResults_0(categoryId, bannerId, assetId) {
    bannerId = bannerId === VOID ? null : bannerId;
    assetId = assetId === VOID ? null : assetId;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('bannerId', bannerId == null ? null : get_value(bannerId));
    PrimeTutorialSource.call(this, 'BannerResults', mapOf([tmp, tmp_0, to('assetId', assetId == null ? null : get_value_1(assetId))]));
  }
  protoOf(BannerResults_0).toString = function () {
    return 'BannerResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function PaymentNotification() {
    PaymentNotification_instance = this;
    PrimeTutorialSource.call(this, 'PaymentNotification');
  }
  protoOf(PaymentNotification).toString = function () {
    return 'PaymentNotification(value=' + this.value + ')';
  };
  var PaymentNotification_instance;
  function PaymentNotification_getInstance() {
    if (PaymentNotification_instance == null)
      new PaymentNotification();
    return PaymentNotification_instance;
  }
  function Guapo(source) {
    PrimeTutorialSource.call(this, 'Guapo', mapOf_0(to('source', source == null ? null : get_value(source))));
  }
  protoOf(Guapo).toString = function () {
    return 'Guapo(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function PrimeTutorialSource(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(PrimeTutorialSource).r = function () {
    return this.value;
  };
  protoOf(PrimeTutorialSource).qa = function () {
    return this.data;
  };
  protoOf(PrimeTutorialSource).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(PrimeTutorialSource).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof PrimeTutorialSource) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function PrivacyReview() {
    Screen.call(this, 'Privacy Review');
  }
  function PrivacyReviewAccepted() {
    Event.call(this, 'Privacy Review Accepted');
  }
  function PrivacyReviewCancelled() {
    Event.call(this, 'Privacy Review Cancelled');
  }
  function ProductAdded(product, productAddedOrigin, storeAddressId, productSelectionOrigin, collectionId, collectionGroupId, categoryId, productId, collectionGroupType, collectionGroupName, productLabel, isSponsored, productImageTags, productValue, storeId, userSelectedLanguage, storeProductId, isRestricted, searchId, isCustomisable, attributesCount, sectionsCount, requiredSectionsCount, basketId, increment, productSaleType, isWeightedProduct, productVariantGroupId, numAvailableVariants, isPaginated) {
    productSelectionOrigin = productSelectionOrigin === VOID ? null : productSelectionOrigin;
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    collectionGroupType = collectionGroupType === VOID ? null : collectionGroupType;
    collectionGroupName = collectionGroupName === VOID ? null : collectionGroupName;
    productLabel = productLabel === VOID ? null : productLabel;
    userSelectedLanguage = userSelectedLanguage === VOID ? null : userSelectedLanguage;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    isRestricted = isRestricted === VOID ? null : isRestricted;
    searchId = searchId === VOID ? null : searchId;
    increment = increment === VOID ? null : increment;
    productSaleType = productSaleType === VOID ? null : productSaleType;
    isWeightedProduct = isWeightedProduct === VOID ? null : isWeightedProduct;
    productVariantGroupId = productVariantGroupId === VOID ? null : productVariantGroupId;
    numAvailableVariants = numAvailableVariants === VOID ? null : numAvailableVariants;
    isPaginated = isPaginated === VOID ? null : isPaginated;
    var tmp33_products = listOf(product);
    var tmp = to('productAddedOrigin', productAddedOrigin == null ? null : productAddedOrigin.value);
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('productSelectionOrigin', productSelectionOrigin == null ? null : productSelectionOrigin.value);
    var tmp_2 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_3 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_4 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_5 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_6 = to('collectionGroupType', collectionGroupType == null ? null : get_value(collectionGroupType));
    var tmp_7 = to('collectionGroupName', collectionGroupName == null ? null : get_value(collectionGroupName));
    var tmp_8 = to('productLabel', productLabel == null ? null : productLabel.value);
    var tmp_9 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_10 = to('productImageTags', productImageTags == null ? null : get_value_2(productImageTags));
    var tmp_11 = to('productValue', productValue == null ? null : get_value_1(productValue));
    var tmp_12 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_13 = to('userSelectedLanguage', userSelectedLanguage == null ? null : get_value(userSelectedLanguage));
    var tmp_14 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp_15 = to('isRestricted', isRestricted == null ? null : get_value_0(isRestricted));
    var tmp_16 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_17 = to('isCustomisable', isCustomisable == null ? null : get_value_0(isCustomisable));
    var tmp_18 = to('attributesCount', attributesCount == null ? null : get_value_1(attributesCount));
    var tmp_19 = to('sectionsCount', sectionsCount == null ? null : get_value_1(sectionsCount));
    var tmp_20 = to('requiredSectionsCount', requiredSectionsCount == null ? null : get_value_1(requiredSectionsCount));
    var tmp_21 = to('basketId', basketId == null ? null : get_value(basketId));
    var tmp_22 = to('increment', increment == null ? null : get_value_1(increment));
    var tmp_23 = to('productSaleType', productSaleType == null ? null : productSaleType.value);
    var tmp_24 = to('isWeightedProduct', isWeightedProduct == null ? null : get_value_0(isWeightedProduct));
    var tmp_25 = to('productVariantGroupId', productVariantGroupId == null ? null : get_value(productVariantGroupId));
    var tmp_26 = to('numAvailableVariants', numAvailableVariants == null ? null : get_value_1(numAvailableVariants));
    var tmp_27 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, to('isPaginated', isPaginated == null ? null : get_value_0(isPaginated))]);
    var tmp30_elvis_lhs = productAddedOrigin == null ? null : productAddedOrigin.data;
    var tmp_28 = plus(tmp_27, tmp30_elvis_lhs == null ? emptyMap() : tmp30_elvis_lhs);
    var tmp32_elvis_lhs = productSelectionOrigin == null ? null : productSelectionOrigin.data;
    var tmp34_data = plus(tmp_28, tmp32_elvis_lhs == null ? emptyMap() : tmp32_elvis_lhs);
    var tmp35_action = Action_AddToCart_getInstance();
    Event_0.call(this, tmp35_action, tmp33_products, VOID, VOID, tmp34_data);
  }
  function ProductCustomisationAddToOrder(customisationItemIds) {
    ProductAddedOrigin.call(this, 'Product Customisation Add to Order', mapOf_0(to('customisationItemIds', customisationItemIds == null ? null : get_value_2(customisationItemIds))));
  }
  protoOf(ProductCustomisationAddToOrder).toString = function () {
    return 'ProductCustomisationAddToOrder(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function StoreMenuPlusButton() {
    StoreMenuPlusButton_instance = this;
    ProductAddedOrigin.call(this, 'Store Menu Plus Button');
  }
  protoOf(StoreMenuPlusButton).toString = function () {
    return 'StoreMenuPlusButton(value=' + this.value + ')';
  };
  var StoreMenuPlusButton_instance;
  function StoreMenuPlusButton_getInstance() {
    if (StoreMenuPlusButton_instance == null)
      new StoreMenuPlusButton();
    return StoreMenuPlusButton_instance;
  }
  function ItemDetailAddToOrder() {
    ItemDetailAddToOrder_instance = this;
    ProductAddedOrigin.call(this, 'Item Detail Add to Order');
  }
  protoOf(ItemDetailAddToOrder).toString = function () {
    return 'ItemDetailAddToOrder(value=' + this.value + ')';
  };
  var ItemDetailAddToOrder_instance;
  function ItemDetailAddToOrder_getInstance() {
    if (ItemDetailAddToOrder_instance == null)
      new ItemDetailAddToOrder();
    return ItemDetailAddToOrder_instance;
  }
  function NewOrderPlusButton() {
    NewOrderPlusButton_instance = this;
    ProductAddedOrigin.call(this, 'New Order Plus Button');
  }
  protoOf(NewOrderPlusButton).toString = function () {
    return 'NewOrderPlusButton(value=' + this.value + ')';
  };
  var NewOrderPlusButton_instance;
  function NewOrderPlusButton_getInstance() {
    if (NewOrderPlusButton_instance == null)
      new NewOrderPlusButton();
    return NewOrderPlusButton_instance;
  }
  function ProductUpsellPlusButton() {
    ProductUpsellPlusButton_instance = this;
    ProductAddedOrigin.call(this, 'Product Upsell Plus Button');
  }
  protoOf(ProductUpsellPlusButton).toString = function () {
    return 'ProductUpsellPlusButton(value=' + this.value + ')';
  };
  var ProductUpsellPlusButton_instance;
  function ProductUpsellPlusButton_getInstance() {
    if (ProductUpsellPlusButton_instance == null)
      new ProductUpsellPlusButton();
    return ProductUpsellPlusButton_instance;
  }
  function ProductScreenUpsellPlusButton() {
    ProductScreenUpsellPlusButton_instance = this;
    ProductAddedOrigin.call(this, 'Product Screen Upsell Plus Button');
  }
  protoOf(ProductScreenUpsellPlusButton).toString = function () {
    return 'ProductScreenUpsellPlusButton(value=' + this.value + ')';
  };
  var ProductScreenUpsellPlusButton_instance;
  function ProductScreenUpsellPlusButton_getInstance() {
    if (ProductScreenUpsellPlusButton_instance == null)
      new ProductScreenUpsellPlusButton();
    return ProductScreenUpsellPlusButton_instance;
  }
  function ProductPageUpsellingCarouselPlus() {
    ProductPageUpsellingCarouselPlus_instance = this;
    ProductAddedOrigin.call(this, 'Product Page Upselling Carousel Plus');
  }
  protoOf(ProductPageUpsellingCarouselPlus).toString = function () {
    return 'ProductPageUpsellingCarouselPlus(value=' + this.value + ')';
  };
  var ProductPageUpsellingCarouselPlus_instance;
  function ProductPageUpsellingCarouselPlus_getInstance() {
    if (ProductPageUpsellingCarouselPlus_instance == null)
      new ProductPageUpsellingCarouselPlus();
    return ProductPageUpsellingCarouselPlus_instance;
  }
  function ProductPageUpsellingCarouselTile() {
    ProductPageUpsellingCarouselTile_instance = this;
    ProductAddedOrigin.call(this, 'Product Page Upselling Carousel Tile');
  }
  protoOf(ProductPageUpsellingCarouselTile).toString = function () {
    return 'ProductPageUpsellingCarouselTile(value=' + this.value + ')';
  };
  var ProductPageUpsellingCarouselTile_instance;
  function ProductPageUpsellingCarouselTile_getInstance() {
    if (ProductPageUpsellingCarouselTile_instance == null)
      new ProductPageUpsellingCarouselTile();
    return ProductPageUpsellingCarouselTile_instance;
  }
  function Cart_0() {
    Cart_instance_0 = this;
    ProductAddedOrigin.call(this, 'Cart');
  }
  protoOf(Cart_0).toString = function () {
    return 'Cart(value=' + this.value + ')';
  };
  var Cart_instance_0;
  function Cart_getInstance_0() {
    if (Cart_instance_0 == null)
      new Cart_0();
    return Cart_instance_0;
  }
  function BasketPlusButton() {
    BasketPlusButton_instance = this;
    ProductAddedOrigin.call(this, 'Basket');
  }
  protoOf(BasketPlusButton).toString = function () {
    return 'BasketPlusButton(value=' + this.value + ')';
  };
  var BasketPlusButton_instance;
  function BasketPlusButton_getInstance() {
    if (BasketPlusButton_instance == null)
      new BasketPlusButton();
    return BasketPlusButton_instance;
  }
  function ProductAddedOrigin(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(ProductAddedOrigin).r = function () {
    return this.value;
  };
  protoOf(ProductAddedOrigin).qa = function () {
    return this.data;
  };
  protoOf(ProductAddedOrigin).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(ProductAddedOrigin).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ProductAddedOrigin) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ProductAdditionalInformationClicked(productId, storeAddressId, productExternalId, productAdditionalInformation, storeProductId) {
    productExternalId = productExternalId === VOID ? null : productExternalId;
    productAdditionalInformation = productAdditionalInformation === VOID ? null : productAdditionalInformation;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('productExternalId', productExternalId == null ? null : get_value(productExternalId));
    var tmp_2 = to('productAdditionalInformation', productAdditionalInformation == null ? null : productAdditionalInformation.value);
    Event.call(this, 'Product Additional Information Clicked', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  var ProductAdditionalInformationGroupType_Description_instance;
  var ProductAdditionalInformationGroupType_Specification_instance;
  var ProductAdditionalInformationGroupType_ReturnPolicy_instance;
  var ProductAdditionalInformationGroupType_ModelUpsellCarousel_instance;
  var ProductAdditionalInformationGroupType_ManualUpsellCarousel_instance;
  function values_58() {
    return [ProductAdditionalInformationGroupType_Description_getInstance(), ProductAdditionalInformationGroupType_Specification_getInstance(), ProductAdditionalInformationGroupType_ReturnPolicy_getInstance(), ProductAdditionalInformationGroupType_ModelUpsellCarousel_getInstance(), ProductAdditionalInformationGroupType_ManualUpsellCarousel_getInstance()];
  }
  function valueOf_58(value) {
    switch (value) {
      case 'Description':
        return ProductAdditionalInformationGroupType_Description_getInstance();
      case 'Specification':
        return ProductAdditionalInformationGroupType_Specification_getInstance();
      case 'ReturnPolicy':
        return ProductAdditionalInformationGroupType_ReturnPolicy_getInstance();
      case 'ModelUpsellCarousel':
        return ProductAdditionalInformationGroupType_ModelUpsellCarousel_getInstance();
      case 'ManualUpsellCarousel':
        return ProductAdditionalInformationGroupType_ManualUpsellCarousel_getInstance();
      default:
        ProductAdditionalInformationGroupType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductAdditionalInformationGroupType_entriesInitialized;
  function ProductAdditionalInformationGroupType_initEntries() {
    if (ProductAdditionalInformationGroupType_entriesInitialized)
      return Unit_instance;
    ProductAdditionalInformationGroupType_entriesInitialized = true;
    ProductAdditionalInformationGroupType_Description_instance = new ProductAdditionalInformationGroupType('Description', 0, 'Description');
    ProductAdditionalInformationGroupType_Specification_instance = new ProductAdditionalInformationGroupType('Specification', 1, 'Specification');
    ProductAdditionalInformationGroupType_ReturnPolicy_instance = new ProductAdditionalInformationGroupType('ReturnPolicy', 2, 'Return Policy');
    ProductAdditionalInformationGroupType_ModelUpsellCarousel_instance = new ProductAdditionalInformationGroupType('ModelUpsellCarousel', 3, 'ModelUpsellCarousel');
    ProductAdditionalInformationGroupType_ManualUpsellCarousel_instance = new ProductAdditionalInformationGroupType('ManualUpsellCarousel', 4, 'ManualUpsellCarousel');
  }
  function ProductAdditionalInformationGroupType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProductAdditionalInformationGroupType).r = function () {
    return this.value;
  };
  function ProductAdditionalInformationGroupType_Description_getInstance() {
    ProductAdditionalInformationGroupType_initEntries();
    return ProductAdditionalInformationGroupType_Description_instance;
  }
  function ProductAdditionalInformationGroupType_Specification_getInstance() {
    ProductAdditionalInformationGroupType_initEntries();
    return ProductAdditionalInformationGroupType_Specification_instance;
  }
  function ProductAdditionalInformationGroupType_ReturnPolicy_getInstance() {
    ProductAdditionalInformationGroupType_initEntries();
    return ProductAdditionalInformationGroupType_ReturnPolicy_instance;
  }
  function ProductAdditionalInformationGroupType_ModelUpsellCarousel_getInstance() {
    ProductAdditionalInformationGroupType_initEntries();
    return ProductAdditionalInformationGroupType_ModelUpsellCarousel_instance;
  }
  function ProductAdditionalInformationGroupType_ManualUpsellCarousel_getInstance() {
    ProductAdditionalInformationGroupType_initEntries();
    return ProductAdditionalInformationGroupType_ManualUpsellCarousel_instance;
  }
  function ProductCustomisation(productId, storeAddressId, hasPicture, description, requiredSections, availableSections, isCustomisable, searchId, collectionId, collectionGroupId, categoryId, productExternalId, productAdditionalInformation, origin, storeProductId, socialSignal, dietaryLabels, isWeightedProduct, productVariantGroupId) {
    description = description === VOID ? null : description;
    searchId = searchId === VOID ? null : searchId;
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    productExternalId = productExternalId === VOID ? null : productExternalId;
    productAdditionalInformation = productAdditionalInformation === VOID ? null : productAdditionalInformation;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    socialSignal = socialSignal === VOID ? null : socialSignal;
    dietaryLabels = dietaryLabels === VOID ? null : dietaryLabels;
    isWeightedProduct = isWeightedProduct === VOID ? null : isWeightedProduct;
    productVariantGroupId = productVariantGroupId === VOID ? null : productVariantGroupId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('hasPicture', hasPicture == null ? null : get_value_0(hasPicture));
    var tmp_2 = to('description', description == null ? null : get_value(description));
    var tmp_3 = to('requiredSections', requiredSections == null ? null : get_value_1(requiredSections));
    var tmp_4 = to('availableSections', availableSections == null ? null : get_value_1(availableSections));
    var tmp_5 = to('isCustomisable', isCustomisable == null ? null : get_value_0(isCustomisable));
    var tmp_6 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_7 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_8 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_9 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_10 = to('productExternalId', productExternalId == null ? null : get_value(productExternalId));
    var tmp_11 = to('productAdditionalInformation', productAdditionalInformation == null ? null : get_value_2(productAdditionalInformation));
    var tmp_12 = to('origin', origin == null ? null : origin.value);
    var tmp_13 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp_14 = to('socialSignal', socialSignal == null ? null : get_value(socialSignal));
    var tmp_15 = to('dietaryLabels', dietaryLabels == null ? null : get_value_2(dietaryLabels));
    var tmp_16 = to('isWeightedProduct', isWeightedProduct == null ? null : get_value_0(isWeightedProduct));
    var tmp_17 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, to('productVariantGroupId', productVariantGroupId == null ? null : get_value(productVariantGroupId))]);
    var tmp20_elvis_lhs = origin == null ? null : origin.data;
    Screen.call(this, 'Product Customisation', VOID, plus(tmp_17, tmp20_elvis_lhs == null ? emptyMap() : tmp20_elvis_lhs));
  }
  function ProductCustomisationDismissed(productId, storeAddressId, hasPicture, description, requiredSections, availableSections, collectionId, collectionGroupId, categoryId, storeProductId) {
    description = description === VOID ? null : description;
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('hasPicture', hasPicture == null ? null : get_value_0(hasPicture));
    var tmp_2 = to('description', description == null ? null : get_value(description));
    var tmp_3 = to('requiredSections', requiredSections == null ? null : get_value_1(requiredSections));
    var tmp_4 = to('availableSections', availableSections == null ? null : get_value_1(availableSections));
    var tmp_5 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_6 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_7 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Event.call(this, 'Product Customisation Dismissed', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  function ProductCustomisationImageImpression(index, numberOfImages, origin) {
    var tmp = to('index', index == null ? null : get_value_1(index));
    var tmp_0 = to('numberOfImages', numberOfImages == null ? null : get_value_1(numberOfImages));
    Event.call(this, 'Product Customisation Image Impression', VOID, VOID, mapOf([tmp, tmp_0, to('origin', origin == null ? null : origin.value)]));
  }
  function ProductCustomisationImageInteracted(index) {
    Event.call(this, 'Product Customisation Image Interacted', VOID, VOID, mapOf_0(to('index', index == null ? null : get_value_1(index))));
  }
  var ProductCustomisationImageOrigin_ProductDetailsPage_instance;
  var ProductCustomisationImageOrigin_ProductCustomisationPage_instance;
  function values_59() {
    return [ProductCustomisationImageOrigin_ProductDetailsPage_getInstance(), ProductCustomisationImageOrigin_ProductCustomisationPage_getInstance()];
  }
  function valueOf_59(value) {
    switch (value) {
      case 'ProductDetailsPage':
        return ProductCustomisationImageOrigin_ProductDetailsPage_getInstance();
      case 'ProductCustomisationPage':
        return ProductCustomisationImageOrigin_ProductCustomisationPage_getInstance();
      default:
        ProductCustomisationImageOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductCustomisationImageOrigin_entriesInitialized;
  function ProductCustomisationImageOrigin_initEntries() {
    if (ProductCustomisationImageOrigin_entriesInitialized)
      return Unit_instance;
    ProductCustomisationImageOrigin_entriesInitialized = true;
    ProductCustomisationImageOrigin_ProductDetailsPage_instance = new ProductCustomisationImageOrigin('ProductDetailsPage', 0, 'ProductDetailsPage');
    ProductCustomisationImageOrigin_ProductCustomisationPage_instance = new ProductCustomisationImageOrigin('ProductCustomisationPage', 1, 'ProductCustomisationPage');
  }
  function ProductCustomisationImageOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProductCustomisationImageOrigin).r = function () {
    return this.value;
  };
  function ProductCustomisationImageOrigin_ProductDetailsPage_getInstance() {
    ProductCustomisationImageOrigin_initEntries();
    return ProductCustomisationImageOrigin_ProductDetailsPage_instance;
  }
  function ProductCustomisationImageOrigin_ProductCustomisationPage_getInstance() {
    ProductCustomisationImageOrigin_initEntries();
    return ProductCustomisationImageOrigin_ProductCustomisationPage_instance;
  }
  function ProductCustomisationImageZoomed(index) {
    Event.call(this, 'Product Customisation Image Zoomed', VOID, VOID, mapOf_0(to('index', index == null ? null : get_value_1(index))));
  }
  function ProductCustomisationItemDeselected(productId, storeAddressId, attributeId, collectionId, collectionGroupId, categoryId, storeProductId) {
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('attributeId', attributeId == null ? null : get_value_1(attributeId));
    var tmp_2 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_3 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_4 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Event.call(this, 'Product Customisation Item Deselected', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  function ProductCustomisationItemSelected(productId, storeAddressId, attributeId, collectionId, collectionGroupId, categoryId, storeProductId) {
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('attributeId', attributeId == null ? null : get_value_1(attributeId));
    var tmp_2 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_3 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_4 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Event.call(this, 'Product Customisation Item Selected', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  function ProductCustomizationAttributeGroupImpression(attributeGroupId, isRequired, productId, storeAddressId, collectionId, collectionGroupId, categoryId, storeProductId) {
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('attributeGroupId', attributeGroupId == null ? null : get_value_1(attributeGroupId));
    var tmp_0 = to('isRequired', isRequired == null ? null : get_value_0(isRequired));
    var tmp_1 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_2 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_3 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_4 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_5 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Event.call(this, 'Product Customisation Attribute Group Impression', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  function ProductPage() {
    ProductPage_instance = this;
    ProductCustomizationOrigin.call(this, 'ProductPage');
  }
  protoOf(ProductPage).toString = function () {
    return 'ProductPage(value=' + this.value + ')';
  };
  var ProductPage_instance;
  function ProductPage_getInstance() {
    if (ProductPage_instance == null)
      new ProductPage();
    return ProductPage_instance;
  }
  function Catalogue_0() {
    Catalogue_instance = this;
    ProductCustomizationOrigin.call(this, 'Catalogue');
  }
  protoOf(Catalogue_0).toString = function () {
    return 'Catalogue(value=' + this.value + ')';
  };
  var Catalogue_instance;
  function Catalogue_getInstance() {
    if (Catalogue_instance == null)
      new Catalogue_0();
    return Catalogue_instance;
  }
  function Checkout_2() {
    Checkout_instance_0 = this;
    ProductCustomizationOrigin.call(this, 'Checkout');
  }
  protoOf(Checkout_2).toString = function () {
    return 'Checkout(value=' + this.value + ')';
  };
  var Checkout_instance_0;
  function Checkout_getInstance_0() {
    if (Checkout_instance_0 == null)
      new Checkout_2();
    return Checkout_instance_0;
  }
  function Search() {
    Search_instance = this;
    ProductCustomizationOrigin.call(this, 'Search');
  }
  protoOf(Search).toString = function () {
    return 'Search(value=' + this.value + ')';
  };
  var Search_instance;
  function Search_getInstance() {
    if (Search_instance == null)
      new Search();
    return Search_instance;
  }
  function Widget_1(widgetId, widgetAppLocation) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    ProductCustomizationOrigin.call(this, 'Widget', mapOf([tmp, to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation))]));
  }
  protoOf(Widget_1).toString = function () {
    return 'Widget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Cart_1() {
    Cart_instance_1 = this;
    ProductCustomizationOrigin.call(this, 'Cart');
  }
  protoOf(Cart_1).toString = function () {
    return 'Cart(value=' + this.value + ')';
  };
  var Cart_instance_1;
  function Cart_getInstance_1() {
    if (Cart_instance_1 == null)
      new Cart_1();
    return Cart_instance_1;
  }
  function Basket() {
    Basket_instance = this;
    ProductCustomizationOrigin.call(this, 'Basket');
  }
  protoOf(Basket).toString = function () {
    return 'Basket(value=' + this.value + ')';
  };
  var Basket_instance;
  function Basket_getInstance() {
    if (Basket_instance == null)
      new Basket();
    return Basket_instance;
  }
  function VideoPlayer_0() {
    VideoPlayer_instance_0 = this;
    ProductCustomizationOrigin.call(this, 'VideoPlayer');
  }
  protoOf(VideoPlayer_0).toString = function () {
    return 'VideoPlayer(value=' + this.value + ')';
  };
  var VideoPlayer_instance_0;
  function VideoPlayer_getInstance_0() {
    if (VideoPlayer_instance_0 == null)
      new VideoPlayer_0();
    return VideoPlayer_instance_0;
  }
  function StoreWallNestedDishes_0(filters) {
    filters = filters === VOID ? null : filters;
    ProductCustomizationOrigin.call(this, 'StoreWallNestedDishes', mapOf_0(to('filters', filters == null ? null : get_value_2(filters))));
  }
  protoOf(StoreWallNestedDishes_0).toString = function () {
    return 'StoreWallNestedDishes(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Other_2() {
    Other_instance_2 = this;
    ProductCustomizationOrigin.call(this, 'Other');
  }
  protoOf(Other_2).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_2;
  function Other_getInstance_2() {
    if (Other_instance_2 == null)
      new Other_2();
    return Other_instance_2;
  }
  function ProductCustomizationOrigin(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(ProductCustomizationOrigin).r = function () {
    return this.value;
  };
  protoOf(ProductCustomizationOrigin).qa = function () {
    return this.data;
  };
  protoOf(ProductCustomizationOrigin).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(ProductCustomizationOrigin).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ProductCustomizationOrigin) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function ProductImpression(collectionSectionId, productId, storeAddressId, productPosition, searchId, description, price, hasPicture, collectionId, collectionGroupId, promotionId, productHorizontalPosition, productExternalId, collectionSectionPosition, categoryId, isSponsored, widgetId, storeProductId, unitPrice, isCustomisable, attributesCount, sectionsCount, requiredSectionsCount, socialSignal, collectionType, socialConnections, priceWithDiscount, productSelectionOrigin, promoId, increment, productSaleType, isWeightedProduct, productVariantGroupId, productVariationVisualKey, numVisualVariants, dietaryLabels, isPaginated) {
    collectionSectionId = collectionSectionId === VOID ? null : collectionSectionId;
    productPosition = productPosition === VOID ? null : productPosition;
    searchId = searchId === VOID ? null : searchId;
    description = description === VOID ? null : description;
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    promotionId = promotionId === VOID ? null : promotionId;
    productHorizontalPosition = productHorizontalPosition === VOID ? null : productHorizontalPosition;
    productExternalId = productExternalId === VOID ? null : productExternalId;
    collectionSectionPosition = collectionSectionPosition === VOID ? null : collectionSectionPosition;
    widgetId = widgetId === VOID ? null : widgetId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    unitPrice = unitPrice === VOID ? null : unitPrice;
    socialSignal = socialSignal === VOID ? null : socialSignal;
    collectionType = collectionType === VOID ? null : collectionType;
    socialConnections = socialConnections === VOID ? null : socialConnections;
    priceWithDiscount = priceWithDiscount === VOID ? null : priceWithDiscount;
    productSelectionOrigin = productSelectionOrigin === VOID ? null : productSelectionOrigin;
    promoId = promoId === VOID ? null : promoId;
    increment = increment === VOID ? null : increment;
    productSaleType = productSaleType === VOID ? null : productSaleType;
    isWeightedProduct = isWeightedProduct === VOID ? null : isWeightedProduct;
    productVariantGroupId = productVariantGroupId === VOID ? null : productVariantGroupId;
    productVariationVisualKey = productVariationVisualKey === VOID ? null : productVariationVisualKey;
    numVisualVariants = numVisualVariants === VOID ? null : numVisualVariants;
    dietaryLabels = dietaryLabels === VOID ? null : dietaryLabels;
    isPaginated = isPaginated === VOID ? null : isPaginated;
    var tmp = to('collectionSectionId', collectionSectionId == null ? null : get_value_1(collectionSectionId));
    var tmp_0 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_1 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_2 = to('productPosition', productPosition == null ? null : get_value_1(productPosition));
    var tmp_3 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_4 = to('description', description == null ? null : get_value(description));
    var tmp_5 = to('price', price == null ? null : get_value_1(price));
    var tmp_6 = to('hasPicture', hasPicture == null ? null : get_value_0(hasPicture));
    var tmp_7 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_8 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_9 = to('promotionId', promotionId == null ? null : get_value_1(promotionId));
    var tmp_10 = to('productHorizontalPosition', productHorizontalPosition == null ? null : get_value_1(productHorizontalPosition));
    var tmp_11 = to('productExternalId', productExternalId == null ? null : get_value(productExternalId));
    var tmp_12 = to('collectionSectionPosition', collectionSectionPosition == null ? null : get_value_1(collectionSectionPosition));
    var tmp_13 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_14 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_15 = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_16 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp_17 = to('unitPrice', unitPrice == null ? null : get_value(unitPrice));
    var tmp_18 = to('isCustomisable', isCustomisable == null ? null : get_value_0(isCustomisable));
    var tmp_19 = to('attributesCount', attributesCount == null ? null : get_value_1(attributesCount));
    var tmp_20 = to('sectionsCount', sectionsCount == null ? null : get_value_1(sectionsCount));
    var tmp_21 = to('requiredSectionsCount', requiredSectionsCount == null ? null : get_value_1(requiredSectionsCount));
    var tmp_22 = to('socialSignal', socialSignal == null ? null : get_value(socialSignal));
    var tmp_23 = to('collectionType', collectionType == null ? null : get_value(collectionType));
    var tmp_24 = to('socialConnections', socialConnections == null ? null : get_value_2(socialConnections));
    var tmp_25 = to('priceWithDiscount', priceWithDiscount == null ? null : get_value_1(priceWithDiscount));
    var tmp_26 = to('productSelectionOrigin', productSelectionOrigin == null ? null : productSelectionOrigin.value);
    var tmp_27 = to('promoId', promoId == null ? null : get_value(promoId));
    var tmp_28 = to('increment', increment == null ? null : get_value_1(increment));
    var tmp_29 = to('productSaleType', productSaleType == null ? null : productSaleType.value);
    var tmp_30 = to('isWeightedProduct', isWeightedProduct == null ? null : get_value_0(isWeightedProduct));
    var tmp_31 = to('productVariantGroupId', productVariantGroupId == null ? null : get_value(productVariantGroupId));
    var tmp_32 = to('productVariationVisualKey', productVariationVisualKey == null ? null : get_value(productVariationVisualKey));
    var tmp_33 = to('numVisualVariants', numVisualVariants == null ? null : get_value_1(numVisualVariants));
    var tmp_34 = to('dietaryLabels', dietaryLabels == null ? null : get_value_2(dietaryLabels));
    var tmp_35 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, to('isPaginated', isPaginated == null ? null : get_value_0(isPaginated))]);
    var tmp38_elvis_lhs = productSelectionOrigin == null ? null : productSelectionOrigin.data;
    Event.call(this, 'Product Impression', VOID, VOID, plus(tmp_35, tmp38_elvis_lhs == null ? emptyMap() : tmp38_elvis_lhs));
  }
  var ProductLabelType_Popular_instance;
  var ProductLabelType_Sponsored_instance;
  var ProductLabelType_Topseller_instance;
  function values_60() {
    return [ProductLabelType_Popular_getInstance(), ProductLabelType_Sponsored_getInstance(), ProductLabelType_Topseller_getInstance()];
  }
  function valueOf_60(value) {
    switch (value) {
      case 'Popular':
        return ProductLabelType_Popular_getInstance();
      case 'Sponsored':
        return ProductLabelType_Sponsored_getInstance();
      case 'Topseller':
        return ProductLabelType_Topseller_getInstance();
      default:
        ProductLabelType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductLabelType_entriesInitialized;
  function ProductLabelType_initEntries() {
    if (ProductLabelType_entriesInitialized)
      return Unit_instance;
    ProductLabelType_entriesInitialized = true;
    ProductLabelType_Popular_instance = new ProductLabelType('Popular', 0, 'Popular');
    ProductLabelType_Sponsored_instance = new ProductLabelType('Sponsored', 1, 'Sponsored');
    ProductLabelType_Topseller_instance = new ProductLabelType('Topseller', 2, 'Topseller');
  }
  function ProductLabelType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProductLabelType).r = function () {
    return this.value;
  };
  function ProductLabelType_Popular_getInstance() {
    ProductLabelType_initEntries();
    return ProductLabelType_Popular_instance;
  }
  function ProductLabelType_Sponsored_getInstance() {
    ProductLabelType_initEntries();
    return ProductLabelType_Sponsored_instance;
  }
  function ProductLabelType_Topseller_getInstance() {
    ProductLabelType_initEntries();
    return ProductLabelType_Topseller_instance;
  }
  function ProductRemoved(product, productRemovedOrigin, storeAddressId, collectionId, collectionGroupId, categoryId, productId, collectionGroupType, collectionGroupName, productLabel, isSponsored, storeId, storeProductId, basketId) {
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    categoryId = categoryId === VOID ? null : categoryId;
    productId = productId === VOID ? null : productId;
    collectionGroupType = collectionGroupType === VOID ? null : collectionGroupType;
    collectionGroupName = collectionGroupName === VOID ? null : collectionGroupName;
    productLabel = productLabel === VOID ? null : productLabel;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp13_products = listOf(product);
    var tmp = to('productRemovedOrigin', productRemovedOrigin == null ? null : productRemovedOrigin.value);
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_2 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_3 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_4 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_5 = to('collectionGroupType', collectionGroupType == null ? null : get_value(collectionGroupType));
    var tmp_6 = to('collectionGroupName', collectionGroupName == null ? null : get_value(collectionGroupName));
    var tmp_7 = to('productLabel', productLabel == null ? null : productLabel.value);
    var tmp_8 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_9 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_10 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp14_data = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, to('basketId', basketId == null ? null : get_value(basketId))]);
    var tmp15_action = Action_RemoveFromCart_getInstance();
    Event_0.call(this, tmp15_action, tmp13_products, VOID, VOID, tmp14_data);
  }
  var ProductRemovedOrigin_StoreMenuMinusButton_instance;
  var ProductRemovedOrigin_NewOrderMinusButton_instance;
  var ProductRemovedOrigin_ProductUpsellMinusButton_instance;
  var ProductRemovedOrigin_ProductScreenUpsellMinusButton_instance;
  var ProductRemovedOrigin_OrderAgainMinusButton_instance;
  var ProductRemovedOrigin_CartMinusButton_instance;
  var ProductRemovedOrigin_BasketMinusButton_instance;
  function values_61() {
    return [ProductRemovedOrigin_StoreMenuMinusButton_getInstance(), ProductRemovedOrigin_NewOrderMinusButton_getInstance(), ProductRemovedOrigin_ProductUpsellMinusButton_getInstance(), ProductRemovedOrigin_ProductScreenUpsellMinusButton_getInstance(), ProductRemovedOrigin_OrderAgainMinusButton_getInstance(), ProductRemovedOrigin_CartMinusButton_getInstance(), ProductRemovedOrigin_BasketMinusButton_getInstance()];
  }
  function valueOf_61(value) {
    switch (value) {
      case 'StoreMenuMinusButton':
        return ProductRemovedOrigin_StoreMenuMinusButton_getInstance();
      case 'NewOrderMinusButton':
        return ProductRemovedOrigin_NewOrderMinusButton_getInstance();
      case 'ProductUpsellMinusButton':
        return ProductRemovedOrigin_ProductUpsellMinusButton_getInstance();
      case 'ProductScreenUpsellMinusButton':
        return ProductRemovedOrigin_ProductScreenUpsellMinusButton_getInstance();
      case 'OrderAgainMinusButton':
        return ProductRemovedOrigin_OrderAgainMinusButton_getInstance();
      case 'CartMinusButton':
        return ProductRemovedOrigin_CartMinusButton_getInstance();
      case 'BasketMinusButton':
        return ProductRemovedOrigin_BasketMinusButton_getInstance();
      default:
        ProductRemovedOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductRemovedOrigin_entriesInitialized;
  function ProductRemovedOrigin_initEntries() {
    if (ProductRemovedOrigin_entriesInitialized)
      return Unit_instance;
    ProductRemovedOrigin_entriesInitialized = true;
    ProductRemovedOrigin_StoreMenuMinusButton_instance = new ProductRemovedOrigin('StoreMenuMinusButton', 0, 'Store Menu Minus Button');
    ProductRemovedOrigin_NewOrderMinusButton_instance = new ProductRemovedOrigin('NewOrderMinusButton', 1, 'New Order Minus Button');
    ProductRemovedOrigin_ProductUpsellMinusButton_instance = new ProductRemovedOrigin('ProductUpsellMinusButton', 2, 'Product Upsell Minus Button');
    ProductRemovedOrigin_ProductScreenUpsellMinusButton_instance = new ProductRemovedOrigin('ProductScreenUpsellMinusButton', 3, 'Product Screen Upsell Minus Button');
    ProductRemovedOrigin_OrderAgainMinusButton_instance = new ProductRemovedOrigin('OrderAgainMinusButton', 4, 'Order Again Minus Button');
    ProductRemovedOrigin_CartMinusButton_instance = new ProductRemovedOrigin('CartMinusButton', 5, 'Cart Minus Button');
    ProductRemovedOrigin_BasketMinusButton_instance = new ProductRemovedOrigin('BasketMinusButton', 6, 'Basket');
  }
  function ProductRemovedOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProductRemovedOrigin).r = function () {
    return this.value;
  };
  function ProductRemovedOrigin_StoreMenuMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_StoreMenuMinusButton_instance;
  }
  function ProductRemovedOrigin_NewOrderMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_NewOrderMinusButton_instance;
  }
  function ProductRemovedOrigin_ProductUpsellMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_ProductUpsellMinusButton_instance;
  }
  function ProductRemovedOrigin_ProductScreenUpsellMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_ProductScreenUpsellMinusButton_instance;
  }
  function ProductRemovedOrigin_OrderAgainMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_OrderAgainMinusButton_instance;
  }
  function ProductRemovedOrigin_CartMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_CartMinusButton_instance;
  }
  function ProductRemovedOrigin_BasketMinusButton_getInstance() {
    ProductRemovedOrigin_initEntries();
    return ProductRemovedOrigin_BasketMinusButton_instance;
  }
  var ProductSaleType_PiecePiece_instance;
  var ProductSaleType_PieceWeight_instance;
  var ProductSaleType_WeightWeight_instance;
  function values_62() {
    return [ProductSaleType_PiecePiece_getInstance(), ProductSaleType_PieceWeight_getInstance(), ProductSaleType_WeightWeight_getInstance()];
  }
  function valueOf_62(value) {
    switch (value) {
      case 'PiecePiece':
        return ProductSaleType_PiecePiece_getInstance();
      case 'PieceWeight':
        return ProductSaleType_PieceWeight_getInstance();
      case 'WeightWeight':
        return ProductSaleType_WeightWeight_getInstance();
      default:
        ProductSaleType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductSaleType_entriesInitialized;
  function ProductSaleType_initEntries() {
    if (ProductSaleType_entriesInitialized)
      return Unit_instance;
    ProductSaleType_entriesInitialized = true;
    ProductSaleType_PiecePiece_instance = new ProductSaleType('PiecePiece', 0, 'piece_piece');
    ProductSaleType_PieceWeight_instance = new ProductSaleType('PieceWeight', 1, 'piece_weight');
    ProductSaleType_WeightWeight_instance = new ProductSaleType('WeightWeight', 2, 'weight_weight');
  }
  function ProductSaleType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProductSaleType).r = function () {
    return this.value;
  };
  function ProductSaleType_PiecePiece_getInstance() {
    ProductSaleType_initEntries();
    return ProductSaleType_PiecePiece_instance;
  }
  function ProductSaleType_PieceWeight_getInstance() {
    ProductSaleType_initEntries();
    return ProductSaleType_PieceWeight_instance;
  }
  function ProductSaleType_WeightWeight_getInstance() {
    ProductSaleType_initEntries();
    return ProductSaleType_WeightWeight_instance;
  }
  function ProductScreenButtonPressed(storeAddressId, suggestedProductIds, productId, isProductCustomization, popularProductIds, sponsoredProductIds, hasSponsoredResults, discountedProductIds, storeProductId, suggestedStoreProductIds, popularStoreProductIds, sponsoredStoreProductIds) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    popularProductIds = popularProductIds === VOID ? null : popularProductIds;
    sponsoredProductIds = sponsoredProductIds === VOID ? null : sponsoredProductIds;
    discountedProductIds = discountedProductIds === VOID ? null : discountedProductIds;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    suggestedStoreProductIds = suggestedStoreProductIds === VOID ? null : suggestedStoreProductIds;
    popularStoreProductIds = popularStoreProductIds === VOID ? null : popularStoreProductIds;
    sponsoredStoreProductIds = sponsoredStoreProductIds === VOID ? null : sponsoredStoreProductIds;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('suggestedProductIds', suggestedProductIds == null ? null : get_value_2(suggestedProductIds));
    var tmp_1 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_2 = to('isProductCustomization', isProductCustomization == null ? null : get_value_0(isProductCustomization));
    var tmp_3 = to('popularProductIds', popularProductIds == null ? null : get_value_2(popularProductIds));
    var tmp_4 = to('sponsoredProductIds', sponsoredProductIds == null ? null : get_value_2(sponsoredProductIds));
    var tmp_5 = to('hasSponsoredResults', hasSponsoredResults == null ? null : get_value_0(hasSponsoredResults));
    var tmp_6 = to('discountedProductIds', discountedProductIds == null ? null : get_value_2(discountedProductIds));
    var tmp_7 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp_8 = to('suggestedStoreProductIds', suggestedStoreProductIds == null ? null : get_value_2(suggestedStoreProductIds));
    var tmp_9 = to('popularStoreProductIds', popularStoreProductIds == null ? null : get_value_2(popularStoreProductIds));
    Event.call(this, 'Product Screen Button Pressed', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, to('sponsoredStoreProductIds', sponsoredStoreProductIds == null ? null : get_value_2(sponsoredStoreProductIds))]));
  }
  function Metadata_93() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_93).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_93;
  function Metadata_getInstance_93() {
    return Metadata_instance_93;
  }
  function ProductScreenUpsellImpression(storeAddressId, suggestedProductIds, productId, isProductCustomization, popularProductIds, sponsoredProductIds, hasSponsoredResults, isSponsored, discountedProductIds, storeProductId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    popularProductIds = popularProductIds === VOID ? null : popularProductIds;
    sponsoredProductIds = sponsoredProductIds === VOID ? null : sponsoredProductIds;
    discountedProductIds = discountedProductIds === VOID ? null : discountedProductIds;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('suggestedProductIds', suggestedProductIds == null ? null : get_value_2(suggestedProductIds));
    var tmp_1 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_2 = to('isProductCustomization', isProductCustomization == null ? null : get_value_0(isProductCustomization));
    var tmp_3 = to('popularProductIds', popularProductIds == null ? null : get_value_2(popularProductIds));
    var tmp_4 = to('sponsoredProductIds', sponsoredProductIds == null ? null : get_value_2(sponsoredProductIds));
    var tmp_5 = to('hasSponsoredResults', hasSponsoredResults == null ? null : get_value_0(hasSponsoredResults));
    var tmp_6 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_7 = to('discountedProductIds', discountedProductIds == null ? null : get_value_2(discountedProductIds));
    Event.call(this, 'Product Screen Upsell Impression', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  function ProductSearchResults(searchType, query, storesResultsCount, productsResultsCount, searchId, webSearchType, isAutosuggested, enteredQuery, isRecentSearches, isTrendingSearches, searchSubmissionType, schedulableStoresCount, openStoresCount, storeAddressIds, productsIds, availabilityStatuses, includesExactMatch, storeProductsIds, loadedTabs, selectedTab, ncrRequestToken, shopsIds, expeditionType, filtersApplied, nestedDishesCount, nestedDishesImageCount, nestedStoreProductIds, searchTaxonomyClassifier) {
    storesResultsCount = storesResultsCount === VOID ? null : storesResultsCount;
    webSearchType = webSearchType === VOID ? null : webSearchType;
    isAutosuggested = isAutosuggested === VOID ? null : isAutosuggested;
    enteredQuery = enteredQuery === VOID ? null : enteredQuery;
    isRecentSearches = isRecentSearches === VOID ? null : isRecentSearches;
    isTrendingSearches = isTrendingSearches === VOID ? null : isTrendingSearches;
    searchSubmissionType = searchSubmissionType === VOID ? null : searchSubmissionType;
    schedulableStoresCount = schedulableStoresCount === VOID ? null : schedulableStoresCount;
    openStoresCount = openStoresCount === VOID ? null : openStoresCount;
    storeAddressIds = storeAddressIds === VOID ? null : storeAddressIds;
    productsIds = productsIds === VOID ? null : productsIds;
    availabilityStatuses = availabilityStatuses === VOID ? null : availabilityStatuses;
    includesExactMatch = includesExactMatch === VOID ? null : includesExactMatch;
    storeProductsIds = storeProductsIds === VOID ? null : storeProductsIds;
    loadedTabs = loadedTabs === VOID ? null : loadedTabs;
    selectedTab = selectedTab === VOID ? null : selectedTab;
    ncrRequestToken = ncrRequestToken === VOID ? null : ncrRequestToken;
    shopsIds = shopsIds === VOID ? null : shopsIds;
    expeditionType = expeditionType === VOID ? null : expeditionType;
    filtersApplied = filtersApplied === VOID ? null : filtersApplied;
    nestedDishesCount = nestedDishesCount === VOID ? null : nestedDishesCount;
    nestedDishesImageCount = nestedDishesImageCount === VOID ? null : nestedDishesImageCount;
    nestedStoreProductIds = nestedStoreProductIds === VOID ? null : nestedStoreProductIds;
    searchTaxonomyClassifier = searchTaxonomyClassifier === VOID ? null : searchTaxonomyClassifier;
    var tmp = to('searchType', searchType == null ? null : searchType.value);
    var tmp_0 = to('query', query == null ? null : get_value(query));
    var tmp_1 = to('storesResultsCount', storesResultsCount == null ? null : get_value_1(storesResultsCount));
    var tmp_2 = to('productsResultsCount', productsResultsCount == null ? null : get_value_1(productsResultsCount));
    var tmp_3 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_4 = to('webSearchType', webSearchType == null ? null : webSearchType.value);
    var tmp_5 = to('isAutosuggested', isAutosuggested == null ? null : get_value_0(isAutosuggested));
    var tmp_6 = to('enteredQuery', enteredQuery == null ? null : get_value(enteredQuery));
    var tmp_7 = to('isRecentSearches', isRecentSearches == null ? null : get_value_0(isRecentSearches));
    var tmp_8 = to('isTrendingSearches', isTrendingSearches == null ? null : get_value_0(isTrendingSearches));
    var tmp_9 = to('searchSubmissionType', searchSubmissionType == null ? null : searchSubmissionType.value);
    var tmp_10 = to('schedulableStoresCount', schedulableStoresCount == null ? null : get_value_1(schedulableStoresCount));
    var tmp_11 = to('openStoresCount', openStoresCount == null ? null : get_value_1(openStoresCount));
    var tmp_12 = to('storeAddressIds', storeAddressIds == null ? null : get_value_2(storeAddressIds));
    var tmp_13 = to('productsIds', productsIds == null ? null : get_value_2(productsIds));
    var tmp_14 = to('availabilityStatuses', availabilityStatuses == null ? null : get_value_2(availabilityStatuses));
    var tmp_15 = to('includesExactMatch', includesExactMatch == null ? null : get_value_0(includesExactMatch));
    var tmp_16 = to('storeProductsIds', storeProductsIds == null ? null : get_value_2(storeProductsIds));
    var tmp_17 = to('loadedTabs', loadedTabs == null ? null : get_value_2(loadedTabs));
    var tmp_18 = to('selectedTab', selectedTab == null ? null : selectedTab.value);
    var tmp_19 = to('ncrRequestToken', ncrRequestToken == null ? null : get_value(ncrRequestToken));
    var tmp_20 = to('shopsIds', shopsIds == null ? null : get_value(shopsIds));
    var tmp_21 = to('expeditionType', expeditionType == null ? null : get_value(expeditionType));
    var tmp_22 = to('filtersApplied', filtersApplied == null ? null : get_value_2(filtersApplied));
    var tmp_23 = to('nestedDishesCount', nestedDishesCount == null ? null : get_value_2(nestedDishesCount));
    var tmp_24 = to('nestedDishesImageCount', nestedDishesImageCount == null ? null : get_value_2(nestedDishesImageCount));
    var tmp_25 = to('nestedStoreProductIds', nestedStoreProductIds == null ? null : get_value_2(nestedStoreProductIds));
    var tmp_26 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, to('searchTaxonomyClassifier', searchTaxonomyClassifier == null ? null : get_value(searchTaxonomyClassifier))]);
    var tmp29_elvis_lhs = searchType == null ? null : searchType.data;
    var tmp_27 = plus(tmp_26, tmp29_elvis_lhs == null ? emptyMap() : tmp29_elvis_lhs);
    var tmp31_elvis_lhs = webSearchType == null ? null : webSearchType.data;
    var tmp_28 = plus(tmp_27, tmp31_elvis_lhs == null ? emptyMap() : tmp31_elvis_lhs);
    var tmp33_elvis_lhs = searchSubmissionType == null ? null : searchSubmissionType.data;
    Screen.call(this, 'Product Search Results', VOID, plus(tmp_28, tmp33_elvis_lhs == null ? emptyMap() : tmp33_elvis_lhs));
  }
  function ProductSelected(productId, collectionSectionId, collectionId, collectionGroupId, storeAddressId, categoryId, productPosition, productHorizontalPosition, collectionSectionPosition, productPositionInCollectionSection, productSelectionOrigin, isSponsored, collectionGroupType, collectionGroupName, storeProductId, searchId, isWeightedProduct, productVariantGroupId, productVariationVisualKey, isPaginated) {
    collectionSectionId = collectionSectionId === VOID ? null : collectionSectionId;
    collectionId = collectionId === VOID ? null : collectionId;
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    productPosition = productPosition === VOID ? null : productPosition;
    productHorizontalPosition = productHorizontalPosition === VOID ? null : productHorizontalPosition;
    collectionSectionPosition = collectionSectionPosition === VOID ? null : collectionSectionPosition;
    productPositionInCollectionSection = productPositionInCollectionSection === VOID ? null : productPositionInCollectionSection;
    collectionGroupType = collectionGroupType === VOID ? null : collectionGroupType;
    collectionGroupName = collectionGroupName === VOID ? null : collectionGroupName;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    searchId = searchId === VOID ? null : searchId;
    isWeightedProduct = isWeightedProduct === VOID ? null : isWeightedProduct;
    productVariantGroupId = productVariantGroupId === VOID ? null : productVariantGroupId;
    productVariationVisualKey = productVariationVisualKey === VOID ? null : productVariationVisualKey;
    isPaginated = isPaginated === VOID ? null : isPaginated;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('collectionSectionId', collectionSectionId == null ? null : get_value_1(collectionSectionId));
    var tmp_1 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_2 = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_3 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_4 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_5 = to('productPosition', productPosition == null ? null : get_value_1(productPosition));
    var tmp_6 = to('productHorizontalPosition', productHorizontalPosition == null ? null : get_value_1(productHorizontalPosition));
    var tmp_7 = to('collectionSectionPosition', collectionSectionPosition == null ? null : get_value_1(collectionSectionPosition));
    var tmp_8 = to('productPositionInCollectionSection', productPositionInCollectionSection == null ? null : get_value_1(productPositionInCollectionSection));
    var tmp_9 = to('productSelectionOrigin', productSelectionOrigin == null ? null : productSelectionOrigin.value);
    var tmp_10 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_11 = to('collectionGroupType', collectionGroupType == null ? null : get_value(collectionGroupType));
    var tmp_12 = to('collectionGroupName', collectionGroupName == null ? null : get_value(collectionGroupName));
    var tmp_13 = to('storeProductId', storeProductId == null ? null : get_value(storeProductId));
    var tmp_14 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_15 = to('isWeightedProduct', isWeightedProduct == null ? null : get_value_0(isWeightedProduct));
    var tmp_16 = to('productVariantGroupId', productVariantGroupId == null ? null : get_value(productVariantGroupId));
    var tmp_17 = to('productVariationVisualKey', productVariationVisualKey == null ? null : get_value(productVariationVisualKey));
    var tmp_18 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, to('isPaginated', isPaginated == null ? null : get_value_0(isPaginated))]);
    var tmp21_elvis_lhs = productSelectionOrigin == null ? null : productSelectionOrigin.data;
    Event.call(this, 'Product Selected', VOID, VOID, plus(tmp_18, tmp21_elvis_lhs == null ? emptyMap() : tmp21_elvis_lhs));
  }
  function TopSeller() {
    TopSeller_instance = this;
    ProductSelectionOrigin.call(this, 'TopSeller');
  }
  protoOf(TopSeller).toString = function () {
    return 'TopSeller(value=' + this.value + ')';
  };
  var TopSeller_instance;
  function TopSeller_getInstance() {
    if (TopSeller_instance == null)
      new TopSeller();
    return TopSeller_instance;
  }
  function EasyReorder_0(easyReorderScreen) {
    ProductSelectionOrigin.call(this, 'EasyReorder', mapOf_0(to('easyReorderScreen', easyReorderScreen == null ? null : easyReorderScreen.value)));
  }
  protoOf(EasyReorder_0).toString = function () {
    return 'EasyReorder(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function SupercollectionProductsCarousel() {
    SupercollectionProductsCarousel_instance = this;
    ProductSelectionOrigin.call(this, 'SupercollectionProductsCarousel');
  }
  protoOf(SupercollectionProductsCarousel).toString = function () {
    return 'SupercollectionProductsCarousel(value=' + this.value + ')';
  };
  var SupercollectionProductsCarousel_instance;
  function SupercollectionProductsCarousel_getInstance() {
    if (SupercollectionProductsCarousel_instance == null)
      new SupercollectionProductsCarousel();
    return SupercollectionProductsCarousel_instance;
  }
  function Promotions_0() {
    Promotions_instance_0 = this;
    ProductSelectionOrigin.call(this, 'Promotions');
  }
  protoOf(Promotions_0).toString = function () {
    return 'Promotions(value=' + this.value + ')';
  };
  var Promotions_instance_0;
  function Promotions_getInstance_0() {
    if (Promotions_instance_0 == null)
      new Promotions_0();
    return Promotions_instance_0;
  }
  function Search_0(searchId) {
    ProductSelectionOrigin.call(this, 'Search', mapOf_0(to('searchId', searchId == null ? null : get_value(searchId))));
  }
  protoOf(Search_0).toString = function () {
    return 'Search(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Catalogue_1() {
    Catalogue_instance_0 = this;
    ProductSelectionOrigin.call(this, 'Catalogue');
  }
  protoOf(Catalogue_1).toString = function () {
    return 'Catalogue(value=' + this.value + ')';
  };
  var Catalogue_instance_0;
  function Catalogue_getInstance_0() {
    if (Catalogue_instance_0 == null)
      new Catalogue_1();
    return Catalogue_instance_0;
  }
  function HomeWidget_0(widgetId) {
    ProductSelectionOrigin.call(this, 'HomeWidget', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(HomeWidget_0).toString = function () {
    return 'HomeWidget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function DoubleGlovo_0() {
    DoubleGlovo_instance_0 = this;
    ProductSelectionOrigin.call(this, 'DoubleGlovo');
  }
  protoOf(DoubleGlovo_0).toString = function () {
    return 'DoubleGlovo(value=' + this.value + ')';
  };
  var DoubleGlovo_instance_0;
  function DoubleGlovo_getInstance_0() {
    if (DoubleGlovo_instance_0 == null)
      new DoubleGlovo_0();
    return DoubleGlovo_instance_0;
  }
  function InStoreBanner() {
    InStoreBanner_instance = this;
    ProductSelectionOrigin.call(this, 'InStoreBanner');
  }
  protoOf(InStoreBanner).toString = function () {
    return 'InStoreBanner(value=' + this.value + ')';
  };
  var InStoreBanner_instance;
  function InStoreBanner_getInstance() {
    if (InStoreBanner_instance == null)
      new InStoreBanner();
    return InStoreBanner_instance;
  }
  function ProductPageUpsellingCarousel() {
    ProductPageUpsellingCarousel_instance = this;
    ProductSelectionOrigin.call(this, 'ProductPageUpsellingCarousel');
  }
  protoOf(ProductPageUpsellingCarousel).toString = function () {
    return 'ProductPageUpsellingCarousel(value=' + this.value + ')';
  };
  var ProductPageUpsellingCarousel_instance;
  function ProductPageUpsellingCarousel_getInstance() {
    if (ProductPageUpsellingCarousel_instance == null)
      new ProductPageUpsellingCarousel();
    return ProductPageUpsellingCarousel_instance;
  }
  function Collection() {
    Collection_instance = this;
    ProductSelectionOrigin.call(this, 'Collection');
  }
  protoOf(Collection).toString = function () {
    return 'Collection(value=' + this.value + ')';
  };
  var Collection_instance;
  function Collection_getInstance() {
    if (Collection_instance == null)
      new Collection();
    return Collection_instance;
  }
  function CollectionsShoppableBanner() {
    CollectionsShoppableBanner_instance = this;
    ProductSelectionOrigin.call(this, 'CollectionsShoppableBanner');
  }
  protoOf(CollectionsShoppableBanner).toString = function () {
    return 'CollectionsShoppableBanner(value=' + this.value + ')';
  };
  var CollectionsShoppableBanner_instance;
  function CollectionsShoppableBanner_getInstance() {
    if (CollectionsShoppableBanner_instance == null)
      new CollectionsShoppableBanner();
    return CollectionsShoppableBanner_instance;
  }
  function CollectionGroup_0() {
    CollectionGroup_instance_0 = this;
    ProductSelectionOrigin.call(this, 'CollectionGroup');
  }
  protoOf(CollectionGroup_0).toString = function () {
    return 'CollectionGroup(value=' + this.value + ')';
  };
  var CollectionGroup_instance_0;
  function CollectionGroup_getInstance_0() {
    if (CollectionGroup_instance_0 == null)
      new CollectionGroup_0();
    return CollectionGroup_instance_0;
  }
  function ShoppableBanner() {
    ShoppableBanner_instance = this;
    ProductSelectionOrigin.call(this, 'ShoppableBanner');
  }
  protoOf(ShoppableBanner).toString = function () {
    return 'ShoppableBanner(value=' + this.value + ')';
  };
  var ShoppableBanner_instance;
  function ShoppableBanner_getInstance() {
    if (ShoppableBanner_instance == null)
      new ShoppableBanner();
    return ShoppableBanner_instance;
  }
  function SponsoredDeeplink() {
    SponsoredDeeplink_instance = this;
    ProductSelectionOrigin.call(this, 'SponsoredDeeplink');
  }
  protoOf(SponsoredDeeplink).toString = function () {
    return 'SponsoredDeeplink(value=' + this.value + ')';
  };
  var SponsoredDeeplink_instance;
  function SponsoredDeeplink_getInstance() {
    if (SponsoredDeeplink_instance == null)
      new SponsoredDeeplink();
    return SponsoredDeeplink_instance;
  }
  function Widget_2(widgetId, widgetAppLocation) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    ProductSelectionOrigin.call(this, 'Widget', mapOf([tmp, to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation))]));
  }
  protoOf(Widget_2).toString = function () {
    return 'Widget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Cart_2() {
    Cart_instance_2 = this;
    ProductSelectionOrigin.call(this, 'Cart');
  }
  protoOf(Cart_2).toString = function () {
    return 'Cart(value=' + this.value + ')';
  };
  var Cart_instance_2;
  function Cart_getInstance_2() {
    if (Cart_instance_2 == null)
      new Cart_2();
    return Cart_instance_2;
  }
  function Basket_0() {
    Basket_instance_0 = this;
    ProductSelectionOrigin.call(this, 'Basket');
  }
  protoOf(Basket_0).toString = function () {
    return 'Basket(value=' + this.value + ')';
  };
  var Basket_instance_0;
  function Basket_getInstance_0() {
    if (Basket_instance_0 == null)
      new Basket_0();
    return Basket_instance_0;
  }
  function StoreWall() {
    StoreWall_instance = this;
    ProductSelectionOrigin.call(this, 'StoreWall');
  }
  protoOf(StoreWall).toString = function () {
    return 'StoreWall(value=' + this.value + ')';
  };
  var StoreWall_instance;
  function StoreWall_getInstance() {
    if (StoreWall_instance == null)
      new StoreWall();
    return StoreWall_instance;
  }
  function StoreWallNestedDishes_1(filters) {
    filters = filters === VOID ? null : filters;
    ProductSelectionOrigin.call(this, 'StoreWallNestedDishes', mapOf_0(to('filters', filters == null ? null : get_value_2(filters))));
  }
  protoOf(StoreWallNestedDishes_1).toString = function () {
    return 'StoreWallNestedDishes(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function SearchNestedDishes_0(searchId) {
    ProductSelectionOrigin.call(this, 'SearchNestedDishes', mapOf_0(to('searchId', searchId == null ? null : get_value(searchId))));
  }
  protoOf(SearchNestedDishes_0).toString = function () {
    return 'SearchNestedDishes(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function StoreWallMealsUnderXCollection(widgetId, widgetAppLocation) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    ProductSelectionOrigin.call(this, 'StoreWallMealsUnderXCollection', mapOf([tmp, to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation))]));
  }
  protoOf(StoreWallMealsUnderXCollection).toString = function () {
    return 'StoreWallMealsUnderXCollection(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Other_3() {
    Other_instance_3 = this;
    ProductSelectionOrigin.call(this, 'Other');
  }
  protoOf(Other_3).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_3;
  function Other_getInstance_3() {
    if (Other_instance_3 == null)
      new Other_3();
    return Other_instance_3;
  }
  function ProductSelectionOrigin(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(ProductSelectionOrigin).r = function () {
    return this.value;
  };
  protoOf(ProductSelectionOrigin).qa = function () {
    return this.data;
  };
  protoOf(ProductSelectionOrigin).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(ProductSelectionOrigin).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof ProductSelectionOrigin) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Metadata_94() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_94).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_94;
  function Metadata_getInstance_94() {
    return Metadata_instance_94;
  }
  function ProductUpsellPopUpButtonPressed(storeAddressId, productIds, popularProductIds, sponsoredProductIds, hasSponsoredResults, discountedProductIds, storeProductIds, isPrimePromoUpsell, checkboxChecked) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    popularProductIds = popularProductIds === VOID ? null : popularProductIds;
    sponsoredProductIds = sponsoredProductIds === VOID ? null : sponsoredProductIds;
    discountedProductIds = discountedProductIds === VOID ? null : discountedProductIds;
    storeProductIds = storeProductIds === VOID ? null : storeProductIds;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('productIds', productIds == null ? null : get_value_2(productIds));
    var tmp_1 = to('popularProductIds', popularProductIds == null ? null : get_value_2(popularProductIds));
    var tmp_2 = to('sponsoredProductIds', sponsoredProductIds == null ? null : get_value_2(sponsoredProductIds));
    var tmp_3 = to('hasSponsoredResults', hasSponsoredResults == null ? null : get_value_0(hasSponsoredResults));
    var tmp_4 = to('discountedProductIds', discountedProductIds == null ? null : get_value_2(discountedProductIds));
    var tmp_5 = to('storeProductIds', storeProductIds == null ? null : get_value_2(storeProductIds));
    var tmp_6 = to('isPrimePromoUpsell', isPrimePromoUpsell == null ? null : get_value_0(isPrimePromoUpsell));
    Event.call(this, 'Product Upsell Pop-Up Button Pressed', VOID, 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, to('checkboxChecked', checkboxChecked == null ? null : get_value_0(checkboxChecked))]));
  }
  function Metadata_95() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_95).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_95;
  function Metadata_getInstance_95() {
    return Metadata_instance_95;
  }
  function ProductUpsellPopUpScreen(storeAddressId, productIds, mbsFeeShown, popularProductIds, sponsoredProductIds, hasSponsoredResults, discountedProductIds, layoutDesign, storeProductIds, isPrimePromoUpsell) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    popularProductIds = popularProductIds === VOID ? null : popularProductIds;
    sponsoredProductIds = sponsoredProductIds === VOID ? null : sponsoredProductIds;
    discountedProductIds = discountedProductIds === VOID ? null : discountedProductIds;
    layoutDesign = layoutDesign === VOID ? null : layoutDesign;
    storeProductIds = storeProductIds === VOID ? null : storeProductIds;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('productIds', productIds == null ? null : get_value_2(productIds));
    var tmp_1 = to('mbsFeeShown', mbsFeeShown == null ? null : get_value_0(mbsFeeShown));
    var tmp_2 = to('popularProductIds', popularProductIds == null ? null : get_value_2(popularProductIds));
    var tmp_3 = to('sponsoredProductIds', sponsoredProductIds == null ? null : get_value_2(sponsoredProductIds));
    var tmp_4 = to('hasSponsoredResults', hasSponsoredResults == null ? null : get_value_0(hasSponsoredResults));
    var tmp_5 = to('discountedProductIds', discountedProductIds == null ? null : get_value_2(discountedProductIds));
    var tmp_6 = to('layoutDesign', layoutDesign == null ? null : layoutDesign.value);
    var tmp_7 = to('storeProductIds', storeProductIds == null ? null : get_value_2(storeProductIds));
    Screen.call(this, 'Product Upsell Pop-Up Screen', 'CK: Checkout', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, to('isPrimePromoUpsell', isPrimePromoUpsell == null ? null : get_value_0(isPrimePromoUpsell))]));
  }
  function Metadata_96() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_96).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_96;
  function Metadata_getInstance_96() {
    return Metadata_instance_96;
  }
  function ProductUpsellPopUpScreenAttemptToDismiss(storeAddressId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    Event.call(this, 'Product Upsell Pop-Up Screen Attempt to Dismiss', VOID, 'CK: Checkout', mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  function Metadata_97() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_97).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_97;
  function Metadata_getInstance_97() {
    return Metadata_instance_97;
  }
  function ProductUpsellPopUpScreenDismissed(storeAddressId, action) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    action = action === VOID ? null : action;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Product Upsell Pop-Up Screen Dismissed', VOID, 'CK: Checkout', mapOf([tmp, to('action', action == null ? null : action.value)]));
  }
  var ProductUpsellPopUpScreenDismissedAction_DragDown_instance;
  var ProductUpsellPopUpScreenDismissedAction_BackButton_instance;
  function values_63() {
    return [ProductUpsellPopUpScreenDismissedAction_DragDown_getInstance(), ProductUpsellPopUpScreenDismissedAction_BackButton_getInstance()];
  }
  function valueOf_63(value) {
    switch (value) {
      case 'DragDown':
        return ProductUpsellPopUpScreenDismissedAction_DragDown_getInstance();
      case 'BackButton':
        return ProductUpsellPopUpScreenDismissedAction_BackButton_getInstance();
      default:
        ProductUpsellPopUpScreenDismissedAction_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProductUpsellPopUpScreenDismissedAction_entriesInitialized;
  function ProductUpsellPopUpScreenDismissedAction_initEntries() {
    if (ProductUpsellPopUpScreenDismissedAction_entriesInitialized)
      return Unit_instance;
    ProductUpsellPopUpScreenDismissedAction_entriesInitialized = true;
    ProductUpsellPopUpScreenDismissedAction_DragDown_instance = new ProductUpsellPopUpScreenDismissedAction('DragDown', 0, 'DragDown');
    ProductUpsellPopUpScreenDismissedAction_BackButton_instance = new ProductUpsellPopUpScreenDismissedAction('BackButton', 1, 'BackButton');
  }
  function ProductUpsellPopUpScreenDismissedAction(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProductUpsellPopUpScreenDismissedAction).r = function () {
    return this.value;
  };
  function ProductUpsellPopUpScreenDismissedAction_DragDown_getInstance() {
    ProductUpsellPopUpScreenDismissedAction_initEntries();
    return ProductUpsellPopUpScreenDismissedAction_DragDown_instance;
  }
  function ProductUpsellPopUpScreenDismissedAction_BackButton_getInstance() {
    ProductUpsellPopUpScreenDismissedAction_initEntries();
    return ProductUpsellPopUpScreenDismissedAction_BackButton_instance;
  }
  function ProductsSearched(searchType, query, searchId, isAutosuggested, enteredQuery, isRecentSearches, isTrendingSearches, searchSubmissionType) {
    isAutosuggested = isAutosuggested === VOID ? null : isAutosuggested;
    enteredQuery = enteredQuery === VOID ? null : enteredQuery;
    isRecentSearches = isRecentSearches === VOID ? null : isRecentSearches;
    isTrendingSearches = isTrendingSearches === VOID ? null : isTrendingSearches;
    searchSubmissionType = searchSubmissionType === VOID ? null : searchSubmissionType;
    var tmp = to('searchType', searchType == null ? null : searchType.value);
    var tmp_0 = to('query', query == null ? null : get_value(query));
    var tmp_1 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_2 = to('isAutosuggested', isAutosuggested == null ? null : get_value_0(isAutosuggested));
    var tmp_3 = to('enteredQuery', enteredQuery == null ? null : get_value(enteredQuery));
    var tmp_4 = to('isRecentSearches', isRecentSearches == null ? null : get_value_0(isRecentSearches));
    var tmp_5 = to('isTrendingSearches', isTrendingSearches == null ? null : get_value_0(isTrendingSearches));
    var tmp_6 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('searchSubmissionType', searchSubmissionType == null ? null : searchSubmissionType.value)]);
    var tmp9_elvis_lhs = searchType == null ? null : searchType.data;
    var tmp_7 = plus(tmp_6, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs);
    var tmp11_elvis_lhs = searchSubmissionType == null ? null : searchSubmissionType.data;
    Event.call(this, 'Products Searched', VOID, VOID, plus(tmp_7, tmp11_elvis_lhs == null ? emptyMap() : tmp11_elvis_lhs));
  }
  function Profile_1(origin) {
    origin = origin === VOID ? null : origin;
    var tmp = mapOf_0(to('origin', origin == null ? null : origin.value));
    var tmp2_elvis_lhs = origin == null ? null : origin.data;
    Screen.call(this, 'Profile', VOID, plus(tmp, tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs));
  }
  function Metadata_98() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_98).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_98;
  function Metadata_getInstance_98() {
    return Metadata_instance_98;
  }
  function ProfilePrimeIconClicked(subscriptionId) {
    Event.call(this, 'Profile Prime Icon Clicked', VOID, 'GRO: Growth', mapOf_0(to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId))));
  }
  function Metadata_99() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_99).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_99;
  function Metadata_getInstance_99() {
    return Metadata_instance_99;
  }
  function ProfilePrimeIconSeen(subscriptionId) {
    Event.call(this, 'Profile Prime Icon Seen', VOID, 'GRO: Growth', mapOf_0(to('subscriptionId', subscriptionId == null ? null : get_value_1(subscriptionId))));
  }
  var ProfileSection_Orders_instance;
  var ProfileSection_Account_instance;
  var ProfileSection_Prime_instance;
  var ProfileSection_PromoCode_instance;
  var ProfileSection_FAQ_instance;
  var ProfileSection_LogOut_instance;
  var ProfileSection_Mgm_instance;
  function values_64() {
    return [ProfileSection_Orders_getInstance(), ProfileSection_Account_getInstance(), ProfileSection_Prime_getInstance(), ProfileSection_PromoCode_getInstance(), ProfileSection_FAQ_getInstance(), ProfileSection_LogOut_getInstance(), ProfileSection_Mgm_getInstance()];
  }
  function valueOf_64(value) {
    switch (value) {
      case 'Orders':
        return ProfileSection_Orders_getInstance();
      case 'Account':
        return ProfileSection_Account_getInstance();
      case 'Prime':
        return ProfileSection_Prime_getInstance();
      case 'PromoCode':
        return ProfileSection_PromoCode_getInstance();
      case 'FAQ':
        return ProfileSection_FAQ_getInstance();
      case 'LogOut':
        return ProfileSection_LogOut_getInstance();
      case 'Mgm':
        return ProfileSection_Mgm_getInstance();
      default:
        ProfileSection_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ProfileSection_entriesInitialized;
  function ProfileSection_initEntries() {
    if (ProfileSection_entriesInitialized)
      return Unit_instance;
    ProfileSection_entriesInitialized = true;
    ProfileSection_Orders_instance = new ProfileSection('Orders', 0, 'Orders');
    ProfileSection_Account_instance = new ProfileSection('Account', 1, 'Account');
    ProfileSection_Prime_instance = new ProfileSection('Prime', 2, 'Prime');
    ProfileSection_PromoCode_instance = new ProfileSection('PromoCode', 3, 'PromoCode');
    ProfileSection_FAQ_instance = new ProfileSection('FAQ', 4, 'FAQ');
    ProfileSection_LogOut_instance = new ProfileSection('LogOut', 5, 'Logout');
    ProfileSection_Mgm_instance = new ProfileSection('Mgm', 6, 'Mgm');
  }
  function ProfileSection(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ProfileSection).r = function () {
    return this.value;
  };
  function ProfileSection_Orders_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_Orders_instance;
  }
  function ProfileSection_Account_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_Account_instance;
  }
  function ProfileSection_Prime_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_Prime_instance;
  }
  function ProfileSection_PromoCode_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_PromoCode_instance;
  }
  function ProfileSection_FAQ_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_FAQ_instance;
  }
  function ProfileSection_LogOut_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_LogOut_instance;
  }
  function ProfileSection_Mgm_getInstance() {
    ProfileSection_initEntries();
    return ProfileSection_Mgm_instance;
  }
  function Metadata_100() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_100).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_100;
  function Metadata_getInstance_100() {
    return Metadata_instance_100;
  }
  function PromoCode() {
    Screen.call(this, 'Promo Code', 'GRO: Growth');
  }
  function PromotionShown(promotionId, storeAddressId, listedDeliveryFee, promotionType, promotionSource, promotionStoreOrigin, feesPricingCalculationId) {
    var tmp = to('promotionId', promotionId == null ? null : get_value_1(promotionId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('listedDeliveryFee', listedDeliveryFee == null ? null : get_value_1(listedDeliveryFee));
    var tmp_2 = to('promotionType', promotionType == null ? null : promotionType.value);
    var tmp_3 = to('promotionSource', promotionSource == null ? null : promotionSource.value);
    var tmp_4 = to('promotionStoreOrigin', promotionStoreOrigin == null ? null : promotionStoreOrigin.value);
    var tmp_5 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('feesPricingCalculationId', feesPricingCalculationId == null ? null : get_value(feesPricingCalculationId))]);
    var tmp8_elvis_lhs = promotionType == null ? null : promotionType.data;
    Event.call(this, 'Promotion Shown', VOID, VOID, plus(tmp_5, tmp8_elvis_lhs == null ? emptyMap() : tmp8_elvis_lhs));
  }
  var PromotionSource_UUFD_instance;
  var PromotionSource_StorePromotion_instance;
  var PromotionSource_PromoCode_instance;
  var PromotionSource_Segmentation_instance;
  function values_65() {
    return [PromotionSource_UUFD_getInstance(), PromotionSource_StorePromotion_getInstance(), PromotionSource_PromoCode_getInstance(), PromotionSource_Segmentation_getInstance()];
  }
  function valueOf_65(value) {
    switch (value) {
      case 'UUFD':
        return PromotionSource_UUFD_getInstance();
      case 'StorePromotion':
        return PromotionSource_StorePromotion_getInstance();
      case 'PromoCode':
        return PromotionSource_PromoCode_getInstance();
      case 'Segmentation':
        return PromotionSource_Segmentation_getInstance();
      default:
        PromotionSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PromotionSource_entriesInitialized;
  function PromotionSource_initEntries() {
    if (PromotionSource_entriesInitialized)
      return Unit_instance;
    PromotionSource_entriesInitialized = true;
    PromotionSource_UUFD_instance = new PromotionSource('UUFD', 0, 'UUFD');
    PromotionSource_StorePromotion_instance = new PromotionSource('StorePromotion', 1, 'StorePromotion');
    PromotionSource_PromoCode_instance = new PromotionSource('PromoCode', 2, '2x1');
    PromotionSource_Segmentation_instance = new PromotionSource('Segmentation', 3, 'Segmentation');
  }
  function PromotionSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PromotionSource).r = function () {
    return this.value;
  };
  function PromotionSource_UUFD_getInstance() {
    PromotionSource_initEntries();
    return PromotionSource_UUFD_instance;
  }
  function PromotionSource_StorePromotion_getInstance() {
    PromotionSource_initEntries();
    return PromotionSource_StorePromotion_instance;
  }
  function PromotionSource_PromoCode_getInstance() {
    PromotionSource_initEntries();
    return PromotionSource_PromoCode_instance;
  }
  function PromotionSource_Segmentation_getInstance() {
    PromotionSource_initEntries();
    return PromotionSource_Segmentation_instance;
  }
  var PromotionStoreOrigin_StoreWall_instance;
  var PromotionStoreOrigin_StoreScreen_instance;
  var PromotionStoreOrigin_Checkout_instance;
  function values_66() {
    return [PromotionStoreOrigin_StoreWall_getInstance(), PromotionStoreOrigin_StoreScreen_getInstance(), PromotionStoreOrigin_Checkout_getInstance()];
  }
  function valueOf_66(value) {
    switch (value) {
      case 'StoreWall':
        return PromotionStoreOrigin_StoreWall_getInstance();
      case 'StoreScreen':
        return PromotionStoreOrigin_StoreScreen_getInstance();
      case 'Checkout':
        return PromotionStoreOrigin_Checkout_getInstance();
      default:
        PromotionStoreOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PromotionStoreOrigin_entriesInitialized;
  function PromotionStoreOrigin_initEntries() {
    if (PromotionStoreOrigin_entriesInitialized)
      return Unit_instance;
    PromotionStoreOrigin_entriesInitialized = true;
    PromotionStoreOrigin_StoreWall_instance = new PromotionStoreOrigin('StoreWall', 0, 'StoreWall');
    PromotionStoreOrigin_StoreScreen_instance = new PromotionStoreOrigin('StoreScreen', 1, 'StoreScreen');
    PromotionStoreOrigin_Checkout_instance = new PromotionStoreOrigin('Checkout', 2, 'Checkout');
  }
  function PromotionStoreOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PromotionStoreOrigin).r = function () {
    return this.value;
  };
  function PromotionStoreOrigin_StoreWall_getInstance() {
    PromotionStoreOrigin_initEntries();
    return PromotionStoreOrigin_StoreWall_instance;
  }
  function PromotionStoreOrigin_StoreScreen_getInstance() {
    PromotionStoreOrigin_initEntries();
    return PromotionStoreOrigin_StoreScreen_instance;
  }
  function PromotionStoreOrigin_Checkout_getInstance() {
    PromotionStoreOrigin_initEntries();
    return PromotionStoreOrigin_Checkout_instance;
  }
  function ProductDiscount(promotionDiscountPercent) {
    PromotionType.call(this, 'ProductDiscount', mapOf_0(to('promotionDiscountPercent', promotionDiscountPercent == null ? null : get_value_1(promotionDiscountPercent))));
  }
  protoOf(ProductDiscount).toString = function () {
    return 'ProductDiscount(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function DeliveryFeeDiscount(discountedDeliveryFee) {
    PromotionType.call(this, 'DeliveryFeeDiscount', mapOf_0(to('discountedDeliveryFee', discountedDeliveryFee == null ? null : get_value_1(discountedDeliveryFee))));
  }
  protoOf(DeliveryFeeDiscount).toString = function () {
    return 'DeliveryFeeDiscount(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function TwoForOne() {
    TwoForOne_instance = this;
    PromotionType.call(this, 'TwoForOne');
  }
  protoOf(TwoForOne).toString = function () {
    return 'TwoForOne(value=' + this.value + ')';
  };
  var TwoForOne_instance;
  function TwoForOne_getInstance() {
    if (TwoForOne_instance == null)
      new TwoForOne();
    return TwoForOne_instance;
  }
  function PromotionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(PromotionType).r = function () {
    return this.value;
  };
  protoOf(PromotionType).qa = function () {
    return this.data;
  };
  protoOf(PromotionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(PromotionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof PromotionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var RankingType_MO_instance;
  var RankingType_Legacy_instance;
  var RankingType_Hyperlocal_instance;
  var RankingType_NewUserRanking_instance;
  function values_67() {
    return [RankingType_MO_getInstance(), RankingType_Legacy_getInstance(), RankingType_Hyperlocal_getInstance(), RankingType_NewUserRanking_getInstance()];
  }
  function valueOf_67(value) {
    switch (value) {
      case 'MO':
        return RankingType_MO_getInstance();
      case 'Legacy':
        return RankingType_Legacy_getInstance();
      case 'Hyperlocal':
        return RankingType_Hyperlocal_getInstance();
      case 'NewUserRanking':
        return RankingType_NewUserRanking_getInstance();
      default:
        RankingType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RankingType_entriesInitialized;
  function RankingType_initEntries() {
    if (RankingType_entriesInitialized)
      return Unit_instance;
    RankingType_entriesInitialized = true;
    RankingType_MO_instance = new RankingType('MO', 0, 'MO');
    RankingType_Legacy_instance = new RankingType('Legacy', 1, 'Legacy');
    RankingType_Hyperlocal_instance = new RankingType('Hyperlocal', 2, 'Hyperlocal');
    RankingType_NewUserRanking_instance = new RankingType('NewUserRanking', 3, 'NewUserRanking');
  }
  function RankingType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(RankingType).r = function () {
    return this.value;
  };
  function RankingType_MO_getInstance() {
    RankingType_initEntries();
    return RankingType_MO_instance;
  }
  function RankingType_Legacy_getInstance() {
    RankingType_initEntries();
    return RankingType_Legacy_instance;
  }
  function RankingType_Hyperlocal_getInstance() {
    RankingType_initEntries();
    return RankingType_Hyperlocal_instance;
  }
  function RankingType_NewUserRanking_getInstance() {
    RankingType_initEntries();
    return RankingType_NewUserRanking_instance;
  }
  var RecoveryOrigin_BasketEntryPoint_instance;
  var RecoveryOrigin_StoreView_instance;
  var RecoveryOrigin_ProductDetailsView_instance;
  function values_68() {
    return [RecoveryOrigin_BasketEntryPoint_getInstance(), RecoveryOrigin_StoreView_getInstance(), RecoveryOrigin_ProductDetailsView_getInstance()];
  }
  function valueOf_68(value) {
    switch (value) {
      case 'BasketEntryPoint':
        return RecoveryOrigin_BasketEntryPoint_getInstance();
      case 'StoreView':
        return RecoveryOrigin_StoreView_getInstance();
      case 'ProductDetailsView':
        return RecoveryOrigin_ProductDetailsView_getInstance();
      default:
        RecoveryOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RecoveryOrigin_entriesInitialized;
  function RecoveryOrigin_initEntries() {
    if (RecoveryOrigin_entriesInitialized)
      return Unit_instance;
    RecoveryOrigin_entriesInitialized = true;
    RecoveryOrigin_BasketEntryPoint_instance = new RecoveryOrigin('BasketEntryPoint', 0, 'Basket Entry Point');
    RecoveryOrigin_StoreView_instance = new RecoveryOrigin('StoreView', 1, 'Store View');
    RecoveryOrigin_ProductDetailsView_instance = new RecoveryOrigin('ProductDetailsView', 2, 'Product Details View');
  }
  function RecoveryOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(RecoveryOrigin).r = function () {
    return this.value;
  };
  function RecoveryOrigin_BasketEntryPoint_getInstance() {
    RecoveryOrigin_initEntries();
    return RecoveryOrigin_BasketEntryPoint_instance;
  }
  function RecoveryOrigin_StoreView_getInstance() {
    RecoveryOrigin_initEntries();
    return RecoveryOrigin_StoreView_instance;
  }
  function RecoveryOrigin_ProductDetailsView_getInstance() {
    RecoveryOrigin_initEntries();
    return RecoveryOrigin_ProductDetailsView_instance;
  }
  function Metadata_101() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_101).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_101;
  function Metadata_getInstance_101() {
    return Metadata_instance_101;
  }
  function ReorderButtonPressed(originalOrderId, origin, storeId, storeAddressId) {
    origin = origin === VOID ? null : origin;
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('originalOrderId', originalOrderId == null ? null : get_value_1(originalOrderId));
    var tmp_0 = to('origin', origin == null ? null : origin.value);
    var tmp_1 = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Reorder button pressed', VOID, 'CS: Customer Solutions', mapOf([tmp, tmp_0, tmp_1, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  var ReorderOrigin_Orders_instance;
  var ReorderOrigin_OrderDetails_instance;
  var ReorderOrigin_ReorderCarousel_instance;
  function values_69() {
    return [ReorderOrigin_Orders_getInstance(), ReorderOrigin_OrderDetails_getInstance(), ReorderOrigin_ReorderCarousel_getInstance()];
  }
  function valueOf_69(value) {
    switch (value) {
      case 'Orders':
        return ReorderOrigin_Orders_getInstance();
      case 'OrderDetails':
        return ReorderOrigin_OrderDetails_getInstance();
      case 'ReorderCarousel':
        return ReorderOrigin_ReorderCarousel_getInstance();
      default:
        ReorderOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ReorderOrigin_entriesInitialized;
  function ReorderOrigin_initEntries() {
    if (ReorderOrigin_entriesInitialized)
      return Unit_instance;
    ReorderOrigin_entriesInitialized = true;
    ReorderOrigin_Orders_instance = new ReorderOrigin('Orders', 0, 'Orders');
    ReorderOrigin_OrderDetails_instance = new ReorderOrigin('OrderDetails', 1, 'OrderDetails');
    ReorderOrigin_ReorderCarousel_instance = new ReorderOrigin('ReorderCarousel', 2, 'ReorderCarousel');
  }
  function ReorderOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ReorderOrigin).r = function () {
    return this.value;
  };
  function ReorderOrigin_Orders_getInstance() {
    ReorderOrigin_initEntries();
    return ReorderOrigin_Orders_instance;
  }
  function ReorderOrigin_OrderDetails_getInstance() {
    ReorderOrigin_initEntries();
    return ReorderOrigin_OrderDetails_instance;
  }
  function ReorderOrigin_ReorderCarousel_getInstance() {
    ReorderOrigin_initEntries();
    return ReorderOrigin_ReorderCarousel_instance;
  }
  function ResetYourAccountStarted(phone) {
    Event.call(this, 'Reset Your Account Started', VOID, VOID, mapOf_0(to('phone', phone == null ? null : get_value(phone))));
  }
  function ReturnPolicyBannerClicked(location) {
    Event.call(this, 'Return Policy Banner Clicked', VOID, VOID, mapOf_0(to('location', location == null ? null : location.value)));
  }
  function ReturnPolicyBannerImpression(location) {
    Event.call(this, 'Return Policy Banner Impression', VOID, VOID, mapOf_0(to('location', location == null ? null : location.value)));
  }
  var ReturnPolicyOrigin_StorePage_instance;
  var ReturnPolicyOrigin_ProductCustomizationScreen_instance;
  var ReturnPolicyOrigin_ProductDetailsScreen_instance;
  function values_70() {
    return [ReturnPolicyOrigin_StorePage_getInstance(), ReturnPolicyOrigin_ProductCustomizationScreen_getInstance(), ReturnPolicyOrigin_ProductDetailsScreen_getInstance()];
  }
  function valueOf_70(value) {
    switch (value) {
      case 'StorePage':
        return ReturnPolicyOrigin_StorePage_getInstance();
      case 'ProductCustomizationScreen':
        return ReturnPolicyOrigin_ProductCustomizationScreen_getInstance();
      case 'ProductDetailsScreen':
        return ReturnPolicyOrigin_ProductDetailsScreen_getInstance();
      default:
        ReturnPolicyOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ReturnPolicyOrigin_entriesInitialized;
  function ReturnPolicyOrigin_initEntries() {
    if (ReturnPolicyOrigin_entriesInitialized)
      return Unit_instance;
    ReturnPolicyOrigin_entriesInitialized = true;
    ReturnPolicyOrigin_StorePage_instance = new ReturnPolicyOrigin('StorePage', 0, 'STORE_PAGE');
    ReturnPolicyOrigin_ProductCustomizationScreen_instance = new ReturnPolicyOrigin('ProductCustomizationScreen', 1, 'PRODUCT_CUSTOMIZATION_SCREEN');
    ReturnPolicyOrigin_ProductDetailsScreen_instance = new ReturnPolicyOrigin('ProductDetailsScreen', 2, 'PRODUCT_DETAILS_SCREEN');
  }
  function ReturnPolicyOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ReturnPolicyOrigin).r = function () {
    return this.value;
  };
  function ReturnPolicyOrigin_StorePage_getInstance() {
    ReturnPolicyOrigin_initEntries();
    return ReturnPolicyOrigin_StorePage_instance;
  }
  function ReturnPolicyOrigin_ProductCustomizationScreen_getInstance() {
    ReturnPolicyOrigin_initEntries();
    return ReturnPolicyOrigin_ProductCustomizationScreen_instance;
  }
  function ReturnPolicyOrigin_ProductDetailsScreen_getInstance() {
    ReturnPolicyOrigin_initEntries();
    return ReturnPolicyOrigin_ProductDetailsScreen_instance;
  }
  var ReviewCollectionVersionType_Order_instance;
  var ReviewCollectionVersionType_NoRatingOrder_instance;
  var ReviewCollectionVersionType_Product_instance;
  var ReviewCollectionVersionType_IndividualProduct_instance;
  var ReviewCollectionVersionType_Control_instance;
  function values_71() {
    return [ReviewCollectionVersionType_Order_getInstance(), ReviewCollectionVersionType_NoRatingOrder_getInstance(), ReviewCollectionVersionType_Product_getInstance(), ReviewCollectionVersionType_IndividualProduct_getInstance(), ReviewCollectionVersionType_Control_getInstance()];
  }
  function valueOf_71(value) {
    switch (value) {
      case 'Order':
        return ReviewCollectionVersionType_Order_getInstance();
      case 'NoRatingOrder':
        return ReviewCollectionVersionType_NoRatingOrder_getInstance();
      case 'Product':
        return ReviewCollectionVersionType_Product_getInstance();
      case 'IndividualProduct':
        return ReviewCollectionVersionType_IndividualProduct_getInstance();
      case 'Control':
        return ReviewCollectionVersionType_Control_getInstance();
      default:
        ReviewCollectionVersionType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var ReviewCollectionVersionType_entriesInitialized;
  function ReviewCollectionVersionType_initEntries() {
    if (ReviewCollectionVersionType_entriesInitialized)
      return Unit_instance;
    ReviewCollectionVersionType_entriesInitialized = true;
    ReviewCollectionVersionType_Order_instance = new ReviewCollectionVersionType('Order', 0, 'Order');
    ReviewCollectionVersionType_NoRatingOrder_instance = new ReviewCollectionVersionType('NoRatingOrder', 1, 'NoRatingOrder');
    ReviewCollectionVersionType_Product_instance = new ReviewCollectionVersionType('Product', 2, 'Product');
    ReviewCollectionVersionType_IndividualProduct_instance = new ReviewCollectionVersionType('IndividualProduct', 3, 'IndividualProduct');
    ReviewCollectionVersionType_Control_instance = new ReviewCollectionVersionType('Control', 4, 'Control');
  }
  function ReviewCollectionVersionType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(ReviewCollectionVersionType).r = function () {
    return this.value;
  };
  function ReviewCollectionVersionType_Order_getInstance() {
    ReviewCollectionVersionType_initEntries();
    return ReviewCollectionVersionType_Order_instance;
  }
  function ReviewCollectionVersionType_NoRatingOrder_getInstance() {
    ReviewCollectionVersionType_initEntries();
    return ReviewCollectionVersionType_NoRatingOrder_instance;
  }
  function ReviewCollectionVersionType_Product_getInstance() {
    ReviewCollectionVersionType_initEntries();
    return ReviewCollectionVersionType_Product_instance;
  }
  function ReviewCollectionVersionType_IndividualProduct_getInstance() {
    ReviewCollectionVersionType_initEntries();
    return ReviewCollectionVersionType_IndividualProduct_instance;
  }
  function ReviewCollectionVersionType_Control_getInstance() {
    ReviewCollectionVersionType_initEntries();
    return ReviewCollectionVersionType_Control_instance;
  }
  var RootContent_CollectionGroups_instance;
  var RootContent_Collections_instance;
  var RootContent_Products_instance;
  function values_72() {
    return [RootContent_CollectionGroups_getInstance(), RootContent_Collections_getInstance(), RootContent_Products_getInstance()];
  }
  function valueOf_72(value) {
    switch (value) {
      case 'CollectionGroups':
        return RootContent_CollectionGroups_getInstance();
      case 'Collections':
        return RootContent_Collections_getInstance();
      case 'Products':
        return RootContent_Products_getInstance();
      default:
        RootContent_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var RootContent_entriesInitialized;
  function RootContent_initEntries() {
    if (RootContent_entriesInitialized)
      return Unit_instance;
    RootContent_entriesInitialized = true;
    RootContent_CollectionGroups_instance = new RootContent('CollectionGroups', 0, 'Collection Groups');
    RootContent_Collections_instance = new RootContent('Collections', 1, 'Collections');
    RootContent_Products_instance = new RootContent('Products', 2, 'Products');
  }
  function RootContent(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(RootContent).r = function () {
    return this.value;
  };
  function RootContent_CollectionGroups_getInstance() {
    RootContent_initEntries();
    return RootContent_CollectionGroups_instance;
  }
  function RootContent_Collections_getInstance() {
    RootContent_initEntries();
    return RootContent_Collections_instance;
  }
  function RootContent_Products_getInstance() {
    RootContent_initEntries();
    return RootContent_Products_instance;
  }
  function SearchAutosuggestionsShown(autosuggestedQueries, enteredQuery, searchType) {
    searchType = searchType === VOID ? null : searchType;
    var tmp = to('autosuggestedQueries', autosuggestedQueries == null ? null : get_value_2(autosuggestedQueries));
    var tmp_0 = to('enteredQuery', enteredQuery == null ? null : get_value(enteredQuery));
    var tmp_1 = mapOf([tmp, tmp_0, to('searchType', searchType == null ? null : searchType.value)]);
    var tmp4_elvis_lhs = searchType == null ? null : searchType.data;
    Event.call(this, 'Search Autosuggestions Shown', VOID, VOID, plus(tmp_1, tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs));
  }
  var SearchOrigin_Collections_instance;
  var SearchOrigin_CollectionGroups_instance;
  var SearchOrigin_Products_instance;
  var SearchOrigin_External_instance;
  function values_73() {
    return [SearchOrigin_Collections_getInstance(), SearchOrigin_CollectionGroups_getInstance(), SearchOrigin_Products_getInstance(), SearchOrigin_External_getInstance()];
  }
  function valueOf_73(value) {
    switch (value) {
      case 'Collections':
        return SearchOrigin_Collections_getInstance();
      case 'CollectionGroups':
        return SearchOrigin_CollectionGroups_getInstance();
      case 'Products':
        return SearchOrigin_Products_getInstance();
      case 'External':
        return SearchOrigin_External_getInstance();
      default:
        SearchOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SearchOrigin_entriesInitialized;
  function SearchOrigin_initEntries() {
    if (SearchOrigin_entriesInitialized)
      return Unit_instance;
    SearchOrigin_entriesInitialized = true;
    SearchOrigin_Collections_instance = new SearchOrigin('Collections', 0, 'Collections');
    SearchOrigin_CollectionGroups_instance = new SearchOrigin('CollectionGroups', 1, 'CollectionGroups');
    SearchOrigin_Products_instance = new SearchOrigin('Products', 2, 'Products');
    SearchOrigin_External_instance = new SearchOrigin('External', 3, 'External');
  }
  function SearchOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SearchOrigin).r = function () {
    return this.value;
  };
  function SearchOrigin_Collections_getInstance() {
    SearchOrigin_initEntries();
    return SearchOrigin_Collections_instance;
  }
  function SearchOrigin_CollectionGroups_getInstance() {
    SearchOrigin_initEntries();
    return SearchOrigin_CollectionGroups_instance;
  }
  function SearchOrigin_Products_getInstance() {
    SearchOrigin_initEntries();
    return SearchOrigin_Products_instance;
  }
  function SearchOrigin_External_getInstance() {
    SearchOrigin_initEntries();
    return SearchOrigin_External_instance;
  }
  var SearchSubVertical_All_instance;
  var SearchSubVertical_Restaurants_instance;
  var SearchSubVertical_Groceries_instance;
  var SearchSubVertical_Shops_instance;
  var SearchSubVertical_Health_instance;
  var SearchSubVertical_Smoking_instance;
  function values_74() {
    return [SearchSubVertical_All_getInstance(), SearchSubVertical_Restaurants_getInstance(), SearchSubVertical_Groceries_getInstance(), SearchSubVertical_Shops_getInstance(), SearchSubVertical_Health_getInstance(), SearchSubVertical_Smoking_getInstance()];
  }
  function valueOf_74(value) {
    switch (value) {
      case 'All':
        return SearchSubVertical_All_getInstance();
      case 'Restaurants':
        return SearchSubVertical_Restaurants_getInstance();
      case 'Groceries':
        return SearchSubVertical_Groceries_getInstance();
      case 'Shops':
        return SearchSubVertical_Shops_getInstance();
      case 'Health':
        return SearchSubVertical_Health_getInstance();
      case 'Smoking':
        return SearchSubVertical_Smoking_getInstance();
      default:
        SearchSubVertical_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SearchSubVertical_entriesInitialized;
  function SearchSubVertical_initEntries() {
    if (SearchSubVertical_entriesInitialized)
      return Unit_instance;
    SearchSubVertical_entriesInitialized = true;
    SearchSubVertical_All_instance = new SearchSubVertical('All', 0, 'All');
    SearchSubVertical_Restaurants_instance = new SearchSubVertical('Restaurants', 1, 'Restaurants');
    SearchSubVertical_Groceries_instance = new SearchSubVertical('Groceries', 2, 'Groceries');
    SearchSubVertical_Shops_instance = new SearchSubVertical('Shops', 3, 'Shops');
    SearchSubVertical_Health_instance = new SearchSubVertical('Health', 4, 'Health');
    SearchSubVertical_Smoking_instance = new SearchSubVertical('Smoking', 5, 'Smoking');
  }
  function SearchSubVertical(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SearchSubVertical).r = function () {
    return this.value;
  };
  function SearchSubVertical_All_getInstance() {
    SearchSubVertical_initEntries();
    return SearchSubVertical_All_instance;
  }
  function SearchSubVertical_Restaurants_getInstance() {
    SearchSubVertical_initEntries();
    return SearchSubVertical_Restaurants_instance;
  }
  function SearchSubVertical_Groceries_getInstance() {
    SearchSubVertical_initEntries();
    return SearchSubVertical_Groceries_instance;
  }
  function SearchSubVertical_Shops_getInstance() {
    SearchSubVertical_initEntries();
    return SearchSubVertical_Shops_instance;
  }
  function SearchSubVertical_Health_getInstance() {
    SearchSubVertical_initEntries();
    return SearchSubVertical_Health_instance;
  }
  function SearchSubVertical_Smoking_getInstance() {
    SearchSubVertical_initEntries();
    return SearchSubVertical_Smoking_instance;
  }
  function Typed() {
    Typed_instance = this;
    SearchSubmissionType.call(this, 'Typed');
  }
  protoOf(Typed).toString = function () {
    return 'Typed(value=' + this.value + ')';
  };
  var Typed_instance;
  function Typed_getInstance() {
    if (Typed_instance == null)
      new Typed();
    return Typed_instance;
  }
  function AutoSuggested(position) {
    SearchSubmissionType.call(this, 'Auto-Suggested', mapOf_0(to('position', position == null ? null : get_value_1(position))));
  }
  protoOf(AutoSuggested).toString = function () {
    return 'AutoSuggested(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function RecentSearch(position) {
    SearchSubmissionType.call(this, 'Recent Search', mapOf_0(to('position', position == null ? null : get_value_1(position))));
  }
  protoOf(RecentSearch).toString = function () {
    return 'RecentSearch(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function TrendingSearch(position) {
    SearchSubmissionType.call(this, 'Trending Search', mapOf_0(to('position', position == null ? null : get_value_1(position))));
  }
  protoOf(TrendingSearch).toString = function () {
    return 'TrendingSearch(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Category_0() {
    Category_instance = this;
    SearchSubmissionType.call(this, 'Category Type Selected');
  }
  protoOf(Category_0).toString = function () {
    return 'Category(value=' + this.value + ')';
  };
  var Category_instance;
  function Category_getInstance() {
    if (Category_instance == null)
      new Category_0();
    return Category_instance;
  }
  function FilterSelected() {
    FilterSelected_instance = this;
    SearchSubmissionType.call(this, 'Filter Selected');
  }
  protoOf(FilterSelected).toString = function () {
    return 'FilterSelected(value=' + this.value + ')';
  };
  var FilterSelected_instance;
  function FilterSelected_getInstance() {
    if (FilterSelected_instance == null)
      new FilterSelected();
    return FilterSelected_instance;
  }
  function SearchShowAllButton_0() {
    SearchShowAllButton_instance_0 = this;
    SearchSubmissionType.call(this, 'Search Show All Button');
  }
  protoOf(SearchShowAllButton_0).toString = function () {
    return 'SearchShowAllButton(value=' + this.value + ')';
  };
  var SearchShowAllButton_instance_0;
  function SearchShowAllButton_getInstance_0() {
    if (SearchShowAllButton_instance_0 == null)
      new SearchShowAllButton_0();
    return SearchShowAllButton_instance_0;
  }
  function SearchSubmissionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(SearchSubmissionType).r = function () {
    return this.value;
  };
  protoOf(SearchSubmissionType).qa = function () {
    return this.data;
  };
  protoOf(SearchSubmissionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(SearchSubmissionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof SearchSubmissionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Global() {
    Global_instance = this;
    SearchType.call(this, 'Global');
  }
  protoOf(Global).toString = function () {
    return 'Global(value=' + this.value + ')';
  };
  var Global_instance;
  function Global_getInstance() {
    if (Global_instance == null)
      new Global();
    return Global_instance;
  }
  function CategoryGroup_1(categoryGroupId) {
    SearchType.call(this, 'Category Group', mapOf_0(to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))));
  }
  protoOf(CategoryGroup_1).toString = function () {
    return 'CategoryGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Category_1(categoryId, appliedFilter, appliedHighlightId, appliedSortingId) {
    appliedFilter = appliedFilter === VOID ? null : appliedFilter;
    appliedHighlightId = appliedHighlightId === VOID ? null : appliedHighlightId;
    appliedSortingId = appliedSortingId === VOID ? null : appliedSortingId;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('appliedFilter', appliedFilter == null ? null : get_value(appliedFilter));
    var tmp_1 = to('appliedHighlightId', appliedHighlightId == null ? null : get_value_1(appliedHighlightId));
    SearchType.call(this, 'Category', mapOf([tmp, tmp_0, tmp_1, to('appliedSortingId', appliedSortingId == null ? null : get_value_1(appliedSortingId))]));
  }
  protoOf(Category_1).toString = function () {
    return 'Category(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Store_1(categoryId, storeAddressId, searchOrigin) {
    categoryId = categoryId === VOID ? null : categoryId;
    searchOrigin = searchOrigin === VOID ? null : searchOrigin;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    SearchType.call(this, 'Store', mapOf([tmp, tmp_0, to('searchOrigin', searchOrigin == null ? null : searchOrigin.value)]));
  }
  protoOf(Store_1).toString = function () {
    return 'Store(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function StoreGroup(storeGroupId, appliedFilter, appliedHighlightId, appliedSortingId) {
    appliedFilter = appliedFilter === VOID ? null : appliedFilter;
    appliedHighlightId = appliedHighlightId === VOID ? null : appliedHighlightId;
    appliedSortingId = appliedSortingId === VOID ? null : appliedSortingId;
    var tmp = to('storeGroupId', storeGroupId == null ? null : get_value_1(storeGroupId));
    var tmp_0 = to('appliedFilter', appliedFilter == null ? null : get_value(appliedFilter));
    var tmp_1 = to('appliedHighlightId', appliedHighlightId == null ? null : get_value_1(appliedHighlightId));
    SearchType.call(this, 'Store Group', mapOf([tmp, tmp_0, tmp_1, to('appliedSortingId', appliedSortingId == null ? null : get_value_1(appliedSortingId))]));
  }
  protoOf(StoreGroup).toString = function () {
    return 'StoreGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedGroup_0(feedGroupId) {
    SearchType.call(this, 'Feed Group', mapOf_0(to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId))));
  }
  protoOf(FeedGroup_0).toString = function () {
    return 'FeedGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function SearchType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(SearchType).r = function () {
    return this.value;
  };
  protoOf(SearchType).qa = function () {
    return this.data;
  };
  protoOf(SearchType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(SearchType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof SearchType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function SeenFilters(userTypes, cityTypes, types, sortings, personalizedFilters) {
    types = types === VOID ? null : types;
    sortings = sortings === VOID ? null : sortings;
    personalizedFilters = personalizedFilters === VOID ? null : personalizedFilters;
    var tmp = to('userTypes', userTypes == null ? null : get_value_2(userTypes));
    var tmp_0 = to('cityTypes', cityTypes == null ? null : get_value_2(cityTypes));
    var tmp_1 = to('types', types == null ? null : get_value_2(types));
    var tmp_2 = to('sortings', sortings == null ? null : get_value_2(sortings));
    Event.call(this, 'Seen Filters', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, to('personalizedFilters', personalizedFilters == null ? null : get_value_2(personalizedFilters))]));
  }
  function SessionLocationSet() {
    Event.call(this, 'Session Location Set');
  }
  function SignInButtonClicked(source) {
    Event.call(this, 'Sign In Button Clicked', VOID, VOID, mapOf_0(to('source', source == null ? null : source.value)));
  }
  function SignInLanding(origin) {
    Screen.call(this, 'Sign In Landing', VOID, mapOf_0(to('origin', origin == null ? null : origin.value)));
  }
  var SignInLandingOrigin_Launch_instance;
  var SignInLandingOrigin_Other_instance;
  function values_75() {
    return [SignInLandingOrigin_Launch_getInstance(), SignInLandingOrigin_Other_getInstance()];
  }
  function valueOf_75(value) {
    switch (value) {
      case 'Launch':
        return SignInLandingOrigin_Launch_getInstance();
      case 'Other':
        return SignInLandingOrigin_Other_getInstance();
      default:
        SignInLandingOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SignInLandingOrigin_entriesInitialized;
  function SignInLandingOrigin_initEntries() {
    if (SignInLandingOrigin_entriesInitialized)
      return Unit_instance;
    SignInLandingOrigin_entriesInitialized = true;
    SignInLandingOrigin_Launch_instance = new SignInLandingOrigin('Launch', 0, 'Launch');
    SignInLandingOrigin_Other_instance = new SignInLandingOrigin('Other', 1, 'Other');
  }
  function SignInLandingOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SignInLandingOrigin).r = function () {
    return this.value;
  };
  function SignInLandingOrigin_Launch_getInstance() {
    SignInLandingOrigin_initEntries();
    return SignInLandingOrigin_Launch_instance;
  }
  function SignInLandingOrigin_Other_getInstance() {
    SignInLandingOrigin_initEntries();
    return SignInLandingOrigin_Other_instance;
  }
  var SignInSource_Email_instance;
  var SignInSource_Facebook_instance;
  var SignInSource_Apple_instance;
  var SignInSource_Google_instance;
  var SignInSource_Phone_instance;
  function values_76() {
    return [SignInSource_Email_getInstance(), SignInSource_Facebook_getInstance(), SignInSource_Apple_getInstance(), SignInSource_Google_getInstance(), SignInSource_Phone_getInstance()];
  }
  function valueOf_76(value) {
    switch (value) {
      case 'Email':
        return SignInSource_Email_getInstance();
      case 'Facebook':
        return SignInSource_Facebook_getInstance();
      case 'Apple':
        return SignInSource_Apple_getInstance();
      case 'Google':
        return SignInSource_Google_getInstance();
      case 'Phone':
        return SignInSource_Phone_getInstance();
      default:
        SignInSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SignInSource_entriesInitialized;
  function SignInSource_initEntries() {
    if (SignInSource_entriesInitialized)
      return Unit_instance;
    SignInSource_entriesInitialized = true;
    SignInSource_Email_instance = new SignInSource('Email', 0, 'Email');
    SignInSource_Facebook_instance = new SignInSource('Facebook', 1, 'Facebook');
    SignInSource_Apple_instance = new SignInSource('Apple', 2, 'Apple');
    SignInSource_Google_instance = new SignInSource('Google', 3, 'Google');
    SignInSource_Phone_instance = new SignInSource('Phone', 4, 'Phone');
  }
  function SignInSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SignInSource).r = function () {
    return this.value;
  };
  function SignInSource_Email_getInstance() {
    SignInSource_initEntries();
    return SignInSource_Email_instance;
  }
  function SignInSource_Facebook_getInstance() {
    SignInSource_initEntries();
    return SignInSource_Facebook_instance;
  }
  function SignInSource_Apple_getInstance() {
    SignInSource_initEntries();
    return SignInSource_Apple_instance;
  }
  function SignInSource_Google_getInstance() {
    SignInSource_initEntries();
    return SignInSource_Google_instance;
  }
  function SignInSource_Phone_getInstance() {
    SignInSource_initEntries();
    return SignInSource_Phone_instance;
  }
  function SignUp(signUpSource) {
    signUpSource = signUpSource === VOID ? null : signUpSource;
    Screen.call(this, 'Sign Up', VOID, mapOf_0(to('signUpSource', signUpSource == null ? null : signUpSource.value)));
  }
  var SignUpSource_Home_instance;
  var SignUpSource_HomeCountry_instance;
  var SignUpSource_HomeGlobal_instance;
  var SignUpSource_StoresList_instance;
  var SignUpSource_StoreMenu_instance;
  function values_77() {
    return [SignUpSource_Home_getInstance(), SignUpSource_HomeCountry_getInstance(), SignUpSource_HomeGlobal_getInstance(), SignUpSource_StoresList_getInstance(), SignUpSource_StoreMenu_getInstance()];
  }
  function valueOf_77(value) {
    switch (value) {
      case 'Home':
        return SignUpSource_Home_getInstance();
      case 'HomeCountry':
        return SignUpSource_HomeCountry_getInstance();
      case 'HomeGlobal':
        return SignUpSource_HomeGlobal_getInstance();
      case 'StoresList':
        return SignUpSource_StoresList_getInstance();
      case 'StoreMenu':
        return SignUpSource_StoreMenu_getInstance();
      default:
        SignUpSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SignUpSource_entriesInitialized;
  function SignUpSource_initEntries() {
    if (SignUpSource_entriesInitialized)
      return Unit_instance;
    SignUpSource_entriesInitialized = true;
    SignUpSource_Home_instance = new SignUpSource('Home', 0, 'Home');
    SignUpSource_HomeCountry_instance = new SignUpSource('HomeCountry', 1, 'Home Country');
    SignUpSource_HomeGlobal_instance = new SignUpSource('HomeGlobal', 2, 'Home Global');
    SignUpSource_StoresList_instance = new SignUpSource('StoresList', 3, 'Stores List');
    SignUpSource_StoreMenu_instance = new SignUpSource('StoreMenu', 4, 'Store Menu');
  }
  function SignUpSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SignUpSource).r = function () {
    return this.value;
  };
  function SignUpSource_Home_getInstance() {
    SignUpSource_initEntries();
    return SignUpSource_Home_instance;
  }
  function SignUpSource_HomeCountry_getInstance() {
    SignUpSource_initEntries();
    return SignUpSource_HomeCountry_instance;
  }
  function SignUpSource_HomeGlobal_getInstance() {
    SignUpSource_initEntries();
    return SignUpSource_HomeGlobal_instance;
  }
  function SignUpSource_StoresList_getInstance() {
    SignUpSource_initEntries();
    return SignUpSource_StoresList_instance;
  }
  function SignUpSource_StoreMenu_getInstance() {
    SignUpSource_initEntries();
    return SignUpSource_StoreMenu_instance;
  }
  function Metadata_102() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_102).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_102;
  function Metadata_getInstance_102() {
    return Metadata_instance_102;
  }
  function SocialSignalsConnections(source, productId, socialSignalType, socialConnections) {
    productId = productId === VOID ? null : productId;
    var tmp = to('source', source == null ? null : source.value);
    var tmp_0 = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_1 = to('socialSignalType', socialSignalType == null ? null : get_value(socialSignalType));
    Screen.call(this, 'Social Signals Connections', 'TREX: Tracking and Reviews Experience', mapOf([tmp, tmp_0, tmp_1, to('socialConnections', socialConnections == null ? null : get_value_2(socialConnections))]));
  }
  var SocialSignalsSource_Stores_instance;
  var SocialSignalsSource_Store_instance;
  function values_78() {
    return [SocialSignalsSource_Stores_getInstance(), SocialSignalsSource_Store_getInstance()];
  }
  function valueOf_78(value) {
    switch (value) {
      case 'Stores':
        return SocialSignalsSource_Stores_getInstance();
      case 'Store':
        return SocialSignalsSource_Store_getInstance();
      default:
        SocialSignalsSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SocialSignalsSource_entriesInitialized;
  function SocialSignalsSource_initEntries() {
    if (SocialSignalsSource_entriesInitialized)
      return Unit_instance;
    SocialSignalsSource_entriesInitialized = true;
    SocialSignalsSource_Stores_instance = new SocialSignalsSource('Stores', 0, 'Stores');
    SocialSignalsSource_Store_instance = new SocialSignalsSource('Store', 1, 'Store');
  }
  function SocialSignalsSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SocialSignalsSource).r = function () {
    return this.value;
  };
  function SocialSignalsSource_Stores_getInstance() {
    SocialSignalsSource_initEntries();
    return SocialSignalsSource_Stores_instance;
  }
  function SocialSignalsSource_Store_getInstance() {
    SocialSignalsSource_initEntries();
    return SocialSignalsSource_Store_instance;
  }
  function SponsoredBubbleShown(properties) {
    var tmp1_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Sponsored Bubble Shown', VOID, VOID, tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs);
  }
  function Store_2(rootContent, layoutDesign, activeFeatures, storeAddressId, isOpen, isMarketPlace, isPrime, deliveryFee, etaLowerBound, etaUpperBound, categoryId, rating, orderHandlingStrategyType, promotionIds, isSchedulingEnabled, searchId, returnPolicyBannerDisplayed, moreInfoHereDisplayed, catalogueLevelsNumber, feesPricingCalculationId, badges, isStoreSurged, productsCount, sectionsCount, collectionsCount, supercollectionsCount, promoIds) {
    rootContent = rootContent === VOID ? null : rootContent;
    layoutDesign = layoutDesign === VOID ? null : layoutDesign;
    activeFeatures = activeFeatures === VOID ? null : activeFeatures;
    etaLowerBound = etaLowerBound === VOID ? null : etaLowerBound;
    etaUpperBound = etaUpperBound === VOID ? null : etaUpperBound;
    categoryId = categoryId === VOID ? null : categoryId;
    searchId = searchId === VOID ? null : searchId;
    catalogueLevelsNumber = catalogueLevelsNumber === VOID ? null : catalogueLevelsNumber;
    badges = badges === VOID ? null : badges;
    isStoreSurged = isStoreSurged === VOID ? null : isStoreSurged;
    promoIds = promoIds === VOID ? null : promoIds;
    var tmp = to('rootContent', rootContent == null ? null : rootContent.value);
    var tmp_0 = to('layoutDesign', layoutDesign == null ? null : layoutDesign.value);
    var tmp_1 = to('activeFeatures', activeFeatures == null ? null : get_value_2(activeFeatures));
    var tmp_2 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_3 = to('isOpen', isOpen == null ? null : get_value_0(isOpen));
    var tmp_4 = to('isMarketPlace', isMarketPlace == null ? null : get_value_0(isMarketPlace));
    var tmp_5 = to('isPrime', isPrime == null ? null : get_value_0(isPrime));
    var tmp_6 = to('deliveryFee', deliveryFee == null ? null : get_value_1(deliveryFee));
    var tmp_7 = to('etaLowerBound', etaLowerBound == null ? null : get_value_1(etaLowerBound));
    var tmp_8 = to('etaUpperBound', etaUpperBound == null ? null : get_value_1(etaUpperBound));
    var tmp_9 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_10 = to('rating', rating == null ? null : get_value(rating));
    var tmp_11 = to('orderHandlingStrategyType', orderHandlingStrategyType == null ? null : orderHandlingStrategyType.value);
    var tmp_12 = to('promotionIds', promotionIds == null ? null : get_value_2(promotionIds));
    var tmp_13 = to('isSchedulingEnabled', isSchedulingEnabled == null ? null : get_value_0(isSchedulingEnabled));
    var tmp_14 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_15 = to('returnPolicyBannerDisplayed', returnPolicyBannerDisplayed == null ? null : get_value_0(returnPolicyBannerDisplayed));
    var tmp_16 = to('moreInfoHereDisplayed', moreInfoHereDisplayed == null ? null : get_value_0(moreInfoHereDisplayed));
    var tmp_17 = to('catalogueLevelsNumber', catalogueLevelsNumber == null ? null : get_value_1(catalogueLevelsNumber));
    var tmp_18 = to('feesPricingCalculationId', feesPricingCalculationId == null ? null : get_value(feesPricingCalculationId));
    var tmp_19 = to('badges', badges == null ? null : get_value_2(badges));
    var tmp_20 = to('isStoreSurged', isStoreSurged == null ? null : get_value_0(isStoreSurged));
    var tmp_21 = to('productsCount', productsCount == null ? null : get_value_1(productsCount));
    var tmp_22 = to('sectionsCount', sectionsCount == null ? null : get_value_1(sectionsCount));
    var tmp_23 = to('collectionsCount', collectionsCount == null ? null : get_value_1(collectionsCount));
    var tmp_24 = to('supercollectionsCount', supercollectionsCount == null ? null : get_value_1(supercollectionsCount));
    Screen.call(this, 'Store', VOID, mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, to('promoIds', promoIds == null ? null : get_value_2(promoIds))]));
  }
  function StoreAccessed(storeAddressId, origin, operationType, isSponsored, promotionIds, promotionTypes, availabilityStatus, auctionId, storeId, userSelectedLanguage, filters, ncrRequestToken, shopId, shopPosition, userId, searchTerm, shopClickOrigin, shopSponsoring, shopSponsoringPlacement, screenName, swimlaneTitle, isFavorites, playlistIds, expeditionType, promoIds) {
    operationType = operationType === VOID ? null : operationType;
    promotionIds = promotionIds === VOID ? null : promotionIds;
    promotionTypes = promotionTypes === VOID ? null : promotionTypes;
    availabilityStatus = availabilityStatus === VOID ? null : availabilityStatus;
    auctionId = auctionId === VOID ? null : auctionId;
    storeId = storeId === VOID ? null : storeId;
    userSelectedLanguage = userSelectedLanguage === VOID ? null : userSelectedLanguage;
    filters = filters === VOID ? null : filters;
    ncrRequestToken = ncrRequestToken === VOID ? null : ncrRequestToken;
    shopId = shopId === VOID ? null : shopId;
    shopPosition = shopPosition === VOID ? null : shopPosition;
    userId = userId === VOID ? null : userId;
    searchTerm = searchTerm === VOID ? null : searchTerm;
    shopClickOrigin = shopClickOrigin === VOID ? null : shopClickOrigin;
    shopSponsoring = shopSponsoring === VOID ? null : shopSponsoring;
    shopSponsoringPlacement = shopSponsoringPlacement === VOID ? null : shopSponsoringPlacement;
    screenName = screenName === VOID ? null : screenName;
    swimlaneTitle = swimlaneTitle === VOID ? null : swimlaneTitle;
    isFavorites = isFavorites === VOID ? null : isFavorites;
    playlistIds = playlistIds === VOID ? null : playlistIds;
    expeditionType = expeditionType === VOID ? null : expeditionType;
    promoIds = promoIds === VOID ? null : promoIds;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('origin', origin == null ? null : origin.value);
    var tmp_1 = to('operationType', operationType == null ? null : operationType.value);
    var tmp_2 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_3 = to('promotionIds', promotionIds == null ? null : get_value_2(promotionIds));
    var tmp_4 = to('promotionTypes', promotionTypes == null ? null : get_value_2(promotionTypes));
    var tmp_5 = to('availabilityStatus', availabilityStatus == null ? null : availabilityStatus.value);
    var tmp_6 = to('auctionId', auctionId == null ? null : get_value(auctionId));
    var tmp_7 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_8 = to('userSelectedLanguage', userSelectedLanguage == null ? null : get_value(userSelectedLanguage));
    var tmp_9 = to('filters', filters == null ? null : get_value_2(filters));
    var tmp_10 = to('ncrRequestToken', ncrRequestToken == null ? null : get_value(ncrRequestToken));
    var tmp_11 = to('shopId', shopId == null ? null : get_value_1(shopId));
    var tmp_12 = to('shopPosition', shopPosition == null ? null : get_value_1(shopPosition));
    var tmp_13 = to('userId', userId == null ? null : get_value(userId));
    var tmp_14 = to('searchTerm', searchTerm == null ? null : get_value(searchTerm));
    var tmp_15 = to('shopClickOrigin', shopClickOrigin == null ? null : get_value(shopClickOrigin));
    var tmp_16 = to('shopSponsoring', shopSponsoring == null ? null : get_value(shopSponsoring));
    var tmp_17 = to('shopSponsoringPlacement', shopSponsoringPlacement == null ? null : get_value(shopSponsoringPlacement));
    var tmp_18 = to('screenName', screenName == null ? null : get_value(screenName));
    var tmp_19 = to('swimlaneTitle', swimlaneTitle == null ? null : get_value(swimlaneTitle));
    var tmp_20 = to('isFavorites', isFavorites == null ? null : get_value_0(isFavorites));
    var tmp_21 = to('playlistIds', playlistIds == null ? null : get_value_2(playlistIds));
    var tmp_22 = to('expeditionType', expeditionType == null ? null : get_value(expeditionType));
    var tmp_23 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, to('promoIds', promoIds == null ? null : get_value_2(promoIds))]);
    var tmp26_elvis_lhs = origin == null ? null : origin.data;
    var tmp_24 = plus(tmp_23, tmp26_elvis_lhs == null ? emptyMap() : tmp26_elvis_lhs);
    var tmp28_elvis_lhs = operationType == null ? null : operationType.data;
    var tmp_25 = plus(tmp_24, tmp28_elvis_lhs == null ? emptyMap() : tmp28_elvis_lhs);
    var tmp30_elvis_lhs = availabilityStatus == null ? null : availabilityStatus.data;
    Event.call(this, 'Store Accessed', VOID, VOID, plus(tmp_25, tmp30_elvis_lhs == null ? emptyMap() : tmp30_elvis_lhs));
  }
  function Search_1(searchId) {
    StoreAccessedOperation.call(this, 'Search', mapOf_0(to('searchId', searchId == null ? null : get_value(searchId))));
  }
  protoOf(Search_1).toString = function () {
    return 'Search(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Filters_1(filterId) {
    filterId = filterId === VOID ? null : filterId;
    StoreAccessedOperation.call(this, 'Filters', mapOf_0(to('filterId', filterId == null ? null : get_value_1(filterId))));
  }
  protoOf(Filters_1).toString = function () {
    return 'Filters(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function StoreAccessedOperation(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(StoreAccessedOperation).r = function () {
    return this.value;
  };
  protoOf(StoreAccessedOperation).qa = function () {
    return this.data;
  };
  protoOf(StoreAccessedOperation).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(StoreAccessedOperation).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof StoreAccessedOperation) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Category_2(categoryId) {
    StoreAccessedOrigin.call(this, 'Category', mapOf_0(to('categoryId', categoryId == null ? null : get_value_1(categoryId))));
  }
  protoOf(Category_2).toString = function () {
    return 'Category(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CategoryGroup_2(categoryGroupId) {
    StoreAccessedOrigin.call(this, 'CategoryGroup', mapOf_0(to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))));
  }
  protoOf(CategoryGroup_2).toString = function () {
    return 'CategoryGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Checkout_3() {
    Checkout_instance_1 = this;
    StoreAccessedOrigin.call(this, 'Checkout');
  }
  protoOf(Checkout_3).toString = function () {
    return 'Checkout(value=' + this.value + ')';
  };
  var Checkout_instance_1;
  function Checkout_getInstance_1() {
    if (Checkout_instance_1 == null)
      new Checkout_3();
    return Checkout_instance_1;
  }
  function FeedGroup_1(feedGroupId) {
    StoreAccessedOrigin.call(this, 'FeedGroup', mapOf_0(to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId))));
  }
  protoOf(FeedGroup_1).toString = function () {
    return 'FeedGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedGroupResults_0(feedGroupId) {
    StoreAccessedOrigin.call(this, 'FeedGroupResults', mapOf_0(to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId))));
  }
  protoOf(FeedGroupResults_0).toString = function () {
    return 'FeedGroupResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeWidget_1(widgetId) {
    StoreAccessedOrigin.call(this, 'HomeWidget', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(HomeWidget_1).toString = function () {
    return 'HomeWidget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeWidgetResults_0(widgetId) {
    StoreAccessedOrigin.call(this, 'HomeWidgetResults', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(HomeWidgetResults_0).toString = function () {
    return 'HomeWidgetResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeSearchBarResults_0() {
    HomeSearchBarResults_instance = this;
    StoreAccessedOrigin.call(this, 'HomeSearchBarResults');
  }
  protoOf(HomeSearchBarResults_0).toString = function () {
    return 'HomeSearchBarResults(value=' + this.value + ')';
  };
  var HomeSearchBarResults_instance;
  function HomeSearchBarResults_getInstance() {
    if (HomeSearchBarResults_instance == null)
      new HomeSearchBarResults_0();
    return HomeSearchBarResults_instance;
  }
  function Story_1(storyId) {
    StoreAccessedOrigin.call(this, 'Story', mapOf_0(to('storyId', storyId == null ? null : get_value(storyId))));
  }
  protoOf(Story_1).toString = function () {
    return 'Story(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function SearchWidget(widgetId) {
    StoreAccessedOrigin.call(this, 'SearchWidget', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(SearchWidget).toString = function () {
    return 'SearchWidget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Deeplink_2() {
    Deeplink_instance_0 = this;
    StoreAccessedOrigin.call(this, 'Deeplink');
  }
  protoOf(Deeplink_2).toString = function () {
    return 'Deeplink(value=' + this.value + ')';
  };
  var Deeplink_instance_0;
  function Deeplink_getInstance_0() {
    if (Deeplink_instance_0 == null)
      new Deeplink_2();
    return Deeplink_instance_0;
  }
  function Direct_0() {
    Direct_instance_0 = this;
    StoreAccessedOrigin.call(this, 'Direct');
  }
  protoOf(Direct_0).toString = function () {
    return 'Direct(value=' + this.value + ')';
  };
  var Direct_instance_0;
  function Direct_getInstance_0() {
    if (Direct_instance_0 == null)
      new Direct_0();
    return Direct_instance_0;
  }
  function Other_4() {
    Other_instance_4 = this;
    StoreAccessedOrigin.call(this, 'Other');
  }
  protoOf(Other_4).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_4;
  function Other_getInstance_4() {
    if (Other_instance_4 == null)
      new Other_4();
    return Other_instance_4;
  }
  function StoreAccessedOrigin(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(StoreAccessedOrigin).r = function () {
    return this.value;
  };
  protoOf(StoreAccessedOrigin).qa = function () {
    return this.data;
  };
  protoOf(StoreAccessedOrigin).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(StoreAccessedOrigin).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof StoreAccessedOrigin) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var StoreCarouselType_EasyReorder_instance;
  var StoreCarouselType_TopSellers_instance;
  var StoreCarouselType_CollectionGroup_instance;
  var StoreCarouselType_Other_instance;
  function values_79() {
    return [StoreCarouselType_EasyReorder_getInstance(), StoreCarouselType_TopSellers_getInstance(), StoreCarouselType_CollectionGroup_getInstance(), StoreCarouselType_Other_getInstance()];
  }
  function valueOf_79(value) {
    switch (value) {
      case 'EasyReorder':
        return StoreCarouselType_EasyReorder_getInstance();
      case 'TopSellers':
        return StoreCarouselType_TopSellers_getInstance();
      case 'CollectionGroup':
        return StoreCarouselType_CollectionGroup_getInstance();
      case 'Other':
        return StoreCarouselType_Other_getInstance();
      default:
        StoreCarouselType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var StoreCarouselType_entriesInitialized;
  function StoreCarouselType_initEntries() {
    if (StoreCarouselType_entriesInitialized)
      return Unit_instance;
    StoreCarouselType_entriesInitialized = true;
    StoreCarouselType_EasyReorder_instance = new StoreCarouselType('EasyReorder', 0, 'EasyReorder');
    StoreCarouselType_TopSellers_instance = new StoreCarouselType('TopSellers', 1, 'TopSellers');
    StoreCarouselType_CollectionGroup_instance = new StoreCarouselType('CollectionGroup', 2, 'CollectionGroup');
    StoreCarouselType_Other_instance = new StoreCarouselType('Other', 3, 'Other');
  }
  function StoreCarouselType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(StoreCarouselType).r = function () {
    return this.value;
  };
  function StoreCarouselType_EasyReorder_getInstance() {
    StoreCarouselType_initEntries();
    return StoreCarouselType_EasyReorder_instance;
  }
  function StoreCarouselType_TopSellers_getInstance() {
    StoreCarouselType_initEntries();
    return StoreCarouselType_TopSellers_instance;
  }
  function StoreCarouselType_CollectionGroup_getInstance() {
    StoreCarouselType_initEntries();
    return StoreCarouselType_CollectionGroup_instance;
  }
  function StoreCarouselType_Other_getInstance() {
    StoreCarouselType_initEntries();
    return StoreCarouselType_Other_instance;
  }
  function StoreFunnel(categoryId, storeAddressId, layoutDisplayed, storeFunnelOrigin) {
    storeFunnelOrigin = storeFunnelOrigin === VOID ? null : storeFunnelOrigin;
    var tmp = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_1 = to('layoutDisplayed', layoutDisplayed == null ? null : layoutDisplayed.value);
    var tmp_2 = mapOf([tmp, tmp_0, tmp_1, to('storeFunnelOrigin', storeFunnelOrigin == null ? null : storeFunnelOrigin.value)]);
    var tmp5_elvis_lhs = layoutDisplayed == null ? null : layoutDisplayed.data;
    Screen.call(this, 'Store Funnel', VOID, plus(tmp_2, tmp5_elvis_lhs == null ? emptyMap() : tmp5_elvis_lhs));
  }
  function CollectionGroups(collectionGroupIds) {
    StoreFunnelLayout.call(this, 'CollectionGroups', mapOf_0(to('collectionGroupIds', collectionGroupIds == null ? null : get_value_2(collectionGroupIds))));
  }
  protoOf(CollectionGroups).toString = function () {
    return 'CollectionGroups(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Collections(collectionGroupId, collectionIds) {
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    var tmp = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    StoreFunnelLayout.call(this, 'Collections', mapOf([tmp, to('collectionIds', collectionIds == null ? null : get_value_2(collectionIds))]));
  }
  protoOf(Collections).toString = function () {
    return 'Collections(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Products(collectionGroupId, collectionId, collectionSectionIds, collectionProductIds) {
    collectionGroupId = collectionGroupId === VOID ? null : collectionGroupId;
    collectionId = collectionId === VOID ? null : collectionId;
    var tmp = to('collectionGroupId', collectionGroupId == null ? null : get_value_1(collectionGroupId));
    var tmp_0 = to('collectionId', collectionId == null ? null : get_value_1(collectionId));
    var tmp_1 = to('collectionSectionIds', collectionSectionIds == null ? null : get_value_2(collectionSectionIds));
    StoreFunnelLayout.call(this, 'Products', mapOf([tmp, tmp_0, tmp_1, to('collectionProductIds', collectionProductIds == null ? null : get_value_2(collectionProductIds))]));
  }
  protoOf(Products).toString = function () {
    return 'Products(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function ProductsTopSellers() {
    ProductsTopSellers_instance = this;
    StoreFunnelLayout.call(this, 'ProductsTopSellers');
  }
  protoOf(ProductsTopSellers).toString = function () {
    return 'ProductsTopSellers(value=' + this.value + ')';
  };
  var ProductsTopSellers_instance;
  function ProductsTopSellers_getInstance() {
    if (ProductsTopSellers_instance == null)
      new ProductsTopSellers();
    return ProductsTopSellers_instance;
  }
  function ProductsEasyReorder() {
    ProductsEasyReorder_instance = this;
    StoreFunnelLayout.call(this, 'ProductsEasyReorder');
  }
  protoOf(ProductsEasyReorder).toString = function () {
    return 'ProductsEasyReorder(value=' + this.value + ')';
  };
  var ProductsEasyReorder_instance;
  function ProductsEasyReorder_getInstance() {
    if (ProductsEasyReorder_instance == null)
      new ProductsEasyReorder();
    return ProductsEasyReorder_instance;
  }
  function NoMenu() {
    NoMenu_instance = this;
    StoreFunnelLayout.call(this, 'NoMenu');
  }
  protoOf(NoMenu).toString = function () {
    return 'NoMenu(value=' + this.value + ')';
  };
  var NoMenu_instance;
  function NoMenu_getInstance() {
    if (NoMenu_instance == null)
      new NoMenu();
    return NoMenu_instance;
  }
  function StoreFunnelLayout(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(StoreFunnelLayout).r = function () {
    return this.value;
  };
  protoOf(StoreFunnelLayout).qa = function () {
    return this.data;
  };
  protoOf(StoreFunnelLayout).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(StoreFunnelLayout).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof StoreFunnelLayout) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  var StoreFunnelOrigin_Store_instance;
  var StoreFunnelOrigin_CollectionGroup_instance;
  var StoreFunnelOrigin_Collection_instance;
  var StoreFunnelOrigin_EasyReorder_instance;
  var StoreFunnelOrigin_TopSellers_instance;
  var StoreFunnelOrigin_BackArrow_instance;
  function values_80() {
    return [StoreFunnelOrigin_Store_getInstance(), StoreFunnelOrigin_CollectionGroup_getInstance(), StoreFunnelOrigin_Collection_getInstance(), StoreFunnelOrigin_EasyReorder_getInstance(), StoreFunnelOrigin_TopSellers_getInstance(), StoreFunnelOrigin_BackArrow_getInstance()];
  }
  function valueOf_80(value) {
    switch (value) {
      case 'Store':
        return StoreFunnelOrigin_Store_getInstance();
      case 'CollectionGroup':
        return StoreFunnelOrigin_CollectionGroup_getInstance();
      case 'Collection':
        return StoreFunnelOrigin_Collection_getInstance();
      case 'EasyReorder':
        return StoreFunnelOrigin_EasyReorder_getInstance();
      case 'TopSellers':
        return StoreFunnelOrigin_TopSellers_getInstance();
      case 'BackArrow':
        return StoreFunnelOrigin_BackArrow_getInstance();
      default:
        StoreFunnelOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var StoreFunnelOrigin_entriesInitialized;
  function StoreFunnelOrigin_initEntries() {
    if (StoreFunnelOrigin_entriesInitialized)
      return Unit_instance;
    StoreFunnelOrigin_entriesInitialized = true;
    StoreFunnelOrigin_Store_instance = new StoreFunnelOrigin('Store', 0, 'Store');
    StoreFunnelOrigin_CollectionGroup_instance = new StoreFunnelOrigin('CollectionGroup', 1, 'CollectionGroup');
    StoreFunnelOrigin_Collection_instance = new StoreFunnelOrigin('Collection', 2, 'Collection');
    StoreFunnelOrigin_EasyReorder_instance = new StoreFunnelOrigin('EasyReorder', 3, 'EasyReorder');
    StoreFunnelOrigin_TopSellers_instance = new StoreFunnelOrigin('TopSellers', 4, 'TopSellers');
    StoreFunnelOrigin_BackArrow_instance = new StoreFunnelOrigin('BackArrow', 5, 'BackArrow');
  }
  function StoreFunnelOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(StoreFunnelOrigin).r = function () {
    return this.value;
  };
  function StoreFunnelOrigin_Store_getInstance() {
    StoreFunnelOrigin_initEntries();
    return StoreFunnelOrigin_Store_instance;
  }
  function StoreFunnelOrigin_CollectionGroup_getInstance() {
    StoreFunnelOrigin_initEntries();
    return StoreFunnelOrigin_CollectionGroup_instance;
  }
  function StoreFunnelOrigin_Collection_getInstance() {
    StoreFunnelOrigin_initEntries();
    return StoreFunnelOrigin_Collection_instance;
  }
  function StoreFunnelOrigin_EasyReorder_getInstance() {
    StoreFunnelOrigin_initEntries();
    return StoreFunnelOrigin_EasyReorder_instance;
  }
  function StoreFunnelOrigin_TopSellers_getInstance() {
    StoreFunnelOrigin_initEntries();
    return StoreFunnelOrigin_TopSellers_instance;
  }
  function StoreFunnelOrigin_BackArrow_getInstance() {
    StoreFunnelOrigin_initEntries();
    return StoreFunnelOrigin_BackArrow_instance;
  }
  function StoreHomeMosaicImpression(storeAddressId) {
    Event.call(this, 'Store Home Mosaic Impression', VOID, VOID, mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  function StoreImpression(storeAddressId, isOpen, position, origin, deliveryFee, rating, numberOfRatedOrders, promotionIds, storeId, isPrime, etaLowerBound, etaUpperBound, sortingId, type, searchId, horizontalPosition, page, hasPicture, deliveryFeeCurrency, tags, isSponsored, searchProductMatches, searchProductImages, feesPricingCalculationId, rankingType, rankingScore, priceTag, isStoreSurged, titleBadge, inStorePrices, newStoreWall, availabilityStatus, filters, upgradeBanner, auctionId, impressionType, storeRankPosition, widgetHorizontalPosition, widgetVerticalPosition, ncrRequestToken, shopId, shopPosition, userId, searchTerm, shopSponsoring, shopSponsoringPlacement, screenName, impressionListName, swimlaneTitle, isFavorites, playlistIds, expeditionType, nestedStoreProductIds, promoIds, widgetId) {
    origin = origin === VOID ? null : origin;
    etaLowerBound = etaLowerBound === VOID ? null : etaLowerBound;
    etaUpperBound = etaUpperBound === VOID ? null : etaUpperBound;
    sortingId = sortingId === VOID ? null : sortingId;
    type = type === VOID ? null : type;
    searchId = searchId === VOID ? null : searchId;
    tags = tags === VOID ? null : tags;
    searchProductMatches = searchProductMatches === VOID ? null : searchProductMatches;
    searchProductImages = searchProductImages === VOID ? null : searchProductImages;
    rankingType = rankingType === VOID ? null : rankingType;
    rankingScore = rankingScore === VOID ? null : rankingScore;
    priceTag = priceTag === VOID ? null : priceTag;
    isStoreSurged = isStoreSurged === VOID ? null : isStoreSurged;
    titleBadge = titleBadge === VOID ? null : titleBadge;
    inStorePrices = inStorePrices === VOID ? null : inStorePrices;
    newStoreWall = newStoreWall === VOID ? null : newStoreWall;
    availabilityStatus = availabilityStatus === VOID ? null : availabilityStatus;
    filters = filters === VOID ? null : filters;
    upgradeBanner = upgradeBanner === VOID ? null : upgradeBanner;
    auctionId = auctionId === VOID ? null : auctionId;
    impressionType = impressionType === VOID ? null : impressionType;
    storeRankPosition = storeRankPosition === VOID ? null : storeRankPosition;
    widgetHorizontalPosition = widgetHorizontalPosition === VOID ? null : widgetHorizontalPosition;
    widgetVerticalPosition = widgetVerticalPosition === VOID ? null : widgetVerticalPosition;
    ncrRequestToken = ncrRequestToken === VOID ? null : ncrRequestToken;
    shopId = shopId === VOID ? null : shopId;
    shopPosition = shopPosition === VOID ? null : shopPosition;
    userId = userId === VOID ? null : userId;
    searchTerm = searchTerm === VOID ? null : searchTerm;
    shopSponsoring = shopSponsoring === VOID ? null : shopSponsoring;
    shopSponsoringPlacement = shopSponsoringPlacement === VOID ? null : shopSponsoringPlacement;
    screenName = screenName === VOID ? null : screenName;
    impressionListName = impressionListName === VOID ? null : impressionListName;
    swimlaneTitle = swimlaneTitle === VOID ? null : swimlaneTitle;
    isFavorites = isFavorites === VOID ? null : isFavorites;
    playlistIds = playlistIds === VOID ? null : playlistIds;
    expeditionType = expeditionType === VOID ? null : expeditionType;
    nestedStoreProductIds = nestedStoreProductIds === VOID ? null : nestedStoreProductIds;
    promoIds = promoIds === VOID ? null : promoIds;
    widgetId = widgetId === VOID ? null : widgetId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('isOpen', isOpen == null ? null : get_value_0(isOpen));
    var tmp_1 = to('position', position == null ? null : get_value_1(position));
    var tmp_2 = to('origin', origin == null ? null : origin.value);
    var tmp_3 = to('deliveryFee', deliveryFee == null ? null : get_value_1(deliveryFee));
    var tmp_4 = to('rating', rating == null ? null : get_value(rating));
    var tmp_5 = to('numberOfRatedOrders', numberOfRatedOrders == null ? null : get_value(numberOfRatedOrders));
    var tmp_6 = to('promotionIds', promotionIds == null ? null : get_value_2(promotionIds));
    var tmp_7 = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_8 = to('isPrime', isPrime == null ? null : get_value_0(isPrime));
    var tmp_9 = to('etaLowerBound', etaLowerBound == null ? null : get_value_1(etaLowerBound));
    var tmp_10 = to('etaUpperBound', etaUpperBound == null ? null : get_value_1(etaUpperBound));
    var tmp_11 = to('sortingId', sortingId == null ? null : get_value_1(sortingId));
    var tmp_12 = to('type', type == null ? null : get_value(type));
    var tmp_13 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_14 = to('horizontalPosition', horizontalPosition == null ? null : get_value_1(horizontalPosition));
    var tmp_15 = to('page', page == null ? null : get_value_1(page));
    var tmp_16 = to('hasPicture', hasPicture == null ? null : get_value_0(hasPicture));
    var tmp_17 = to('deliveryFeeCurrency', deliveryFeeCurrency == null ? null : get_value(deliveryFeeCurrency));
    var tmp_18 = to('tags', tags == null ? null : get_value_2(tags));
    var tmp_19 = to('isSponsored', isSponsored == null ? null : get_value_0(isSponsored));
    var tmp_20 = to('searchProductMatches', searchProductMatches == null ? null : get_value_1(searchProductMatches));
    var tmp_21 = to('searchProductImages', searchProductImages == null ? null : get_value_1(searchProductImages));
    var tmp_22 = to('feesPricingCalculationId', feesPricingCalculationId == null ? null : get_value(feesPricingCalculationId));
    var tmp_23 = to('rankingType', rankingType == null ? null : rankingType.value);
    var tmp_24 = to('rankingScore', rankingScore == null ? null : get_value_1(rankingScore));
    var tmp_25 = to('priceTag', priceTag == null ? null : get_value_1(priceTag));
    var tmp_26 = to('isStoreSurged', isStoreSurged == null ? null : get_value_0(isStoreSurged));
    var tmp_27 = to('titleBadge', titleBadge == null ? null : get_value(titleBadge));
    var tmp_28 = to('inStorePrices', inStorePrices == null ? null : get_value_0(inStorePrices));
    var tmp_29 = to('newStoreWall', newStoreWall == null ? null : get_value_0(newStoreWall));
    var tmp_30 = to('availabilityStatus', availabilityStatus == null ? null : availabilityStatus.value);
    var tmp_31 = to('filters', filters == null ? null : get_value_2(filters));
    var tmp_32 = to('upgradeBanner', upgradeBanner == null ? null : get_value_0(upgradeBanner));
    var tmp_33 = to('auctionId', auctionId == null ? null : get_value(auctionId));
    var tmp_34 = to('impressionType', impressionType == null ? null : impressionType.value);
    var tmp_35 = to('storeRankPosition', storeRankPosition == null ? null : get_value_1(storeRankPosition));
    var tmp_36 = to('widgetHorizontalPosition', widgetHorizontalPosition == null ? null : get_value_1(widgetHorizontalPosition));
    var tmp_37 = to('widgetVerticalPosition', widgetVerticalPosition == null ? null : get_value_1(widgetVerticalPosition));
    var tmp_38 = to('ncrRequestToken', ncrRequestToken == null ? null : get_value(ncrRequestToken));
    var tmp_39 = to('shopId', shopId == null ? null : get_value_1(shopId));
    var tmp_40 = to('shopPosition', shopPosition == null ? null : get_value_1(shopPosition));
    var tmp_41 = to('userId', userId == null ? null : get_value(userId));
    var tmp_42 = to('searchTerm', searchTerm == null ? null : get_value(searchTerm));
    var tmp_43 = to('shopSponsoring', shopSponsoring == null ? null : get_value(shopSponsoring));
    var tmp_44 = to('shopSponsoringPlacement', shopSponsoringPlacement == null ? null : get_value(shopSponsoringPlacement));
    var tmp_45 = to('screenName', screenName == null ? null : get_value(screenName));
    var tmp_46 = to('impressionListName', impressionListName == null ? null : get_value(impressionListName));
    var tmp_47 = to('swimlaneTitle', swimlaneTitle == null ? null : get_value(swimlaneTitle));
    var tmp_48 = to('isFavorites', isFavorites == null ? null : get_value_0(isFavorites));
    var tmp_49 = to('playlistIds', playlistIds == null ? null : get_value_2(playlistIds));
    var tmp_50 = to('expeditionType', expeditionType == null ? null : get_value(expeditionType));
    var tmp_51 = to('nestedStoreProductIds', nestedStoreProductIds == null ? null : get_value_2(nestedStoreProductIds));
    var tmp_52 = to('promoIds', promoIds == null ? null : get_value_2(promoIds));
    var tmp_53 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, tmp_28, tmp_29, tmp_30, tmp_31, tmp_32, tmp_33, tmp_34, tmp_35, tmp_36, tmp_37, tmp_38, tmp_39, tmp_40, tmp_41, tmp_42, tmp_43, tmp_44, tmp_45, tmp_46, tmp_47, tmp_48, tmp_49, tmp_50, tmp_51, tmp_52, to('widgetId', widgetId == null ? null : get_value(widgetId))]);
    var tmp56_elvis_lhs = origin == null ? null : origin.data;
    var tmp_54 = plus(tmp_53, tmp56_elvis_lhs == null ? emptyMap() : tmp56_elvis_lhs);
    var tmp58_elvis_lhs = availabilityStatus == null ? null : availabilityStatus.data;
    var tmp_55 = plus(tmp_54, tmp58_elvis_lhs == null ? emptyMap() : tmp58_elvis_lhs);
    var tmp60_elvis_lhs = impressionType == null ? null : impressionType.data;
    Event.call(this, 'Store Impression', VOID, VOID, plus(tmp_55, tmp60_elvis_lhs == null ? emptyMap() : tmp60_elvis_lhs));
  }
  function Metadata_103() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_103).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_103;
  function Metadata_getInstance_103() {
    return Metadata_instance_103;
  }
  function StoreInfoButtonClicked(storeId, storeAddressId) {
    storeId = storeId === VOID ? null : storeId;
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    var tmp = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Store Info Button Clicked', VOID, 'CK: Checkout', mapOf([tmp, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  function Metadata_104() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_104).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_104;
  function Metadata_getInstance_104() {
    return Metadata_instance_104;
  }
  function StoreInfoScreen(storeId, storeAddressId, storeInfoDisplayed) {
    var tmp = to('storeId', storeId == null ? null : get_value(storeId));
    var tmp_0 = to('storeAddressId', storeAddressId == null ? null : get_value(storeAddressId));
    Screen.call(this, 'Store Info Screen', 'CK: Checkout', mapOf([tmp, tmp_0, to('storeInfoDisplayed', storeInfoDisplayed == null ? null : get_value(storeInfoDisplayed))]));
  }
  function StoreLeft(storeAddressId, cartId, creationSessionId, customerId) {
    customerId = customerId === VOID ? null : customerId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('cartId', cartId == null ? null : get_value(cartId));
    var tmp_1 = to('creationSessionId', creationSessionId == null ? null : get_value(creationSessionId));
    Event.call(this, 'Store Left', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('customerId', customerId == null ? null : get_value_1(customerId))]));
  }
  function StoreMobileNavigationBarImpression(storeAddressId, navigationBarGroupsCount, searchId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    navigationBarGroupsCount = navigationBarGroupsCount === VOID ? null : navigationBarGroupsCount;
    searchId = searchId === VOID ? null : searchId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('navigationBarGroupsCount', navigationBarGroupsCount == null ? null : get_value_1(navigationBarGroupsCount));
    Event.call(this, 'Store Mobile Navigation Bar Impression', VOID, VOID, mapOf([tmp, tmp_0, to('searchId', searchId == null ? null : get_value(searchId))]));
  }
  function Stores(origin, storeAddressIds, storeIds, storeIdsCount, componentsLoaded, componentsPosition, rankingRequestId, isSurgeActivated, page, newStoreWall, isRefreshed, ncrRequestToken, shopsIds, playlistId) {
    storeIdsCount = storeIdsCount === VOID ? null : storeIdsCount;
    componentsLoaded = componentsLoaded === VOID ? null : componentsLoaded;
    componentsPosition = componentsPosition === VOID ? null : componentsPosition;
    rankingRequestId = rankingRequestId === VOID ? null : rankingRequestId;
    isSurgeActivated = isSurgeActivated === VOID ? null : isSurgeActivated;
    page = page === VOID ? null : page;
    newStoreWall = newStoreWall === VOID ? null : newStoreWall;
    isRefreshed = isRefreshed === VOID ? null : isRefreshed;
    ncrRequestToken = ncrRequestToken === VOID ? null : ncrRequestToken;
    shopsIds = shopsIds === VOID ? null : shopsIds;
    playlistId = playlistId === VOID ? null : playlistId;
    var tmp = to('origin', origin == null ? null : origin.value);
    var tmp_0 = to('storeAddressIds', storeAddressIds == null ? null : get_value_2(storeAddressIds));
    var tmp_1 = to('storeIds', storeIds == null ? null : get_value_2(storeIds));
    var tmp_2 = to('storeIdsCount', storeIdsCount == null ? null : get_value_1(storeIdsCount));
    var tmp_3 = to('componentsLoaded', componentsLoaded == null ? null : get_value_2(componentsLoaded));
    var tmp_4 = to('componentsPosition', componentsPosition == null ? null : get_value_2(componentsPosition));
    var tmp_5 = to('rankingRequestId', rankingRequestId == null ? null : get_value(rankingRequestId));
    var tmp_6 = to('isSurgeActivated', isSurgeActivated == null ? null : get_value_0(isSurgeActivated));
    var tmp_7 = to('page', page == null ? null : get_value_1(page));
    var tmp_8 = to('newStoreWall', newStoreWall == null ? null : get_value_0(newStoreWall));
    var tmp_9 = to('isRefreshed', isRefreshed == null ? null : get_value_0(isRefreshed));
    var tmp_10 = to('ncrRequestToken', ncrRequestToken == null ? null : get_value(ncrRequestToken));
    var tmp_11 = to('shopsIds', shopsIds == null ? null : get_value(shopsIds));
    var tmp_12 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, to('playlistId', playlistId == null ? null : get_value(playlistId))]);
    var tmp15_elvis_lhs = origin == null ? null : origin.data;
    Screen.call(this, 'Stores', VOID, plus(tmp_12, tmp15_elvis_lhs == null ? emptyMap() : tmp15_elvis_lhs));
  }
  function HomeSearchBar() {
    HomeSearchBar_instance = this;
    StoresOrigin.call(this, 'HomeSearchBar');
  }
  protoOf(HomeSearchBar).toString = function () {
    return 'HomeSearchBar(value=' + this.value + ')';
  };
  var HomeSearchBar_instance;
  function HomeSearchBar_getInstance() {
    if (HomeSearchBar_instance == null)
      new HomeSearchBar();
    return HomeSearchBar_instance;
  }
  function Category_3(categoryId) {
    StoresOrigin.call(this, 'Category', mapOf_0(to('categoryId', categoryId == null ? null : get_value_1(categoryId))));
  }
  protoOf(Category_3).toString = function () {
    return 'Category(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function CategoryGroup_3(categoryGroupId) {
    StoresOrigin.call(this, 'CategoryGroup', mapOf_0(to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))));
  }
  protoOf(CategoryGroup_3).toString = function () {
    return 'CategoryGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function FeedGroup_2(feedGroupId) {
    StoresOrigin.call(this, 'FeedGroup', mapOf_0(to('feedGroupId', feedGroupId == null ? null : get_value(feedGroupId))));
  }
  protoOf(FeedGroup_2).toString = function () {
    return 'FeedGroup(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Deeplink_3() {
    Deeplink_instance_1 = this;
    StoresOrigin.call(this, 'Deeplink');
  }
  protoOf(Deeplink_3).toString = function () {
    return 'Deeplink(value=' + this.value + ')';
  };
  var Deeplink_instance_1;
  function Deeplink_getInstance_1() {
    if (Deeplink_instance_1 == null)
      new Deeplink_3();
    return Deeplink_instance_1;
  }
  function Story_2() {
    Story_instance_0 = this;
    StoresOrigin.call(this, 'Story');
  }
  protoOf(Story_2).toString = function () {
    return 'Story(value=' + this.value + ')';
  };
  var Story_instance_0;
  function Story_getInstance_0() {
    if (Story_instance_0 == null)
      new Story_2();
    return Story_instance_0;
  }
  function HomeWidget_2(widgetId) {
    StoresOrigin.call(this, 'HomeWidget', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(HomeWidget_2).toString = function () {
    return 'HomeWidget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function HomeWidgetResults_1(widgetId) {
    StoresOrigin.call(this, 'HomeWidgetResults', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(HomeWidgetResults_1).toString = function () {
    return 'HomeWidgetResults(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function SearchWidget_0(widgetId) {
    StoresOrigin.call(this, 'SearchWidget', mapOf_0(to('widgetId', widgetId == null ? null : get_value(widgetId))));
  }
  protoOf(SearchWidget_0).toString = function () {
    return 'SearchWidget(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Other_5() {
    Other_instance_5 = this;
    StoresOrigin.call(this, 'Other');
  }
  protoOf(Other_5).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_5;
  function Other_getInstance_5() {
    if (Other_instance_5 == null)
      new Other_5();
    return Other_instance_5;
  }
  function StoresOrigin(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(StoresOrigin).r = function () {
    return this.value;
  };
  protoOf(StoresOrigin).qa = function () {
    return this.data;
  };
  protoOf(StoresOrigin).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(StoresOrigin).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof StoresOrigin) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function SurgeBannerShown(storeAddressId, isOpen, position, storeId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    isOpen = isOpen === VOID ? null : isOpen;
    storeId = storeId === VOID ? null : storeId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    var tmp_0 = to('isOpen', isOpen == null ? null : get_value_0(isOpen));
    var tmp_1 = to('position', position == null ? null : get_value_1(position));
    Event.call(this, 'Surge Banner Shown', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('storeId', storeId == null ? null : get_value_1(storeId))]));
  }
  function TellUsYourName() {
    Screen.call(this, 'Tell Us Your Name');
  }
  function ThreeDS2AuthenticationFailed(errorMessage, invoiceId) {
    var tmp = to('errorMessage', errorMessage == null ? null : get_value(errorMessage));
    Event.call(this, '3DS2 Authentication Failed', VOID, VOID, mapOf([tmp, to('invoiceId', invoiceId == null ? null : get_value(invoiceId))]));
  }
  var TokenizedAPMStatus_FetchConfig_instance;
  var TokenizedAPMStatus_Started_instance;
  var TokenizedAPMStatus_Authorized_instance;
  var TokenizedAPMStatus_Confirmed_instance;
  var TokenizedAPMStatus_Failed_instance;
  function values_81() {
    return [TokenizedAPMStatus_FetchConfig_getInstance(), TokenizedAPMStatus_Started_getInstance(), TokenizedAPMStatus_Authorized_getInstance(), TokenizedAPMStatus_Confirmed_getInstance(), TokenizedAPMStatus_Failed_getInstance()];
  }
  function valueOf_81(value) {
    switch (value) {
      case 'FetchConfig':
        return TokenizedAPMStatus_FetchConfig_getInstance();
      case 'Started':
        return TokenizedAPMStatus_Started_getInstance();
      case 'Authorized':
        return TokenizedAPMStatus_Authorized_getInstance();
      case 'Confirmed':
        return TokenizedAPMStatus_Confirmed_getInstance();
      case 'Failed':
        return TokenizedAPMStatus_Failed_getInstance();
      default:
        TokenizedAPMStatus_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var TokenizedAPMStatus_entriesInitialized;
  function TokenizedAPMStatus_initEntries() {
    if (TokenizedAPMStatus_entriesInitialized)
      return Unit_instance;
    TokenizedAPMStatus_entriesInitialized = true;
    TokenizedAPMStatus_FetchConfig_instance = new TokenizedAPMStatus('FetchConfig', 0, 'FetchConfig');
    TokenizedAPMStatus_Started_instance = new TokenizedAPMStatus('Started', 1, 'Started');
    TokenizedAPMStatus_Authorized_instance = new TokenizedAPMStatus('Authorized', 2, 'Authorized');
    TokenizedAPMStatus_Confirmed_instance = new TokenizedAPMStatus('Confirmed', 3, 'Confirmed');
    TokenizedAPMStatus_Failed_instance = new TokenizedAPMStatus('Failed', 4, 'Failed');
  }
  function TokenizedAPMStatus(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(TokenizedAPMStatus).r = function () {
    return this.value;
  };
  function TokenizedAPMStatus_FetchConfig_getInstance() {
    TokenizedAPMStatus_initEntries();
    return TokenizedAPMStatus_FetchConfig_instance;
  }
  function TokenizedAPMStatus_Started_getInstance() {
    TokenizedAPMStatus_initEntries();
    return TokenizedAPMStatus_Started_instance;
  }
  function TokenizedAPMStatus_Authorized_getInstance() {
    TokenizedAPMStatus_initEntries();
    return TokenizedAPMStatus_Authorized_instance;
  }
  function TokenizedAPMStatus_Confirmed_getInstance() {
    TokenizedAPMStatus_initEntries();
    return TokenizedAPMStatus_Confirmed_instance;
  }
  function TokenizedAPMStatus_Failed_getInstance() {
    TokenizedAPMStatus_initEntries();
    return TokenizedAPMStatus_Failed_instance;
  }
  function Metadata_105() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_105).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_105;
  function Metadata_getInstance_105() {
    return Metadata_instance_105;
  }
  function TooFarToDeliverScreenDissmissed(isSameCity) {
    Event.call(this, 'Too Far To Deliver Screen Dismissed', VOID, 'CK: Checkout', mapOf_0(to('isSameCity', isSameCity == null ? null : get_value_0(isSameCity))));
  }
  function Metadata_106() {
    this.OWNER = 'CK: Checkout';
  }
  protoOf(Metadata_106).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_106;
  function Metadata_getInstance_106() {
    return Metadata_instance_106;
  }
  function TooFarToDeliverScreenShown(isSameCity) {
    Screen.call(this, 'Too Far To Deliver Screen Shown', 'CK: Checkout', mapOf_0(to('isSameCity', isSameCity == null ? null : get_value_0(isSameCity))));
  }
  function Metadata_107() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_107).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_107;
  function Metadata_getInstance_107() {
    return Metadata_instance_107;
  }
  function UseCurrentLocationPressed(source) {
    source = source === VOID ? null : source;
    Event.call(this, 'Use Current Location Button Pressed', VOID, 'TREX: Tracking and Reviews Experience', mapOf_0(to('source', source == null ? null : source.value)));
  }
  var UseCurrentLocationSource_HomeGlobal_instance;
  var UseCurrentLocationSource_HomeCountry_instance;
  var UseCurrentLocationSource_HomeCity_instance;
  var UseCurrentLocationSource_Store_instance;
  var UseCurrentLocationSource_StoreFunnel_instance;
  var UseCurrentLocationSource_Checkout_instance;
  function values_82() {
    return [UseCurrentLocationSource_HomeGlobal_getInstance(), UseCurrentLocationSource_HomeCountry_getInstance(), UseCurrentLocationSource_HomeCity_getInstance(), UseCurrentLocationSource_Store_getInstance(), UseCurrentLocationSource_StoreFunnel_getInstance(), UseCurrentLocationSource_Checkout_getInstance()];
  }
  function valueOf_82(value) {
    switch (value) {
      case 'HomeGlobal':
        return UseCurrentLocationSource_HomeGlobal_getInstance();
      case 'HomeCountry':
        return UseCurrentLocationSource_HomeCountry_getInstance();
      case 'HomeCity':
        return UseCurrentLocationSource_HomeCity_getInstance();
      case 'Store':
        return UseCurrentLocationSource_Store_getInstance();
      case 'StoreFunnel':
        return UseCurrentLocationSource_StoreFunnel_getInstance();
      case 'Checkout':
        return UseCurrentLocationSource_Checkout_getInstance();
      default:
        UseCurrentLocationSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var UseCurrentLocationSource_entriesInitialized;
  function UseCurrentLocationSource_initEntries() {
    if (UseCurrentLocationSource_entriesInitialized)
      return Unit_instance;
    UseCurrentLocationSource_entriesInitialized = true;
    UseCurrentLocationSource_HomeGlobal_instance = new UseCurrentLocationSource('HomeGlobal', 0, 'Home Global');
    UseCurrentLocationSource_HomeCountry_instance = new UseCurrentLocationSource('HomeCountry', 1, 'Home Country');
    UseCurrentLocationSource_HomeCity_instance = new UseCurrentLocationSource('HomeCity', 2, 'Home city');
    UseCurrentLocationSource_Store_instance = new UseCurrentLocationSource('Store', 3, 'Store');
    UseCurrentLocationSource_StoreFunnel_instance = new UseCurrentLocationSource('StoreFunnel', 4, 'Store Funnel');
    UseCurrentLocationSource_Checkout_instance = new UseCurrentLocationSource('Checkout', 5, 'Checkout');
  }
  function UseCurrentLocationSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(UseCurrentLocationSource).r = function () {
    return this.value;
  };
  function UseCurrentLocationSource_HomeGlobal_getInstance() {
    UseCurrentLocationSource_initEntries();
    return UseCurrentLocationSource_HomeGlobal_instance;
  }
  function UseCurrentLocationSource_HomeCountry_getInstance() {
    UseCurrentLocationSource_initEntries();
    return UseCurrentLocationSource_HomeCountry_instance;
  }
  function UseCurrentLocationSource_HomeCity_getInstance() {
    UseCurrentLocationSource_initEntries();
    return UseCurrentLocationSource_HomeCity_instance;
  }
  function UseCurrentLocationSource_Store_getInstance() {
    UseCurrentLocationSource_initEntries();
    return UseCurrentLocationSource_Store_instance;
  }
  function UseCurrentLocationSource_StoreFunnel_getInstance() {
    UseCurrentLocationSource_initEntries();
    return UseCurrentLocationSource_StoreFunnel_instance;
  }
  function UseCurrentLocationSource_Checkout_getInstance() {
    UseCurrentLocationSource_initEntries();
    return UseCurrentLocationSource_Checkout_instance;
  }
  function UserLoggedIn(userRegistrationType, isNewUser) {
    var tmp = to('userRegistrationType', userRegistrationType == null ? null : userRegistrationType.value);
    Event.call(this, 'User Logged In', VOID, VOID, mapOf([tmp, to('isNewUser', isNewUser == null ? null : get_value_0(isNewUser))]));
  }
  var UserRegistrationType_Email_instance;
  var UserRegistrationType_Facebook_instance;
  var UserRegistrationType_Apple_instance;
  var UserRegistrationType_Migration_instance;
  var UserRegistrationType_Google_instance;
  var UserRegistrationType_Phone_instance;
  function values_83() {
    return [UserRegistrationType_Email_getInstance(), UserRegistrationType_Facebook_getInstance(), UserRegistrationType_Apple_getInstance(), UserRegistrationType_Migration_getInstance(), UserRegistrationType_Google_getInstance(), UserRegistrationType_Phone_getInstance()];
  }
  function valueOf_83(value) {
    switch (value) {
      case 'Email':
        return UserRegistrationType_Email_getInstance();
      case 'Facebook':
        return UserRegistrationType_Facebook_getInstance();
      case 'Apple':
        return UserRegistrationType_Apple_getInstance();
      case 'Migration':
        return UserRegistrationType_Migration_getInstance();
      case 'Google':
        return UserRegistrationType_Google_getInstance();
      case 'Phone':
        return UserRegistrationType_Phone_getInstance();
      default:
        UserRegistrationType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var UserRegistrationType_entriesInitialized;
  function UserRegistrationType_initEntries() {
    if (UserRegistrationType_entriesInitialized)
      return Unit_instance;
    UserRegistrationType_entriesInitialized = true;
    UserRegistrationType_Email_instance = new UserRegistrationType('Email', 0, 'Email');
    UserRegistrationType_Facebook_instance = new UserRegistrationType('Facebook', 1, 'Facebook');
    UserRegistrationType_Apple_instance = new UserRegistrationType('Apple', 2, 'Apple');
    UserRegistrationType_Migration_instance = new UserRegistrationType('Migration', 3, 'Migration');
    UserRegistrationType_Google_instance = new UserRegistrationType('Google', 4, 'Google');
    UserRegistrationType_Phone_instance = new UserRegistrationType('Phone', 5, 'Phone');
  }
  function UserRegistrationType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(UserRegistrationType).r = function () {
    return this.value;
  };
  function UserRegistrationType_Email_getInstance() {
    UserRegistrationType_initEntries();
    return UserRegistrationType_Email_instance;
  }
  function UserRegistrationType_Facebook_getInstance() {
    UserRegistrationType_initEntries();
    return UserRegistrationType_Facebook_instance;
  }
  function UserRegistrationType_Apple_getInstance() {
    UserRegistrationType_initEntries();
    return UserRegistrationType_Apple_instance;
  }
  function UserRegistrationType_Migration_getInstance() {
    UserRegistrationType_initEntries();
    return UserRegistrationType_Migration_instance;
  }
  function UserRegistrationType_Google_getInstance() {
    UserRegistrationType_initEntries();
    return UserRegistrationType_Google_instance;
  }
  function UserRegistrationType_Phone_getInstance() {
    UserRegistrationType_initEntries();
    return UserRegistrationType_Phone_instance;
  }
  function UserSignedUp(userRegistrationType) {
    Event.call(this, 'User Signed Up', VOID, VOID, mapOf_0(to('userRegistrationType', userRegistrationType == null ? null : userRegistrationType.value)));
  }
  function All(storeAddressIds, productIds) {
    var tmp = to('storeAddressIds', storeAddressIds == null ? null : get_value_2(storeAddressIds));
    WebSearchType.call(this, 'All', mapOf([tmp, to('productIds', productIds == null ? null : get_value_2(productIds))]));
  }
  protoOf(All).toString = function () {
    return 'All(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Products_0(productIds) {
    WebSearchType.call(this, 'Products', mapOf_0(to('productIds', productIds == null ? null : get_value_2(productIds))));
  }
  protoOf(Products_0).toString = function () {
    return 'Products(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Stores_0(storeAddressIds) {
    WebSearchType.call(this, 'Stores', mapOf_0(to('storeAddressIds', storeAddressIds == null ? null : get_value_2(storeAddressIds))));
  }
  protoOf(Stores_0).toString = function () {
    return 'Stores(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function WebSearchType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(WebSearchType).r = function () {
    return this.value;
  };
  protoOf(WebSearchType).qa = function () {
    return this.data;
  };
  protoOf(WebSearchType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(WebSearchType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof WebSearchType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function WidgetContentImpression(widgetId, widgetName, widgetTitle, widgetType, widgetPosition, position, widgetContentType, properties, widgetAppLocation) {
    widgetAppLocation = widgetAppLocation === VOID ? null : widgetAppLocation;
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('widgetName', widgetName == null ? null : get_value(widgetName));
    var tmp_1 = to('widgetTitle', widgetTitle == null ? null : get_value(widgetTitle));
    var tmp_2 = to('widgetType', widgetType == null ? null : get_value(widgetType));
    var tmp_3 = to('widgetPosition', widgetPosition == null ? null : get_value_1(widgetPosition));
    var tmp_4 = to('position', position == null ? null : get_value_1(position));
    var tmp_5 = to('widgetContentType', widgetContentType == null ? null : widgetContentType.value);
    var tmp_6 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation))]);
    var tmp9_elvis_lhs = widgetContentType == null ? null : widgetContentType.data;
    var tmp_7 = plus(tmp_6, tmp9_elvis_lhs == null ? emptyMap() : tmp9_elvis_lhs);
    var tmp11_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Widget Content Impression', VOID, VOID, plus(tmp_7, tmp11_elvis_lhs == null ? emptyMap() : tmp11_elvis_lhs));
  }
  function Store_3(storeAddressId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    WidgetContentImpressionType.call(this, 'Store', mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  protoOf(Store_3).toString = function () {
    return 'Store(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Product(productId, productExternalId, storeProductId) {
    productId = productId === VOID ? null : productId;
    productExternalId = productExternalId === VOID ? null : productExternalId;
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    var tmp_0 = to('productExternalId', productExternalId == null ? null : get_value(productExternalId));
    WidgetContentImpressionType.call(this, 'Product', mapOf([tmp, tmp_0, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  protoOf(Product).toString = function () {
    return 'Product(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Other_6() {
    Other_instance_6 = this;
    WidgetContentImpressionType.call(this, 'Other');
  }
  protoOf(Other_6).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_6;
  function Other_getInstance_6() {
    if (Other_instance_6 == null)
      new Other_6();
    return Other_instance_6;
  }
  function WidgetContentImpressionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(WidgetContentImpressionType).r = function () {
    return this.value;
  };
  protoOf(WidgetContentImpressionType).qa = function () {
    return this.data;
  };
  protoOf(WidgetContentImpressionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(WidgetContentImpressionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof WidgetContentImpressionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function Stores_1(storeAddresses, storesTags) {
    storesTags = storesTags === VOID ? null : storesTags;
    var tmp = to('storeAddresses', storeAddresses == null ? null : get_value_2(storeAddresses));
    WidgetElementsShown.call(this, 'Stores', mapOf([tmp, to('storesTags', storesTags == null ? null : get_value_2(storesTags))]));
  }
  protoOf(Stores_1).toString = function () {
    return 'Stores(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Products_1(productIds, externalProductsIds, productsTags, storeAddresses, selectionStrategy, storeProductsIds) {
    externalProductsIds = externalProductsIds === VOID ? null : externalProductsIds;
    productsTags = productsTags === VOID ? null : productsTags;
    storeAddresses = storeAddresses === VOID ? null : storeAddresses;
    selectionStrategy = selectionStrategy === VOID ? null : selectionStrategy;
    storeProductsIds = storeProductsIds === VOID ? null : storeProductsIds;
    var tmp = to('productIds', productIds == null ? null : get_value_2(productIds));
    var tmp_0 = to('externalProductsIds', externalProductsIds == null ? null : get_value_2(externalProductsIds));
    var tmp_1 = to('productsTags', productsTags == null ? null : get_value_2(productsTags));
    var tmp_2 = to('storeAddresses', storeAddresses == null ? null : get_value_2(storeAddresses));
    var tmp_3 = to('selectionStrategy', selectionStrategy == null ? null : get_value(selectionStrategy));
    WidgetElementsShown.call(this, 'Products', mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, to('storeProductsIds', storeProductsIds == null ? null : get_value_2(storeProductsIds))]));
  }
  protoOf(Products_1).toString = function () {
    return 'Products(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Videos(videoIds, storeAddressIds, productIds, externalProductsIds, storeProductsIds) {
    externalProductsIds = externalProductsIds === VOID ? null : externalProductsIds;
    storeProductsIds = storeProductsIds === VOID ? null : storeProductsIds;
    var tmp = to('videoIds', videoIds == null ? null : get_value_2(videoIds));
    var tmp_0 = to('storeAddressIds', storeAddressIds == null ? null : get_value_2(storeAddressIds));
    var tmp_1 = to('productIds', productIds == null ? null : get_value_2(productIds));
    var tmp_2 = to('externalProductsIds', externalProductsIds == null ? null : get_value_2(externalProductsIds));
    WidgetElementsShown.call(this, 'Videos', mapOf([tmp, tmp_0, tmp_1, tmp_2, to('storeProductsIds', storeProductsIds == null ? null : get_value_2(storeProductsIds))]));
  }
  protoOf(Videos).toString = function () {
    return 'Videos(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Playlists(playlistIds) {
    WidgetElementsShown.call(this, 'Playlists', mapOf_0(to('playlistIds', playlistIds == null ? null : get_value_2(playlistIds))));
  }
  protoOf(Playlists).toString = function () {
    return 'Playlists(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function WidgetElementsShown(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(WidgetElementsShown).r = function () {
    return this.value;
  };
  protoOf(WidgetElementsShown).qa = function () {
    return this.data;
  };
  protoOf(WidgetElementsShown).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(WidgetElementsShown).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof WidgetElementsShown) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function WidgetFilterDisplayed(widgetId, filterName, attributeName, position) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('filterName', filterName == null ? null : filterName.value);
    var tmp_1 = to('attributeName', attributeName == null ? null : get_value(attributeName));
    Event.call(this, 'Widget Filter Displayed', VOID, VOID, mapOf([tmp, tmp_0, tmp_1, to('position', position == null ? null : get_value_1(position))]));
  }
  function WidgetImpression(widgetId, widgetName, widgetTitle, widgetType, position, properties, widgetElementsShown, widgetAppLocation, categoryId, widgetLayout, filters, ncrRequestToken, shopsIds, occasion, priceThreshold, searchId, categoryGroupId) {
    widgetElementsShown = widgetElementsShown === VOID ? null : widgetElementsShown;
    widgetAppLocation = widgetAppLocation === VOID ? null : widgetAppLocation;
    categoryId = categoryId === VOID ? null : categoryId;
    widgetLayout = widgetLayout === VOID ? null : widgetLayout;
    filters = filters === VOID ? null : filters;
    ncrRequestToken = ncrRequestToken === VOID ? null : ncrRequestToken;
    shopsIds = shopsIds === VOID ? null : shopsIds;
    occasion = occasion === VOID ? null : occasion;
    priceThreshold = priceThreshold === VOID ? null : priceThreshold;
    searchId = searchId === VOID ? null : searchId;
    categoryGroupId = categoryGroupId === VOID ? null : categoryGroupId;
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('widgetName', widgetName == null ? null : get_value(widgetName));
    var tmp_1 = to('widgetTitle', widgetTitle == null ? null : get_value(widgetTitle));
    var tmp_2 = to('widgetType', widgetType == null ? null : get_value(widgetType));
    var tmp_3 = to('position', position == null ? null : get_value_1(position));
    var tmp_4 = to('widgetElementsShown', widgetElementsShown == null ? null : widgetElementsShown.value);
    var tmp_5 = to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation));
    var tmp_6 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_7 = to('widgetLayout', widgetLayout == null ? null : widgetLayout.value);
    var tmp_8 = to('filters', filters == null ? null : get_value_2(filters));
    var tmp_9 = to('ncrRequestToken', ncrRequestToken == null ? null : get_value(ncrRequestToken));
    var tmp_10 = to('shopsIds', shopsIds == null ? null : get_value(shopsIds));
    var tmp_11 = to('occasion', occasion == null ? null : get_value(occasion));
    var tmp_12 = to('priceThreshold', priceThreshold == null ? null : get_value_1(priceThreshold));
    var tmp_13 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_14 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))]);
    var tmp17_elvis_lhs = properties == null ? null : get_data(properties);
    var tmp_15 = plus(tmp_14, tmp17_elvis_lhs == null ? emptyMap() : tmp17_elvis_lhs);
    var tmp19_elvis_lhs = widgetElementsShown == null ? null : widgetElementsShown.data;
    var tmp_16 = plus(tmp_15, tmp19_elvis_lhs == null ? emptyMap() : tmp19_elvis_lhs);
    var tmp21_elvis_lhs = widgetLayout == null ? null : widgetLayout.data;
    Event.call(this, 'Widget Impression', VOID, VOID, plus(tmp_16, tmp21_elvis_lhs == null ? emptyMap() : tmp21_elvis_lhs));
  }
  function WidgetInteracted(widgetId, widgetName, widgetTitle, widgetType, widgetInteractionType, position, properties, widgetAppLocation, categoryId, widgetLayout, filters, searchId, categoryGroupId) {
    widgetTitle = widgetTitle === VOID ? null : widgetTitle;
    widgetAppLocation = widgetAppLocation === VOID ? null : widgetAppLocation;
    categoryId = categoryId === VOID ? null : categoryId;
    widgetLayout = widgetLayout === VOID ? null : widgetLayout;
    filters = filters === VOID ? null : filters;
    searchId = searchId === VOID ? null : searchId;
    categoryGroupId = categoryGroupId === VOID ? null : categoryGroupId;
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('widgetName', widgetName == null ? null : get_value(widgetName));
    var tmp_1 = to('widgetTitle', widgetTitle == null ? null : get_value(widgetTitle));
    var tmp_2 = to('widgetType', widgetType == null ? null : get_value(widgetType));
    var tmp_3 = to('widgetInteractionType', widgetInteractionType == null ? null : widgetInteractionType.value);
    var tmp_4 = to('position', position == null ? null : get_value_1(position));
    var tmp_5 = to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation));
    var tmp_6 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_7 = to('widgetLayout', widgetLayout == null ? null : widgetLayout.value);
    var tmp_8 = to('filters', filters == null ? null : get_value_2(filters));
    var tmp_9 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_10 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId))]);
    var tmp13_elvis_lhs = widgetInteractionType == null ? null : widgetInteractionType.data;
    var tmp_11 = plus(tmp_10, tmp13_elvis_lhs == null ? emptyMap() : tmp13_elvis_lhs);
    var tmp15_elvis_lhs = properties == null ? null : get_data(properties);
    var tmp_12 = plus(tmp_11, tmp15_elvis_lhs == null ? emptyMap() : tmp15_elvis_lhs);
    var tmp17_elvis_lhs = widgetLayout == null ? null : widgetLayout.data;
    Event.call(this, 'Widget Interacted', VOID, VOID, plus(tmp_12, tmp17_elvis_lhs == null ? emptyMap() : tmp17_elvis_lhs));
  }
  function CtaSelected_0() {
    CtaSelected_instance_0 = this;
    WidgetInteractionType.call(this, 'CtaSelected');
  }
  protoOf(CtaSelected_0).toString = function () {
    return 'CtaSelected(value=' + this.value + ')';
  };
  var CtaSelected_instance_0;
  function CtaSelected_getInstance_0() {
    if (CtaSelected_instance_0 == null)
      new CtaSelected_0();
    return CtaSelected_instance_0;
  }
  function StoreSelected_0(storeAddressId) {
    WidgetInteractionType.call(this, 'StoreSelected', mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  protoOf(StoreSelected_0).toString = function () {
    return 'StoreSelected(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function ProductSelected_0(productId, storeProductId) {
    storeProductId = storeProductId === VOID ? null : storeProductId;
    var tmp = to('productId', productId == null ? null : get_value_1(productId));
    WidgetInteractionType.call(this, 'ProductSelected', mapOf([tmp, to('storeProductId', storeProductId == null ? null : get_value(storeProductId))]));
  }
  protoOf(ProductSelected_0).toString = function () {
    return 'ProductSelected(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function VideoSelected(videoId) {
    WidgetInteractionType.call(this, 'VideoSelected', mapOf_0(to('videoId', videoId == null ? null : get_value_1(videoId))));
  }
  protoOf(VideoSelected).toString = function () {
    return 'VideoSelected(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function Other_7() {
    Other_instance_7 = this;
    WidgetInteractionType.call(this, 'Other');
  }
  protoOf(Other_7).toString = function () {
    return 'Other(value=' + this.value + ')';
  };
  var Other_instance_7;
  function Other_getInstance_7() {
    if (Other_instance_7 == null)
      new Other_7();
    return Other_instance_7;
  }
  function PlaylistSelected(playlistId) {
    WidgetInteractionType.call(this, 'PlaylistSelected', mapOf_0(to('playlistId', playlistId == null ? null : get_value(playlistId))));
  }
  protoOf(PlaylistSelected).toString = function () {
    return 'PlaylistSelected(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function WidgetInteractionType(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(WidgetInteractionType).r = function () {
    return this.value;
  };
  protoOf(WidgetInteractionType).qa = function () {
    return this.data;
  };
  protoOf(WidgetInteractionType).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(WidgetInteractionType).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof WidgetInteractionType) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function StoreCardCarousel() {
    StoreCardCarousel_instance = this;
    WidgetLayout.call(this, 'StoreCardCarousel');
  }
  protoOf(StoreCardCarousel).toString = function () {
    return 'StoreCardCarousel(value=' + this.value + ')';
  };
  var StoreCardCarousel_instance;
  function StoreCardCarousel_getInstance() {
    if (StoreCardCarousel_instance == null)
      new StoreCardCarousel();
    return StoreCardCarousel_instance;
  }
  function ProductCarousel() {
    ProductCarousel_instance = this;
    WidgetLayout.call(this, 'ProductCarousel');
  }
  protoOf(ProductCarousel).toString = function () {
    return 'ProductCarousel(value=' + this.value + ')';
  };
  var ProductCarousel_instance;
  function ProductCarousel_getInstance() {
    if (ProductCarousel_instance == null)
      new ProductCarousel();
    return ProductCarousel_instance;
  }
  function StoreLogoCarousel() {
    StoreLogoCarousel_instance = this;
    WidgetLayout.call(this, 'StoreLogoCarousel');
  }
  protoOf(StoreLogoCarousel).toString = function () {
    return 'StoreLogoCarousel(value=' + this.value + ')';
  };
  var StoreLogoCarousel_instance;
  function StoreLogoCarousel_getInstance() {
    if (StoreLogoCarousel_instance == null)
      new StoreLogoCarousel();
    return StoreLogoCarousel_instance;
  }
  function VideoCarousel() {
    VideoCarousel_instance = this;
    WidgetLayout.call(this, 'VideoCarousel');
  }
  protoOf(VideoCarousel).toString = function () {
    return 'VideoCarousel(value=' + this.value + ')';
  };
  var VideoCarousel_instance;
  function VideoCarousel_getInstance() {
    if (VideoCarousel_instance == null)
      new VideoCarousel();
    return VideoCarousel_instance;
  }
  function StoreLogoGrid(rowNum, isScrollable) {
    isScrollable = isScrollable === VOID ? null : isScrollable;
    var tmp = to('rowNum', rowNum == null ? null : get_value_1(rowNum));
    WidgetLayout.call(this, 'StoreLogoGrid', mapOf([tmp, to('isScrollable', isScrollable == null ? null : get_value_0(isScrollable))]));
  }
  protoOf(StoreLogoGrid).toString = function () {
    return 'StoreLogoGrid(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function ProductGrid(rowNum, isScrollable) {
    isScrollable = isScrollable === VOID ? null : isScrollable;
    var tmp = to('rowNum', rowNum == null ? null : get_value_1(rowNum));
    WidgetLayout.call(this, 'ProductGrid', mapOf([tmp, to('isScrollable', isScrollable == null ? null : get_value_0(isScrollable))]));
  }
  protoOf(ProductGrid).toString = function () {
    return 'ProductGrid(value=' + this.value + ', data=' + toString(this.data) + ')';
  };
  function PlaylistCarousel() {
    PlaylistCarousel_instance = this;
    WidgetLayout.call(this, 'PlaylistCarousel');
  }
  protoOf(PlaylistCarousel).toString = function () {
    return 'PlaylistCarousel(value=' + this.value + ')';
  };
  var PlaylistCarousel_instance;
  function PlaylistCarousel_getInstance() {
    if (PlaylistCarousel_instance == null)
      new PlaylistCarousel();
    return PlaylistCarousel_instance;
  }
  function WidgetLayout(value, data) {
    data = data === VOID ? emptyMap() : data;
    this.value = value;
    this.data = data;
  }
  protoOf(WidgetLayout).r = function () {
    return this.value;
  };
  protoOf(WidgetLayout).qa = function () {
    return this.data;
  };
  protoOf(WidgetLayout).hashCode = function () {
    return getStringHashCode(this.value);
  };
  protoOf(WidgetLayout).equals = function (other) {
    var tmp;
    var tmp_0;
    if (other instanceof WidgetLayout) {
      tmp_0 = this.value === other.value;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.data, other.data);
    } else {
      tmp = false;
    }
    return tmp;
  };
  function WidgetLoaded(widgetId, widgetName, position, widgetTitle, widgetType, widgetLayout, widgetAppLocation, categoryId, widgetElementsShown, filters, ncrRequestToken, shopsIds, searchId, categoryGroupId, contextualAttributeList) {
    widgetLayout = widgetLayout === VOID ? null : widgetLayout;
    widgetAppLocation = widgetAppLocation === VOID ? null : widgetAppLocation;
    categoryId = categoryId === VOID ? null : categoryId;
    widgetElementsShown = widgetElementsShown === VOID ? null : widgetElementsShown;
    filters = filters === VOID ? null : filters;
    ncrRequestToken = ncrRequestToken === VOID ? null : ncrRequestToken;
    shopsIds = shopsIds === VOID ? null : shopsIds;
    searchId = searchId === VOID ? null : searchId;
    categoryGroupId = categoryGroupId === VOID ? null : categoryGroupId;
    contextualAttributeList = contextualAttributeList === VOID ? null : contextualAttributeList;
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = to('widgetName', widgetName == null ? null : get_value(widgetName));
    var tmp_1 = to('position', position == null ? null : get_value_1(position));
    var tmp_2 = to('widgetTitle', widgetTitle == null ? null : get_value(widgetTitle));
    var tmp_3 = to('widgetType', widgetType == null ? null : get_value(widgetType));
    var tmp_4 = to('widgetLayout', widgetLayout == null ? null : widgetLayout.value);
    var tmp_5 = to('widgetAppLocation', widgetAppLocation == null ? null : get_value(widgetAppLocation));
    var tmp_6 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    var tmp_7 = to('widgetElementsShown', widgetElementsShown == null ? null : widgetElementsShown.value);
    var tmp_8 = to('filters', filters == null ? null : get_value_2(filters));
    var tmp_9 = to('ncrRequestToken', ncrRequestToken == null ? null : get_value(ncrRequestToken));
    var tmp_10 = to('shopsIds', shopsIds == null ? null : get_value(shopsIds));
    var tmp_11 = to('searchId', searchId == null ? null : get_value(searchId));
    var tmp_12 = to('categoryGroupId', categoryGroupId == null ? null : get_value_1(categoryGroupId));
    var tmp_13 = mapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, to('contextualAttributeList', contextualAttributeList == null ? null : get_value(contextualAttributeList))]);
    var tmp16_elvis_lhs = widgetLayout == null ? null : widgetLayout.data;
    var tmp_14 = plus(tmp_13, tmp16_elvis_lhs == null ? emptyMap() : tmp16_elvis_lhs);
    var tmp18_elvis_lhs = widgetElementsShown == null ? null : widgetElementsShown.data;
    Event.call(this, 'Widget Loaded', VOID, VOID, plus(tmp_14, tmp18_elvis_lhs == null ? emptyMap() : tmp18_elvis_lhs));
  }
  function WidgetStoreImpression(widgetId, position, properties) {
    var tmp = to('widgetId', widgetId == null ? null : get_value(widgetId));
    var tmp_0 = mapOf([tmp, to('position', position == null ? null : get_value_1(position))]);
    var tmp3_elvis_lhs = properties == null ? null : get_data(properties);
    Event.call(this, 'Widget Store Impression', VOID, VOID, plus(tmp_0, tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs));
  }
  function WidgetsLoaded(widgetsLoaded) {
    Event.call(this, 'Widgets Loaded', VOID, VOID, mapOf_0(to('widgetsLoaded', widgetsLoaded == null ? null : get_value_2(widgetsLoaded))));
  }
  function WrongCredentials() {
    Event.call(this, 'Wrong Credentials');
  }
  function Account(accountSection) {
    Screen.call(this, 'Account', VOID, mapOf_0(to('accountSection', accountSection == null ? null : get_value_1(accountSection))));
  }
  function AccountSectionTapped(accountSection) {
    Event.call(this, 'Account Section Tapped', VOID, VOID, mapOf_0(to('accountSection', accountSection == null ? null : get_value_1(accountSection))));
  }
  function Metadata_108() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_108).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_108;
  function Metadata_getInstance_108() {
    return Metadata_instance_108;
  }
  function AddDeliveryAddressOnStorePage(storeAddressId) {
    Event.call(this, 'Add Delivery Adress on Store Page', VOID, 'TREX: Tracking and Reviews Experience', mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  function Metadata_109() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_109).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_109;
  function Metadata_getInstance_109() {
    return Metadata_instance_109;
  }
  function AddressCreationOnStorePage(storeAddressId, deviceId) {
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Screen.call(this, 'Address Creation on Store Page Popup Screen', 'TREX: Tracking and Reviews Experience', mapOf([tmp, to('deviceId', deviceId == null ? null : get_value_1(deviceId))]));
  }
  function Metadata_110() {
    this.OWNER = 'TREX: Tracking and Reviews Experience';
  }
  protoOf(Metadata_110).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_110;
  function Metadata_getInstance_110() {
    return Metadata_instance_110;
  }
  function AddressOutsideStoreDeliveryZoneScreen(storeAddressId) {
    storeAddressId = storeAddressId === VOID ? null : storeAddressId;
    Screen.call(this, 'Address Outside Store Delivery Zone Screen', 'TREX: Tracking and Reviews Experience', mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  var AvailableButtons_NoSchedulingOption_instance;
  var AvailableButtons_SchedulingOption_instance;
  function values_84() {
    return [AvailableButtons_NoSchedulingOption_getInstance(), AvailableButtons_SchedulingOption_getInstance()];
  }
  function valueOf_84(value) {
    switch (value) {
      case 'NoSchedulingOption':
        return AvailableButtons_NoSchedulingOption_getInstance();
      case 'SchedulingOption':
        return AvailableButtons_SchedulingOption_getInstance();
      default:
        AvailableButtons_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var AvailableButtons_entriesInitialized;
  function AvailableButtons_initEntries() {
    if (AvailableButtons_entriesInitialized)
      return Unit_instance;
    AvailableButtons_entriesInitialized = true;
    AvailableButtons_NoSchedulingOption_instance = new AvailableButtons('NoSchedulingOption', 0, 'Only stores nearby');
    AvailableButtons_SchedulingOption_instance = new AvailableButtons('SchedulingOption', 1, 'Stores Nearby and Scheduling');
  }
  function AvailableButtons(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(AvailableButtons).r = function () {
    return this.value;
  };
  function AvailableButtons_NoSchedulingOption_getInstance() {
    AvailableButtons_initEntries();
    return AvailableButtons_NoSchedulingOption_instance;
  }
  function AvailableButtons_SchedulingOption_getInstance() {
    AvailableButtons_initEntries();
    return AvailableButtons_SchedulingOption_instance;
  }
  function Metadata_111() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_111).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_111;
  function Metadata_getInstance_111() {
    return Metadata_instance_111;
  }
  function CartScreen(storeAddressId, categoryId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Cart Screen', VOID, 'WASP: Web Acquisition Store Page', mapOf([tmp, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  function DownloadPressed(downloadPressedSource, osPicked) {
    var tmp = to('downloadPressedSource', downloadPressedSource == null ? null : downloadPressedSource.value);
    Event.call(this, 'Download pressed', VOID, VOID, mapOf([tmp, to('osPicked', osPicked == null ? null : osPicked.value)]));
  }
  var DownloadPressedSource_Home_instance;
  var DownloadPressedSource_HomeGlobal_instance;
  var DownloadPressedSource_HomeCountry_instance;
  var DownloadPressedSource_OngoingOrderDetails_instance;
  var DownloadPressedSource_Other_instance;
  function values_85() {
    return [DownloadPressedSource_Home_getInstance(), DownloadPressedSource_HomeGlobal_getInstance(), DownloadPressedSource_HomeCountry_getInstance(), DownloadPressedSource_OngoingOrderDetails_getInstance(), DownloadPressedSource_Other_getInstance()];
  }
  function valueOf_85(value) {
    switch (value) {
      case 'Home':
        return DownloadPressedSource_Home_getInstance();
      case 'HomeGlobal':
        return DownloadPressedSource_HomeGlobal_getInstance();
      case 'HomeCountry':
        return DownloadPressedSource_HomeCountry_getInstance();
      case 'OngoingOrderDetails':
        return DownloadPressedSource_OngoingOrderDetails_getInstance();
      case 'Other':
        return DownloadPressedSource_Other_getInstance();
      default:
        DownloadPressedSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var DownloadPressedSource_entriesInitialized;
  function DownloadPressedSource_initEntries() {
    if (DownloadPressedSource_entriesInitialized)
      return Unit_instance;
    DownloadPressedSource_entriesInitialized = true;
    DownloadPressedSource_Home_instance = new DownloadPressedSource('Home', 0, 'Home');
    DownloadPressedSource_HomeGlobal_instance = new DownloadPressedSource('HomeGlobal', 1, 'Home Global');
    DownloadPressedSource_HomeCountry_instance = new DownloadPressedSource('HomeCountry', 2, 'Home Country');
    DownloadPressedSource_OngoingOrderDetails_instance = new DownloadPressedSource('OngoingOrderDetails', 3, 'Ongoing Order Details');
    DownloadPressedSource_Other_instance = new DownloadPressedSource('Other', 4, 'Unknown source');
  }
  function DownloadPressedSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(DownloadPressedSource).r = function () {
    return this.value;
  };
  function DownloadPressedSource_Home_getInstance() {
    DownloadPressedSource_initEntries();
    return DownloadPressedSource_Home_instance;
  }
  function DownloadPressedSource_HomeGlobal_getInstance() {
    DownloadPressedSource_initEntries();
    return DownloadPressedSource_HomeGlobal_instance;
  }
  function DownloadPressedSource_HomeCountry_getInstance() {
    DownloadPressedSource_initEntries();
    return DownloadPressedSource_HomeCountry_instance;
  }
  function DownloadPressedSource_OngoingOrderDetails_getInstance() {
    DownloadPressedSource_initEntries();
    return DownloadPressedSource_OngoingOrderDetails_instance;
  }
  function DownloadPressedSource_Other_getInstance() {
    DownloadPressedSource_initEntries();
    return DownloadPressedSource_Other_instance;
  }
  function Metadata_112() {
    this.OWNER = 'WALE: Web Acquisition Landing Experience';
  }
  protoOf(Metadata_112).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_112;
  function Metadata_getInstance_112() {
    return Metadata_instance_112;
  }
  function FilterPromotionsCarouselShown(filter, storeIds) {
    var tmp = to('filter', filter == null ? null : get_value(filter));
    Event.call(this, 'Impression of promotions carousel on City Filter page', VOID, 'WALE: Web Acquisition Landing Experience', mapOf([tmp, to('storeIds', storeIds == null ? null : get_value_2(storeIds))]));
  }
  function Metadata_113() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_113).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_113;
  function Metadata_getInstance_113() {
    return Metadata_instance_113;
  }
  function FreeDeliveryBanner(storeId) {
    Event.call(this, 'Free Delivery Banner Shown', VOID, 'WASP: Web Acquisition Store Page', mapOf_0(to('storeId', storeId == null ? null : get_value_1(storeId))));
  }
  function Metadata_114() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_114).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_114;
  function Metadata_getInstance_114() {
    return Metadata_instance_114;
  }
  function GetStartedButton(page, source) {
    var tmp = to('page', page == null ? null : get_value(page));
    Event.call(this, 'Get Started Button Clicked', VOID, 'WASP: Web Acquisition Store Page', mapOf([tmp, to('source', source == null ? null : source.value)]));
  }
  var GetStartedButtonSource_HeaderActionsDesktop_instance;
  var GetStartedButtonSource_HeaderActionsMobile_instance;
  var GetStartedButtonSource_TopBanner_instance;
  function values_86() {
    return [GetStartedButtonSource_HeaderActionsDesktop_getInstance(), GetStartedButtonSource_HeaderActionsMobile_getInstance(), GetStartedButtonSource_TopBanner_getInstance()];
  }
  function valueOf_86(value) {
    switch (value) {
      case 'HeaderActionsDesktop':
        return GetStartedButtonSource_HeaderActionsDesktop_getInstance();
      case 'HeaderActionsMobile':
        return GetStartedButtonSource_HeaderActionsMobile_getInstance();
      case 'TopBanner':
        return GetStartedButtonSource_TopBanner_getInstance();
      default:
        GetStartedButtonSource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var GetStartedButtonSource_entriesInitialized;
  function GetStartedButtonSource_initEntries() {
    if (GetStartedButtonSource_entriesInitialized)
      return Unit_instance;
    GetStartedButtonSource_entriesInitialized = true;
    GetStartedButtonSource_HeaderActionsDesktop_instance = new GetStartedButtonSource('HeaderActionsDesktop', 0, 'Header Desktop');
    GetStartedButtonSource_HeaderActionsMobile_instance = new GetStartedButtonSource('HeaderActionsMobile', 1, 'Header Mobile');
    GetStartedButtonSource_TopBanner_instance = new GetStartedButtonSource('TopBanner', 2, 'Top Banner');
  }
  function GetStartedButtonSource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(GetStartedButtonSource).r = function () {
    return this.value;
  };
  function GetStartedButtonSource_HeaderActionsDesktop_getInstance() {
    GetStartedButtonSource_initEntries();
    return GetStartedButtonSource_HeaderActionsDesktop_instance;
  }
  function GetStartedButtonSource_HeaderActionsMobile_getInstance() {
    GetStartedButtonSource_initEntries();
    return GetStartedButtonSource_HeaderActionsMobile_instance;
  }
  function GetStartedButtonSource_TopBanner_getInstance() {
    GetStartedButtonSource_initEntries();
    return GetStartedButtonSource_TopBanner_instance;
  }
  function GoogleOneTapDisplayed() {
    Event.call(this, 'Google One Tap Displayed');
  }
  function GoogleOneTapSkipped(reason) {
    Event.call(this, 'Google One Tap Skipped', VOID, VOID, mapOf_0(to('reason', reason == null ? null : reason.value)));
  }
  var GoogleOneTapSkippedReason_UserCancel_instance;
  var GoogleOneTapSkippedReason_TapOutside_instance;
  var GoogleOneTapSkippedReason_Other_instance;
  function values_87() {
    return [GoogleOneTapSkippedReason_UserCancel_getInstance(), GoogleOneTapSkippedReason_TapOutside_getInstance(), GoogleOneTapSkippedReason_Other_getInstance()];
  }
  function valueOf_87(value) {
    switch (value) {
      case 'UserCancel':
        return GoogleOneTapSkippedReason_UserCancel_getInstance();
      case 'TapOutside':
        return GoogleOneTapSkippedReason_TapOutside_getInstance();
      case 'Other':
        return GoogleOneTapSkippedReason_Other_getInstance();
      default:
        GoogleOneTapSkippedReason_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var GoogleOneTapSkippedReason_entriesInitialized;
  function GoogleOneTapSkippedReason_initEntries() {
    if (GoogleOneTapSkippedReason_entriesInitialized)
      return Unit_instance;
    GoogleOneTapSkippedReason_entriesInitialized = true;
    GoogleOneTapSkippedReason_UserCancel_instance = new GoogleOneTapSkippedReason('UserCancel', 0, 'UserCancel');
    GoogleOneTapSkippedReason_TapOutside_instance = new GoogleOneTapSkippedReason('TapOutside', 1, 'TapOutside');
    GoogleOneTapSkippedReason_Other_instance = new GoogleOneTapSkippedReason('Other', 2, 'Other');
  }
  function GoogleOneTapSkippedReason(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(GoogleOneTapSkippedReason).r = function () {
    return this.value;
  };
  function GoogleOneTapSkippedReason_UserCancel_getInstance() {
    GoogleOneTapSkippedReason_initEntries();
    return GoogleOneTapSkippedReason_UserCancel_instance;
  }
  function GoogleOneTapSkippedReason_TapOutside_getInstance() {
    GoogleOneTapSkippedReason_initEntries();
    return GoogleOneTapSkippedReason_TapOutside_instance;
  }
  function GoogleOneTapSkippedReason_Other_getInstance() {
    GoogleOneTapSkippedReason_initEntries();
    return GoogleOneTapSkippedReason_Other_instance;
  }
  function HomeCountry(homeCountrySource, countryCode) {
    var tmp = to('homeCountrySource', homeCountrySource == null ? null : homeCountrySource.value);
    Screen.call(this, 'Home Country', VOID, mapOf([tmp, to('countryCode', countryCode == null ? null : get_value(countryCode))]));
  }
  function HomeGlobal() {
    Screen.call(this, 'Home Global');
  }
  function Metadata_115() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_115).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_115;
  function Metadata_getInstance_115() {
    return Metadata_instance_115;
  }
  function LogInError(loginErrorMessage) {
    Event.call(this, 'Login Error', VOID, 'WASP: Web Acquisition Store Page', mapOf_0(to('loginErrorMessage', loginErrorMessage == null ? null : get_value(loginErrorMessage))));
  }
  function LogOutAttempted(origin, successful) {
    var tmp = to('origin', origin == null ? null : origin.value);
    var tmp_0 = mapOf([tmp, to('successful', successful == null ? null : get_value_0(successful))]);
    var tmp3_elvis_lhs = origin == null ? null : origin.data;
    Event.call(this, 'Log Out Attempted', VOID, VOID, plus(tmp_0, tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs));
  }
  var OsPicked_Android_instance;
  var OsPicked_IOS_instance;
  function values_88() {
    return [OsPicked_Android_getInstance(), OsPicked_IOS_getInstance()];
  }
  function valueOf_88(value) {
    switch (value) {
      case 'Android':
        return OsPicked_Android_getInstance();
      case 'IOS':
        return OsPicked_IOS_getInstance();
      default:
        OsPicked_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OsPicked_entriesInitialized;
  function OsPicked_initEntries() {
    if (OsPicked_entriesInitialized)
      return Unit_instance;
    OsPicked_entriesInitialized = true;
    OsPicked_Android_instance = new OsPicked('Android', 0, 'Android');
    OsPicked_IOS_instance = new OsPicked('IOS', 1, 'IOS');
  }
  function OsPicked(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OsPicked).r = function () {
    return this.value;
  };
  function OsPicked_Android_getInstance() {
    OsPicked_initEntries();
    return OsPicked_Android_instance;
  }
  function OsPicked_IOS_getInstance() {
    OsPicked_initEntries();
    return OsPicked_IOS_instance;
  }
  function Metadata_116() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_116).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_116;
  function Metadata_getInstance_116() {
    return Metadata_instance_116;
  }
  function OutOfDeliveryZonePopUpClosed() {
    Event.call(this, 'Out of Delivery Zone Pop Up Closed', VOID, 'WASP: Web Acquisition Store Page');
  }
  function Metadata_117() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_117).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_117;
  function Metadata_getInstance_117() {
    return Metadata_instance_117;
  }
  function OutOfDeliveryZonePopUpShown() {
    Screen.call(this, 'Out of delivery zone pop up message', 'WASP: Web Acquisition Store Page');
  }
  var OutsideStoreDeliveryZoneReason_OutOfCityZone_instance;
  var OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_instance;
  function values_89() {
    return [OutsideStoreDeliveryZoneReason_OutOfCityZone_getInstance(), OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_getInstance()];
  }
  function valueOf_89(value) {
    switch (value) {
      case 'OutOfCityZone':
        return OutsideStoreDeliveryZoneReason_OutOfCityZone_getInstance();
      case 'OutOfDeliveryZone':
        return OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_getInstance();
      default:
        OutsideStoreDeliveryZoneReason_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OutsideStoreDeliveryZoneReason_entriesInitialized;
  function OutsideStoreDeliveryZoneReason_initEntries() {
    if (OutsideStoreDeliveryZoneReason_entriesInitialized)
      return Unit_instance;
    OutsideStoreDeliveryZoneReason_entriesInitialized = true;
    OutsideStoreDeliveryZoneReason_OutOfCityZone_instance = new OutsideStoreDeliveryZoneReason('OutOfCityZone', 0, 'OutOfCityZone');
    OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_instance = new OutsideStoreDeliveryZoneReason('OutOfDeliveryZone', 1, 'OutOfDeliveryZone');
  }
  function OutsideStoreDeliveryZoneReason(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(OutsideStoreDeliveryZoneReason).r = function () {
    return this.value;
  };
  function OutsideStoreDeliveryZoneReason_OutOfCityZone_getInstance() {
    OutsideStoreDeliveryZoneReason_initEntries();
    return OutsideStoreDeliveryZoneReason_OutOfCityZone_instance;
  }
  function OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_getInstance() {
    OutsideStoreDeliveryZoneReason_initEntries();
    return OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_instance;
  }
  function Metadata_118() {
    this.OWNER = 'B2B: eLogistics Last-Mile';
  }
  protoOf(Metadata_118).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_118;
  function Metadata_getInstance_118() {
    return Metadata_instance_118;
  }
  function ParcelInformationEdit(trackingUuid) {
    Event.call(this, 'Parcel Information Edit', VOID, 'B2B: eLogistics Last-Mile', mapOf_0(to('trackingUuid', trackingUuid == null ? null : get_value(trackingUuid))));
  }
  function Metadata_119() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_119).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_119;
  function Metadata_getInstance_119() {
    return Metadata_instance_119;
  }
  function PrimeLandingPageInteracted(type) {
    Event.call(this, 'Prime Landing Page Interacted', VOID, 'GRO: Growth', mapOf_0(to('type', type == null ? null : type.value)));
  }
  var PrimeLandingPageInteractionType_GetPrimeCTA_instance;
  var PrimeLandingPageInteractionType_ExploreGlovoCTA_instance;
  function values_90() {
    return [PrimeLandingPageInteractionType_GetPrimeCTA_getInstance(), PrimeLandingPageInteractionType_ExploreGlovoCTA_getInstance()];
  }
  function valueOf_90(value) {
    switch (value) {
      case 'GetPrimeCTA':
        return PrimeLandingPageInteractionType_GetPrimeCTA_getInstance();
      case 'ExploreGlovoCTA':
        return PrimeLandingPageInteractionType_ExploreGlovoCTA_getInstance();
      default:
        PrimeLandingPageInteractionType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var PrimeLandingPageInteractionType_entriesInitialized;
  function PrimeLandingPageInteractionType_initEntries() {
    if (PrimeLandingPageInteractionType_entriesInitialized)
      return Unit_instance;
    PrimeLandingPageInteractionType_entriesInitialized = true;
    PrimeLandingPageInteractionType_GetPrimeCTA_instance = new PrimeLandingPageInteractionType('GetPrimeCTA', 0, 'GetPrimeCTA');
    PrimeLandingPageInteractionType_ExploreGlovoCTA_instance = new PrimeLandingPageInteractionType('ExploreGlovoCTA', 1, 'ExploreGlovoCTA');
  }
  function PrimeLandingPageInteractionType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(PrimeLandingPageInteractionType).r = function () {
    return this.value;
  };
  function PrimeLandingPageInteractionType_GetPrimeCTA_getInstance() {
    PrimeLandingPageInteractionType_initEntries();
    return PrimeLandingPageInteractionType_GetPrimeCTA_instance;
  }
  function PrimeLandingPageInteractionType_ExploreGlovoCTA_getInstance() {
    PrimeLandingPageInteractionType_initEntries();
    return PrimeLandingPageInteractionType_ExploreGlovoCTA_instance;
  }
  function Metadata_120() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_120).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_120;
  function Metadata_getInstance_120() {
    return Metadata_instance_120;
  }
  function PrimeLandingPageScreen() {
    Screen.call(this, 'Prime Landing Page', 'GRO: Growth');
  }
  function Metadata_121() {
    this.OWNER = 'GRO: Growth';
  }
  protoOf(Metadata_121).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_121;
  function Metadata_getInstance_121() {
    return Metadata_instance_121;
  }
  function ProfileSectionTapped(section) {
    Event.call(this, 'Profile Section Tapped', VOID, 'GRO: Growth', mapOf_0(to('section', section == null ? null : section.value)));
  }
  function Metadata_122() {
    this.OWNER = 'WALE: Web Acquisition Landing Experience';
  }
  protoOf(Metadata_122).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_122;
  function Metadata_getInstance_122() {
    return Metadata_instance_122;
  }
  function PromotionsCarouselClicked(storeId, promotionType) {
    var tmp = to('storeId', storeId == null ? null : get_value_1(storeId));
    Event.call(this, 'Interaction with promotions carousel', VOID, 'WALE: Web Acquisition Landing Experience', mapOf([tmp, to('promotionType', promotionType == null ? null : get_value(promotionType))]));
  }
  function Metadata_123() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_123).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_123;
  function Metadata_getInstance_123() {
    return Metadata_instance_123;
  }
  function PromotionsPageLanding() {
    Screen.call(this, 'Promotions Page', 'WASP: Web Acquisition Store Page');
  }
  function Metadata_124() {
    this.OWNER = 'CS: Customer Solutions';
  }
  protoOf(Metadata_124).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_124;
  function Metadata_getInstance_124() {
    return Metadata_instance_124;
  }
  function ReorderCarouselImpression(storeIds) {
    Event.call(this, 'Reoder carousel Impression', VOID, 'CS: Customer Solutions', mapOf_0(to('storeIds', storeIds == null ? null : get_value_2(storeIds))));
  }
  function Metadata_125() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_125).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_125;
  function Metadata_getInstance_125() {
    return Metadata_instance_125;
  }
  function ResetPassword() {
    Event.call(this, 'Reset Password', VOID, 'WASP: Web Acquisition Store Page');
  }
  function Metadata_126() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_126).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_126;
  function Metadata_getInstance_126() {
    return Metadata_instance_126;
  }
  function ResetPasswordError(resetErrorMessage) {
    Event.call(this, 'Reset Password Error', VOID, 'WASP: Web Acquisition Store Page', mapOf_0(to('resetErrorMessage', resetErrorMessage == null ? null : get_value(resetErrorMessage))));
  }
  function Metadata_127() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_127).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_127;
  function Metadata_getInstance_127() {
    return Metadata_instance_127;
  }
  function ScheduleButton(storeAddressId, categoryId) {
    categoryId = categoryId === VOID ? null : categoryId;
    var tmp = to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId));
    Event.call(this, 'Schedule Button on Closed Store Popup', VOID, 'WASP: Web Acquisition Store Page', mapOf([tmp, to('categoryId', categoryId == null ? null : get_value_1(categoryId))]));
  }
  function Metadata_128() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_128).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_128;
  function Metadata_getInstance_128() {
    return Metadata_instance_128;
  }
  function ShowMorePromotionsArrowButtonOnStorePageClicked(storeAddressId) {
    Event.call(this, 'Show More Promotions Arrow Button on the Store Page.', VOID, 'WASP: Web Acquisition Store Page', mapOf_0(to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))));
  }
  function SideDrawerCategoryClick(source) {
    Event.call(this, 'Side Drawer Category Click', VOID, VOID, mapOf_0(to('source', source == null ? null : get_value(source))));
  }
  function SideDrawerClick(origin, categoryName) {
    categoryName = categoryName === VOID ? null : categoryName;
    var tmp = to('origin', origin == null ? null : origin.value);
    Event.call(this, 'Side Drawer Click', VOID, VOID, mapOf([tmp, to('categoryName', categoryName == null ? null : get_value(categoryName))]));
  }
  function SideDrawerImpression(origin, categoryName) {
    categoryName = categoryName === VOID ? null : categoryName;
    var tmp = to('origin', origin == null ? null : origin.value);
    Event.call(this, 'Side Drawer Category Page', VOID, VOID, mapOf([tmp, to('categoryName', categoryName == null ? null : get_value(categoryName))]));
  }
  var SideDrawerOrigin_StorePage_instance;
  var SideDrawerOrigin_CategoryPage_instance;
  var SideDrawerOrigin_SearchPage_instance;
  var SideDrawerOrigin_PromotionsPage_instance;
  var SideDrawerOrigin_BestNearYou_instance;
  function values_91() {
    return [SideDrawerOrigin_StorePage_getInstance(), SideDrawerOrigin_CategoryPage_getInstance(), SideDrawerOrigin_SearchPage_getInstance(), SideDrawerOrigin_PromotionsPage_getInstance(), SideDrawerOrigin_BestNearYou_getInstance()];
  }
  function valueOf_91(value) {
    switch (value) {
      case 'StorePage':
        return SideDrawerOrigin_StorePage_getInstance();
      case 'CategoryPage':
        return SideDrawerOrigin_CategoryPage_getInstance();
      case 'SearchPage':
        return SideDrawerOrigin_SearchPage_getInstance();
      case 'PromotionsPage':
        return SideDrawerOrigin_PromotionsPage_getInstance();
      case 'BestNearYou':
        return SideDrawerOrigin_BestNearYou_getInstance();
      default:
        SideDrawerOrigin_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var SideDrawerOrigin_entriesInitialized;
  function SideDrawerOrigin_initEntries() {
    if (SideDrawerOrigin_entriesInitialized)
      return Unit_instance;
    SideDrawerOrigin_entriesInitialized = true;
    SideDrawerOrigin_StorePage_instance = new SideDrawerOrigin('StorePage', 0, 'Store Page');
    SideDrawerOrigin_CategoryPage_instance = new SideDrawerOrigin('CategoryPage', 1, 'Category page');
    SideDrawerOrigin_SearchPage_instance = new SideDrawerOrigin('SearchPage', 2, 'Search page');
    SideDrawerOrigin_PromotionsPage_instance = new SideDrawerOrigin('PromotionsPage', 3, 'Promotions page');
    SideDrawerOrigin_BestNearYou_instance = new SideDrawerOrigin('BestNearYou', 4, 'Best near you page');
  }
  function SideDrawerOrigin(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(SideDrawerOrigin).r = function () {
    return this.value;
  };
  function SideDrawerOrigin_StorePage_getInstance() {
    SideDrawerOrigin_initEntries();
    return SideDrawerOrigin_StorePage_instance;
  }
  function SideDrawerOrigin_CategoryPage_getInstance() {
    SideDrawerOrigin_initEntries();
    return SideDrawerOrigin_CategoryPage_instance;
  }
  function SideDrawerOrigin_SearchPage_getInstance() {
    SideDrawerOrigin_initEntries();
    return SideDrawerOrigin_SearchPage_instance;
  }
  function SideDrawerOrigin_PromotionsPage_getInstance() {
    SideDrawerOrigin_initEntries();
    return SideDrawerOrigin_PromotionsPage_instance;
  }
  function SideDrawerOrigin_BestNearYou_getInstance() {
    SideDrawerOrigin_initEntries();
    return SideDrawerOrigin_BestNearYou_instance;
  }
  function Metadata_129() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_129).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_129;
  function Metadata_getInstance_129() {
    return Metadata_instance_129;
  }
  function SignUpError(signUpErrorMessage) {
    Event.call(this, 'Sign Up Error', VOID, 'WASP: Web Acquisition Store Page', mapOf_0(to('signUpErrorMessage', signUpErrorMessage == null ? null : get_value(signUpErrorMessage))));
  }
  function Metadata_130() {
    this.OWNER = 'B2B: eLogistics Last-Mile';
  }
  protoOf(Metadata_130).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_130;
  function Metadata_getInstance_130() {
    return Metadata_instance_130;
  }
  function SignatureConfirmationClicked(signaturePageUrl) {
    Event.call(this, 'Signature Confirmation Clicked', VOID, 'B2B: eLogistics Last-Mile', mapOf_0(to('signaturePageUrl', signaturePageUrl == null ? null : get_value(signaturePageUrl))));
  }
  function Metadata_131() {
    this.OWNER = 'B2B: eLogistics Last-Mile';
  }
  protoOf(Metadata_131).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_131;
  function Metadata_getInstance_131() {
    return Metadata_instance_131;
  }
  function SignaturePageOpened(signaturePageUrl) {
    Event.call(this, 'Signature Page Opened', VOID, 'B2B: eLogistics Last-Mile', mapOf_0(to('signaturePageUrl', signaturePageUrl == null ? null : get_value(signaturePageUrl))));
  }
  function SocialFeatureAddContactsClicked() {
    Event.call(this, 'Social Add Contacts Button Clicked');
  }
  function SocialFeatureStartSurveyClicked() {
    Event.call(this, 'Social Start Survey Button Clicked');
  }
  function Metadata_132() {
    this.OWNER = 'B2B: eLogistics Last-Mile';
  }
  protoOf(Metadata_132).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_132;
  function Metadata_getInstance_132() {
    return Metadata_instance_132;
  }
  function TrackYourParcelSearch() {
    Event.call(this, 'Tracking Your Parcel Search', VOID, 'B2B: eLogistics Last-Mile');
  }
  var WebToAppBannerType_Control_instance;
  var WebToAppBannerType_Variant1_instance;
  var WebToAppBannerType_Variant2_instance;
  function values_92() {
    return [WebToAppBannerType_Control_getInstance(), WebToAppBannerType_Variant1_getInstance(), WebToAppBannerType_Variant2_getInstance()];
  }
  function valueOf_92(value) {
    switch (value) {
      case 'Control':
        return WebToAppBannerType_Control_getInstance();
      case 'Variant1':
        return WebToAppBannerType_Variant1_getInstance();
      case 'Variant2':
        return WebToAppBannerType_Variant2_getInstance();
      default:
        WebToAppBannerType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var WebToAppBannerType_entriesInitialized;
  function WebToAppBannerType_initEntries() {
    if (WebToAppBannerType_entriesInitialized)
      return Unit_instance;
    WebToAppBannerType_entriesInitialized = true;
    WebToAppBannerType_Control_instance = new WebToAppBannerType('Control', 0, 'Control');
    WebToAppBannerType_Variant1_instance = new WebToAppBannerType('Variant1', 1, 'Variant1');
    WebToAppBannerType_Variant2_instance = new WebToAppBannerType('Variant2', 2, 'Variant2');
  }
  function WebToAppBannerType(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(WebToAppBannerType).r = function () {
    return this.value;
  };
  function WebToAppBannerType_Control_getInstance() {
    WebToAppBannerType_initEntries();
    return WebToAppBannerType_Control_instance;
  }
  function WebToAppBannerType_Variant1_getInstance() {
    WebToAppBannerType_initEntries();
    return WebToAppBannerType_Variant1_instance;
  }
  function WebToAppBannerType_Variant2_getInstance() {
    WebToAppBannerType_initEntries();
    return WebToAppBannerType_Variant2_instance;
  }
  function WebToAppClicked(bannerType, deviceId) {
    var tmp = to('bannerType', bannerType == null ? null : bannerType.value);
    Event.call(this, 'WebToAppClicked', VOID, VOID, mapOf([tmp, to('deviceId', deviceId == null ? null : get_value_1(deviceId))]));
  }
  function WebToAppDismiss(bannerType, deviceId) {
    var tmp = to('bannerType', bannerType == null ? null : bannerType.value);
    Event.call(this, 'WebToAppDismiss', VOID, VOID, mapOf([tmp, to('deviceId', deviceId == null ? null : get_value_1(deviceId))]));
  }
  function WebToAppImpression(bannerType, deviceId) {
    var tmp = to('bannerType', bannerType == null ? null : bannerType.value);
    Event.call(this, 'WebToAppImpression', VOID, VOID, mapOf([tmp, to('deviceId', deviceId == null ? null : get_value_1(deviceId))]));
  }
  function Metadata_133() {
    this.OWNER = 'WASP: Web Acquisition Store Page';
  }
  protoOf(Metadata_133).bb = function () {
    return this.OWNER;
  };
  var Metadata_instance_133;
  function Metadata_getInstance_133() {
    return Metadata_instance_133;
  }
  function exploreStoresFromClosedStore(storeId, categoryId, storeAddressId) {
    var tmp = to('storeId', storeId == null ? null : get_value_1(storeId));
    var tmp_0 = to('categoryId', categoryId == null ? null : get_value_1(categoryId));
    Event.call(this, 'Explore Stores from Closed Store', VOID, 'WASP: Web Acquisition Store Page', mapOf([tmp, tmp_0, to('storeAddressId', storeAddressId == null ? null : get_value_1(storeAddressId))]));
  }
  var homeCountrySource_Default_instance;
  var homeCountrySource_HomeGlobal_instance;
  function values_93() {
    return [homeCountrySource_Default_getInstance(), homeCountrySource_HomeGlobal_getInstance()];
  }
  function valueOf_93(value) {
    switch (value) {
      case 'Default':
        return homeCountrySource_Default_getInstance();
      case 'HomeGlobal':
        return homeCountrySource_HomeGlobal_getInstance();
      default:
        homeCountrySource_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var homeCountrySource_entriesInitialized;
  function homeCountrySource_initEntries() {
    if (homeCountrySource_entriesInitialized)
      return Unit_instance;
    homeCountrySource_entriesInitialized = true;
    homeCountrySource_Default_instance = new homeCountrySource('Default', 0, 'Default');
    homeCountrySource_HomeGlobal_instance = new homeCountrySource('HomeGlobal', 1, 'Home Global');
  }
  function homeCountrySource(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(homeCountrySource).r = function () {
    return this.value;
  };
  function homeCountrySource_Default_getInstance() {
    homeCountrySource_initEntries();
    return homeCountrySource_Default_instance;
  }
  function homeCountrySource_HomeGlobal_getInstance() {
    homeCountrySource_initEntries();
    return homeCountrySource_HomeGlobal_instance;
  }
  //region block: post-declaration
  defineProp(protoOf(ActiveFeatures), 'name', protoOf(ActiveFeatures).e1);
  defineProp(protoOf(ActiveFeatures), 'ordinal', protoOf(ActiveFeatures).f1);
  defineProp(protoOf(AddressBottomSheetActionType), 'name', protoOf(AddressBottomSheetActionType).e1);
  defineProp(protoOf(AddressBottomSheetActionType), 'ordinal', protoOf(AddressBottomSheetActionType).f1);
  defineProp(protoOf(AddressCheckType), 'name', protoOf(AddressCheckType).e1);
  defineProp(protoOf(AddressCheckType), 'ordinal', protoOf(AddressCheckType).f1);
  defineProp(protoOf(AddressDetailsSource), 'name', protoOf(AddressDetailsSource).e1);
  defineProp(protoOf(AddressDetailsSource), 'ordinal', protoOf(AddressDetailsSource).f1);
  defineProp(protoOf(AddressLandingOption), 'name', protoOf(AddressLandingOption).e1);
  defineProp(protoOf(AddressLandingOption), 'ordinal', protoOf(AddressLandingOption).f1);
  defineProp(protoOf(AddressSearchSource), 'name', protoOf(AddressSearchSource).e1);
  defineProp(protoOf(AddressSearchSource), 'ordinal', protoOf(AddressSearchSource).f1);
  defineProp(protoOf(AddressSource), 'name', protoOf(AddressSource).e1);
  defineProp(protoOf(AddressSource), 'ordinal', protoOf(AddressSource).f1);
  defineProp(protoOf(AddressType), 'name', protoOf(AddressType).e1);
  defineProp(protoOf(AddressType), 'ordinal', protoOf(AddressType).f1);
  defineProp(protoOf(AppliedFilterOrigin), 'name', protoOf(AppliedFilterOrigin).e1);
  defineProp(protoOf(AppliedFilterOrigin), 'ordinal', protoOf(AppliedFilterOrigin).f1);
  defineProp(protoOf(AuthenticationOption), 'name', protoOf(AuthenticationOption).e1);
  defineProp(protoOf(AuthenticationOption), 'ordinal', protoOf(AuthenticationOption).f1);
  defineProp(protoOf(BadgeType), 'name', protoOf(BadgeType).e1);
  defineProp(protoOf(BadgeType), 'ordinal', protoOf(BadgeType).f1);
  defineProp(protoOf(BasketCreationOrigin), 'name', protoOf(BasketCreationOrigin).e1);
  defineProp(protoOf(BasketCreationOrigin), 'ordinal', protoOf(BasketCreationOrigin).f1);
  defineProp(protoOf(BasketOrigin), 'name', protoOf(BasketOrigin).e1);
  defineProp(protoOf(BasketOrigin), 'ordinal', protoOf(BasketOrigin).f1);
  defineProp(protoOf(BottomSheetScreen), 'name', protoOf(BottomSheetScreen).e1);
  defineProp(protoOf(BottomSheetScreen), 'ordinal', protoOf(BottomSheetScreen).f1);
  defineProp(protoOf(BottomSheetSource), 'name', protoOf(BottomSheetSource).e1);
  defineProp(protoOf(BottomSheetSource), 'ordinal', protoOf(BottomSheetSource).f1);
  defineProp(protoOf(CCChatProvider), 'name', protoOf(CCChatProvider).e1);
  defineProp(protoOf(CCChatProvider), 'ordinal', protoOf(CCChatProvider).f1);
  defineProp(protoOf(CTA), 'name', protoOf(CTA).e1);
  defineProp(protoOf(CTA), 'ordinal', protoOf(CTA).f1);
  defineProp(protoOf(CarouselScrollDirection), 'name', protoOf(CarouselScrollDirection).e1);
  defineProp(protoOf(CarouselScrollDirection), 'ordinal', protoOf(CarouselScrollDirection).f1);
  defineProp(protoOf(ChatNotificationType), 'name', protoOf(ChatNotificationType).e1);
  defineProp(protoOf(ChatNotificationType), 'ordinal', protoOf(ChatNotificationType).f1);
  defineProp(protoOf(ChatProvider), 'name', protoOf(ChatProvider).e1);
  defineProp(protoOf(ChatProvider), 'ordinal', protoOf(ChatProvider).f1);
  defineProp(protoOf(ChatType), 'name', protoOf(ChatType).e1);
  defineProp(protoOf(ChatType), 'ordinal', protoOf(ChatType).f1);
  defineProp(protoOf(ConnectionSource), 'name', protoOf(ConnectionSource).e1);
  defineProp(protoOf(ConnectionSource), 'ordinal', protoOf(ConnectionSource).f1);
  defineProp(protoOf(ContactReason), 'name', protoOf(ContactReason).e1);
  defineProp(protoOf(ContactReason), 'ordinal', protoOf(ContactReason).f1);
  defineProp(protoOf(ContactUsOrigin), 'name', protoOf(ContactUsOrigin).e1);
  defineProp(protoOf(ContactUsOrigin), 'ordinal', protoOf(ContactUsOrigin).f1);
  defineProp(protoOf(ContentTranslatedAction), 'name', protoOf(ContentTranslatedAction).e1);
  defineProp(protoOf(ContentTranslatedAction), 'ordinal', protoOf(ContentTranslatedAction).f1);
  defineProp(protoOf(CsatReason), 'name', protoOf(CsatReason).e1);
  defineProp(protoOf(CsatReason), 'ordinal', protoOf(CsatReason).f1);
  defineProp(protoOf(CsatSide), 'name', protoOf(CsatSide).e1);
  defineProp(protoOf(CsatSide), 'ordinal', protoOf(CsatSide).f1);
  defineProp(protoOf(EasyReorderScreenType), 'name', protoOf(EasyReorderScreenType).e1);
  defineProp(protoOf(EasyReorderScreenType), 'ordinal', protoOf(EasyReorderScreenType).f1);
  defineProp(protoOf(EditAddressOrigins), 'name', protoOf(EditAddressOrigins).e1);
  defineProp(protoOf(EditAddressOrigins), 'ordinal', protoOf(EditAddressOrigins).f1);
  defineProp(protoOf(ElementAction), 'name', protoOf(ElementAction).e1);
  defineProp(protoOf(ElementAction), 'ordinal', protoOf(ElementAction).f1);
  defineProp(protoOf(ElementScreen), 'name', protoOf(ElementScreen).e1);
  defineProp(protoOf(ElementScreen), 'ordinal', protoOf(ElementScreen).f1);
  defineProp(protoOf(ElementSource), 'name', protoOf(ElementSource).e1);
  defineProp(protoOf(ElementSource), 'ordinal', protoOf(ElementSource).f1);
  defineProp(protoOf(ElementType), 'name', protoOf(ElementType).e1);
  defineProp(protoOf(ElementType), 'ordinal', protoOf(ElementType).f1);
  defineProp(protoOf(EnterEmailOrigin), 'name', protoOf(EnterEmailOrigin).e1);
  defineProp(protoOf(EnterEmailOrigin), 'ordinal', protoOf(EnterEmailOrigin).f1);
  defineProp(protoOf(FilterName), 'name', protoOf(FilterName).e1);
  defineProp(protoOf(FilterName), 'ordinal', protoOf(FilterName).f1);
  defineProp(protoOf(FilterOrigin), 'name', protoOf(FilterOrigin).e1);
  defineProp(protoOf(FilterOrigin), 'ordinal', protoOf(FilterOrigin).f1);
  defineProp(protoOf(HomePageNotLoadedReason), 'name', protoOf(HomePageNotLoadedReason).e1);
  defineProp(protoOf(HomePageNotLoadedReason), 'ordinal', protoOf(HomePageNotLoadedReason).f1);
  defineProp(protoOf(HomeSource), 'name', protoOf(HomeSource).e1);
  defineProp(protoOf(HomeSource), 'ordinal', protoOf(HomeSource).f1);
  defineProp(protoOf(InfoButtonSource), 'name', protoOf(InfoButtonSource).e1);
  defineProp(protoOf(InfoButtonSource), 'ordinal', protoOf(InfoButtonSource).f1);
  defineProp(protoOf(InfoType), 'name', protoOf(InfoType).e1);
  defineProp(protoOf(InfoType), 'ordinal', protoOf(InfoType).f1);
  defineProp(protoOf(LayoutDesign), 'name', protoOf(LayoutDesign).e1);
  defineProp(protoOf(LayoutDesign), 'ordinal', protoOf(LayoutDesign).f1);
  defineProp(protoOf(MbsCalculationStrategy), 'name', protoOf(MbsCalculationStrategy).e1);
  defineProp(protoOf(MbsCalculationStrategy), 'ordinal', protoOf(MbsCalculationStrategy).f1);
  defineProp(protoOf(MgmSource), 'name', protoOf(MgmSource).e1);
  defineProp(protoOf(MgmSource), 'ordinal', protoOf(MgmSource).f1);
  defineProp(protoOf(NavigationTabBarAppLocation), 'name', protoOf(NavigationTabBarAppLocation).e1);
  defineProp(protoOf(NavigationTabBarAppLocation), 'ordinal', protoOf(NavigationTabBarAppLocation).f1);
  defineProp(protoOf(NavigationTabBarElements), 'name', protoOf(NavigationTabBarElements).e1);
  defineProp(protoOf(NavigationTabBarElements), 'ordinal', protoOf(NavigationTabBarElements).f1);
  defineProp(protoOf(NotificationConfigurationScreenSource), 'name', protoOf(NotificationConfigurationScreenSource).e1);
  defineProp(protoOf(NotificationConfigurationScreenSource), 'ordinal', protoOf(NotificationConfigurationScreenSource).f1);
  defineProp(protoOf(NotificationStatus), 'name', protoOf(NotificationStatus).e1);
  defineProp(protoOf(NotificationStatus), 'ordinal', protoOf(NotificationStatus).f1);
  defineProp(protoOf(OngoingOrderEditCta), 'name', protoOf(OngoingOrderEditCta).e1);
  defineProp(protoOf(OngoingOrderEditCta), 'ordinal', protoOf(OngoingOrderEditCta).f1);
  defineProp(protoOf(OngoingOrderEditFeature), 'name', protoOf(OngoingOrderEditFeature).e1);
  defineProp(protoOf(OngoingOrderEditFeature), 'ordinal', protoOf(OngoingOrderEditFeature).f1);
  defineProp(protoOf(OrderCancellationReason), 'name', protoOf(OrderCancellationReason).e1);
  defineProp(protoOf(OrderCancellationReason), 'ordinal', protoOf(OrderCancellationReason).f1);
  defineProp(protoOf(OrderHandlingStrategyType), 'name', protoOf(OrderHandlingStrategyType).e1);
  defineProp(protoOf(OrderHandlingStrategyType), 'ordinal', protoOf(OrderHandlingStrategyType).f1);
  defineProp(protoOf(OrderVertical), 'name', protoOf(OrderVertical).e1);
  defineProp(protoOf(OrderVertical), 'ordinal', protoOf(OrderVertical).f1);
  defineProp(protoOf(PaymentChangeScreenOrigin), 'name', protoOf(PaymentChangeScreenOrigin).e1);
  defineProp(protoOf(PaymentChangeScreenOrigin), 'ordinal', protoOf(PaymentChangeScreenOrigin).f1);
  defineProp(protoOf(PaymentProcessingStatus), 'name', protoOf(PaymentProcessingStatus).e1);
  defineProp(protoOf(PaymentProcessingStatus), 'ordinal', protoOf(PaymentProcessingStatus).f1);
  defineProp(protoOf(PersonalizedFilterType), 'name', protoOf(PersonalizedFilterType).e1);
  defineProp(protoOf(PersonalizedFilterType), 'ordinal', protoOf(PersonalizedFilterType).f1);
  defineProp(protoOf(PhoneScreenOrigin), 'name', protoOf(PhoneScreenOrigin).e1);
  defineProp(protoOf(PhoneScreenOrigin), 'ordinal', protoOf(PhoneScreenOrigin).f1);
  defineProp(protoOf(PhoneVerificationMethod), 'name', protoOf(PhoneVerificationMethod).e1);
  defineProp(protoOf(PhoneVerificationMethod), 'ordinal', protoOf(PhoneVerificationMethod).f1);
  defineProp(protoOf(PrimeOrigin), 'name', protoOf(PrimeOrigin).e1);
  defineProp(protoOf(PrimeOrigin), 'ordinal', protoOf(PrimeOrigin).f1);
  defineProp(protoOf(PrimeSubscriptionType), 'name', protoOf(PrimeSubscriptionType).e1);
  defineProp(protoOf(PrimeSubscriptionType), 'ordinal', protoOf(PrimeSubscriptionType).f1);
  defineProp(protoOf(ProductAdditionalInformationGroupType), 'name', protoOf(ProductAdditionalInformationGroupType).e1);
  defineProp(protoOf(ProductAdditionalInformationGroupType), 'ordinal', protoOf(ProductAdditionalInformationGroupType).f1);
  defineProp(protoOf(ProductCustomisationImageOrigin), 'name', protoOf(ProductCustomisationImageOrigin).e1);
  defineProp(protoOf(ProductCustomisationImageOrigin), 'ordinal', protoOf(ProductCustomisationImageOrigin).f1);
  defineProp(protoOf(ProductLabelType), 'name', protoOf(ProductLabelType).e1);
  defineProp(protoOf(ProductLabelType), 'ordinal', protoOf(ProductLabelType).f1);
  defineProp(protoOf(ProductRemovedOrigin), 'name', protoOf(ProductRemovedOrigin).e1);
  defineProp(protoOf(ProductRemovedOrigin), 'ordinal', protoOf(ProductRemovedOrigin).f1);
  defineProp(protoOf(ProductSaleType), 'name', protoOf(ProductSaleType).e1);
  defineProp(protoOf(ProductSaleType), 'ordinal', protoOf(ProductSaleType).f1);
  defineProp(protoOf(ProductUpsellPopUpScreenDismissedAction), 'name', protoOf(ProductUpsellPopUpScreenDismissedAction).e1);
  defineProp(protoOf(ProductUpsellPopUpScreenDismissedAction), 'ordinal', protoOf(ProductUpsellPopUpScreenDismissedAction).f1);
  defineProp(protoOf(ProfileSection), 'name', protoOf(ProfileSection).e1);
  defineProp(protoOf(ProfileSection), 'ordinal', protoOf(ProfileSection).f1);
  defineProp(protoOf(PromotionSource), 'name', protoOf(PromotionSource).e1);
  defineProp(protoOf(PromotionSource), 'ordinal', protoOf(PromotionSource).f1);
  defineProp(protoOf(PromotionStoreOrigin), 'name', protoOf(PromotionStoreOrigin).e1);
  defineProp(protoOf(PromotionStoreOrigin), 'ordinal', protoOf(PromotionStoreOrigin).f1);
  defineProp(protoOf(RankingType), 'name', protoOf(RankingType).e1);
  defineProp(protoOf(RankingType), 'ordinal', protoOf(RankingType).f1);
  defineProp(protoOf(RecoveryOrigin), 'name', protoOf(RecoveryOrigin).e1);
  defineProp(protoOf(RecoveryOrigin), 'ordinal', protoOf(RecoveryOrigin).f1);
  defineProp(protoOf(ReorderOrigin), 'name', protoOf(ReorderOrigin).e1);
  defineProp(protoOf(ReorderOrigin), 'ordinal', protoOf(ReorderOrigin).f1);
  defineProp(protoOf(ReturnPolicyOrigin), 'name', protoOf(ReturnPolicyOrigin).e1);
  defineProp(protoOf(ReturnPolicyOrigin), 'ordinal', protoOf(ReturnPolicyOrigin).f1);
  defineProp(protoOf(ReviewCollectionVersionType), 'name', protoOf(ReviewCollectionVersionType).e1);
  defineProp(protoOf(ReviewCollectionVersionType), 'ordinal', protoOf(ReviewCollectionVersionType).f1);
  defineProp(protoOf(RootContent), 'name', protoOf(RootContent).e1);
  defineProp(protoOf(RootContent), 'ordinal', protoOf(RootContent).f1);
  defineProp(protoOf(SearchOrigin), 'name', protoOf(SearchOrigin).e1);
  defineProp(protoOf(SearchOrigin), 'ordinal', protoOf(SearchOrigin).f1);
  defineProp(protoOf(SearchSubVertical), 'name', protoOf(SearchSubVertical).e1);
  defineProp(protoOf(SearchSubVertical), 'ordinal', protoOf(SearchSubVertical).f1);
  defineProp(protoOf(SignInLandingOrigin), 'name', protoOf(SignInLandingOrigin).e1);
  defineProp(protoOf(SignInLandingOrigin), 'ordinal', protoOf(SignInLandingOrigin).f1);
  defineProp(protoOf(SignInSource), 'name', protoOf(SignInSource).e1);
  defineProp(protoOf(SignInSource), 'ordinal', protoOf(SignInSource).f1);
  defineProp(protoOf(SignUpSource), 'name', protoOf(SignUpSource).e1);
  defineProp(protoOf(SignUpSource), 'ordinal', protoOf(SignUpSource).f1);
  defineProp(protoOf(SocialSignalsSource), 'name', protoOf(SocialSignalsSource).e1);
  defineProp(protoOf(SocialSignalsSource), 'ordinal', protoOf(SocialSignalsSource).f1);
  defineProp(protoOf(StoreCarouselType), 'name', protoOf(StoreCarouselType).e1);
  defineProp(protoOf(StoreCarouselType), 'ordinal', protoOf(StoreCarouselType).f1);
  defineProp(protoOf(StoreFunnelOrigin), 'name', protoOf(StoreFunnelOrigin).e1);
  defineProp(protoOf(StoreFunnelOrigin), 'ordinal', protoOf(StoreFunnelOrigin).f1);
  defineProp(protoOf(TokenizedAPMStatus), 'name', protoOf(TokenizedAPMStatus).e1);
  defineProp(protoOf(TokenizedAPMStatus), 'ordinal', protoOf(TokenizedAPMStatus).f1);
  defineProp(protoOf(UseCurrentLocationSource), 'name', protoOf(UseCurrentLocationSource).e1);
  defineProp(protoOf(UseCurrentLocationSource), 'ordinal', protoOf(UseCurrentLocationSource).f1);
  defineProp(protoOf(UserRegistrationType), 'name', protoOf(UserRegistrationType).e1);
  defineProp(protoOf(UserRegistrationType), 'ordinal', protoOf(UserRegistrationType).f1);
  defineProp(protoOf(AvailableButtons), 'name', protoOf(AvailableButtons).e1);
  defineProp(protoOf(AvailableButtons), 'ordinal', protoOf(AvailableButtons).f1);
  defineProp(protoOf(DownloadPressedSource), 'name', protoOf(DownloadPressedSource).e1);
  defineProp(protoOf(DownloadPressedSource), 'ordinal', protoOf(DownloadPressedSource).f1);
  defineProp(protoOf(GetStartedButtonSource), 'name', protoOf(GetStartedButtonSource).e1);
  defineProp(protoOf(GetStartedButtonSource), 'ordinal', protoOf(GetStartedButtonSource).f1);
  defineProp(protoOf(GoogleOneTapSkippedReason), 'name', protoOf(GoogleOneTapSkippedReason).e1);
  defineProp(protoOf(GoogleOneTapSkippedReason), 'ordinal', protoOf(GoogleOneTapSkippedReason).f1);
  defineProp(protoOf(OsPicked), 'name', protoOf(OsPicked).e1);
  defineProp(protoOf(OsPicked), 'ordinal', protoOf(OsPicked).f1);
  defineProp(protoOf(OutsideStoreDeliveryZoneReason), 'name', protoOf(OutsideStoreDeliveryZoneReason).e1);
  defineProp(protoOf(OutsideStoreDeliveryZoneReason), 'ordinal', protoOf(OutsideStoreDeliveryZoneReason).f1);
  defineProp(protoOf(PrimeLandingPageInteractionType), 'name', protoOf(PrimeLandingPageInteractionType).e1);
  defineProp(protoOf(PrimeLandingPageInteractionType), 'ordinal', protoOf(PrimeLandingPageInteractionType).f1);
  defineProp(protoOf(SideDrawerOrigin), 'name', protoOf(SideDrawerOrigin).e1);
  defineProp(protoOf(SideDrawerOrigin), 'ordinal', protoOf(SideDrawerOrigin).f1);
  defineProp(protoOf(WebToAppBannerType), 'name', protoOf(WebToAppBannerType).e1);
  defineProp(protoOf(WebToAppBannerType), 'ordinal', protoOf(WebToAppBannerType).f1);
  defineProp(protoOf(homeCountrySource), 'name', protoOf(homeCountrySource).e1);
  defineProp(protoOf(homeCountrySource), 'ordinal', protoOf(homeCountrySource).f1);
  //endregion
  //region block: init
  Metadata_instance = new Metadata();
  Metadata_instance_0 = new Metadata_0();
  Metadata_instance_1 = new Metadata_1();
  Metadata_instance_2 = new Metadata_2();
  Metadata_instance_3 = new Metadata_3();
  Metadata_instance_4 = new Metadata_4();
  Metadata_instance_5 = new Metadata_5();
  Metadata_instance_6 = new Metadata_6();
  Metadata_instance_7 = new Metadata_7();
  Metadata_instance_8 = new Metadata_8();
  Metadata_instance_9 = new Metadata_9();
  Metadata_instance_10 = new Metadata_10();
  Metadata_instance_11 = new Metadata_11();
  Metadata_instance_12 = new Metadata_12();
  Metadata_instance_13 = new Metadata_13();
  Metadata_instance_14 = new Metadata_14();
  Metadata_instance_15 = new Metadata_15();
  Metadata_instance_16 = new Metadata_16();
  Metadata_instance_17 = new Metadata_17();
  Metadata_instance_18 = new Metadata_18();
  Metadata_instance_19 = new Metadata_19();
  Metadata_instance_20 = new Metadata_20();
  Metadata_instance_21 = new Metadata_21();
  Metadata_instance_22 = new Metadata_22();
  Metadata_instance_23 = new Metadata_23();
  Metadata_instance_24 = new Metadata_24();
  Metadata_instance_25 = new Metadata_25();
  Metadata_instance_26 = new Metadata_26();
  Metadata_instance_27 = new Metadata_27();
  Metadata_instance_28 = new Metadata_28();
  Metadata_instance_29 = new Metadata_29();
  Metadata_instance_30 = new Metadata_30();
  Metadata_instance_31 = new Metadata_31();
  Metadata_instance_32 = new Metadata_32();
  Metadata_instance_33 = new Metadata_33();
  Metadata_instance_34 = new Metadata_34();
  Metadata_instance_35 = new Metadata_35();
  Metadata_instance_36 = new Metadata_36();
  Metadata_instance_37 = new Metadata_37();
  Metadata_instance_38 = new Metadata_38();
  Metadata_instance_39 = new Metadata_39();
  Metadata_instance_40 = new Metadata_40();
  Metadata_instance_41 = new Metadata_41();
  Metadata_instance_42 = new Metadata_42();
  Metadata_instance_43 = new Metadata_43();
  Metadata_instance_44 = new Metadata_44();
  Metadata_instance_45 = new Metadata_45();
  Metadata_instance_46 = new Metadata_46();
  Metadata_instance_47 = new Metadata_47();
  Metadata_instance_48 = new Metadata_48();
  Metadata_instance_49 = new Metadata_49();
  Metadata_instance_50 = new Metadata_50();
  Metadata_instance_51 = new Metadata_51();
  Metadata_instance_52 = new Metadata_52();
  Metadata_instance_53 = new Metadata_53();
  Metadata_instance_54 = new Metadata_54();
  Metadata_instance_55 = new Metadata_55();
  Metadata_instance_56 = new Metadata_56();
  Metadata_instance_57 = new Metadata_57();
  Metadata_instance_58 = new Metadata_58();
  Metadata_instance_59 = new Metadata_59();
  Metadata_instance_60 = new Metadata_60();
  Metadata_instance_61 = new Metadata_61();
  Metadata_instance_62 = new Metadata_62();
  Metadata_instance_63 = new Metadata_63();
  Metadata_instance_64 = new Metadata_64();
  Metadata_instance_65 = new Metadata_65();
  Metadata_instance_66 = new Metadata_66();
  Metadata_instance_67 = new Metadata_67();
  Metadata_instance_68 = new Metadata_68();
  Metadata_instance_69 = new Metadata_69();
  Metadata_instance_70 = new Metadata_70();
  Metadata_instance_71 = new Metadata_71();
  Metadata_instance_72 = new Metadata_72();
  Metadata_instance_73 = new Metadata_73();
  Metadata_instance_74 = new Metadata_74();
  Metadata_instance_75 = new Metadata_75();
  Metadata_instance_76 = new Metadata_76();
  Metadata_instance_77 = new Metadata_77();
  Metadata_instance_78 = new Metadata_78();
  Metadata_instance_79 = new Metadata_79();
  Metadata_instance_80 = new Metadata_80();
  Metadata_instance_81 = new Metadata_81();
  Metadata_instance_82 = new Metadata_82();
  Metadata_instance_83 = new Metadata_83();
  Metadata_instance_84 = new Metadata_84();
  Metadata_instance_85 = new Metadata_85();
  Metadata_instance_86 = new Metadata_86();
  Metadata_instance_87 = new Metadata_87();
  Metadata_instance_88 = new Metadata_88();
  Metadata_instance_89 = new Metadata_89();
  Metadata_instance_90 = new Metadata_90();
  Metadata_instance_91 = new Metadata_91();
  Metadata_instance_92 = new Metadata_92();
  Metadata_instance_93 = new Metadata_93();
  Metadata_instance_94 = new Metadata_94();
  Metadata_instance_95 = new Metadata_95();
  Metadata_instance_96 = new Metadata_96();
  Metadata_instance_97 = new Metadata_97();
  Metadata_instance_98 = new Metadata_98();
  Metadata_instance_99 = new Metadata_99();
  Metadata_instance_100 = new Metadata_100();
  Metadata_instance_101 = new Metadata_101();
  Metadata_instance_102 = new Metadata_102();
  Metadata_instance_103 = new Metadata_103();
  Metadata_instance_104 = new Metadata_104();
  Metadata_instance_105 = new Metadata_105();
  Metadata_instance_106 = new Metadata_106();
  Metadata_instance_107 = new Metadata_107();
  Metadata_instance_108 = new Metadata_108();
  Metadata_instance_109 = new Metadata_109();
  Metadata_instance_110 = new Metadata_110();
  Metadata_instance_111 = new Metadata_111();
  Metadata_instance_112 = new Metadata_112();
  Metadata_instance_113 = new Metadata_113();
  Metadata_instance_114 = new Metadata_114();
  Metadata_instance_115 = new Metadata_115();
  Metadata_instance_116 = new Metadata_116();
  Metadata_instance_117 = new Metadata_117();
  Metadata_instance_118 = new Metadata_118();
  Metadata_instance_119 = new Metadata_119();
  Metadata_instance_120 = new Metadata_120();
  Metadata_instance_121 = new Metadata_121();
  Metadata_instance_122 = new Metadata_122();
  Metadata_instance_123 = new Metadata_123();
  Metadata_instance_124 = new Metadata_124();
  Metadata_instance_125 = new Metadata_125();
  Metadata_instance_126 = new Metadata_126();
  Metadata_instance_127 = new Metadata_127();
  Metadata_instance_128 = new Metadata_128();
  Metadata_instance_129 = new Metadata_129();
  Metadata_instance_130 = new Metadata_130();
  Metadata_instance_131 = new Metadata_131();
  Metadata_instance_132 = new Metadata_132();
  Metadata_instance_133 = new Metadata_133();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ActiveFeatures = ActiveFeatures;
    $com$glovoapp$analytics$events.ActiveFeatures.values = values;
    $com$glovoapp$analytics$events.ActiveFeatures.valueOf = valueOf;
    defineProp($com$glovoapp$analytics$events.ActiveFeatures, 'TopSellers', ActiveFeatures_TopSellers_getInstance);
    defineProp($com$glovoapp$analytics$events.ActiveFeatures, 'EasyReorder', ActiveFeatures_EasyReorder_getInstance);
    defineProp($com$glovoapp$analytics$events.ActiveFeatures, 'PickupToggle', ActiveFeatures_PickupToggle_getInstance);
    defineProp($com$glovoapp$analytics$events.ActiveFeatures, 'MenuTranslation', ActiveFeatures_MenuTranslation_getInstance);
    defineProp($com$glovoapp$analytics$events.ActiveFeatures, 'MbsProgressBar', ActiveFeatures_MbsProgressBar_getInstance);
    defineProp($com$glovoapp$analytics$events.ActiveFeatures, 'PrimePromotions', ActiveFeatures_PrimePromotions_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddTokenizedAPMStatus = AddTokenizedAPMStatus;
    defineProp($com$glovoapp$analytics$events.AddTokenizedAPMStatus, 'Metadata', Metadata_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressBottomSheet = AddressBottomSheet;
    defineProp($com$glovoapp$analytics$events.AddressBottomSheet, 'Metadata', Metadata_getInstance_0);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressBottomSheetAction = AddressBottomSheetAction;
    defineProp($com$glovoapp$analytics$events.AddressBottomSheetAction, 'Metadata', Metadata_getInstance_1);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressBottomSheetActionType = AddressBottomSheetActionType;
    $com$glovoapp$analytics$events.AddressBottomSheetActionType.values = values_0;
    $com$glovoapp$analytics$events.AddressBottomSheetActionType.valueOf = valueOf_0;
    defineProp($com$glovoapp$analytics$events.AddressBottomSheetActionType, 'Dismissed', AddressBottomSheetActionType_Dismissed_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressBottomSheetActionType, 'CurrentLocation', AddressBottomSheetActionType_CurrentLocation_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressBottomSheetActionType, 'SavedAddress', AddressBottomSheetActionType_SavedAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressBottomSheetActionType, 'EditSavedAddress', AddressBottomSheetActionType_EditSavedAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressBottomSheetActionType, 'AddAddress', AddressBottomSheetActionType_AddAddress_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressCheck = AddressCheck;
    defineProp($com$glovoapp$analytics$events.AddressCheck, 'Metadata', Metadata_getInstance_2);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressCheckType = AddressCheckType;
    $com$glovoapp$analytics$events.AddressCheckType.values = values_1;
    $com$glovoapp$analytics$events.AddressCheckType.valueOf = valueOf_1;
    defineProp($com$glovoapp$analytics$events.AddressCheckType, 'Search', AddressCheckType_Search_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressCheckType, 'Map', AddressCheckType_Map_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressCreationSucceeded = AddressCreationSucceeded;
    defineProp($com$glovoapp$analytics$events.AddressCreationSucceeded, 'Metadata', Metadata_getInstance_3);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressDetails = AddressDetails;
    defineProp($com$glovoapp$analytics$events.AddressDetails, 'Metadata', Metadata_getInstance_4);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressDetailsSource = AddressDetailsSource;
    $com$glovoapp$analytics$events.AddressDetailsSource.values = values_2;
    $com$glovoapp$analytics$events.AddressDetailsSource.valueOf = valueOf_2;
    defineProp($com$glovoapp$analytics$events.AddressDetailsSource, 'SavedAddressEdit', AddressDetailsSource_SavedAddressEdit_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressDetailsSource, 'DraftEdit', AddressDetailsSource_DraftEdit_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressDetailsSource, 'PinOnMap', AddressDetailsSource_PinOnMap_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressDetailsSource, 'Search', AddressDetailsSource_Search_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressDetailsSource, 'UnsavedCurrentLocation', AddressDetailsSource_UnsavedCurrentLocation_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressFlowLandingScreen = AddressFlowLandingScreen;
    defineProp($com$glovoapp$analytics$events.AddressFlowLandingScreen, 'Metadata', Metadata_getInstance_5);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressLandingOption = AddressLandingOption;
    $com$glovoapp$analytics$events.AddressLandingOption.values = values_3;
    $com$glovoapp$analytics$events.AddressLandingOption.valueOf = valueOf_3;
    defineProp($com$glovoapp$analytics$events.AddressLandingOption, 'PinOnMap', AddressLandingOption_PinOnMap_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressLandingOption, 'SavedAddress', AddressLandingOption_SavedAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressLandingOption, 'DraftAddress', AddressLandingOption_DraftAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressLandingOption, 'CurrentLocation', AddressLandingOption_CurrentLocation_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressLandingOption, 'NewAddress', AddressLandingOption_NewAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressLandingOption, 'Dismiss', AddressLandingOption_Dismiss_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressLandingOptionClicked = AddressLandingOptionClicked;
    defineProp($com$glovoapp$analytics$events.AddressLandingOptionClicked, 'Metadata', Metadata_getInstance_6);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressMapSearchFailed = AddressMapSearchFailed;
    defineProp($com$glovoapp$analytics$events.AddressMapSearchFailed, 'Metadata', Metadata_getInstance_7);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressSearchFailed = AddressSearchFailed;
    defineProp($com$glovoapp$analytics$events.AddressSearchFailed, 'Metadata', Metadata_getInstance_8);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressSearchSource = AddressSearchSource;
    $com$glovoapp$analytics$events.AddressSearchSource.values = values_4;
    $com$glovoapp$analytics$events.AddressSearchSource.valueOf = valueOf_4;
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'NewOrder', AddressSearchSource_NewOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'Home', AddressSearchSource_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'SelfAddressChange', AddressSearchSource_SelfAddressChange_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'StorePage', AddressSearchSource_StorePage_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'Category', AddressSearchSource_Category_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'Other', AddressSearchSource_Other_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'OrderWarning', AddressSearchSource_OrderWarning_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeGlobalSearchBar', AddressSearchSource_HomeGlobalSearchBar_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeGlobalTopBrands', AddressSearchSource_HomeGlobalTopBrands_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeGlobalExploreRestaurants', AddressSearchSource_HomeGlobalExploreRestaurants_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeCountrySearchBar', AddressSearchSource_HomeCountrySearchBar_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeCountryTopBrands', AddressSearchSource_HomeCountryTopBrands_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeCountryExploreRestaurants', AddressSearchSource_HomeCountryExploreRestaurants_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'Onboarding', AddressSearchSource_Onboarding_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'HomeBottomSheet', AddressSearchSource_HomeBottomSheet_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'AddressLandingScreen', AddressSearchSource_AddressLandingScreen_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSearchSource, 'CheckoutTemplate', AddressSearchSource_CheckoutTemplate_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressSource = AddressSource;
    $com$glovoapp$analytics$events.AddressSource.values = values_5;
    $com$glovoapp$analytics$events.AddressSource.valueOf = valueOf_5;
    defineProp($com$glovoapp$analytics$events.AddressSource, 'SearchResult', AddressSource_SearchResult_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSource, 'PinOnMap', AddressSource_PinOnMap_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSource, 'PastDeliveryAddress', AddressSource_PastDeliveryAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSource, 'NewOrder', AddressSource_NewOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressSource, 'EditDeliveryInfo', AddressSource_EditDeliveryInfo_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressTooFarErrorFired = AddressTooFarErrorFired;
    defineProp($com$glovoapp$analytics$events.AddressTooFarErrorFired, 'Metadata', Metadata_getInstance_9);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressType = AddressType;
    $com$glovoapp$analytics$events.AddressType.values = values_6;
    $com$glovoapp$analytics$events.AddressType.valueOf = valueOf_6;
    defineProp($com$glovoapp$analytics$events.AddressType, 'Regular', AddressType_Regular_getInstance);
    defineProp($com$glovoapp$analytics$events.AddressType, 'Custom', AddressType_Custom_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AllFiltersCleared = AllFiltersCleared;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AlternativePlatformNameType = AlternativePlatformNameType;
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'ApplePay', ApplePay_getInstance);
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'GooglePay', GooglePay_getInstance);
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'DotPay', DotPay_getInstance);
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'PayPal', PayPal_getInstance);
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'Edenred', Edenred_getInstance);
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'BalanceCredit', BalanceCredit_getInstance);
    $com$glovoapp$analytics$events.AlternativePlatformNameType.WebPayment = WebPayment;
    $com$glovoapp$analytics$events.AlternativePlatformNameType.NativePayment = NativePayment;
    defineProp($com$glovoapp$analytics$events.AlternativePlatformNameType, 'Unknown', Unknown_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AppliedFilterOrigin = AppliedFilterOrigin;
    $com$glovoapp$analytics$events.AppliedFilterOrigin.values = values_7;
    $com$glovoapp$analytics$events.AppliedFilterOrigin.valueOf = valueOf_7;
    defineProp($com$glovoapp$analytics$events.AppliedFilterOrigin, 'TopShortcuts', AppliedFilterOrigin_TopShortcuts_getInstance);
    defineProp($com$glovoapp$analytics$events.AppliedFilterOrigin, 'FiltersScreen', AppliedFilterOrigin_FiltersScreen_getInstance);
    defineProp($com$glovoapp$analytics$events.AppliedFilterOrigin, 'TogglePrime', AppliedFilterOrigin_TogglePrime_getInstance);
    defineProp($com$glovoapp$analytics$events.AppliedFilterOrigin, 'TogglePickUp', AppliedFilterOrigin_TogglePickUp_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ApplyConsent = ApplyConsent;
    defineProp($com$glovoapp$analytics$events.ApplyConsent, 'Metadata', Metadata_getInstance_10);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AuthenticationOption = AuthenticationOption;
    $com$glovoapp$analytics$events.AuthenticationOption.values = values_8;
    $com$glovoapp$analytics$events.AuthenticationOption.valueOf = valueOf_8;
    defineProp($com$glovoapp$analytics$events.AuthenticationOption, 'PhoneOTP', AuthenticationOption_PhoneOTP_getInstance);
    defineProp($com$glovoapp$analytics$events.AuthenticationOption, 'Email', AuthenticationOption_Email_getInstance);
    defineProp($com$glovoapp$analytics$events.AuthenticationOption, 'Facebook', AuthenticationOption_Facebook_getInstance);
    defineProp($com$glovoapp$analytics$events.AuthenticationOption, 'Apple', AuthenticationOption_Apple_getInstance);
    defineProp($com$glovoapp$analytics$events.AuthenticationOption, 'Google', AuthenticationOption_Google_getInstance);
    defineProp($com$glovoapp$analytics$events.AuthenticationOption, 'Password', AuthenticationOption_Password_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AuthenticationOptionSelected = AuthenticationOptionSelected;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AuthenticationOptionsScreen = AuthenticationOptionsScreen;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AvailabilityStatus = AvailabilityStatus;
    $com$glovoapp$analytics$events.AvailabilityStatus.Closed = Closed;
    $com$glovoapp$analytics$events.AvailabilityStatus.Unavailable = Unavailable;
    $com$glovoapp$analytics$events.AvailabilityStatus.Schedulable = Schedulable;
    defineProp($com$glovoapp$analytics$events.AvailabilityStatus, 'Asap', Asap_getInstance);
    defineProp($com$glovoapp$analytics$events.AvailabilityStatus, 'OutOfDeliveryZone', OutOfDeliveryZone_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BackToBasketScreenFromCheckout = BackToBasketScreenFromCheckout;
    defineProp($com$glovoapp$analytics$events.BackToBasketScreenFromCheckout, 'Metadata', Metadata_getInstance_11);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BadgeType = BadgeType;
    $com$glovoapp$analytics$events.BadgeType.values = values_9;
    $com$glovoapp$analytics$events.BadgeType.valueOf = valueOf_9;
    defineProp($com$glovoapp$analytics$events.BadgeType, 'Taste', BadgeType_Taste_getInstance);
    defineProp($com$glovoapp$analytics$events.BadgeType, 'Price', BadgeType_Price_getInstance);
    defineProp($com$glovoapp$analytics$events.BadgeType, 'PortionSize', BadgeType_PortionSize_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketCreated = BasketCreated;
    defineProp($com$glovoapp$analytics$events.BasketCreated, 'Metadata', Metadata_getInstance_12);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketCreationOrigin = BasketCreationOrigin;
    $com$glovoapp$analytics$events.BasketCreationOrigin.values = values_10;
    $com$glovoapp$analytics$events.BasketCreationOrigin.valueOf = valueOf_10;
    defineProp($com$glovoapp$analytics$events.BasketCreationOrigin, 'StoreView', BasketCreationOrigin_StoreView_getInstance);
    defineProp($com$glovoapp$analytics$events.BasketCreationOrigin, 'ProductDetailsView', BasketCreationOrigin_ProductDetailsView_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketDeleted = BasketDeleted;
    defineProp($com$glovoapp$analytics$events.BasketDeleted, 'Metadata', Metadata_getInstance_13);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketError = BasketError;
    defineProp($com$glovoapp$analytics$events.BasketError, 'Metadata', Metadata_getInstance_14);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketOrigin = BasketOrigin;
    $com$glovoapp$analytics$events.BasketOrigin.values = values_11;
    $com$glovoapp$analytics$events.BasketOrigin.valueOf = valueOf_11;
    defineProp($com$glovoapp$analytics$events.BasketOrigin, 'BasketEntryPoint', BasketOrigin_BasketEntryPoint_getInstance);
    defineProp($com$glovoapp$analytics$events.BasketOrigin, 'StoreView', BasketOrigin_StoreView_getInstance);
    defineProp($com$glovoapp$analytics$events.BasketOrigin, 'OrderHistory', BasketOrigin_OrderHistory_getInstance);
    defineProp($com$glovoapp$analytics$events.BasketOrigin, 'LoyaltyProgram', BasketOrigin_LoyaltyProgram_getInstance);
    defineProp($com$glovoapp$analytics$events.BasketOrigin, 'NavigationTabBar', BasketOrigin_NavigationTabBar_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketRecovered = BasketRecovered;
    defineProp($com$glovoapp$analytics$events.BasketRecovered, 'Metadata', Metadata_getInstance_15);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BasketScreen = BasketScreen;
    defineProp($com$glovoapp$analytics$events.BasketScreen, 'Metadata', Metadata_getInstance_16);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BottomSheetScreen = BottomSheetScreen;
    $com$glovoapp$analytics$events.BottomSheetScreen.values = values_12;
    $com$glovoapp$analytics$events.BottomSheetScreen.valueOf = valueOf_12;
    defineProp($com$glovoapp$analytics$events.BottomSheetScreen, 'Checkout', BottomSheetScreen_Checkout_getInstance);
    defineProp($com$glovoapp$analytics$events.BottomSheetScreen, 'StoresWall', BottomSheetScreen_StoresWall_getInstance);
    defineProp($com$glovoapp$analytics$events.BottomSheetScreen, 'StoreView', BottomSheetScreen_StoreView_getInstance);
    defineProp($com$glovoapp$analytics$events.BottomSheetScreen, 'Home', BottomSheetScreen_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.BottomSheetScreen, 'LoyaltyProgram', BottomSheetScreen_LoyaltyProgram_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BottomSheetShown = BottomSheetShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BottomSheetSource = BottomSheetSource;
    $com$glovoapp$analytics$events.BottomSheetSource.values = values_13;
    $com$glovoapp$analytics$events.BottomSheetSource.valueOf = valueOf_13;
    defineProp($com$glovoapp$analytics$events.BottomSheetSource, 'InfoButton', BottomSheetSource_InfoButton_getInstance);
    defineProp($com$glovoapp$analytics$events.BottomSheetSource, 'Banner', BottomSheetSource_Banner_getInstance);
    defineProp($com$glovoapp$analytics$events.BottomSheetSource, 'Icon', BottomSheetSource_Icon_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.BottomSheetType = BottomSheetType;
    $com$glovoapp$analytics$events.BottomSheetType.CheckoutErrorHandling = CheckoutErrorHandling;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CCChatProvider = CCChatProvider;
    $com$glovoapp$analytics$events.CCChatProvider.values = values_14;
    $com$glovoapp$analytics$events.CCChatProvider.valueOf = valueOf_14;
    defineProp($com$glovoapp$analytics$events.CCChatProvider, 'Smooch', CCChatProvider_Smooch_getInstance);
    defineProp($com$glovoapp$analytics$events.CCChatProvider, 'SendBird', CCChatProvider_SendBird_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CTA = CTA;
    $com$glovoapp$analytics$events.CTA.values = values_15;
    $com$glovoapp$analytics$events.CTA.valueOf = valueOf_15;
    defineProp($com$glovoapp$analytics$events.CTA, 'CancelOrder', CTA_CancelOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'ChangePhoneNumber', CTA_ChangePhoneNumber_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'CloseContactTree', CTA_CloseContactTree_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'CourierChat', CTA_CourierChat_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'Email', CTA_Email_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'FaqLink', CTA_FaqLink_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'Form', CTA_Form_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'LegalBook', CTA_LegalBook_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'MultiSelectForm', CTA_MultiSelectForm_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'NoAction', CTA_NoAction_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'Node', CTA_Node_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'OnDemand', CTA_OnDemand_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'PhoneCall', CTA_PhoneCall_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'Popup', CTA_Popup_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'ProductSelector', CTA_ProductSelector_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'Reorder', CTA_Reorder_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'SupportChat', CTA_SupportChat_getInstance);
    defineProp($com$glovoapp$analytics$events.CTA, 'WebLink', CTA_WebLink_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CarouselScrollDirection = CarouselScrollDirection;
    $com$glovoapp$analytics$events.CarouselScrollDirection.values = values_16;
    $com$glovoapp$analytics$events.CarouselScrollDirection.valueOf = valueOf_16;
    defineProp($com$glovoapp$analytics$events.CarouselScrollDirection, 'Left', CarouselScrollDirection_Left_getInstance);
    defineProp($com$glovoapp$analytics$events.CarouselScrollDirection, 'Right', CarouselScrollDirection_Right_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CarouselScrolled = CarouselScrolled;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartEntryPointImpression = CartEntryPointImpression;
    defineProp($com$glovoapp$analytics$events.CartEntryPointImpression, 'Metadata', Metadata_getInstance_17);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartEntryPointNavigationClick = CartEntryPointNavigationClick;
    defineProp($com$glovoapp$analytics$events.CartEntryPointNavigationClick, 'Metadata', Metadata_getInstance_18);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartExpired = CartExpired;
    defineProp($com$glovoapp$analytics$events.CartExpired, 'Metadata', Metadata_getInstance_19);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartInteracted = CartInteracted;
    defineProp($com$glovoapp$analytics$events.CartInteracted, 'Metadata', Metadata_getInstance_20);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartInteractionType = CartInteractionType;
    defineProp($com$glovoapp$analytics$events.CartInteractionType, 'HelpClicked', HelpClicked_getInstance);
    defineProp($com$glovoapp$analytics$events.CartInteractionType, 'GoBack', GoBack_getInstance);
    $com$glovoapp$analytics$events.CartInteractionType.AddRemoveQuantityClicked = AddRemoveQuantityClicked;
    $com$glovoapp$analytics$events.CartInteractionType.RemoveProductClicked = RemoveProductClicked;
    defineProp($com$glovoapp$analytics$events.CartInteractionType, 'GoCheckout', GoCheckout_getInstance);
    defineProp($com$glovoapp$analytics$events.CartInteractionType, 'GoPNAInstructions', GoPNAInstructions_getInstance);
    defineProp($com$glovoapp$analytics$events.CartInteractionType, 'GoGiftingOptions', GoGiftingOptions_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartLoaded = CartLoaded;
    defineProp($com$glovoapp$analytics$events.CartLoaded, 'Metadata', Metadata_getInstance_21);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartProductImpression = CartProductImpression;
    defineProp($com$glovoapp$analytics$events.CartProductImpression, 'Metadata', Metadata_getInstance_22);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartRecoveryStarted = CartRecoveryStarted;
    defineProp($com$glovoapp$analytics$events.CartRecoveryStarted, 'Metadata', Metadata_getInstance_23);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartRemovalButtonClicked = CartRemovalButtonClicked;
    defineProp($com$glovoapp$analytics$events.CartRemovalButtonClicked, 'Metadata', Metadata_getInstance_24);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartRemovalModalConfirmed = CartRemovalModalConfirmed;
    defineProp($com$glovoapp$analytics$events.CartRemovalModalConfirmed, 'Metadata', Metadata_getInstance_25);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartRemovalModalDenied = CartRemovalModalDenied;
    defineProp($com$glovoapp$analytics$events.CartRemovalModalDenied, 'Metadata', Metadata_getInstance_26);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartType = CartType;
    $com$glovoapp$analytics$events.CartType.ProductNotAvailable = ProductNotAvailable;
    $com$glovoapp$analytics$events.CartType.ProductList = ProductList;
    defineProp($com$glovoapp$analytics$events.CartType, 'EmptyCart', EmptyCart_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CashAmountConfirmed = CashAmountConfirmed;
    defineProp($com$glovoapp$analytics$events.CashAmountConfirmed, 'Metadata', Metadata_getInstance_27);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CashAmountScreen = CashAmountScreen;
    defineProp($com$glovoapp$analytics$events.CashAmountScreen, 'Metadata', Metadata_getInstance_28);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CategoryGroup = CategoryGroup;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CategoryGroupContentShown = CategoryGroupContentShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CategoryGroupOpened = CategoryGroupOpened;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CategoryOpened = CategoryOpened;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ChatNotificationType = ChatNotificationType;
    $com$glovoapp$analytics$events.ChatNotificationType.values = values_17;
    $com$glovoapp$analytics$events.ChatNotificationType.valueOf = valueOf_17;
    defineProp($com$glovoapp$analytics$events.ChatNotificationType, 'CustomerCourier', ChatNotificationType_CustomerCourier_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatNotificationType, 'Proactive', ChatNotificationType_Proactive_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatNotificationType, 'Support', ChatNotificationType_Support_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ChatProvider = ChatProvider;
    $com$glovoapp$analytics$events.ChatProvider.values = values_18;
    $com$glovoapp$analytics$events.ChatProvider.valueOf = valueOf_18;
    defineProp($com$glovoapp$analytics$events.ChatProvider, 'Kustomer', ChatProvider_Kustomer_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatProvider, 'Smooch', ChatProvider_Smooch_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatProvider, 'SendBird', ChatProvider_SendBird_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ChatType = ChatType;
    $com$glovoapp$analytics$events.ChatType.values = values_19;
    $com$glovoapp$analytics$events.ChatType.valueOf = valueOf_19;
    defineProp($com$glovoapp$analytics$events.ChatType, 'Kustomer', ChatType_Kustomer_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatType, 'Smooch', ChatType_Smooch_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatType, 'Support', ChatType_Support_getInstance);
    defineProp($com$glovoapp$analytics$events.ChatType, 'CCchat', ChatType_CCchat_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Checkout = Checkout;
    defineProp($com$glovoapp$analytics$events.Checkout, 'Metadata', Metadata_getInstance_29);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutComponentShown = CheckoutComponentShown;
    defineProp($com$glovoapp$analytics$events.CheckoutComponentShown, 'Metadata', Metadata_getInstance_30);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutConfirmationButtonPressed = CheckoutConfirmationButtonPressed;
    defineProp($com$glovoapp$analytics$events.CheckoutConfirmationButtonPressed, 'Metadata', Metadata_getInstance_31);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutContentShown = CheckoutContentShown;
    defineProp($com$glovoapp$analytics$events.CheckoutContentShown, 'Metadata', Metadata_getInstance_32);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutCountdownContinueButtonPressed = CheckoutCountdownContinueButtonPressed;
    defineProp($com$glovoapp$analytics$events.CheckoutCountdownContinueButtonPressed, 'Metadata', Metadata_getInstance_33);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutCountdownFinished = CheckoutCountdownFinished;
    defineProp($com$glovoapp$analytics$events.CheckoutCountdownFinished, 'Metadata', Metadata_getInstance_34);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutCountdownModifyButtonPressed = CheckoutCountdownModifyButtonPressed;
    defineProp($com$glovoapp$analytics$events.CheckoutCountdownModifyButtonPressed, 'Metadata', Metadata_getInstance_35);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutCountdownScreenShown = CheckoutCountdownScreenShown;
    defineProp($com$glovoapp$analytics$events.CheckoutCountdownScreenShown, 'Metadata', Metadata_getInstance_36);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutMapHyperlinkClicked = CheckoutMapHyperlinkClicked;
    defineProp($com$glovoapp$analytics$events.CheckoutMapHyperlinkClicked, 'Metadata', Metadata_getInstance_37);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutOrderButtonPressed = CheckoutOrderButtonPressed;
    defineProp($com$glovoapp$analytics$events.CheckoutOrderButtonPressed, 'Metadata', Metadata_getInstance_38);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutOrderConfirmation = CheckoutOrderConfirmation;
    defineProp($com$glovoapp$analytics$events.CheckoutOrderConfirmation, 'Metadata', Metadata_getInstance_39);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutPrimeBannerShown = CheckoutPrimeBannerShown;
    defineProp($com$glovoapp$analytics$events.CheckoutPrimeBannerShown, 'Metadata', Metadata_getInstance_40);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CheckoutTemplateReceived = CheckoutTemplateReceived;
    defineProp($com$glovoapp$analytics$events.CheckoutTemplateReceived, 'Metadata', Metadata_getInstance_41);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CollectionGroupImpression = CollectionGroupImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CollectionGroupOpened = CollectionGroupOpened;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CollectionImpression = CollectionImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CollectionOpened = CollectionOpened;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CollectionOrigin = CollectionOrigin;
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'CollectionGroup', CollectionGroup_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'NestedCollectionGroup', NestedCollectionGroup_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'NavigationMenu', NavigationMenu_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'ContentExpansionButton', ContentExpansionButton_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'StoreHomeMosaic', StoreHomeMosaic_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'SearchArrow', SearchArrow_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionOrigin, 'Deeplink', Deeplink_getInstance);
    $com$glovoapp$analytics$events.CollectionOrigin.Widget = Widget;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CollectionType = CollectionType;
    $com$glovoapp$analytics$events.CollectionType.Catalogue = Catalogue;
    defineProp($com$glovoapp$analytics$events.CollectionType, 'EasyReorder', EasyReorder_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionType, 'TopSellers', TopSellers_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionType, 'Promotions', Promotions_getInstance);
    defineProp($com$glovoapp$analytics$events.CollectionType, 'MealsUnderX', MealsUnderX_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ConnectionSource = ConnectionSource;
    $com$glovoapp$analytics$events.ConnectionSource.values = values_20;
    $com$glovoapp$analytics$events.ConnectionSource.valueOf = valueOf_20;
    defineProp($com$glovoapp$analytics$events.ConnectionSource, 'Profile', ConnectionSource_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.ConnectionSource, 'PushNotification', ConnectionSource_PushNotification_getInstance);
    defineProp($com$glovoapp$analytics$events.ConnectionSource, 'BottomSheet', ConnectionSource_BottomSheet_getInstance);
    defineProp($com$glovoapp$analytics$events.ConnectionSource, 'FLPBanner', ConnectionSource_FLPBanner_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ConsentFirstLayerApplied = ConsentFirstLayerApplied;
    defineProp($com$glovoapp$analytics$events.ConsentFirstLayerApplied, 'Metadata', Metadata_getInstance_42);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ConsentFirstLayerNotNeeded = ConsentFirstLayerNotNeeded;
    defineProp($com$glovoapp$analytics$events.ConsentFirstLayerNotNeeded, 'Metadata', Metadata_getInstance_43);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ConsentFirstLayerShown = ConsentFirstLayerShown;
    defineProp($com$glovoapp$analytics$events.ConsentFirstLayerShown, 'Metadata', Metadata_getInstance_44);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ConsentSecondLayerApplied = ConsentSecondLayerApplied;
    defineProp($com$glovoapp$analytics$events.ConsentSecondLayerApplied, 'Metadata', Metadata_getInstance_45);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ConsentSecondLayerShown = ConsentSecondLayerShown;
    defineProp($com$glovoapp$analytics$events.ConsentSecondLayerShown, 'Metadata', Metadata_getInstance_46);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactCourier = ContactCourier;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactReason = ContactReason;
    $com$glovoapp$analytics$events.ContactReason.values = values_21;
    $com$glovoapp$analytics$events.ContactReason.valueOf = valueOf_21;
    defineProp($com$glovoapp$analytics$events.ContactReason, 'CourierNotMoving', ContactReason_CourierNotMoving_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'NoCourierOnMap', ContactReason_NoCourierOnMap_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'OrderLate', ContactReason_OrderLate_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChangePaymentMethod', ContactReason_ChangePaymentMethod_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChangePhoneNumber', ContactReason_ChangePhoneNumber_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChangeDeliveryAddress', ContactReason_ChangeDeliveryAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChangeItems', ContactReason_ChangeItems_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PromocodeNotValid', ContactReason_PromocodeNotValid_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PromocodeNotApplied', ContactReason_PromocodeNotApplied_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'CheckBalance', ContactReason_CheckBalance_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'NotDelivered', ContactReason_NotDelivered_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PastOrderLate', ContactReason_PastOrderLate_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'OrderCancelled', ContactReason_OrderCancelled_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'TastedBad', ContactReason_TastedBad_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'IncorrectTemperature', ContactReason_IncorrectTemperature_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PoorQuality', ContactReason_PoorQuality_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PackagingIssues', ContactReason_PackagingIssues_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'AllergyNotConsidered', ContactReason_AllergyNotConsidered_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'MissingExtras', ContactReason_MissingExtras_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'MissingProducts', ContactReason_MissingProducts_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'WrongProducts', ContactReason_WrongProducts_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'DidNotMatchPhoto', ContactReason_DidNotMatchPhoto_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'RudeOrDisrespectful', ContactReason_RudeOrDisrespectful_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'SanitaryEquipment', ContactReason_SanitaryEquipment_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'RemoveTip', ContactReason_RemoveTip_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'TransportedImproperly', ContactReason_TransportedImproperly_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChargedMultipleTimes', ContactReason_ChargedMultipleTimes_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChargedWrongAmount', ContactReason_ChargedWrongAmount_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ProblemWithCash', ContactReason_ProblemWithCash_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PromoCode', ContactReason_PromoCode_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'SpecialStorePromos', ContactReason_SpecialStorePromos_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'GlovoPrimeBecomeMember', ContactReason_GlovoPrimeBecomeMember_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'GlovoPrimeHowItWorks', ContactReason_GlovoPrimeHowItWorks_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'GlovoePrimePaymentIssue', ContactReason_GlovoePrimePaymentIssue_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'GlovoePrimeUnsuscribe', ContactReason_GlovoePrimeUnsuscribe_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChangeEmailAddress', ContactReason_ChangeEmailAddress_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ChangePassword', ContactReason_ChangePassword_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'DeleteAccount', ContactReason_DeleteAccount_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'VerifyIdentity', ContactReason_VerifyIdentity_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ReceiveGlovoNews', ContactReason_ReceiveGlovoNews_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'UnsubscribeGlovoNews', ContactReason_UnsubscribeGlovoNews_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'HowToOrder', ContactReason_HowToOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'DeliveryArea', ContactReason_DeliveryArea_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ServiceHours', ContactReason_ServiceHours_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'AppAdvantages', ContactReason_AppAdvantages_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'DeliveryCosts', ContactReason_DeliveryCosts_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PaymentMethods', ContactReason_PaymentMethods_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'VehiclesInformation', ContactReason_VehiclesInformation_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'BecomeGlover', ContactReason_BecomeGlover_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'BecomePartner', ContactReason_BecomePartner_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'BecomeColleague', ContactReason_BecomeColleague_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ContactBusinessUnit', ContactReason_ContactBusinessUnit_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'ContactPressTeam', ContactReason_ContactPressTeam_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'RightOfAccess', ContactReason_RightOfAccess_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'RightOfModification', ContactReason_RightOfModification_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PersonalDataRestriction', ContactReason_PersonalDataRestriction_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'CancelAccount', ContactReason_CancelAccount_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'RightOfOpposition', ContactReason_RightOfOpposition_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'TermsAndConditions', ContactReason_TermsAndConditions_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactReason, 'PrivacyPolicy', ContactReason_PrivacyPolicy_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactSupportPressed = ContactSupportPressed;
    defineProp($com$glovoapp$analytics$events.ContactSupportPressed, 'Metadata', Metadata_getInstance_47);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactTreeNodePopup = ContactTreeNodePopup;
    defineProp($com$glovoapp$analytics$events.ContactTreeNodePopup, 'Metadata', Metadata_getInstance_48);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactTreeNodeSelected = ContactTreeNodeSelected;
    defineProp($com$glovoapp$analytics$events.ContactTreeNodeSelected, 'Metadata', Metadata_getInstance_49);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactTreeOpened = ContactTreeOpened;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactTreeSelectedNode = ContactTreeSelectedNode;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactUsOrigin = ContactUsOrigin;
    $com$glovoapp$analytics$events.ContactUsOrigin.values = values_22;
    $com$glovoapp$analytics$events.ContactUsOrigin.valueOf = valueOf_22;
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'Profile', ContactUsOrigin_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'Order', ContactUsOrigin_Order_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'OutstandingPayments', ContactUsOrigin_OutstandingPayments_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'OrderRating', ContactUsOrigin_OrderRating_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'InvalidCard', ContactUsOrigin_InvalidCard_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'OrderCancelled', ContactUsOrigin_OrderCancelled_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'FraudWarning', ContactUsOrigin_FraudWarning_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'Checkout', ContactUsOrigin_Checkout_getInstance);
    defineProp($com$glovoapp$analytics$events.ContactUsOrigin, 'Cancel', ContactUsOrigin_Cancel_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContactUsUsed = ContactUsUsed;
    defineProp($com$glovoapp$analytics$events.ContactUsUsed, 'Metadata', Metadata_getInstance_50);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ContentTranslatedAction = ContentTranslatedAction;
    $com$glovoapp$analytics$events.ContentTranslatedAction.values = values_23;
    $com$glovoapp$analytics$events.ContentTranslatedAction.valueOf = valueOf_23;
    defineProp($com$glovoapp$analytics$events.ContentTranslatedAction, 'Translate', ContentTranslatedAction_Translate_getInstance);
    defineProp($com$glovoapp$analytics$events.ContentTranslatedAction, 'Untranslate', ContentTranslatedAction_Untranslate_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CreatePassword = CreatePassword;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CsatReason = CsatReason;
    $com$glovoapp$analytics$events.CsatReason.values = values_24;
    $com$glovoapp$analytics$events.CsatReason.valueOf = valueOf_24;
    defineProp($com$glovoapp$analytics$events.CsatReason, 'NoAgent', CsatReason_NoAgent_getInstance);
    defineProp($com$glovoapp$analytics$events.CsatReason, 'NotRelevant', CsatReason_NotRelevant_getInstance);
    defineProp($com$glovoapp$analytics$events.CsatReason, 'TooManySteps', CsatReason_TooManySteps_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CsatSide = CsatSide;
    $com$glovoapp$analytics$events.CsatSide.values = values_25;
    $com$glovoapp$analytics$events.CsatSide.valueOf = valueOf_25;
    defineProp($com$glovoapp$analytics$events.CsatSide, 'Right', CsatSide_Right_getInstance);
    defineProp($com$glovoapp$analytics$events.CsatSide, 'Left', CsatSide_Left_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DeliveryOptionSelected = DeliveryOptionSelected;
    defineProp($com$glovoapp$analytics$events.DeliveryOptionSelected, 'Metadata', Metadata_getInstance_51);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DeliveryOptionsAvailable = DeliveryOptionsAvailable;
    defineProp($com$glovoapp$analytics$events.DeliveryOptionsAvailable, 'Metadata', Metadata_getInstance_52);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DeliveryOptionsDescriptionViewed = DeliveryOptionsDescriptionViewed;
    defineProp($com$glovoapp$analytics$events.DeliveryOptionsDescriptionViewed, 'Metadata', Metadata_getInstance_53);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DeliveryOptionsExpandableListChanged = DeliveryOptionsExpandableListChanged;
    defineProp($com$glovoapp$analytics$events.DeliveryOptionsExpandableListChanged, 'Metadata', Metadata_getInstance_54);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DynamicSessionStarted = DynamicSessionStarted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EasyReorderScreenType = EasyReorderScreenType;
    $com$glovoapp$analytics$events.EasyReorderScreenType.values = values_26;
    $com$glovoapp$analytics$events.EasyReorderScreenType.valueOf = valueOf_26;
    defineProp($com$glovoapp$analytics$events.EasyReorderScreenType, 'EasyReorderCarousel', EasyReorderScreenType_EasyReorderCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.EasyReorderScreenType, 'EasyReorderSection', EasyReorderScreenType_EasyReorderSection_getInstance);
    defineProp($com$glovoapp$analytics$events.EasyReorderScreenType, 'EasyReorderAllOptions', EasyReorderScreenType_EasyReorderAllOptions_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EditAddressButtonPressed = EditAddressButtonPressed;
    defineProp($com$glovoapp$analytics$events.EditAddressButtonPressed, 'Metadata', Metadata_getInstance_55);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EditAddressClicked = EditAddressClicked;
    defineProp($com$glovoapp$analytics$events.EditAddressClicked, 'Metadata', Metadata_getInstance_56);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EditAddressOrigins = EditAddressOrigins;
    $com$glovoapp$analytics$events.EditAddressOrigins.values = values_27;
    $com$glovoapp$analytics$events.EditAddressOrigins.valueOf = valueOf_27;
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'OutOfDeliveryPopup', EditAddressOrigins_OutOfDeliveryPopup_getInstance);
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'NewOrder', EditAddressOrigins_NewOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'Home', EditAddressOrigins_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'SelfAddressChange', EditAddressOrigins_SelfAddressChange_getInstance);
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'StorePage', EditAddressOrigins_StorePage_getInstance);
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'Category', EditAddressOrigins_Category_getInstance);
    defineProp($com$glovoapp$analytics$events.EditAddressOrigins, 'Other', EditAddressOrigins_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ElementAction = ElementAction;
    $com$glovoapp$analytics$events.ElementAction.values = values_28;
    $com$glovoapp$analytics$events.ElementAction.valueOf = valueOf_28;
    defineProp($com$glovoapp$analytics$events.ElementAction, 'Dismissal', ElementAction_Dismissal_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ElementScreen = ElementScreen;
    $com$glovoapp$analytics$events.ElementScreen.values = values_29;
    $com$glovoapp$analytics$events.ElementScreen.valueOf = valueOf_29;
    defineProp($com$glovoapp$analytics$events.ElementScreen, 'StoresWall', ElementScreen_StoresWall_getInstance);
    defineProp($com$glovoapp$analytics$events.ElementScreen, 'StoreView', ElementScreen_StoreView_getInstance);
    defineProp($com$glovoapp$analytics$events.ElementScreen, 'Home', ElementScreen_Home_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ElementSource = ElementSource;
    $com$glovoapp$analytics$events.ElementSource.values = values_30;
    $com$glovoapp$analytics$events.ElementSource.valueOf = valueOf_30;
    defineProp($com$glovoapp$analytics$events.ElementSource, 'Banner', ElementSource_Banner_getInstance);
    defineProp($com$glovoapp$analytics$events.ElementSource, 'Icon', ElementSource_Icon_getInstance);
    defineProp($com$glovoapp$analytics$events.ElementSource, 'BottomSheet', ElementSource_BottomSheet_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ElementTapped = ElementTapped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ElementType = ElementType;
    $com$glovoapp$analytics$events.ElementType.values = values_31;
    $com$glovoapp$analytics$events.ElementType.valueOf = valueOf_31;
    defineProp($com$glovoapp$analytics$events.ElementType, 'Surge', ElementType_Surge_getInstance);
    defineProp($com$glovoapp$analytics$events.ElementType, 'Promotion', ElementType_Promotion_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EnterEmailOrigin = EnterEmailOrigin;
    $com$glovoapp$analytics$events.EnterEmailOrigin.values = values_32;
    $com$glovoapp$analytics$events.EnterEmailOrigin.valueOf = valueOf_32;
    defineProp($com$glovoapp$analytics$events.EnterEmailOrigin, 'Unification', EnterEmailOrigin_Unification_getInstance);
    defineProp($com$glovoapp$analytics$events.EnterEmailOrigin, 'PhoneLogin', EnterEmailOrigin_PhoneLogin_getInstance);
    defineProp($com$glovoapp$analytics$events.EnterEmailOrigin, 'PhoneSignup', EnterEmailOrigin_PhoneSignup_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EnterEmailScreen = EnterEmailScreen;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EnterPassword = EnterPassword;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ExploreStoresButtonClicked = ExploreStoresButtonClicked;
    defineProp($com$glovoapp$analytics$events.ExploreStoresButtonClicked, 'Metadata', Metadata_getInstance_57);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FAQ = FAQ;
    defineProp($com$glovoapp$analytics$events.FAQ, 'Metadata', Metadata_getInstance_58);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedGroupImpression = FeedGroupImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedGroupInteracted = FeedGroupInteracted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedGroupInteractionType = FeedGroupInteractionType;
    defineProp($com$glovoapp$analytics$events.FeedGroupInteractionType, 'CtaSelected', CtaSelected_getInstance);
    defineProp($com$glovoapp$analytics$events.FeedGroupInteractionType, 'PromotionEventSelected', PromotionEventSelected_getInstance);
    defineProp($com$glovoapp$analytics$events.FeedGroupInteractionType, 'LottieSelected', LottieSelected_getInstance);
    defineProp($com$glovoapp$analytics$events.FeedGroupInteractionType, 'GamificationSelected', GamificationSelected_getInstance);
    $com$glovoapp$analytics$events.FeedGroupInteractionType.StoreSelected = StoreSelected;
    defineProp($com$glovoapp$analytics$events.FeedGroupInteractionType, 'InfoSelected', InfoSelected_getInstance);
    defineProp($com$glovoapp$analytics$events.FeedGroupInteractionType, 'Other', Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedGroupLoaded = FeedGroupLoaded;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedbackCsat = FeedbackCsat;
    defineProp($com$glovoapp$analytics$events.FeedbackCsat, 'Metadata', Metadata_getInstance_59);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedbackCsatReasonAdded = FeedbackCsatReasonAdded;
    defineProp($com$glovoapp$analytics$events.FeedbackCsatReasonAdded, 'Metadata', Metadata_getInstance_60);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FeedbackCsatSubmitted = FeedbackCsatSubmitted;
    defineProp($com$glovoapp$analytics$events.FeedbackCsatSubmitted, 'Metadata', Metadata_getInstance_61);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FilterDisplayed = FilterDisplayed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FilterName = FilterName;
    $com$glovoapp$analytics$events.FilterName.values = values_33;
    $com$glovoapp$analytics$events.FilterName.valueOf = valueOf_33;
    defineProp($com$glovoapp$analytics$events.FilterName, 'StoreType', FilterName_StoreType_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterName, 'Sorting', FilterName_Sorting_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterName, 'Price', FilterName_Price_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterName, 'Promotions', FilterName_Promotions_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterName, 'EdenRed', FilterName_EdenRed_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterName, 'TopPerformers', FilterName_TopPerformers_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterName, 'EasyReorder', FilterName_EasyReorder_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FilterOrigin = FilterOrigin;
    $com$glovoapp$analytics$events.FilterOrigin.values = values_34;
    $com$glovoapp$analytics$events.FilterOrigin.valueOf = valueOf_34;
    defineProp($com$glovoapp$analytics$events.FilterOrigin, 'Shortcut', FilterOrigin_Shortcut_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterOrigin, 'Pill', FilterOrigin_Pill_getInstance);
    defineProp($com$glovoapp$analytics$events.FilterOrigin, 'BottomSheet', FilterOrigin_BottomSheet_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Filters = Filters;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FiltersApplied = FiltersApplied;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FiltersApplyResults = FiltersApplyResults;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ForgotPassword = ForgotPassword;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GiftingComponentPressed = GiftingComponentPressed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GiftingOptionDisplayed = GiftingOptionDisplayed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GiftingRecipientDetailsSaved = GiftingRecipientDetailsSaved;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GoToCheckout = GoToCheckout;
    defineProp($com$glovoapp$analytics$events.GoToCheckout, 'Metadata', Metadata_getInstance_62);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Home = Home;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.HomeContentShown = HomeContentShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.HomeLocationErrorScreenView = HomeLocationErrorScreenView;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.HomePageNotLoadedReason = HomePageNotLoadedReason;
    $com$glovoapp$analytics$events.HomePageNotLoadedReason.values = values_35;
    $com$glovoapp$analytics$events.HomePageNotLoadedReason.valueOf = valueOf_35;
    defineProp($com$glovoapp$analytics$events.HomePageNotLoadedReason, 'OutOfDeliveryZone', HomePageNotLoadedReason_OutOfDeliveryZone_getInstance);
    defineProp($com$glovoapp$analytics$events.HomePageNotLoadedReason, 'FailureToFetchGpsWhileOn', HomePageNotLoadedReason_FailureToFetchGpsWhileOn_getInstance);
    defineProp($com$glovoapp$analytics$events.HomePageNotLoadedReason, 'CannotFindAddress', HomePageNotLoadedReason_CannotFindAddress_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.HomeSource = HomeSource;
    $com$glovoapp$analytics$events.HomeSource.values = values_36;
    $com$glovoapp$analytics$events.HomeSource.valueOf = valueOf_36;
    defineProp($com$glovoapp$analytics$events.HomeSource, 'Direct', HomeSource_Direct_getInstance);
    defineProp($com$glovoapp$analytics$events.HomeSource, 'HomeGlobal', HomeSource_HomeGlobal_getInstance);
    defineProp($com$glovoapp$analytics$events.HomeSource, 'HomeCountry', HomeSource_HomeCountry_getInstance);
    defineProp($com$glovoapp$analytics$events.HomeSource, 'StoresList', HomeSource_StoresList_getInstance);
    defineProp($com$glovoapp$analytics$events.HomeSource, 'StoreMenu', HomeSource_StoreMenu_getInstance);
    defineProp($com$glovoapp$analytics$events.HomeSource, 'NavigationTabBar', HomeSource_NavigationTabBar_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.IdenticalAddressPopUpViewed = IdenticalAddressPopUpViewed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ImpressionType = ImpressionType;
    defineProp($com$glovoapp$analytics$events.ImpressionType, 'StoreCard', StoreCard_getInstance);
    $com$glovoapp$analytics$events.ImpressionType.Logo = Logo;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InfoButtonSource = InfoButtonSource;
    $com$glovoapp$analytics$events.InfoButtonSource.values = values_37;
    $com$glovoapp$analytics$events.InfoButtonSource.valueOf = valueOf_37;
    defineProp($com$glovoapp$analytics$events.InfoButtonSource, 'Checkout', InfoButtonSource_Checkout_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InfoButtonTapped = InfoButtonTapped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InfoType = InfoType;
    $com$glovoapp$analytics$events.InfoType.values = values_38;
    $com$glovoapp$analytics$events.InfoType.valueOf = valueOf_38;
    defineProp($com$glovoapp$analytics$events.InfoType, 'Fee', InfoType_Fee_getInstance);
    defineProp($com$glovoapp$analytics$events.InfoType, 'Partner', InfoType_Partner_getInstance);
    defineProp($com$glovoapp$analytics$events.InfoType, 'BusyAreaFeesInfo', InfoType_BusyAreaFeesInfo_getInstance);
    defineProp($com$glovoapp$analytics$events.InfoType, 'DeliveryCosts', InfoType_DeliveryCosts_getInstance);
    defineProp($com$glovoapp$analytics$events.InfoType, 'DeliveryCostsBusyAreaFeesInfo', InfoType_DeliveryCostsBusyAreaFeesInfo_getInstance);
    defineProp($com$glovoapp$analytics$events.InfoType, 'PromoMoreInfo', InfoType_PromoMoreInfo_getInstance);
    defineProp($com$glovoapp$analytics$events.InfoType, 'StoreMembershipDisconnect', InfoType_StoreMembershipDisconnect_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InstructionAdded = InstructionAdded;
    defineProp($com$glovoapp$analytics$events.InstructionAdded, 'Metadata', Metadata_getInstance_63);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InstructionImpression = InstructionImpression;
    defineProp($com$glovoapp$analytics$events.InstructionImpression, 'Metadata', Metadata_getInstance_64);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InstructionType = InstructionType;
    $com$glovoapp$analytics$events.InstructionType.ProductInstructionPNA = ProductInstructionPNA;
    $com$glovoapp$analytics$events.InstructionType.OrderInstructionPNA = OrderInstructionPNA;
    $com$glovoapp$analytics$events.InstructionType.OrderInstructionGifting = OrderInstructionGifting;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.InvalidEmail = InvalidEmail;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.LayoutDesign = LayoutDesign;
    $com$glovoapp$analytics$events.LayoutDesign.values = values_39;
    $com$glovoapp$analytics$events.LayoutDesign.valueOf = valueOf_39;
    defineProp($com$glovoapp$analytics$events.LayoutDesign, 'ListView', LayoutDesign_ListView_getInstance);
    defineProp($com$glovoapp$analytics$events.LayoutDesign, 'GridView', LayoutDesign_GridView_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.LocationTrackingPermissionGranted = LocationTrackingPermissionGranted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.LogOutButtonClicked = LogOutButtonClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.LoginScreen = LoginScreen;
    defineProp($com$glovoapp$analytics$events.LoginScreen, 'Metadata', Metadata_getInstance_65);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MbsCalculationStrategy = MbsCalculationStrategy;
    $com$glovoapp$analytics$events.MbsCalculationStrategy.values = values_40;
    $com$glovoapp$analytics$events.MbsCalculationStrategy.valueOf = valueOf_40;
    defineProp($com$glovoapp$analytics$events.MbsCalculationStrategy, 'Standard', MbsCalculationStrategy_Standard_getInstance);
    defineProp($com$glovoapp$analytics$events.MbsCalculationStrategy, 'Capped', MbsCalculationStrategy_Capped_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MbsMoreInfoTapped = MbsMoreInfoTapped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MbsProgressBarShown = MbsProgressBarShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MbsThresholdReached = MbsThresholdReached;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Mgm = Mgm;
    defineProp($com$glovoapp$analytics$events.Mgm, 'Metadata', Metadata_getInstance_66);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MgmSource = MgmSource;
    $com$glovoapp$analytics$events.MgmSource.values = values_41;
    $com$glovoapp$analytics$events.MgmSource.valueOf = valueOf_41;
    defineProp($com$glovoapp$analytics$events.MgmSource, 'Banner', MgmSource_Banner_getInstance);
    defineProp($com$glovoapp$analytics$events.MgmSource, 'Home', MgmSource_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.MgmSource, 'Deeplink', MgmSource_Deeplink_getInstance);
    defineProp($com$glovoapp$analytics$events.MgmSource, 'Profile', MgmSource_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.MgmSource, 'Story', MgmSource_Story_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MigrationExploreButtonPressed = MigrationExploreButtonPressed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MigrationSucceeded = MigrationSucceeded;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.MigrationWelcome = MigrationWelcome;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NavigationBarElementTapped = NavigationBarElementTapped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NavigationTabBarAppLocation = NavigationTabBarAppLocation;
    $com$glovoapp$analytics$events.NavigationTabBarAppLocation.values = values_42;
    $com$glovoapp$analytics$events.NavigationTabBarAppLocation.valueOf = valueOf_42;
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Home', NavigationTabBarAppLocation_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'StoreWall', NavigationTabBarAppLocation_StoreWall_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Profile', NavigationTabBarAppLocation_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Cart', NavigationTabBarAppLocation_Cart_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Search', NavigationTabBarAppLocation_Search_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Orders', NavigationTabBarAppLocation_Orders_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Account', NavigationTabBarAppLocation_Account_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Promocodes', NavigationTabBarAppLocation_Promocodes_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Language', NavigationTabBarAppLocation_Language_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'FAQ', NavigationTabBarAppLocation_FAQ_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Notifications', NavigationTabBarAppLocation_Notifications_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarAppLocation, 'Other', NavigationTabBarAppLocation_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NavigationTabBarElements = NavigationTabBarElements;
    $com$glovoapp$analytics$events.NavigationTabBarElements.values = values_43;
    $com$glovoapp$analytics$events.NavigationTabBarElements.valueOf = valueOf_43;
    defineProp($com$glovoapp$analytics$events.NavigationTabBarElements, 'Home', NavigationTabBarElements_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarElements, 'Cart', NavigationTabBarElements_Cart_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarElements, 'Profile', NavigationTabBarElements_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.NavigationTabBarElements, 'Search', NavigationTabBarElements_Search_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NavigationTabBarLoaded = NavigationTabBarLoaded;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NavigationTabBarTapped = NavigationTabBarTapped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NewBottomSheetDismissed = NewBottomSheetDismissed;
    defineProp($com$glovoapp$analytics$events.NewBottomSheetDismissed, 'Metadata', Metadata_getInstance_67);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NewBottomSheetShown = NewBottomSheetShown;
    defineProp($com$glovoapp$analytics$events.NewBottomSheetShown, 'Metadata', Metadata_getInstance_68);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NewOrder = NewOrder;
    defineProp($com$glovoapp$analytics$events.NewOrder, 'Metadata', Metadata_getInstance_69);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NewOrderContentShown = NewOrderContentShown;
    defineProp($com$glovoapp$analytics$events.NewOrderContentShown, 'Metadata', Metadata_getInstance_70);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NoInternetConnectionScreen = NoInternetConnectionScreen;
    defineProp($com$glovoapp$analytics$events.NoInternetConnectionScreen, 'Metadata', Metadata_getInstance_71);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NotificationConfigurationCenter = NotificationConfigurationCenter;
    defineProp($com$glovoapp$analytics$events.NotificationConfigurationCenter, 'Metadata', Metadata_getInstance_72);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NotificationConfigurationCenterButtonPressed = NotificationConfigurationCenterButtonPressed;
    defineProp($com$glovoapp$analytics$events.NotificationConfigurationCenterButtonPressed, 'Metadata', Metadata_getInstance_73);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NotificationConfigurationScreenSource = NotificationConfigurationScreenSource;
    $com$glovoapp$analytics$events.NotificationConfigurationScreenSource.values = values_44;
    $com$glovoapp$analytics$events.NotificationConfigurationScreenSource.valueOf = valueOf_44;
    defineProp($com$glovoapp$analytics$events.NotificationConfigurationScreenSource, 'Settings', NotificationConfigurationScreenSource_Settings_getInstance);
    defineProp($com$glovoapp$analytics$events.NotificationConfigurationScreenSource, 'OngoingOrderPopup', NotificationConfigurationScreenSource_OngoingOrderPopup_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.NotificationStatus = NotificationStatus;
    $com$glovoapp$analytics$events.NotificationStatus.values = values_45;
    $com$glovoapp$analytics$events.NotificationStatus.valueOf = valueOf_45;
    defineProp($com$glovoapp$analytics$events.NotificationStatus, 'Enabled', NotificationStatus_Enabled_getInstance);
    defineProp($com$glovoapp$analytics$events.NotificationStatus, 'Disabled', NotificationStatus_Disabled_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OngoingOrderDetailsFirstScrollDown = OngoingOrderDetailsFirstScrollDown;
    defineProp($com$glovoapp$analytics$events.OngoingOrderDetailsFirstScrollDown, 'Metadata', Metadata_getInstance_74);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OngoingOrderDetailsFirstViewed = OngoingOrderDetailsFirstViewed;
    defineProp($com$glovoapp$analytics$events.OngoingOrderDetailsFirstViewed, 'Metadata', Metadata_getInstance_75);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OngoingOrderEditCta = OngoingOrderEditCta;
    $com$glovoapp$analytics$events.OngoingOrderEditCta.values = values_46;
    $com$glovoapp$analytics$events.OngoingOrderEditCta.valueOf = valueOf_46;
    defineProp($com$glovoapp$analytics$events.OngoingOrderEditCta, 'Phone', OngoingOrderEditCta_Phone_getInstance);
    defineProp($com$glovoapp$analytics$events.OngoingOrderEditCta, 'Link', OngoingOrderEditCta_Link_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OngoingOrderEditFeature = OngoingOrderEditFeature;
    $com$glovoapp$analytics$events.OngoingOrderEditFeature.values = values_47;
    $com$glovoapp$analytics$events.OngoingOrderEditFeature.valueOf = valueOf_47;
    defineProp($com$glovoapp$analytics$events.OngoingOrderEditFeature, 'Address', OngoingOrderEditFeature_Address_getInstance);
    defineProp($com$glovoapp$analytics$events.OngoingOrderEditFeature, 'Products', OngoingOrderEditFeature_Products_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OngoingOrderEditPressed = OngoingOrderEditPressed;
    defineProp($com$glovoapp$analytics$events.OngoingOrderEditPressed, 'Metadata', Metadata_getInstance_76);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OpenChatPressed = OpenChatPressed;
    defineProp($com$glovoapp$analytics$events.OpenChatPressed, 'Metadata', Metadata_getInstance_77);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OpenChatsListViewed = OpenChatsListViewed;
    defineProp($com$glovoapp$analytics$events.OpenChatsListViewed, 'Metadata', Metadata_getInstance_78);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderCancellationReason = OrderCancellationReason;
    $com$glovoapp$analytics$events.OrderCancellationReason.values = values_48;
    $com$glovoapp$analytics$events.OrderCancellationReason.valueOf = valueOf_48;
    defineProp($com$glovoapp$analytics$events.OrderCancellationReason, 'ByUser', OrderCancellationReason_ByUser_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderCancellationReason, 'OrderDelayed', OrderCancellationReason_OrderDelayed_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderCancelled = OrderCancelled;
    defineProp($com$glovoapp$analytics$events.OrderCancelled, 'Metadata', Metadata_getInstance_79);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderConfirmationButtonPressed = OrderConfirmationButtonPressed;
    defineProp($com$glovoapp$analytics$events.OrderConfirmationButtonPressed, 'Metadata', Metadata_getInstance_80);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderCreated = OrderCreated;
    defineProp($com$glovoapp$analytics$events.OrderCreated, 'Metadata', Metadata_getInstance_81);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderDetails = OrderDetails;
    defineProp($com$glovoapp$analytics$events.OrderDetails, 'Metadata', Metadata_getInstance_82);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderHandlingStrategyType = OrderHandlingStrategyType;
    $com$glovoapp$analytics$events.OrderHandlingStrategyType.values = values_49;
    $com$glovoapp$analytics$events.OrderHandlingStrategyType.valueOf = valueOf_49;
    defineProp($com$glovoapp$analytics$events.OrderHandlingStrategyType, 'InStore', OrderHandlingStrategyType_InStore_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderHandlingStrategyType, 'Delivery', OrderHandlingStrategyType_Delivery_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderHandlingStrategyType, 'Pickup', OrderHandlingStrategyType_Pickup_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderRated = OrderRated;
    defineProp($com$glovoapp$analytics$events.OrderRated, 'Metadata', Metadata_getInstance_83);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderRating = OrderRating;
    defineProp($com$glovoapp$analytics$events.OrderRating, 'Metadata', Metadata_getInstance_84);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderType = OrderType;
    defineProp($com$glovoapp$analytics$events.OrderType, 'Purchase', Purchase_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderType, 'Shipment', Shipment_getInstance);
    $com$glovoapp$analytics$events.OrderType.Store = Store;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OrderVertical = OrderVertical;
    $com$glovoapp$analytics$events.OrderVertical.values = values_50;
    $com$glovoapp$analytics$events.OrderVertical.valueOf = valueOf_50;
    defineProp($com$glovoapp$analytics$events.OrderVertical, 'Partner', OrderVertical_Partner_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderVertical, 'FakePartner', OrderVertical_FakePartner_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderVertical, 'Courier', OrderVertical_Courier_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderVertical, 'Quiero', OrderVertical_Quiero_getInstance);
    defineProp($com$glovoapp$analytics$events.OrderVertical, 'Marketplace', OrderVertical_Marketplace_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Orders = Orders;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Origins = Origins;
    $com$glovoapp$analytics$events.Origins.Category = Category;
    $com$glovoapp$analytics$events.Origins.CategoryGroup = CategoryGroup_0;
    defineProp($com$glovoapp$analytics$events.Origins, 'Checkout', Checkout_getInstance);
    $com$glovoapp$analytics$events.Origins.NewBottomSheet = NewBottomSheet;
    $com$glovoapp$analytics$events.Origins.FeedGroup = FeedGroup;
    $com$glovoapp$analytics$events.Origins.FeedGroupResults = FeedGroupResults;
    $com$glovoapp$analytics$events.Origins.HomeWidget = HomeWidget;
    $com$glovoapp$analytics$events.Origins.HomeWidgetResults = HomeWidgetResults;
    $com$glovoapp$analytics$events.Origins.HomeSearchBarResults = HomeSearchBarResults;
    $com$glovoapp$analytics$events.Origins.SearchNestedDishes = SearchNestedDishes;
    $com$glovoapp$analytics$events.Origins.Story = Story;
    $com$glovoapp$analytics$events.Origins.Deeplink = Deeplink_0;
    defineProp($com$glovoapp$analytics$events.Origins, 'Direct', Direct_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'Other', Other_getInstance_0);
    $com$glovoapp$analytics$events.Origins.HomeBubble = HomeBubble;
    $com$glovoapp$analytics$events.Origins.CategoryGroupBubble = CategoryGroupBubble;
    $com$glovoapp$analytics$events.Origins.CategoryResults = CategoryResults;
    $com$glovoapp$analytics$events.Origins.FeedCarousel = FeedCarousel;
    $com$glovoapp$analytics$events.Origins.FeedCarouselResults = FeedCarouselResults;
    $com$glovoapp$analytics$events.Origins.CategoryGroupSearchBarResults = CategoryGroupSearchBarResults;
    $com$glovoapp$analytics$events.Origins.BannerResults = BannerResults;
    defineProp($com$glovoapp$analytics$events.Origins, 'FoodNearYouFeed', FoodNearYouFeed_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'FilterLanding', FilterLanding_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'BrandLanding', BrandLanding_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'ClosedStoreSimilarStoresModal', ClosedStoreSimilarStoresModal_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'Orders', Orders_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'OutOfDeliveryPopUp', OutOfDeliveryPopUp_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'DoubleGlovo', DoubleGlovo_getInstance);
    $com$glovoapp$analytics$events.Origins.Widget = Widget_0;
    $com$glovoapp$analytics$events.Origins.WidgetResults = WidgetResults;
    defineProp($com$glovoapp$analytics$events.Origins, 'Cart', Cart_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'StoreDetails', StoreDetails_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'VideoPlayer', VideoPlayer_getInstance);
    $com$glovoapp$analytics$events.Origins.Playlist = Playlist;
    defineProp($com$glovoapp$analytics$events.Origins, 'PlaylistBottomSheet', PlaylistBottomSheet_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'StoreWallNestedDishes', StoreWallNestedDishes_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'SearchShowAllButton', SearchShowAllButton_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'Home', Home_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'NavigationTabBar', NavigationTabBar_getInstance);
    defineProp($com$glovoapp$analytics$events.Origins, 'Profile', Profile_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OutOfDeliveryZoneScreenView = OutOfDeliveryZoneScreenView;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentChange = PaymentChange;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentChangeScreenOrigin = PaymentChangeScreenOrigin;
    $com$glovoapp$analytics$events.PaymentChangeScreenOrigin.values = values_51;
    $com$glovoapp$analytics$events.PaymentChangeScreenOrigin.valueOf = valueOf_51;
    defineProp($com$glovoapp$analytics$events.PaymentChangeScreenOrigin, 'Profile', PaymentChangeScreenOrigin_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentChangeScreenOrigin, 'Checkout', PaymentChangeScreenOrigin_Checkout_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentChangeScreenOrigin, 'Prime', PaymentChangeScreenOrigin_Prime_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentChangeScreenOrigin, 'Recovery', PaymentChangeScreenOrigin_Recovery_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentChangeScreenOrigin, 'Debt', PaymentChangeScreenOrigin_Debt_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentInfo = PaymentInfo;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentInfoEntered = PaymentInfoEntered;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentInfoFailed = PaymentInfoFailed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentMethod = PaymentMethod;
    defineProp($com$glovoapp$analytics$events.PaymentMethod, 'Cash', Cash_getInstance);
    $com$glovoapp$analytics$events.PaymentMethod.CreditCard = CreditCard;
    defineProp($com$glovoapp$analytics$events.PaymentMethod, 'DirectDebit', DirectDebit_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentMethod, 'BankTransfer', BankTransfer_getInstance);
    $com$glovoapp$analytics$events.PaymentMethod.Alternative = Alternative;
    defineProp($com$glovoapp$analytics$events.PaymentMethod, 'Others', Others_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentMethodSelector = PaymentMethodSelector;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentMethodSelectorUpdated = PaymentMethodSelectorUpdated;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentProcessingCanceled = PaymentProcessingCanceled;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentProcessingFinished = PaymentProcessingFinished;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentProcessingStarted = PaymentProcessingStarted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PaymentProcessingStatus = PaymentProcessingStatus;
    $com$glovoapp$analytics$events.PaymentProcessingStatus.values = values_52;
    $com$glovoapp$analytics$events.PaymentProcessingStatus.valueOf = valueOf_52;
    defineProp($com$glovoapp$analytics$events.PaymentProcessingStatus, 'Success', PaymentProcessingStatus_Success_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentProcessingStatus, 'Failure', PaymentProcessingStatus_Failure_getInstance);
    defineProp($com$glovoapp$analytics$events.PaymentProcessingStatus, 'Canceled', PaymentProcessingStatus_Canceled_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PersonalizedFilterType = PersonalizedFilterType;
    $com$glovoapp$analytics$events.PersonalizedFilterType.values = values_53;
    $com$glovoapp$analytics$events.PersonalizedFilterType.valueOf = valueOf_53;
    defineProp($com$glovoapp$analytics$events.PersonalizedFilterType, 'User', PersonalizedFilterType_User_getInstance);
    defineProp($com$glovoapp$analytics$events.PersonalizedFilterType, 'City', PersonalizedFilterType_City_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneScreenOrigin = PhoneScreenOrigin;
    $com$glovoapp$analytics$events.PhoneScreenOrigin.values = values_54;
    $com$glovoapp$analytics$events.PhoneScreenOrigin.valueOf = valueOf_54;
    defineProp($com$glovoapp$analytics$events.PhoneScreenOrigin, 'Profile', PhoneScreenOrigin_Profile_getInstance);
    defineProp($com$glovoapp$analytics$events.PhoneScreenOrigin, 'ContactTree', PhoneScreenOrigin_ContactTree_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneScreenViewed = PhoneScreenViewed;
    defineProp($com$glovoapp$analytics$events.PhoneScreenViewed, 'Metadata', Metadata_getInstance_85);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerification = PhoneVerification;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationCallRequested = PhoneVerificationCallRequested;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationEnterCode = PhoneVerificationEnterCode;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationFailed = PhoneVerificationFailed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationMethod = PhoneVerificationMethod;
    $com$glovoapp$analytics$events.PhoneVerificationMethod.values = values_55;
    $com$glovoapp$analytics$events.PhoneVerificationMethod.valueOf = valueOf_55;
    defineProp($com$glovoapp$analytics$events.PhoneVerificationMethod, 'SMS', PhoneVerificationMethod_SMS_getInstance);
    defineProp($com$glovoapp$analytics$events.PhoneVerificationMethod, 'Whatsapp', PhoneVerificationMethod_Whatsapp_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationMethodButtonClicked = PhoneVerificationMethodButtonClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationNoAttemptsLeft = PhoneVerificationNoAttemptsLeft;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerificationStarted = PhoneVerificationStarted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PhoneVerified = PhoneVerified;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PopupCTAPressed = PopupCTAPressed;
    defineProp($com$glovoapp$analytics$events.PopupCTAPressed, 'Metadata', Metadata_getInstance_86);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PreSearch = PreSearch;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PreferredLanguagePage = PreferredLanguagePage;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PreferredLanguagesList = PreferredLanguagesList;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeCheckoutBoxDeselected = PrimeCheckoutBoxDeselected;
    defineProp($com$glovoapp$analytics$events.PrimeCheckoutBoxDeselected, 'Metadata', Metadata_getInstance_87);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeCheckoutBoxSelected = PrimeCheckoutBoxSelected;
    defineProp($com$glovoapp$analytics$events.PrimeCheckoutBoxSelected, 'Metadata', Metadata_getInstance_88);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeOrigin = PrimeOrigin;
    $com$glovoapp$analytics$events.PrimeOrigin.values = values_56;
    $com$glovoapp$analytics$events.PrimeOrigin.valueOf = valueOf_56;
    defineProp($com$glovoapp$analytics$events.PrimeOrigin, 'Tutorial', PrimeOrigin_Tutorial_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeOrigin, 'Checkout', PrimeOrigin_Checkout_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeOrigin, 'Resubscription', PrimeOrigin_Resubscription_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeSubscribeSelected = PrimeSubscribeSelected;
    defineProp($com$glovoapp$analytics$events.PrimeSubscribeSelected, 'Metadata', Metadata_getInstance_89);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeSubscriptionConfirmed = PrimeSubscriptionConfirmed;
    defineProp($com$glovoapp$analytics$events.PrimeSubscriptionConfirmed, 'Metadata', Metadata_getInstance_90);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeSubscriptionType = PrimeSubscriptionType;
    $com$glovoapp$analytics$events.PrimeSubscriptionType.values = values_57;
    $com$glovoapp$analytics$events.PrimeSubscriptionType.valueOf = valueOf_57;
    defineProp($com$glovoapp$analytics$events.PrimeSubscriptionType, 'General', PrimeSubscriptionType_General_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeSubscriptionType, 'Sponsored', PrimeSubscriptionType_Sponsored_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeTutorialDismissed = PrimeTutorialDismissed;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialDismissed, 'Metadata', Metadata_getInstance_91);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeTutorialShown = PrimeTutorialShown;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialShown, 'Metadata', Metadata_getInstance_92);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeTutorialSource = PrimeTutorialSource;
    $com$glovoapp$analytics$events.PrimeTutorialSource.Deeplink = Deeplink_1;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Profile', Profile_getInstance_0);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Story', Story_getInstance);
    $com$glovoapp$analytics$events.PrimeTutorialSource.Checkout = Checkout_1;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Header', Header_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Promocodes', Promocodes_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Store', Store_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'StorePrimePromotions', StorePrimePromotions_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'StorePrimeBadge', StorePrimeBadge_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Other', Other_getInstance_1);
    $com$glovoapp$analytics$events.PrimeTutorialSource.HomeBanner = HomeBanner;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'PrimeLandingPage', PrimeLandingPage_getInstance);
    $com$glovoapp$analytics$events.PrimeTutorialSource.OngoingOrder = OngoingOrder;
    $com$glovoapp$analytics$events.PrimeTutorialSource.StoresList = StoresList;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Filters', Filters_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'Resubscription', Resubscription_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'HomeScreenBenefit', HomeScreenBenefit_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'ProfileHeader', ProfileHeader_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'SurgePrice', SurgePrice_getInstance);
    $com$glovoapp$analytics$events.PrimeTutorialSource.BannerResults = BannerResults_0;
    defineProp($com$glovoapp$analytics$events.PrimeTutorialSource, 'PaymentNotification', PaymentNotification_getInstance);
    $com$glovoapp$analytics$events.PrimeTutorialSource.Guapo = Guapo;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrivacyReview = PrivacyReview;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrivacyReviewAccepted = PrivacyReviewAccepted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrivacyReviewCancelled = PrivacyReviewCancelled;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductAdded = ProductAdded;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductAddedOrigin = ProductAddedOrigin;
    $com$glovoapp$analytics$events.ProductAddedOrigin.ProductCustomisationAddToOrder = ProductCustomisationAddToOrder;
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'StoreMenuPlusButton', StoreMenuPlusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'ItemDetailAddToOrder', ItemDetailAddToOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'NewOrderPlusButton', NewOrderPlusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'ProductUpsellPlusButton', ProductUpsellPlusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'ProductScreenUpsellPlusButton', ProductScreenUpsellPlusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'ProductPageUpsellingCarouselPlus', ProductPageUpsellingCarouselPlus_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'ProductPageUpsellingCarouselTile', ProductPageUpsellingCarouselTile_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'Cart', Cart_getInstance_0);
    defineProp($com$glovoapp$analytics$events.ProductAddedOrigin, 'BasketPlusButton', BasketPlusButton_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductAdditionalInformationClicked = ProductAdditionalInformationClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductAdditionalInformationGroupType = ProductAdditionalInformationGroupType;
    $com$glovoapp$analytics$events.ProductAdditionalInformationGroupType.values = values_58;
    $com$glovoapp$analytics$events.ProductAdditionalInformationGroupType.valueOf = valueOf_58;
    defineProp($com$glovoapp$analytics$events.ProductAdditionalInformationGroupType, 'Description', ProductAdditionalInformationGroupType_Description_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAdditionalInformationGroupType, 'Specification', ProductAdditionalInformationGroupType_Specification_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAdditionalInformationGroupType, 'ReturnPolicy', ProductAdditionalInformationGroupType_ReturnPolicy_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAdditionalInformationGroupType, 'ModelUpsellCarousel', ProductAdditionalInformationGroupType_ModelUpsellCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductAdditionalInformationGroupType, 'ManualUpsellCarousel', ProductAdditionalInformationGroupType_ManualUpsellCarousel_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisation = ProductCustomisation;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationDismissed = ProductCustomisationDismissed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationImageImpression = ProductCustomisationImageImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationImageInteracted = ProductCustomisationImageInteracted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationImageOrigin = ProductCustomisationImageOrigin;
    $com$glovoapp$analytics$events.ProductCustomisationImageOrigin.values = values_59;
    $com$glovoapp$analytics$events.ProductCustomisationImageOrigin.valueOf = valueOf_59;
    defineProp($com$glovoapp$analytics$events.ProductCustomisationImageOrigin, 'ProductDetailsPage', ProductCustomisationImageOrigin_ProductDetailsPage_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductCustomisationImageOrigin, 'ProductCustomisationPage', ProductCustomisationImageOrigin_ProductCustomisationPage_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationImageZoomed = ProductCustomisationImageZoomed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationItemDeselected = ProductCustomisationItemDeselected;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomisationItemSelected = ProductCustomisationItemSelected;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomizationAttributeGroupImpression = ProductCustomizationAttributeGroupImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductCustomizationOrigin = ProductCustomizationOrigin;
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'ProductPage', ProductPage_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'Catalogue', Catalogue_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'Checkout', Checkout_getInstance_0);
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'Search', Search_getInstance);
    $com$glovoapp$analytics$events.ProductCustomizationOrigin.Widget = Widget_1;
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'Cart', Cart_getInstance_1);
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'Basket', Basket_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'VideoPlayer', VideoPlayer_getInstance_0);
    $com$glovoapp$analytics$events.ProductCustomizationOrigin.StoreWallNestedDishes = StoreWallNestedDishes_0;
    defineProp($com$glovoapp$analytics$events.ProductCustomizationOrigin, 'Other', Other_getInstance_2);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductImpression = ProductImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductLabelType = ProductLabelType;
    $com$glovoapp$analytics$events.ProductLabelType.values = values_60;
    $com$glovoapp$analytics$events.ProductLabelType.valueOf = valueOf_60;
    defineProp($com$glovoapp$analytics$events.ProductLabelType, 'Popular', ProductLabelType_Popular_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductLabelType, 'Sponsored', ProductLabelType_Sponsored_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductLabelType, 'Topseller', ProductLabelType_Topseller_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductRemoved = ProductRemoved;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductRemovedOrigin = ProductRemovedOrigin;
    $com$glovoapp$analytics$events.ProductRemovedOrigin.values = values_61;
    $com$glovoapp$analytics$events.ProductRemovedOrigin.valueOf = valueOf_61;
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'StoreMenuMinusButton', ProductRemovedOrigin_StoreMenuMinusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'NewOrderMinusButton', ProductRemovedOrigin_NewOrderMinusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'ProductUpsellMinusButton', ProductRemovedOrigin_ProductUpsellMinusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'ProductScreenUpsellMinusButton', ProductRemovedOrigin_ProductScreenUpsellMinusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'OrderAgainMinusButton', ProductRemovedOrigin_OrderAgainMinusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'CartMinusButton', ProductRemovedOrigin_CartMinusButton_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductRemovedOrigin, 'BasketMinusButton', ProductRemovedOrigin_BasketMinusButton_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductSaleType = ProductSaleType;
    $com$glovoapp$analytics$events.ProductSaleType.values = values_62;
    $com$glovoapp$analytics$events.ProductSaleType.valueOf = valueOf_62;
    defineProp($com$glovoapp$analytics$events.ProductSaleType, 'PiecePiece', ProductSaleType_PiecePiece_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSaleType, 'PieceWeight', ProductSaleType_PieceWeight_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSaleType, 'WeightWeight', ProductSaleType_WeightWeight_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductScreenButtonPressed = ProductScreenButtonPressed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductScreenUpsellImpression = ProductScreenUpsellImpression;
    defineProp($com$glovoapp$analytics$events.ProductScreenUpsellImpression, 'Metadata', Metadata_getInstance_93);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductSearchResults = ProductSearchResults;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductSelected = ProductSelected;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductSelectionOrigin = ProductSelectionOrigin;
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'TopSeller', TopSeller_getInstance);
    $com$glovoapp$analytics$events.ProductSelectionOrigin.EasyReorder = EasyReorder_0;
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'SupercollectionProductsCarousel', SupercollectionProductsCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'Promotions', Promotions_getInstance_0);
    $com$glovoapp$analytics$events.ProductSelectionOrigin.Search = Search_0;
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'Catalogue', Catalogue_getInstance_0);
    $com$glovoapp$analytics$events.ProductSelectionOrigin.HomeWidget = HomeWidget_0;
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'DoubleGlovo', DoubleGlovo_getInstance_0);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'InStoreBanner', InStoreBanner_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'ProductPageUpsellingCarousel', ProductPageUpsellingCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'Collection', Collection_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'CollectionsShoppableBanner', CollectionsShoppableBanner_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'CollectionGroup', CollectionGroup_getInstance_0);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'ShoppableBanner', ShoppableBanner_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'SponsoredDeeplink', SponsoredDeeplink_getInstance);
    $com$glovoapp$analytics$events.ProductSelectionOrigin.Widget = Widget_2;
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'Cart', Cart_getInstance_2);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'Basket', Basket_getInstance_0);
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'StoreWall', StoreWall_getInstance);
    $com$glovoapp$analytics$events.ProductSelectionOrigin.StoreWallNestedDishes = StoreWallNestedDishes_1;
    $com$glovoapp$analytics$events.ProductSelectionOrigin.SearchNestedDishes = SearchNestedDishes_0;
    $com$glovoapp$analytics$events.ProductSelectionOrigin.StoreWallMealsUnderXCollection = StoreWallMealsUnderXCollection;
    defineProp($com$glovoapp$analytics$events.ProductSelectionOrigin, 'Other', Other_getInstance_3);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductUpsellPopUpButtonPressed = ProductUpsellPopUpButtonPressed;
    defineProp($com$glovoapp$analytics$events.ProductUpsellPopUpButtonPressed, 'Metadata', Metadata_getInstance_94);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductUpsellPopUpScreen = ProductUpsellPopUpScreen;
    defineProp($com$glovoapp$analytics$events.ProductUpsellPopUpScreen, 'Metadata', Metadata_getInstance_95);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductUpsellPopUpScreenAttemptToDismiss = ProductUpsellPopUpScreenAttemptToDismiss;
    defineProp($com$glovoapp$analytics$events.ProductUpsellPopUpScreenAttemptToDismiss, 'Metadata', Metadata_getInstance_96);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissed = ProductUpsellPopUpScreenDismissed;
    defineProp($com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissed, 'Metadata', Metadata_getInstance_97);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissedAction = ProductUpsellPopUpScreenDismissedAction;
    $com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissedAction.values = values_63;
    $com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissedAction.valueOf = valueOf_63;
    defineProp($com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissedAction, 'DragDown', ProductUpsellPopUpScreenDismissedAction_DragDown_getInstance);
    defineProp($com$glovoapp$analytics$events.ProductUpsellPopUpScreenDismissedAction, 'BackButton', ProductUpsellPopUpScreenDismissedAction_BackButton_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProductsSearched = ProductsSearched;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Profile = Profile_1;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProfilePrimeIconClicked = ProfilePrimeIconClicked;
    defineProp($com$glovoapp$analytics$events.ProfilePrimeIconClicked, 'Metadata', Metadata_getInstance_98);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProfilePrimeIconSeen = ProfilePrimeIconSeen;
    defineProp($com$glovoapp$analytics$events.ProfilePrimeIconSeen, 'Metadata', Metadata_getInstance_99);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProfileSection = ProfileSection;
    $com$glovoapp$analytics$events.ProfileSection.values = values_64;
    $com$glovoapp$analytics$events.ProfileSection.valueOf = valueOf_64;
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'Orders', ProfileSection_Orders_getInstance);
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'Account', ProfileSection_Account_getInstance);
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'Prime', ProfileSection_Prime_getInstance);
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'PromoCode', ProfileSection_PromoCode_getInstance);
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'FAQ', ProfileSection_FAQ_getInstance);
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'LogOut', ProfileSection_LogOut_getInstance);
    defineProp($com$glovoapp$analytics$events.ProfileSection, 'Mgm', ProfileSection_Mgm_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromoCode = PromoCode;
    defineProp($com$glovoapp$analytics$events.PromoCode, 'Metadata', Metadata_getInstance_100);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromotionShown = PromotionShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromotionSource = PromotionSource;
    $com$glovoapp$analytics$events.PromotionSource.values = values_65;
    $com$glovoapp$analytics$events.PromotionSource.valueOf = valueOf_65;
    defineProp($com$glovoapp$analytics$events.PromotionSource, 'UUFD', PromotionSource_UUFD_getInstance);
    defineProp($com$glovoapp$analytics$events.PromotionSource, 'StorePromotion', PromotionSource_StorePromotion_getInstance);
    defineProp($com$glovoapp$analytics$events.PromotionSource, 'PromoCode', PromotionSource_PromoCode_getInstance);
    defineProp($com$glovoapp$analytics$events.PromotionSource, 'Segmentation', PromotionSource_Segmentation_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromotionStoreOrigin = PromotionStoreOrigin;
    $com$glovoapp$analytics$events.PromotionStoreOrigin.values = values_66;
    $com$glovoapp$analytics$events.PromotionStoreOrigin.valueOf = valueOf_66;
    defineProp($com$glovoapp$analytics$events.PromotionStoreOrigin, 'StoreWall', PromotionStoreOrigin_StoreWall_getInstance);
    defineProp($com$glovoapp$analytics$events.PromotionStoreOrigin, 'StoreScreen', PromotionStoreOrigin_StoreScreen_getInstance);
    defineProp($com$glovoapp$analytics$events.PromotionStoreOrigin, 'Checkout', PromotionStoreOrigin_Checkout_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromotionType = PromotionType;
    $com$glovoapp$analytics$events.PromotionType.ProductDiscount = ProductDiscount;
    $com$glovoapp$analytics$events.PromotionType.DeliveryFeeDiscount = DeliveryFeeDiscount;
    defineProp($com$glovoapp$analytics$events.PromotionType, 'TwoForOne', TwoForOne_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.RankingType = RankingType;
    $com$glovoapp$analytics$events.RankingType.values = values_67;
    $com$glovoapp$analytics$events.RankingType.valueOf = valueOf_67;
    defineProp($com$glovoapp$analytics$events.RankingType, 'MO', RankingType_MO_getInstance);
    defineProp($com$glovoapp$analytics$events.RankingType, 'Legacy', RankingType_Legacy_getInstance);
    defineProp($com$glovoapp$analytics$events.RankingType, 'Hyperlocal', RankingType_Hyperlocal_getInstance);
    defineProp($com$glovoapp$analytics$events.RankingType, 'NewUserRanking', RankingType_NewUserRanking_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.RecoveryOrigin = RecoveryOrigin;
    $com$glovoapp$analytics$events.RecoveryOrigin.values = values_68;
    $com$glovoapp$analytics$events.RecoveryOrigin.valueOf = valueOf_68;
    defineProp($com$glovoapp$analytics$events.RecoveryOrigin, 'BasketEntryPoint', RecoveryOrigin_BasketEntryPoint_getInstance);
    defineProp($com$glovoapp$analytics$events.RecoveryOrigin, 'StoreView', RecoveryOrigin_StoreView_getInstance);
    defineProp($com$glovoapp$analytics$events.RecoveryOrigin, 'ProductDetailsView', RecoveryOrigin_ProductDetailsView_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReorderButtonPressed = ReorderButtonPressed;
    defineProp($com$glovoapp$analytics$events.ReorderButtonPressed, 'Metadata', Metadata_getInstance_101);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReorderOrigin = ReorderOrigin;
    $com$glovoapp$analytics$events.ReorderOrigin.values = values_69;
    $com$glovoapp$analytics$events.ReorderOrigin.valueOf = valueOf_69;
    defineProp($com$glovoapp$analytics$events.ReorderOrigin, 'Orders', ReorderOrigin_Orders_getInstance);
    defineProp($com$glovoapp$analytics$events.ReorderOrigin, 'OrderDetails', ReorderOrigin_OrderDetails_getInstance);
    defineProp($com$glovoapp$analytics$events.ReorderOrigin, 'ReorderCarousel', ReorderOrigin_ReorderCarousel_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ResetYourAccountStarted = ResetYourAccountStarted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReturnPolicyBannerClicked = ReturnPolicyBannerClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReturnPolicyBannerImpression = ReturnPolicyBannerImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReturnPolicyOrigin = ReturnPolicyOrigin;
    $com$glovoapp$analytics$events.ReturnPolicyOrigin.values = values_70;
    $com$glovoapp$analytics$events.ReturnPolicyOrigin.valueOf = valueOf_70;
    defineProp($com$glovoapp$analytics$events.ReturnPolicyOrigin, 'StorePage', ReturnPolicyOrigin_StorePage_getInstance);
    defineProp($com$glovoapp$analytics$events.ReturnPolicyOrigin, 'ProductCustomizationScreen', ReturnPolicyOrigin_ProductCustomizationScreen_getInstance);
    defineProp($com$glovoapp$analytics$events.ReturnPolicyOrigin, 'ProductDetailsScreen', ReturnPolicyOrigin_ProductDetailsScreen_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReviewCollectionVersionType = ReviewCollectionVersionType;
    $com$glovoapp$analytics$events.ReviewCollectionVersionType.values = values_71;
    $com$glovoapp$analytics$events.ReviewCollectionVersionType.valueOf = valueOf_71;
    defineProp($com$glovoapp$analytics$events.ReviewCollectionVersionType, 'Order', ReviewCollectionVersionType_Order_getInstance);
    defineProp($com$glovoapp$analytics$events.ReviewCollectionVersionType, 'NoRatingOrder', ReviewCollectionVersionType_NoRatingOrder_getInstance);
    defineProp($com$glovoapp$analytics$events.ReviewCollectionVersionType, 'Product', ReviewCollectionVersionType_Product_getInstance);
    defineProp($com$glovoapp$analytics$events.ReviewCollectionVersionType, 'IndividualProduct', ReviewCollectionVersionType_IndividualProduct_getInstance);
    defineProp($com$glovoapp$analytics$events.ReviewCollectionVersionType, 'Control', ReviewCollectionVersionType_Control_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.RootContent = RootContent;
    $com$glovoapp$analytics$events.RootContent.values = values_72;
    $com$glovoapp$analytics$events.RootContent.valueOf = valueOf_72;
    defineProp($com$glovoapp$analytics$events.RootContent, 'CollectionGroups', RootContent_CollectionGroups_getInstance);
    defineProp($com$glovoapp$analytics$events.RootContent, 'Collections', RootContent_Collections_getInstance);
    defineProp($com$glovoapp$analytics$events.RootContent, 'Products', RootContent_Products_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SearchAutosuggestionsShown = SearchAutosuggestionsShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SearchOrigin = SearchOrigin;
    $com$glovoapp$analytics$events.SearchOrigin.values = values_73;
    $com$glovoapp$analytics$events.SearchOrigin.valueOf = valueOf_73;
    defineProp($com$glovoapp$analytics$events.SearchOrigin, 'Collections', SearchOrigin_Collections_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchOrigin, 'CollectionGroups', SearchOrigin_CollectionGroups_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchOrigin, 'Products', SearchOrigin_Products_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchOrigin, 'External', SearchOrigin_External_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SearchSubVertical = SearchSubVertical;
    $com$glovoapp$analytics$events.SearchSubVertical.values = values_74;
    $com$glovoapp$analytics$events.SearchSubVertical.valueOf = valueOf_74;
    defineProp($com$glovoapp$analytics$events.SearchSubVertical, 'All', SearchSubVertical_All_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubVertical, 'Restaurants', SearchSubVertical_Restaurants_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubVertical, 'Groceries', SearchSubVertical_Groceries_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubVertical, 'Shops', SearchSubVertical_Shops_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubVertical, 'Health', SearchSubVertical_Health_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubVertical, 'Smoking', SearchSubVertical_Smoking_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SearchSubmissionType = SearchSubmissionType;
    defineProp($com$glovoapp$analytics$events.SearchSubmissionType, 'Typed', Typed_getInstance);
    $com$glovoapp$analytics$events.SearchSubmissionType.AutoSuggested = AutoSuggested;
    $com$glovoapp$analytics$events.SearchSubmissionType.RecentSearch = RecentSearch;
    $com$glovoapp$analytics$events.SearchSubmissionType.TrendingSearch = TrendingSearch;
    defineProp($com$glovoapp$analytics$events.SearchSubmissionType, 'Category', Category_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubmissionType, 'FilterSelected', FilterSelected_getInstance);
    defineProp($com$glovoapp$analytics$events.SearchSubmissionType, 'SearchShowAllButton', SearchShowAllButton_getInstance_0);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SearchType = SearchType;
    defineProp($com$glovoapp$analytics$events.SearchType, 'Global', Global_getInstance);
    $com$glovoapp$analytics$events.SearchType.CategoryGroup = CategoryGroup_1;
    $com$glovoapp$analytics$events.SearchType.Category = Category_1;
    $com$glovoapp$analytics$events.SearchType.Store = Store_1;
    $com$glovoapp$analytics$events.SearchType.StoreGroup = StoreGroup;
    $com$glovoapp$analytics$events.SearchType.FeedGroup = FeedGroup_0;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SeenFilters = SeenFilters;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SessionLocationSet = SessionLocationSet;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignInButtonClicked = SignInButtonClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignInLanding = SignInLanding;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignInLandingOrigin = SignInLandingOrigin;
    $com$glovoapp$analytics$events.SignInLandingOrigin.values = values_75;
    $com$glovoapp$analytics$events.SignInLandingOrigin.valueOf = valueOf_75;
    defineProp($com$glovoapp$analytics$events.SignInLandingOrigin, 'Launch', SignInLandingOrigin_Launch_getInstance);
    defineProp($com$glovoapp$analytics$events.SignInLandingOrigin, 'Other', SignInLandingOrigin_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignInSource = SignInSource;
    $com$glovoapp$analytics$events.SignInSource.values = values_76;
    $com$glovoapp$analytics$events.SignInSource.valueOf = valueOf_76;
    defineProp($com$glovoapp$analytics$events.SignInSource, 'Email', SignInSource_Email_getInstance);
    defineProp($com$glovoapp$analytics$events.SignInSource, 'Facebook', SignInSource_Facebook_getInstance);
    defineProp($com$glovoapp$analytics$events.SignInSource, 'Apple', SignInSource_Apple_getInstance);
    defineProp($com$glovoapp$analytics$events.SignInSource, 'Google', SignInSource_Google_getInstance);
    defineProp($com$glovoapp$analytics$events.SignInSource, 'Phone', SignInSource_Phone_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignUp = SignUp;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignUpSource = SignUpSource;
    $com$glovoapp$analytics$events.SignUpSource.values = values_77;
    $com$glovoapp$analytics$events.SignUpSource.valueOf = valueOf_77;
    defineProp($com$glovoapp$analytics$events.SignUpSource, 'Home', SignUpSource_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.SignUpSource, 'HomeCountry', SignUpSource_HomeCountry_getInstance);
    defineProp($com$glovoapp$analytics$events.SignUpSource, 'HomeGlobal', SignUpSource_HomeGlobal_getInstance);
    defineProp($com$glovoapp$analytics$events.SignUpSource, 'StoresList', SignUpSource_StoresList_getInstance);
    defineProp($com$glovoapp$analytics$events.SignUpSource, 'StoreMenu', SignUpSource_StoreMenu_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SocialSignalsConnections = SocialSignalsConnections;
    defineProp($com$glovoapp$analytics$events.SocialSignalsConnections, 'Metadata', Metadata_getInstance_102);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SocialSignalsSource = SocialSignalsSource;
    $com$glovoapp$analytics$events.SocialSignalsSource.values = values_78;
    $com$glovoapp$analytics$events.SocialSignalsSource.valueOf = valueOf_78;
    defineProp($com$glovoapp$analytics$events.SocialSignalsSource, 'Stores', SocialSignalsSource_Stores_getInstance);
    defineProp($com$glovoapp$analytics$events.SocialSignalsSource, 'Store', SocialSignalsSource_Store_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SponsoredBubbleShown = SponsoredBubbleShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Store = Store_2;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreAccessed = StoreAccessed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreAccessedOperation = StoreAccessedOperation;
    $com$glovoapp$analytics$events.StoreAccessedOperation.Search = Search_1;
    $com$glovoapp$analytics$events.StoreAccessedOperation.Filters = Filters_1;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreAccessedOrigin = StoreAccessedOrigin;
    $com$glovoapp$analytics$events.StoreAccessedOrigin.Category = Category_2;
    $com$glovoapp$analytics$events.StoreAccessedOrigin.CategoryGroup = CategoryGroup_2;
    defineProp($com$glovoapp$analytics$events.StoreAccessedOrigin, 'Checkout', Checkout_getInstance_1);
    $com$glovoapp$analytics$events.StoreAccessedOrigin.FeedGroup = FeedGroup_1;
    $com$glovoapp$analytics$events.StoreAccessedOrigin.FeedGroupResults = FeedGroupResults_0;
    $com$glovoapp$analytics$events.StoreAccessedOrigin.HomeWidget = HomeWidget_1;
    $com$glovoapp$analytics$events.StoreAccessedOrigin.HomeWidgetResults = HomeWidgetResults_0;
    defineProp($com$glovoapp$analytics$events.StoreAccessedOrigin, 'HomeSearchBarResults', HomeSearchBarResults_getInstance);
    $com$glovoapp$analytics$events.StoreAccessedOrigin.Story = Story_1;
    $com$glovoapp$analytics$events.StoreAccessedOrigin.SearchWidget = SearchWidget;
    defineProp($com$glovoapp$analytics$events.StoreAccessedOrigin, 'Deeplink', Deeplink_getInstance_0);
    defineProp($com$glovoapp$analytics$events.StoreAccessedOrigin, 'Direct', Direct_getInstance_0);
    defineProp($com$glovoapp$analytics$events.StoreAccessedOrigin, 'Other', Other_getInstance_4);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreCarouselType = StoreCarouselType;
    $com$glovoapp$analytics$events.StoreCarouselType.values = values_79;
    $com$glovoapp$analytics$events.StoreCarouselType.valueOf = valueOf_79;
    defineProp($com$glovoapp$analytics$events.StoreCarouselType, 'EasyReorder', StoreCarouselType_EasyReorder_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreCarouselType, 'TopSellers', StoreCarouselType_TopSellers_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreCarouselType, 'CollectionGroup', StoreCarouselType_CollectionGroup_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreCarouselType, 'Other', StoreCarouselType_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreFunnel = StoreFunnel;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreFunnelLayout = StoreFunnelLayout;
    $com$glovoapp$analytics$events.StoreFunnelLayout.CollectionGroups = CollectionGroups;
    $com$glovoapp$analytics$events.StoreFunnelLayout.Collections = Collections;
    $com$glovoapp$analytics$events.StoreFunnelLayout.Products = Products;
    defineProp($com$glovoapp$analytics$events.StoreFunnelLayout, 'ProductsTopSellers', ProductsTopSellers_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelLayout, 'ProductsEasyReorder', ProductsEasyReorder_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelLayout, 'NoMenu', NoMenu_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreFunnelOrigin = StoreFunnelOrigin;
    $com$glovoapp$analytics$events.StoreFunnelOrigin.values = values_80;
    $com$glovoapp$analytics$events.StoreFunnelOrigin.valueOf = valueOf_80;
    defineProp($com$glovoapp$analytics$events.StoreFunnelOrigin, 'Store', StoreFunnelOrigin_Store_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelOrigin, 'CollectionGroup', StoreFunnelOrigin_CollectionGroup_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelOrigin, 'Collection', StoreFunnelOrigin_Collection_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelOrigin, 'EasyReorder', StoreFunnelOrigin_EasyReorder_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelOrigin, 'TopSellers', StoreFunnelOrigin_TopSellers_getInstance);
    defineProp($com$glovoapp$analytics$events.StoreFunnelOrigin, 'BackArrow', StoreFunnelOrigin_BackArrow_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreHomeMosaicImpression = StoreHomeMosaicImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreImpression = StoreImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreInfoButtonClicked = StoreInfoButtonClicked;
    defineProp($com$glovoapp$analytics$events.StoreInfoButtonClicked, 'Metadata', Metadata_getInstance_103);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreInfoScreen = StoreInfoScreen;
    defineProp($com$glovoapp$analytics$events.StoreInfoScreen, 'Metadata', Metadata_getInstance_104);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreLeft = StoreLeft;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoreMobileNavigationBarImpression = StoreMobileNavigationBarImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Stores = Stores;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.StoresOrigin = StoresOrigin;
    defineProp($com$glovoapp$analytics$events.StoresOrigin, 'HomeSearchBar', HomeSearchBar_getInstance);
    $com$glovoapp$analytics$events.StoresOrigin.Category = Category_3;
    $com$glovoapp$analytics$events.StoresOrigin.CategoryGroup = CategoryGroup_3;
    $com$glovoapp$analytics$events.StoresOrigin.FeedGroup = FeedGroup_2;
    defineProp($com$glovoapp$analytics$events.StoresOrigin, 'Deeplink', Deeplink_getInstance_1);
    defineProp($com$glovoapp$analytics$events.StoresOrigin, 'Story', Story_getInstance_0);
    $com$glovoapp$analytics$events.StoresOrigin.HomeWidget = HomeWidget_2;
    $com$glovoapp$analytics$events.StoresOrigin.HomeWidgetResults = HomeWidgetResults_1;
    $com$glovoapp$analytics$events.StoresOrigin.SearchWidget = SearchWidget_0;
    defineProp($com$glovoapp$analytics$events.StoresOrigin, 'Other', Other_getInstance_5);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SurgeBannerShown = SurgeBannerShown;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.TellUsYourName = TellUsYourName;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ThreeDS2AuthenticationFailed = ThreeDS2AuthenticationFailed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.TokenizedAPMStatus = TokenizedAPMStatus;
    $com$glovoapp$analytics$events.TokenizedAPMStatus.values = values_81;
    $com$glovoapp$analytics$events.TokenizedAPMStatus.valueOf = valueOf_81;
    defineProp($com$glovoapp$analytics$events.TokenizedAPMStatus, 'FetchConfig', TokenizedAPMStatus_FetchConfig_getInstance);
    defineProp($com$glovoapp$analytics$events.TokenizedAPMStatus, 'Started', TokenizedAPMStatus_Started_getInstance);
    defineProp($com$glovoapp$analytics$events.TokenizedAPMStatus, 'Authorized', TokenizedAPMStatus_Authorized_getInstance);
    defineProp($com$glovoapp$analytics$events.TokenizedAPMStatus, 'Confirmed', TokenizedAPMStatus_Confirmed_getInstance);
    defineProp($com$glovoapp$analytics$events.TokenizedAPMStatus, 'Failed', TokenizedAPMStatus_Failed_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.TooFarToDeliverScreenDissmissed = TooFarToDeliverScreenDissmissed;
    defineProp($com$glovoapp$analytics$events.TooFarToDeliverScreenDissmissed, 'Metadata', Metadata_getInstance_105);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.TooFarToDeliverScreenShown = TooFarToDeliverScreenShown;
    defineProp($com$glovoapp$analytics$events.TooFarToDeliverScreenShown, 'Metadata', Metadata_getInstance_106);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.UseCurrentLocationPressed = UseCurrentLocationPressed;
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationPressed, 'Metadata', Metadata_getInstance_107);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.UseCurrentLocationSource = UseCurrentLocationSource;
    $com$glovoapp$analytics$events.UseCurrentLocationSource.values = values_82;
    $com$glovoapp$analytics$events.UseCurrentLocationSource.valueOf = valueOf_82;
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationSource, 'HomeGlobal', UseCurrentLocationSource_HomeGlobal_getInstance);
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationSource, 'HomeCountry', UseCurrentLocationSource_HomeCountry_getInstance);
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationSource, 'HomeCity', UseCurrentLocationSource_HomeCity_getInstance);
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationSource, 'Store', UseCurrentLocationSource_Store_getInstance);
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationSource, 'StoreFunnel', UseCurrentLocationSource_StoreFunnel_getInstance);
    defineProp($com$glovoapp$analytics$events.UseCurrentLocationSource, 'Checkout', UseCurrentLocationSource_Checkout_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.UserLoggedIn = UserLoggedIn;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.UserRegistrationType = UserRegistrationType;
    $com$glovoapp$analytics$events.UserRegistrationType.values = values_83;
    $com$glovoapp$analytics$events.UserRegistrationType.valueOf = valueOf_83;
    defineProp($com$glovoapp$analytics$events.UserRegistrationType, 'Email', UserRegistrationType_Email_getInstance);
    defineProp($com$glovoapp$analytics$events.UserRegistrationType, 'Facebook', UserRegistrationType_Facebook_getInstance);
    defineProp($com$glovoapp$analytics$events.UserRegistrationType, 'Apple', UserRegistrationType_Apple_getInstance);
    defineProp($com$glovoapp$analytics$events.UserRegistrationType, 'Migration', UserRegistrationType_Migration_getInstance);
    defineProp($com$glovoapp$analytics$events.UserRegistrationType, 'Google', UserRegistrationType_Google_getInstance);
    defineProp($com$glovoapp$analytics$events.UserRegistrationType, 'Phone', UserRegistrationType_Phone_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.UserSignedUp = UserSignedUp;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WebSearchType = WebSearchType;
    $com$glovoapp$analytics$events.WebSearchType.All = All;
    $com$glovoapp$analytics$events.WebSearchType.Products = Products_0;
    $com$glovoapp$analytics$events.WebSearchType.Stores = Stores_0;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetContentImpression = WidgetContentImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetContentImpressionType = WidgetContentImpressionType;
    $com$glovoapp$analytics$events.WidgetContentImpressionType.Store = Store_3;
    $com$glovoapp$analytics$events.WidgetContentImpressionType.Product = Product;
    defineProp($com$glovoapp$analytics$events.WidgetContentImpressionType, 'Other', Other_getInstance_6);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetElementsShown = WidgetElementsShown;
    $com$glovoapp$analytics$events.WidgetElementsShown.Stores = Stores_1;
    $com$glovoapp$analytics$events.WidgetElementsShown.Products = Products_1;
    $com$glovoapp$analytics$events.WidgetElementsShown.Videos = Videos;
    $com$glovoapp$analytics$events.WidgetElementsShown.Playlists = Playlists;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetFilterDisplayed = WidgetFilterDisplayed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetImpression = WidgetImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetInteracted = WidgetInteracted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetInteractionType = WidgetInteractionType;
    defineProp($com$glovoapp$analytics$events.WidgetInteractionType, 'CtaSelected', CtaSelected_getInstance_0);
    $com$glovoapp$analytics$events.WidgetInteractionType.StoreSelected = StoreSelected_0;
    $com$glovoapp$analytics$events.WidgetInteractionType.ProductSelected = ProductSelected_0;
    $com$glovoapp$analytics$events.WidgetInteractionType.VideoSelected = VideoSelected;
    defineProp($com$glovoapp$analytics$events.WidgetInteractionType, 'Other', Other_getInstance_7);
    $com$glovoapp$analytics$events.WidgetInteractionType.PlaylistSelected = PlaylistSelected;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetLayout = WidgetLayout;
    defineProp($com$glovoapp$analytics$events.WidgetLayout, 'StoreCardCarousel', StoreCardCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.WidgetLayout, 'ProductCarousel', ProductCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.WidgetLayout, 'StoreLogoCarousel', StoreLogoCarousel_getInstance);
    defineProp($com$glovoapp$analytics$events.WidgetLayout, 'VideoCarousel', VideoCarousel_getInstance);
    $com$glovoapp$analytics$events.WidgetLayout.StoreLogoGrid = StoreLogoGrid;
    $com$glovoapp$analytics$events.WidgetLayout.ProductGrid = ProductGrid;
    defineProp($com$glovoapp$analytics$events.WidgetLayout, 'PlaylistCarousel', PlaylistCarousel_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetLoaded = WidgetLoaded;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetStoreImpression = WidgetStoreImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WidgetsLoaded = WidgetsLoaded;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WrongCredentials = WrongCredentials;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Account = Account;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AccountSectionTapped = AccountSectionTapped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddDeliveryAddressOnStorePage = AddDeliveryAddressOnStorePage;
    defineProp($com$glovoapp$analytics$events.AddDeliveryAddressOnStorePage, 'Metadata', Metadata_getInstance_108);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressCreationOnStorePage = AddressCreationOnStorePage;
    defineProp($com$glovoapp$analytics$events.AddressCreationOnStorePage, 'Metadata', Metadata_getInstance_109);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AddressOutsideStoreDeliveryZoneScreen = AddressOutsideStoreDeliveryZoneScreen;
    defineProp($com$glovoapp$analytics$events.AddressOutsideStoreDeliveryZoneScreen, 'Metadata', Metadata_getInstance_110);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.AvailableButtons = AvailableButtons;
    $com$glovoapp$analytics$events.AvailableButtons.values = values_84;
    $com$glovoapp$analytics$events.AvailableButtons.valueOf = valueOf_84;
    defineProp($com$glovoapp$analytics$events.AvailableButtons, 'NoSchedulingOption', AvailableButtons_NoSchedulingOption_getInstance);
    defineProp($com$glovoapp$analytics$events.AvailableButtons, 'SchedulingOption', AvailableButtons_SchedulingOption_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.CartScreen = CartScreen;
    defineProp($com$glovoapp$analytics$events.CartScreen, 'Metadata', Metadata_getInstance_111);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DownloadPressed = DownloadPressed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.DownloadPressedSource = DownloadPressedSource;
    $com$glovoapp$analytics$events.DownloadPressedSource.values = values_85;
    $com$glovoapp$analytics$events.DownloadPressedSource.valueOf = valueOf_85;
    defineProp($com$glovoapp$analytics$events.DownloadPressedSource, 'Home', DownloadPressedSource_Home_getInstance);
    defineProp($com$glovoapp$analytics$events.DownloadPressedSource, 'HomeGlobal', DownloadPressedSource_HomeGlobal_getInstance);
    defineProp($com$glovoapp$analytics$events.DownloadPressedSource, 'HomeCountry', DownloadPressedSource_HomeCountry_getInstance);
    defineProp($com$glovoapp$analytics$events.DownloadPressedSource, 'OngoingOrderDetails', DownloadPressedSource_OngoingOrderDetails_getInstance);
    defineProp($com$glovoapp$analytics$events.DownloadPressedSource, 'Other', DownloadPressedSource_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FilterPromotionsCarouselShown = FilterPromotionsCarouselShown;
    defineProp($com$glovoapp$analytics$events.FilterPromotionsCarouselShown, 'Metadata', Metadata_getInstance_112);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.FreeDeliveryBanner = FreeDeliveryBanner;
    defineProp($com$glovoapp$analytics$events.FreeDeliveryBanner, 'Metadata', Metadata_getInstance_113);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GetStartedButton = GetStartedButton;
    defineProp($com$glovoapp$analytics$events.GetStartedButton, 'Metadata', Metadata_getInstance_114);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GetStartedButtonSource = GetStartedButtonSource;
    $com$glovoapp$analytics$events.GetStartedButtonSource.values = values_86;
    $com$glovoapp$analytics$events.GetStartedButtonSource.valueOf = valueOf_86;
    defineProp($com$glovoapp$analytics$events.GetStartedButtonSource, 'HeaderActionsDesktop', GetStartedButtonSource_HeaderActionsDesktop_getInstance);
    defineProp($com$glovoapp$analytics$events.GetStartedButtonSource, 'HeaderActionsMobile', GetStartedButtonSource_HeaderActionsMobile_getInstance);
    defineProp($com$glovoapp$analytics$events.GetStartedButtonSource, 'TopBanner', GetStartedButtonSource_TopBanner_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GoogleOneTapDisplayed = GoogleOneTapDisplayed;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GoogleOneTapSkipped = GoogleOneTapSkipped;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.GoogleOneTapSkippedReason = GoogleOneTapSkippedReason;
    $com$glovoapp$analytics$events.GoogleOneTapSkippedReason.values = values_87;
    $com$glovoapp$analytics$events.GoogleOneTapSkippedReason.valueOf = valueOf_87;
    defineProp($com$glovoapp$analytics$events.GoogleOneTapSkippedReason, 'UserCancel', GoogleOneTapSkippedReason_UserCancel_getInstance);
    defineProp($com$glovoapp$analytics$events.GoogleOneTapSkippedReason, 'TapOutside', GoogleOneTapSkippedReason_TapOutside_getInstance);
    defineProp($com$glovoapp$analytics$events.GoogleOneTapSkippedReason, 'Other', GoogleOneTapSkippedReason_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.HomeCountry = HomeCountry;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.HomeGlobal = HomeGlobal;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.LogInError = LogInError;
    defineProp($com$glovoapp$analytics$events.LogInError, 'Metadata', Metadata_getInstance_115);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.LogOutAttempted = LogOutAttempted;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OsPicked = OsPicked;
    $com$glovoapp$analytics$events.OsPicked.values = values_88;
    $com$glovoapp$analytics$events.OsPicked.valueOf = valueOf_88;
    defineProp($com$glovoapp$analytics$events.OsPicked, 'Android', OsPicked_Android_getInstance);
    defineProp($com$glovoapp$analytics$events.OsPicked, 'IOS', OsPicked_IOS_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OutOfDeliveryZonePopUpClosed = OutOfDeliveryZonePopUpClosed;
    defineProp($com$glovoapp$analytics$events.OutOfDeliveryZonePopUpClosed, 'Metadata', Metadata_getInstance_116);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OutOfDeliveryZonePopUpShown = OutOfDeliveryZonePopUpShown;
    defineProp($com$glovoapp$analytics$events.OutOfDeliveryZonePopUpShown, 'Metadata', Metadata_getInstance_117);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.OutsideStoreDeliveryZoneReason = OutsideStoreDeliveryZoneReason;
    $com$glovoapp$analytics$events.OutsideStoreDeliveryZoneReason.values = values_89;
    $com$glovoapp$analytics$events.OutsideStoreDeliveryZoneReason.valueOf = valueOf_89;
    defineProp($com$glovoapp$analytics$events.OutsideStoreDeliveryZoneReason, 'OutOfCityZone', OutsideStoreDeliveryZoneReason_OutOfCityZone_getInstance);
    defineProp($com$glovoapp$analytics$events.OutsideStoreDeliveryZoneReason, 'OutOfDeliveryZone', OutsideStoreDeliveryZoneReason_OutOfDeliveryZone_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ParcelInformationEdit = ParcelInformationEdit;
    defineProp($com$glovoapp$analytics$events.ParcelInformationEdit, 'Metadata', Metadata_getInstance_118);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeLandingPageInteracted = PrimeLandingPageInteracted;
    defineProp($com$glovoapp$analytics$events.PrimeLandingPageInteracted, 'Metadata', Metadata_getInstance_119);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeLandingPageInteractionType = PrimeLandingPageInteractionType;
    $com$glovoapp$analytics$events.PrimeLandingPageInteractionType.values = values_90;
    $com$glovoapp$analytics$events.PrimeLandingPageInteractionType.valueOf = valueOf_90;
    defineProp($com$glovoapp$analytics$events.PrimeLandingPageInteractionType, 'GetPrimeCTA', PrimeLandingPageInteractionType_GetPrimeCTA_getInstance);
    defineProp($com$glovoapp$analytics$events.PrimeLandingPageInteractionType, 'ExploreGlovoCTA', PrimeLandingPageInteractionType_ExploreGlovoCTA_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PrimeLandingPageScreen = PrimeLandingPageScreen;
    defineProp($com$glovoapp$analytics$events.PrimeLandingPageScreen, 'Metadata', Metadata_getInstance_120);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ProfileSectionTapped = ProfileSectionTapped;
    defineProp($com$glovoapp$analytics$events.ProfileSectionTapped, 'Metadata', Metadata_getInstance_121);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromotionsCarouselClicked = PromotionsCarouselClicked;
    defineProp($com$glovoapp$analytics$events.PromotionsCarouselClicked, 'Metadata', Metadata_getInstance_122);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.PromotionsPageLanding = PromotionsPageLanding;
    defineProp($com$glovoapp$analytics$events.PromotionsPageLanding, 'Metadata', Metadata_getInstance_123);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ReorderCarouselImpression = ReorderCarouselImpression;
    defineProp($com$glovoapp$analytics$events.ReorderCarouselImpression, 'Metadata', Metadata_getInstance_124);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ResetPassword = ResetPassword;
    defineProp($com$glovoapp$analytics$events.ResetPassword, 'Metadata', Metadata_getInstance_125);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ResetPasswordError = ResetPasswordError;
    defineProp($com$glovoapp$analytics$events.ResetPasswordError, 'Metadata', Metadata_getInstance_126);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ScheduleButton = ScheduleButton;
    defineProp($com$glovoapp$analytics$events.ScheduleButton, 'Metadata', Metadata_getInstance_127);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.ShowMorePromotionsArrowButtonOnStorePageClicked = ShowMorePromotionsArrowButtonOnStorePageClicked;
    defineProp($com$glovoapp$analytics$events.ShowMorePromotionsArrowButtonOnStorePageClicked, 'Metadata', Metadata_getInstance_128);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SideDrawerCategoryClick = SideDrawerCategoryClick;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SideDrawerClick = SideDrawerClick;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SideDrawerImpression = SideDrawerImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SideDrawerOrigin = SideDrawerOrigin;
    $com$glovoapp$analytics$events.SideDrawerOrigin.values = values_91;
    $com$glovoapp$analytics$events.SideDrawerOrigin.valueOf = valueOf_91;
    defineProp($com$glovoapp$analytics$events.SideDrawerOrigin, 'StorePage', SideDrawerOrigin_StorePage_getInstance);
    defineProp($com$glovoapp$analytics$events.SideDrawerOrigin, 'CategoryPage', SideDrawerOrigin_CategoryPage_getInstance);
    defineProp($com$glovoapp$analytics$events.SideDrawerOrigin, 'SearchPage', SideDrawerOrigin_SearchPage_getInstance);
    defineProp($com$glovoapp$analytics$events.SideDrawerOrigin, 'PromotionsPage', SideDrawerOrigin_PromotionsPage_getInstance);
    defineProp($com$glovoapp$analytics$events.SideDrawerOrigin, 'BestNearYou', SideDrawerOrigin_BestNearYou_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignUpError = SignUpError;
    defineProp($com$glovoapp$analytics$events.SignUpError, 'Metadata', Metadata_getInstance_129);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignatureConfirmationClicked = SignatureConfirmationClicked;
    defineProp($com$glovoapp$analytics$events.SignatureConfirmationClicked, 'Metadata', Metadata_getInstance_130);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SignaturePageOpened = SignaturePageOpened;
    defineProp($com$glovoapp$analytics$events.SignaturePageOpened, 'Metadata', Metadata_getInstance_131);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SocialFeatureAddContactsClicked = SocialFeatureAddContactsClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.SocialFeatureStartSurveyClicked = SocialFeatureStartSurveyClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.TrackYourParcelSearch = TrackYourParcelSearch;
    defineProp($com$glovoapp$analytics$events.TrackYourParcelSearch, 'Metadata', Metadata_getInstance_132);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WebToAppBannerType = WebToAppBannerType;
    $com$glovoapp$analytics$events.WebToAppBannerType.values = values_92;
    $com$glovoapp$analytics$events.WebToAppBannerType.valueOf = valueOf_92;
    defineProp($com$glovoapp$analytics$events.WebToAppBannerType, 'Control', WebToAppBannerType_Control_getInstance);
    defineProp($com$glovoapp$analytics$events.WebToAppBannerType, 'Variant1', WebToAppBannerType_Variant1_getInstance);
    defineProp($com$glovoapp$analytics$events.WebToAppBannerType, 'Variant2', WebToAppBannerType_Variant2_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WebToAppClicked = WebToAppClicked;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WebToAppDismiss = WebToAppDismiss;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.WebToAppImpression = WebToAppImpression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.exploreStoresFromClosedStore = exploreStoresFromClosedStore;
    defineProp($com$glovoapp$analytics$events.exploreStoresFromClosedStore, 'Metadata', Metadata_getInstance_133);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.homeCountrySource = homeCountrySource;
    $com$glovoapp$analytics$events.homeCountrySource.values = values_93;
    $com$glovoapp$analytics$events.homeCountrySource.valueOf = valueOf_93;
    defineProp($com$glovoapp$analytics$events.homeCountrySource, 'Default', homeCountrySource_Default_getInstance);
    defineProp($com$glovoapp$analytics$events.homeCountrySource, 'HomeGlobal', homeCountrySource_HomeGlobal_getInstance);
  }
  $jsExportAll$(_);
  kotlin_kotlin.$jsExportAll$(_);
  kotlin_com_glovoapp_analytics_common.$jsExportAll$(_);
  //endregion
  return _;
}(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./analytics-multiplatform-common-web.js')));

//# sourceMappingURL=analytics-multiplatform-customer-web.js.map
